// THIS SCRIPT IS GENERATED BY tools/make-unicode.ts. DO NOT EDIT!

export const foldMap: Map<number, number> = new Map([
	[0x41, 0x61],
	[0x42, 0x62],
	[0x43, 0x63],
	[0x44, 0x64],
	[0x45, 0x65],
	[0x46, 0x66],
	[0x47, 0x67],
	[0x48, 0x68],
	[0x49, 0x69],
	[0x4a, 0x6a],
	[0x4b, 0x6b],
	[0x4c, 0x6c],
	[0x4d, 0x6d],
	[0x4e, 0x6e],
	[0x4f, 0x6f],
	[0x50, 0x70],
	[0x51, 0x71],
	[0x52, 0x72],
	[0x53, 0x73],
	[0x54, 0x74],
	[0x55, 0x75],
	[0x56, 0x76],
	[0x57, 0x77],
	[0x58, 0x78],
	[0x59, 0x79],
	[0x5a, 0x7a],
	[0xb5, 0x3bc],
	[0xc0, 0xe0],
	[0xc1, 0xe1],
	[0xc2, 0xe2],
	[0xc3, 0xe3],
	[0xc4, 0xe4],
	[0xc5, 0xe5],
	[0xc6, 0xe6],
	[0xc7, 0xe7],
	[0xc8, 0xe8],
	[0xc9, 0xe9],
	[0xca, 0xea],
	[0xcb, 0xeb],
	[0xcc, 0xec],
	[0xcd, 0xed],
	[0xce, 0xee],
	[0xcf, 0xef],
	[0xd0, 0xf0],
	[0xd1, 0xf1],
	[0xd2, 0xf2],
	[0xd3, 0xf3],
	[0xd4, 0xf4],
	[0xd5, 0xf5],
	[0xd6, 0xf6],
	[0xd8, 0xf8],
	[0xd9, 0xf9],
	[0xda, 0xfa],
	[0xdb, 0xfb],
	[0xdc, 0xfc],
	[0xdd, 0xfd],
	[0xde, 0xfe],
	[0x100, 0x101],
	[0x102, 0x103],
	[0x104, 0x105],
	[0x106, 0x107],
	[0x108, 0x109],
	[0x10a, 0x10b],
	[0x10c, 0x10d],
	[0x10e, 0x10f],
	[0x110, 0x111],
	[0x112, 0x113],
	[0x114, 0x115],
	[0x116, 0x117],
	[0x118, 0x119],
	[0x11a, 0x11b],
	[0x11c, 0x11d],
	[0x11e, 0x11f],
	[0x120, 0x121],
	[0x122, 0x123],
	[0x124, 0x125],
	[0x126, 0x127],
	[0x128, 0x129],
	[0x12a, 0x12b],
	[0x12c, 0x12d],
	[0x12e, 0x12f],
	[0x132, 0x133],
	[0x134, 0x135],
	[0x136, 0x137],
	[0x139, 0x13a],
	[0x13b, 0x13c],
	[0x13d, 0x13e],
	[0x13f, 0x140],
	[0x141, 0x142],
	[0x143, 0x144],
	[0x145, 0x146],
	[0x147, 0x148],
	[0x14a, 0x14b],
	[0x14c, 0x14d],
	[0x14e, 0x14f],
	[0x150, 0x151],
	[0x152, 0x153],
	[0x154, 0x155],
	[0x156, 0x157],
	[0x158, 0x159],
	[0x15a, 0x15b],
	[0x15c, 0x15d],
	[0x15e, 0x15f],
	[0x160, 0x161],
	[0x162, 0x163],
	[0x164, 0x165],
	[0x166, 0x167],
	[0x168, 0x169],
	[0x16a, 0x16b],
	[0x16c, 0x16d],
	[0x16e, 0x16f],
	[0x170, 0x171],
	[0x172, 0x173],
	[0x174, 0x175],
	[0x176, 0x177],
	[0x178, 0xff],
	[0x179, 0x17a],
	[0x17b, 0x17c],
	[0x17d, 0x17e],
	[0x17f, 0x73],
	[0x181, 0x253],
	[0x182, 0x183],
	[0x184, 0x185],
	[0x186, 0x254],
	[0x187, 0x188],
	[0x189, 0x256],
	[0x18a, 0x257],
	[0x18b, 0x18c],
	[0x18e, 0x1dd],
	[0x18f, 0x259],
	[0x190, 0x25b],
	[0x191, 0x192],
	[0x193, 0x260],
	[0x194, 0x263],
	[0x196, 0x269],
	[0x197, 0x268],
	[0x198, 0x199],
	[0x19c, 0x26f],
	[0x19d, 0x272],
	[0x19f, 0x275],
	[0x1a0, 0x1a1],
	[0x1a2, 0x1a3],
	[0x1a4, 0x1a5],
	[0x1a6, 0x280],
	[0x1a7, 0x1a8],
	[0x1a9, 0x283],
	[0x1ac, 0x1ad],
	[0x1ae, 0x288],
	[0x1af, 0x1b0],
	[0x1b1, 0x28a],
	[0x1b2, 0x28b],
	[0x1b3, 0x1b4],
	[0x1b5, 0x1b6],
	[0x1b7, 0x292],
	[0x1b8, 0x1b9],
	[0x1bc, 0x1bd],
	[0x1c4, 0x1c6],
	[0x1c5, 0x1c6],
	[0x1c7, 0x1c9],
	[0x1c8, 0x1c9],
	[0x1ca, 0x1cc],
	[0x1cb, 0x1cc],
	[0x1cd, 0x1ce],
	[0x1cf, 0x1d0],
	[0x1d1, 0x1d2],
	[0x1d3, 0x1d4],
	[0x1d5, 0x1d6],
	[0x1d7, 0x1d8],
	[0x1d9, 0x1da],
	[0x1db, 0x1dc],
	[0x1de, 0x1df],
	[0x1e0, 0x1e1],
	[0x1e2, 0x1e3],
	[0x1e4, 0x1e5],
	[0x1e6, 0x1e7],
	[0x1e8, 0x1e9],
	[0x1ea, 0x1eb],
	[0x1ec, 0x1ed],
	[0x1ee, 0x1ef],
	[0x1f1, 0x1f3],
	[0x1f2, 0x1f3],
	[0x1f4, 0x1f5],
	[0x1f6, 0x195],
	[0x1f7, 0x1bf],
	[0x1f8, 0x1f9],
	[0x1fa, 0x1fb],
	[0x1fc, 0x1fd],
	[0x1fe, 0x1ff],
	[0x200, 0x201],
	[0x202, 0x203],
	[0x204, 0x205],
	[0x206, 0x207],
	[0x208, 0x209],
	[0x20a, 0x20b],
	[0x20c, 0x20d],
	[0x20e, 0x20f],
	[0x210, 0x211],
	[0x212, 0x213],
	[0x214, 0x215],
	[0x216, 0x217],
	[0x218, 0x219],
	[0x21a, 0x21b],
	[0x21c, 0x21d],
	[0x21e, 0x21f],
	[0x220, 0x19e],
	[0x222, 0x223],
	[0x224, 0x225],
	[0x226, 0x227],
	[0x228, 0x229],
	[0x22a, 0x22b],
	[0x22c, 0x22d],
	[0x22e, 0x22f],
	[0x230, 0x231],
	[0x232, 0x233],
	[0x23a, 0x2c65],
	[0x23b, 0x23c],
	[0x23d, 0x19a],
	[0x23e, 0x2c66],
	[0x241, 0x242],
	[0x243, 0x180],
	[0x244, 0x289],
	[0x245, 0x28c],
	[0x246, 0x247],
	[0x248, 0x249],
	[0x24a, 0x24b],
	[0x24c, 0x24d],
	[0x24e, 0x24f],
	[0x345, 0x3b9],
	[0x370, 0x371],
	[0x372, 0x373],
	[0x376, 0x377],
	[0x37f, 0x3f3],
	[0x386, 0x3ac],
	[0x388, 0x3ad],
	[0x389, 0x3ae],
	[0x38a, 0x3af],
	[0x38c, 0x3cc],
	[0x38e, 0x3cd],
	[0x38f, 0x3ce],
	[0x391, 0x3b1],
	[0x392, 0x3b2],
	[0x393, 0x3b3],
	[0x394, 0x3b4],
	[0x395, 0x3b5],
	[0x396, 0x3b6],
	[0x397, 0x3b7],
	[0x398, 0x3b8],
	[0x399, 0x3b9],
	[0x39a, 0x3ba],
	[0x39b, 0x3bb],
	[0x39c, 0x3bc],
	[0x39d, 0x3bd],
	[0x39e, 0x3be],
	[0x39f, 0x3bf],
	[0x3a0, 0x3c0],
	[0x3a1, 0x3c1],
	[0x3a3, 0x3c3],
	[0x3a4, 0x3c4],
	[0x3a5, 0x3c5],
	[0x3a6, 0x3c6],
	[0x3a7, 0x3c7],
	[0x3a8, 0x3c8],
	[0x3a9, 0x3c9],
	[0x3aa, 0x3ca],
	[0x3ab, 0x3cb],
	[0x3c2, 0x3c3],
	[0x3cf, 0x3d7],
	[0x3d0, 0x3b2],
	[0x3d1, 0x3b8],
	[0x3d5, 0x3c6],
	[0x3d6, 0x3c0],
	[0x3d8, 0x3d9],
	[0x3da, 0x3db],
	[0x3dc, 0x3dd],
	[0x3de, 0x3df],
	[0x3e0, 0x3e1],
	[0x3e2, 0x3e3],
	[0x3e4, 0x3e5],
	[0x3e6, 0x3e7],
	[0x3e8, 0x3e9],
	[0x3ea, 0x3eb],
	[0x3ec, 0x3ed],
	[0x3ee, 0x3ef],
	[0x3f0, 0x3ba],
	[0x3f1, 0x3c1],
	[0x3f4, 0x3b8],
	[0x3f5, 0x3b5],
	[0x3f7, 0x3f8],
	[0x3f9, 0x3f2],
	[0x3fa, 0x3fb],
	[0x3fd, 0x37b],
	[0x3fe, 0x37c],
	[0x3ff, 0x37d],
	[0x400, 0x450],
	[0x401, 0x451],
	[0x402, 0x452],
	[0x403, 0x453],
	[0x404, 0x454],
	[0x405, 0x455],
	[0x406, 0x456],
	[0x407, 0x457],
	[0x408, 0x458],
	[0x409, 0x459],
	[0x40a, 0x45a],
	[0x40b, 0x45b],
	[0x40c, 0x45c],
	[0x40d, 0x45d],
	[0x40e, 0x45e],
	[0x40f, 0x45f],
	[0x410, 0x430],
	[0x411, 0x431],
	[0x412, 0x432],
	[0x413, 0x433],
	[0x414, 0x434],
	[0x415, 0x435],
	[0x416, 0x436],
	[0x417, 0x437],
	[0x418, 0x438],
	[0x419, 0x439],
	[0x41a, 0x43a],
	[0x41b, 0x43b],
	[0x41c, 0x43c],
	[0x41d, 0x43d],
	[0x41e, 0x43e],
	[0x41f, 0x43f],
	[0x420, 0x440],
	[0x421, 0x441],
	[0x422, 0x442],
	[0x423, 0x443],
	[0x424, 0x444],
	[0x425, 0x445],
	[0x426, 0x446],
	[0x427, 0x447],
	[0x428, 0x448],
	[0x429, 0x449],
	[0x42a, 0x44a],
	[0x42b, 0x44b],
	[0x42c, 0x44c],
	[0x42d, 0x44d],
	[0x42e, 0x44e],
	[0x42f, 0x44f],
	[0x460, 0x461],
	[0x462, 0x463],
	[0x464, 0x465],
	[0x466, 0x467],
	[0x468, 0x469],
	[0x46a, 0x46b],
	[0x46c, 0x46d],
	[0x46e, 0x46f],
	[0x470, 0x471],
	[0x472, 0x473],
	[0x474, 0x475],
	[0x476, 0x477],
	[0x478, 0x479],
	[0x47a, 0x47b],
	[0x47c, 0x47d],
	[0x47e, 0x47f],
	[0x480, 0x481],
	[0x48a, 0x48b],
	[0x48c, 0x48d],
	[0x48e, 0x48f],
	[0x490, 0x491],
	[0x492, 0x493],
	[0x494, 0x495],
	[0x496, 0x497],
	[0x498, 0x499],
	[0x49a, 0x49b],
	[0x49c, 0x49d],
	[0x49e, 0x49f],
	[0x4a0, 0x4a1],
	[0x4a2, 0x4a3],
	[0x4a4, 0x4a5],
	[0x4a6, 0x4a7],
	[0x4a8, 0x4a9],
	[0x4aa, 0x4ab],
	[0x4ac, 0x4ad],
	[0x4ae, 0x4af],
	[0x4b0, 0x4b1],
	[0x4b2, 0x4b3],
	[0x4b4, 0x4b5],
	[0x4b6, 0x4b7],
	[0x4b8, 0x4b9],
	[0x4ba, 0x4bb],
	[0x4bc, 0x4bd],
	[0x4be, 0x4bf],
	[0x4c0, 0x4cf],
	[0x4c1, 0x4c2],
	[0x4c3, 0x4c4],
	[0x4c5, 0x4c6],
	[0x4c7, 0x4c8],
	[0x4c9, 0x4ca],
	[0x4cb, 0x4cc],
	[0x4cd, 0x4ce],
	[0x4d0, 0x4d1],
	[0x4d2, 0x4d3],
	[0x4d4, 0x4d5],
	[0x4d6, 0x4d7],
	[0x4d8, 0x4d9],
	[0x4da, 0x4db],
	[0x4dc, 0x4dd],
	[0x4de, 0x4df],
	[0x4e0, 0x4e1],
	[0x4e2, 0x4e3],
	[0x4e4, 0x4e5],
	[0x4e6, 0x4e7],
	[0x4e8, 0x4e9],
	[0x4ea, 0x4eb],
	[0x4ec, 0x4ed],
	[0x4ee, 0x4ef],
	[0x4f0, 0x4f1],
	[0x4f2, 0x4f3],
	[0x4f4, 0x4f5],
	[0x4f6, 0x4f7],
	[0x4f8, 0x4f9],
	[0x4fa, 0x4fb],
	[0x4fc, 0x4fd],
	[0x4fe, 0x4ff],
	[0x500, 0x501],
	[0x502, 0x503],
	[0x504, 0x505],
	[0x506, 0x507],
	[0x508, 0x509],
	[0x50a, 0x50b],
	[0x50c, 0x50d],
	[0x50e, 0x50f],
	[0x510, 0x511],
	[0x512, 0x513],
	[0x514, 0x515],
	[0x516, 0x517],
	[0x518, 0x519],
	[0x51a, 0x51b],
	[0x51c, 0x51d],
	[0x51e, 0x51f],
	[0x520, 0x521],
	[0x522, 0x523],
	[0x524, 0x525],
	[0x526, 0x527],
	[0x528, 0x529],
	[0x52a, 0x52b],
	[0x52c, 0x52d],
	[0x52e, 0x52f],
	[0x531, 0x561],
	[0x532, 0x562],
	[0x533, 0x563],
	[0x534, 0x564],
	[0x535, 0x565],
	[0x536, 0x566],
	[0x537, 0x567],
	[0x538, 0x568],
	[0x539, 0x569],
	[0x53a, 0x56a],
	[0x53b, 0x56b],
	[0x53c, 0x56c],
	[0x53d, 0x56d],
	[0x53e, 0x56e],
	[0x53f, 0x56f],
	[0x540, 0x570],
	[0x541, 0x571],
	[0x542, 0x572],
	[0x543, 0x573],
	[0x544, 0x574],
	[0x545, 0x575],
	[0x546, 0x576],
	[0x547, 0x577],
	[0x548, 0x578],
	[0x549, 0x579],
	[0x54a, 0x57a],
	[0x54b, 0x57b],
	[0x54c, 0x57c],
	[0x54d, 0x57d],
	[0x54e, 0x57e],
	[0x54f, 0x57f],
	[0x550, 0x580],
	[0x551, 0x581],
	[0x552, 0x582],
	[0x553, 0x583],
	[0x554, 0x584],
	[0x555, 0x585],
	[0x556, 0x586],
	[0x10a0, 0x2d00],
	[0x10a1, 0x2d01],
	[0x10a2, 0x2d02],
	[0x10a3, 0x2d03],
	[0x10a4, 0x2d04],
	[0x10a5, 0x2d05],
	[0x10a6, 0x2d06],
	[0x10a7, 0x2d07],
	[0x10a8, 0x2d08],
	[0x10a9, 0x2d09],
	[0x10aa, 0x2d0a],
	[0x10ab, 0x2d0b],
	[0x10ac, 0x2d0c],
	[0x10ad, 0x2d0d],
	[0x10ae, 0x2d0e],
	[0x10af, 0x2d0f],
	[0x10b0, 0x2d10],
	[0x10b1, 0x2d11],
	[0x10b2, 0x2d12],
	[0x10b3, 0x2d13],
	[0x10b4, 0x2d14],
	[0x10b5, 0x2d15],
	[0x10b6, 0x2d16],
	[0x10b7, 0x2d17],
	[0x10b8, 0x2d18],
	[0x10b9, 0x2d19],
	[0x10ba, 0x2d1a],
	[0x10bb, 0x2d1b],
	[0x10bc, 0x2d1c],
	[0x10bd, 0x2d1d],
	[0x10be, 0x2d1e],
	[0x10bf, 0x2d1f],
	[0x10c0, 0x2d20],
	[0x10c1, 0x2d21],
	[0x10c2, 0x2d22],
	[0x10c3, 0x2d23],
	[0x10c4, 0x2d24],
	[0x10c5, 0x2d25],
	[0x10c7, 0x2d27],
	[0x10cd, 0x2d2d],
	[0x13f8, 0x13f0],
	[0x13f9, 0x13f1],
	[0x13fa, 0x13f2],
	[0x13fb, 0x13f3],
	[0x13fc, 0x13f4],
	[0x13fd, 0x13f5],
	[0x1c80, 0x432],
	[0x1c81, 0x434],
	[0x1c82, 0x43e],
	[0x1c83, 0x441],
	[0x1c84, 0x442],
	[0x1c85, 0x442],
	[0x1c86, 0x44a],
	[0x1c87, 0x463],
	[0x1c88, 0xa64b],
	[0x1c90, 0x10d0],
	[0x1c91, 0x10d1],
	[0x1c92, 0x10d2],
	[0x1c93, 0x10d3],
	[0x1c94, 0x10d4],
	[0x1c95, 0x10d5],
	[0x1c96, 0x10d6],
	[0x1c97, 0x10d7],
	[0x1c98, 0x10d8],
	[0x1c99, 0x10d9],
	[0x1c9a, 0x10da],
	[0x1c9b, 0x10db],
	[0x1c9c, 0x10dc],
	[0x1c9d, 0x10dd],
	[0x1c9e, 0x10de],
	[0x1c9f, 0x10df],
	[0x1ca0, 0x10e0],
	[0x1ca1, 0x10e1],
	[0x1ca2, 0x10e2],
	[0x1ca3, 0x10e3],
	[0x1ca4, 0x10e4],
	[0x1ca5, 0x10e5],
	[0x1ca6, 0x10e6],
	[0x1ca7, 0x10e7],
	[0x1ca8, 0x10e8],
	[0x1ca9, 0x10e9],
	[0x1caa, 0x10ea],
	[0x1cab, 0x10eb],
	[0x1cac, 0x10ec],
	[0x1cad, 0x10ed],
	[0x1cae, 0x10ee],
	[0x1caf, 0x10ef],
	[0x1cb0, 0x10f0],
	[0x1cb1, 0x10f1],
	[0x1cb2, 0x10f2],
	[0x1cb3, 0x10f3],
	[0x1cb4, 0x10f4],
	[0x1cb5, 0x10f5],
	[0x1cb6, 0x10f6],
	[0x1cb7, 0x10f7],
	[0x1cb8, 0x10f8],
	[0x1cb9, 0x10f9],
	[0x1cba, 0x10fa],
	[0x1cbd, 0x10fd],
	[0x1cbe, 0x10fe],
	[0x1cbf, 0x10ff],
	[0x1e00, 0x1e01],
	[0x1e02, 0x1e03],
	[0x1e04, 0x1e05],
	[0x1e06, 0x1e07],
	[0x1e08, 0x1e09],
	[0x1e0a, 0x1e0b],
	[0x1e0c, 0x1e0d],
	[0x1e0e, 0x1e0f],
	[0x1e10, 0x1e11],
	[0x1e12, 0x1e13],
	[0x1e14, 0x1e15],
	[0x1e16, 0x1e17],
	[0x1e18, 0x1e19],
	[0x1e1a, 0x1e1b],
	[0x1e1c, 0x1e1d],
	[0x1e1e, 0x1e1f],
	[0x1e20, 0x1e21],
	[0x1e22, 0x1e23],
	[0x1e24, 0x1e25],
	[0x1e26, 0x1e27],
	[0x1e28, 0x1e29],
	[0x1e2a, 0x1e2b],
	[0x1e2c, 0x1e2d],
	[0x1e2e, 0x1e2f],
	[0x1e30, 0x1e31],
	[0x1e32, 0x1e33],
	[0x1e34, 0x1e35],
	[0x1e36, 0x1e37],
	[0x1e38, 0x1e39],
	[0x1e3a, 0x1e3b],
	[0x1e3c, 0x1e3d],
	[0x1e3e, 0x1e3f],
	[0x1e40, 0x1e41],
	[0x1e42, 0x1e43],
	[0x1e44, 0x1e45],
	[0x1e46, 0x1e47],
	[0x1e48, 0x1e49],
	[0x1e4a, 0x1e4b],
	[0x1e4c, 0x1e4d],
	[0x1e4e, 0x1e4f],
	[0x1e50, 0x1e51],
	[0x1e52, 0x1e53],
	[0x1e54, 0x1e55],
	[0x1e56, 0x1e57],
	[0x1e58, 0x1e59],
	[0x1e5a, 0x1e5b],
	[0x1e5c, 0x1e5d],
	[0x1e5e, 0x1e5f],
	[0x1e60, 0x1e61],
	[0x1e62, 0x1e63],
	[0x1e64, 0x1e65],
	[0x1e66, 0x1e67],
	[0x1e68, 0x1e69],
	[0x1e6a, 0x1e6b],
	[0x1e6c, 0x1e6d],
	[0x1e6e, 0x1e6f],
	[0x1e70, 0x1e71],
	[0x1e72, 0x1e73],
	[0x1e74, 0x1e75],
	[0x1e76, 0x1e77],
	[0x1e78, 0x1e79],
	[0x1e7a, 0x1e7b],
	[0x1e7c, 0x1e7d],
	[0x1e7e, 0x1e7f],
	[0x1e80, 0x1e81],
	[0x1e82, 0x1e83],
	[0x1e84, 0x1e85],
	[0x1e86, 0x1e87],
	[0x1e88, 0x1e89],
	[0x1e8a, 0x1e8b],
	[0x1e8c, 0x1e8d],
	[0x1e8e, 0x1e8f],
	[0x1e90, 0x1e91],
	[0x1e92, 0x1e93],
	[0x1e94, 0x1e95],
	[0x1e9b, 0x1e61],
	[0x1ea0, 0x1ea1],
	[0x1ea2, 0x1ea3],
	[0x1ea4, 0x1ea5],
	[0x1ea6, 0x1ea7],
	[0x1ea8, 0x1ea9],
	[0x1eaa, 0x1eab],
	[0x1eac, 0x1ead],
	[0x1eae, 0x1eaf],
	[0x1eb0, 0x1eb1],
	[0x1eb2, 0x1eb3],
	[0x1eb4, 0x1eb5],
	[0x1eb6, 0x1eb7],
	[0x1eb8, 0x1eb9],
	[0x1eba, 0x1ebb],
	[0x1ebc, 0x1ebd],
	[0x1ebe, 0x1ebf],
	[0x1ec0, 0x1ec1],
	[0x1ec2, 0x1ec3],
	[0x1ec4, 0x1ec5],
	[0x1ec6, 0x1ec7],
	[0x1ec8, 0x1ec9],
	[0x1eca, 0x1ecb],
	[0x1ecc, 0x1ecd],
	[0x1ece, 0x1ecf],
	[0x1ed0, 0x1ed1],
	[0x1ed2, 0x1ed3],
	[0x1ed4, 0x1ed5],
	[0x1ed6, 0x1ed7],
	[0x1ed8, 0x1ed9],
	[0x1eda, 0x1edb],
	[0x1edc, 0x1edd],
	[0x1ede, 0x1edf],
	[0x1ee0, 0x1ee1],
	[0x1ee2, 0x1ee3],
	[0x1ee4, 0x1ee5],
	[0x1ee6, 0x1ee7],
	[0x1ee8, 0x1ee9],
	[0x1eea, 0x1eeb],
	[0x1eec, 0x1eed],
	[0x1eee, 0x1eef],
	[0x1ef0, 0x1ef1],
	[0x1ef2, 0x1ef3],
	[0x1ef4, 0x1ef5],
	[0x1ef6, 0x1ef7],
	[0x1ef8, 0x1ef9],
	[0x1efa, 0x1efb],
	[0x1efc, 0x1efd],
	[0x1efe, 0x1eff],
	[0x1f08, 0x1f00],
	[0x1f09, 0x1f01],
	[0x1f0a, 0x1f02],
	[0x1f0b, 0x1f03],
	[0x1f0c, 0x1f04],
	[0x1f0d, 0x1f05],
	[0x1f0e, 0x1f06],
	[0x1f0f, 0x1f07],
	[0x1f18, 0x1f10],
	[0x1f19, 0x1f11],
	[0x1f1a, 0x1f12],
	[0x1f1b, 0x1f13],
	[0x1f1c, 0x1f14],
	[0x1f1d, 0x1f15],
	[0x1f28, 0x1f20],
	[0x1f29, 0x1f21],
	[0x1f2a, 0x1f22],
	[0x1f2b, 0x1f23],
	[0x1f2c, 0x1f24],
	[0x1f2d, 0x1f25],
	[0x1f2e, 0x1f26],
	[0x1f2f, 0x1f27],
	[0x1f38, 0x1f30],
	[0x1f39, 0x1f31],
	[0x1f3a, 0x1f32],
	[0x1f3b, 0x1f33],
	[0x1f3c, 0x1f34],
	[0x1f3d, 0x1f35],
	[0x1f3e, 0x1f36],
	[0x1f3f, 0x1f37],
	[0x1f48, 0x1f40],
	[0x1f49, 0x1f41],
	[0x1f4a, 0x1f42],
	[0x1f4b, 0x1f43],
	[0x1f4c, 0x1f44],
	[0x1f4d, 0x1f45],
	[0x1f59, 0x1f51],
	[0x1f5b, 0x1f53],
	[0x1f5d, 0x1f55],
	[0x1f5f, 0x1f57],
	[0x1f68, 0x1f60],
	[0x1f69, 0x1f61],
	[0x1f6a, 0x1f62],
	[0x1f6b, 0x1f63],
	[0x1f6c, 0x1f64],
	[0x1f6d, 0x1f65],
	[0x1f6e, 0x1f66],
	[0x1f6f, 0x1f67],
	[0x1fb8, 0x1fb0],
	[0x1fb9, 0x1fb1],
	[0x1fba, 0x1f70],
	[0x1fbb, 0x1f71],
	[0x1fbe, 0x3b9],
	[0x1fc8, 0x1f72],
	[0x1fc9, 0x1f73],
	[0x1fca, 0x1f74],
	[0x1fcb, 0x1f75],
	[0x1fd8, 0x1fd0],
	[0x1fd9, 0x1fd1],
	[0x1fda, 0x1f76],
	[0x1fdb, 0x1f77],
	[0x1fe8, 0x1fe0],
	[0x1fe9, 0x1fe1],
	[0x1fea, 0x1f7a],
	[0x1feb, 0x1f7b],
	[0x1fec, 0x1fe5],
	[0x1ff8, 0x1f78],
	[0x1ff9, 0x1f79],
	[0x1ffa, 0x1f7c],
	[0x1ffb, 0x1f7d],
	[0x2126, 0x3c9],
	[0x212a, 0x6b],
	[0x212b, 0xe5],
	[0x2132, 0x214e],
	[0x2160, 0x2170],
	[0x2161, 0x2171],
	[0x2162, 0x2172],
	[0x2163, 0x2173],
	[0x2164, 0x2174],
	[0x2165, 0x2175],
	[0x2166, 0x2176],
	[0x2167, 0x2177],
	[0x2168, 0x2178],
	[0x2169, 0x2179],
	[0x216a, 0x217a],
	[0x216b, 0x217b],
	[0x216c, 0x217c],
	[0x216d, 0x217d],
	[0x216e, 0x217e],
	[0x216f, 0x217f],
	[0x2183, 0x2184],
	[0x24b6, 0x24d0],
	[0x24b7, 0x24d1],
	[0x24b8, 0x24d2],
	[0x24b9, 0x24d3],
	[0x24ba, 0x24d4],
	[0x24bb, 0x24d5],
	[0x24bc, 0x24d6],
	[0x24bd, 0x24d7],
	[0x24be, 0x24d8],
	[0x24bf, 0x24d9],
	[0x24c0, 0x24da],
	[0x24c1, 0x24db],
	[0x24c2, 0x24dc],
	[0x24c3, 0x24dd],
	[0x24c4, 0x24de],
	[0x24c5, 0x24df],
	[0x24c6, 0x24e0],
	[0x24c7, 0x24e1],
	[0x24c8, 0x24e2],
	[0x24c9, 0x24e3],
	[0x24ca, 0x24e4],
	[0x24cb, 0x24e5],
	[0x24cc, 0x24e6],
	[0x24cd, 0x24e7],
	[0x24ce, 0x24e8],
	[0x24cf, 0x24e9],
	[0x2c00, 0x2c30],
	[0x2c01, 0x2c31],
	[0x2c02, 0x2c32],
	[0x2c03, 0x2c33],
	[0x2c04, 0x2c34],
	[0x2c05, 0x2c35],
	[0x2c06, 0x2c36],
	[0x2c07, 0x2c37],
	[0x2c08, 0x2c38],
	[0x2c09, 0x2c39],
	[0x2c0a, 0x2c3a],
	[0x2c0b, 0x2c3b],
	[0x2c0c, 0x2c3c],
	[0x2c0d, 0x2c3d],
	[0x2c0e, 0x2c3e],
	[0x2c0f, 0x2c3f],
	[0x2c10, 0x2c40],
	[0x2c11, 0x2c41],
	[0x2c12, 0x2c42],
	[0x2c13, 0x2c43],
	[0x2c14, 0x2c44],
	[0x2c15, 0x2c45],
	[0x2c16, 0x2c46],
	[0x2c17, 0x2c47],
	[0x2c18, 0x2c48],
	[0x2c19, 0x2c49],
	[0x2c1a, 0x2c4a],
	[0x2c1b, 0x2c4b],
	[0x2c1c, 0x2c4c],
	[0x2c1d, 0x2c4d],
	[0x2c1e, 0x2c4e],
	[0x2c1f, 0x2c4f],
	[0x2c20, 0x2c50],
	[0x2c21, 0x2c51],
	[0x2c22, 0x2c52],
	[0x2c23, 0x2c53],
	[0x2c24, 0x2c54],
	[0x2c25, 0x2c55],
	[0x2c26, 0x2c56],
	[0x2c27, 0x2c57],
	[0x2c28, 0x2c58],
	[0x2c29, 0x2c59],
	[0x2c2a, 0x2c5a],
	[0x2c2b, 0x2c5b],
	[0x2c2c, 0x2c5c],
	[0x2c2d, 0x2c5d],
	[0x2c2e, 0x2c5e],
	[0x2c60, 0x2c61],
	[0x2c62, 0x26b],
	[0x2c63, 0x1d7d],
	[0x2c64, 0x27d],
	[0x2c67, 0x2c68],
	[0x2c69, 0x2c6a],
	[0x2c6b, 0x2c6c],
	[0x2c6d, 0x251],
	[0x2c6e, 0x271],
	[0x2c6f, 0x250],
	[0x2c70, 0x252],
	[0x2c72, 0x2c73],
	[0x2c75, 0x2c76],
	[0x2c7e, 0x23f],
	[0x2c7f, 0x240],
	[0x2c80, 0x2c81],
	[0x2c82, 0x2c83],
	[0x2c84, 0x2c85],
	[0x2c86, 0x2c87],
	[0x2c88, 0x2c89],
	[0x2c8a, 0x2c8b],
	[0x2c8c, 0x2c8d],
	[0x2c8e, 0x2c8f],
	[0x2c90, 0x2c91],
	[0x2c92, 0x2c93],
	[0x2c94, 0x2c95],
	[0x2c96, 0x2c97],
	[0x2c98, 0x2c99],
	[0x2c9a, 0x2c9b],
	[0x2c9c, 0x2c9d],
	[0x2c9e, 0x2c9f],
	[0x2ca0, 0x2ca1],
	[0x2ca2, 0x2ca3],
	[0x2ca4, 0x2ca5],
	[0x2ca6, 0x2ca7],
	[0x2ca8, 0x2ca9],
	[0x2caa, 0x2cab],
	[0x2cac, 0x2cad],
	[0x2cae, 0x2caf],
	[0x2cb0, 0x2cb1],
	[0x2cb2, 0x2cb3],
	[0x2cb4, 0x2cb5],
	[0x2cb6, 0x2cb7],
	[0x2cb8, 0x2cb9],
	[0x2cba, 0x2cbb],
	[0x2cbc, 0x2cbd],
	[0x2cbe, 0x2cbf],
	[0x2cc0, 0x2cc1],
	[0x2cc2, 0x2cc3],
	[0x2cc4, 0x2cc5],
	[0x2cc6, 0x2cc7],
	[0x2cc8, 0x2cc9],
	[0x2cca, 0x2ccb],
	[0x2ccc, 0x2ccd],
	[0x2cce, 0x2ccf],
	[0x2cd0, 0x2cd1],
	[0x2cd2, 0x2cd3],
	[0x2cd4, 0x2cd5],
	[0x2cd6, 0x2cd7],
	[0x2cd8, 0x2cd9],
	[0x2cda, 0x2cdb],
	[0x2cdc, 0x2cdd],
	[0x2cde, 0x2cdf],
	[0x2ce0, 0x2ce1],
	[0x2ce2, 0x2ce3],
	[0x2ceb, 0x2cec],
	[0x2ced, 0x2cee],
	[0x2cf2, 0x2cf3],
	[0xa640, 0xa641],
	[0xa642, 0xa643],
	[0xa644, 0xa645],
	[0xa646, 0xa647],
	[0xa648, 0xa649],
	[0xa64a, 0xa64b],
	[0xa64c, 0xa64d],
	[0xa64e, 0xa64f],
	[0xa650, 0xa651],
	[0xa652, 0xa653],
	[0xa654, 0xa655],
	[0xa656, 0xa657],
	[0xa658, 0xa659],
	[0xa65a, 0xa65b],
	[0xa65c, 0xa65d],
	[0xa65e, 0xa65f],
	[0xa660, 0xa661],
	[0xa662, 0xa663],
	[0xa664, 0xa665],
	[0xa666, 0xa667],
	[0xa668, 0xa669],
	[0xa66a, 0xa66b],
	[0xa66c, 0xa66d],
	[0xa680, 0xa681],
	[0xa682, 0xa683],
	[0xa684, 0xa685],
	[0xa686, 0xa687],
	[0xa688, 0xa689],
	[0xa68a, 0xa68b],
	[0xa68c, 0xa68d],
	[0xa68e, 0xa68f],
	[0xa690, 0xa691],
	[0xa692, 0xa693],
	[0xa694, 0xa695],
	[0xa696, 0xa697],
	[0xa698, 0xa699],
	[0xa69a, 0xa69b],
	[0xa722, 0xa723],
	[0xa724, 0xa725],
	[0xa726, 0xa727],
	[0xa728, 0xa729],
	[0xa72a, 0xa72b],
	[0xa72c, 0xa72d],
	[0xa72e, 0xa72f],
	[0xa732, 0xa733],
	[0xa734, 0xa735],
	[0xa736, 0xa737],
	[0xa738, 0xa739],
	[0xa73a, 0xa73b],
	[0xa73c, 0xa73d],
	[0xa73e, 0xa73f],
	[0xa740, 0xa741],
	[0xa742, 0xa743],
	[0xa744, 0xa745],
	[0xa746, 0xa747],
	[0xa748, 0xa749],
	[0xa74a, 0xa74b],
	[0xa74c, 0xa74d],
	[0xa74e, 0xa74f],
	[0xa750, 0xa751],
	[0xa752, 0xa753],
	[0xa754, 0xa755],
	[0xa756, 0xa757],
	[0xa758, 0xa759],
	[0xa75a, 0xa75b],
	[0xa75c, 0xa75d],
	[0xa75e, 0xa75f],
	[0xa760, 0xa761],
	[0xa762, 0xa763],
	[0xa764, 0xa765],
	[0xa766, 0xa767],
	[0xa768, 0xa769],
	[0xa76a, 0xa76b],
	[0xa76c, 0xa76d],
	[0xa76e, 0xa76f],
	[0xa779, 0xa77a],
	[0xa77b, 0xa77c],
	[0xa77d, 0x1d79],
	[0xa77e, 0xa77f],
	[0xa780, 0xa781],
	[0xa782, 0xa783],
	[0xa784, 0xa785],
	[0xa786, 0xa787],
	[0xa78b, 0xa78c],
	[0xa78d, 0x265],
	[0xa790, 0xa791],
	[0xa792, 0xa793],
	[0xa796, 0xa797],
	[0xa798, 0xa799],
	[0xa79a, 0xa79b],
	[0xa79c, 0xa79d],
	[0xa79e, 0xa79f],
	[0xa7a0, 0xa7a1],
	[0xa7a2, 0xa7a3],
	[0xa7a4, 0xa7a5],
	[0xa7a6, 0xa7a7],
	[0xa7a8, 0xa7a9],
	[0xa7aa, 0x266],
	[0xa7ab, 0x25c],
	[0xa7ac, 0x261],
	[0xa7ad, 0x26c],
	[0xa7ae, 0x26a],
	[0xa7b0, 0x29e],
	[0xa7b1, 0x287],
	[0xa7b2, 0x29d],
	[0xa7b3, 0xab53],
	[0xa7b4, 0xa7b5],
	[0xa7b6, 0xa7b7],
	[0xa7b8, 0xa7b9],
	[0xa7ba, 0xa7bb],
	[0xa7bc, 0xa7bd],
	[0xa7be, 0xa7bf],
	[0xa7c2, 0xa7c3],
	[0xa7c4, 0xa794],
	[0xa7c5, 0x282],
	[0xa7c6, 0x1d8e],
	[0xab70, 0x13a0],
	[0xab71, 0x13a1],
	[0xab72, 0x13a2],
	[0xab73, 0x13a3],
	[0xab74, 0x13a4],
	[0xab75, 0x13a5],
	[0xab76, 0x13a6],
	[0xab77, 0x13a7],
	[0xab78, 0x13a8],
	[0xab79, 0x13a9],
	[0xab7a, 0x13aa],
	[0xab7b, 0x13ab],
	[0xab7c, 0x13ac],
	[0xab7d, 0x13ad],
	[0xab7e, 0x13ae],
	[0xab7f, 0x13af],
	[0xab80, 0x13b0],
	[0xab81, 0x13b1],
	[0xab82, 0x13b2],
	[0xab83, 0x13b3],
	[0xab84, 0x13b4],
	[0xab85, 0x13b5],
	[0xab86, 0x13b6],
	[0xab87, 0x13b7],
	[0xab88, 0x13b8],
	[0xab89, 0x13b9],
	[0xab8a, 0x13ba],
	[0xab8b, 0x13bb],
	[0xab8c, 0x13bc],
	[0xab8d, 0x13bd],
	[0xab8e, 0x13be],
	[0xab8f, 0x13bf],
	[0xab90, 0x13c0],
	[0xab91, 0x13c1],
	[0xab92, 0x13c2],
	[0xab93, 0x13c3],
	[0xab94, 0x13c4],
	[0xab95, 0x13c5],
	[0xab96, 0x13c6],
	[0xab97, 0x13c7],
	[0xab98, 0x13c8],
	[0xab99, 0x13c9],
	[0xab9a, 0x13ca],
	[0xab9b, 0x13cb],
	[0xab9c, 0x13cc],
	[0xab9d, 0x13cd],
	[0xab9e, 0x13ce],
	[0xab9f, 0x13cf],
	[0xaba0, 0x13d0],
	[0xaba1, 0x13d1],
	[0xaba2, 0x13d2],
	[0xaba3, 0x13d3],
	[0xaba4, 0x13d4],
	[0xaba5, 0x13d5],
	[0xaba6, 0x13d6],
	[0xaba7, 0x13d7],
	[0xaba8, 0x13d8],
	[0xaba9, 0x13d9],
	[0xabaa, 0x13da],
	[0xabab, 0x13db],
	[0xabac, 0x13dc],
	[0xabad, 0x13dd],
	[0xabae, 0x13de],
	[0xabaf, 0x13df],
	[0xabb0, 0x13e0],
	[0xabb1, 0x13e1],
	[0xabb2, 0x13e2],
	[0xabb3, 0x13e3],
	[0xabb4, 0x13e4],
	[0xabb5, 0x13e5],
	[0xabb6, 0x13e6],
	[0xabb7, 0x13e7],
	[0xabb8, 0x13e8],
	[0xabb9, 0x13e9],
	[0xabba, 0x13ea],
	[0xabbb, 0x13eb],
	[0xabbc, 0x13ec],
	[0xabbd, 0x13ed],
	[0xabbe, 0x13ee],
	[0xabbf, 0x13ef],
	[0xff21, 0xff41],
	[0xff22, 0xff42],
	[0xff23, 0xff43],
	[0xff24, 0xff44],
	[0xff25, 0xff45],
	[0xff26, 0xff46],
	[0xff27, 0xff47],
	[0xff28, 0xff48],
	[0xff29, 0xff49],
	[0xff2a, 0xff4a],
	[0xff2b, 0xff4b],
	[0xff2c, 0xff4c],
	[0xff2d, 0xff4d],
	[0xff2e, 0xff4e],
	[0xff2f, 0xff4f],
	[0xff30, 0xff50],
	[0xff31, 0xff51],
	[0xff32, 0xff52],
	[0xff33, 0xff53],
	[0xff34, 0xff54],
	[0xff35, 0xff55],
	[0xff36, 0xff56],
	[0xff37, 0xff57],
	[0xff38, 0xff58],
	[0xff39, 0xff59],
	[0xff3a, 0xff5a],
	[0x10400, 0x10428],
	[0x10401, 0x10429],
	[0x10402, 0x1042a],
	[0x10403, 0x1042b],
	[0x10404, 0x1042c],
	[0x10405, 0x1042d],
	[0x10406, 0x1042e],
	[0x10407, 0x1042f],
	[0x10408, 0x10430],
	[0x10409, 0x10431],
	[0x1040a, 0x10432],
	[0x1040b, 0x10433],
	[0x1040c, 0x10434],
	[0x1040d, 0x10435],
	[0x1040e, 0x10436],
	[0x1040f, 0x10437],
	[0x10410, 0x10438],
	[0x10411, 0x10439],
	[0x10412, 0x1043a],
	[0x10413, 0x1043b],
	[0x10414, 0x1043c],
	[0x10415, 0x1043d],
	[0x10416, 0x1043e],
	[0x10417, 0x1043f],
	[0x10418, 0x10440],
	[0x10419, 0x10441],
	[0x1041a, 0x10442],
	[0x1041b, 0x10443],
	[0x1041c, 0x10444],
	[0x1041d, 0x10445],
	[0x1041e, 0x10446],
	[0x1041f, 0x10447],
	[0x10420, 0x10448],
	[0x10421, 0x10449],
	[0x10422, 0x1044a],
	[0x10423, 0x1044b],
	[0x10424, 0x1044c],
	[0x10425, 0x1044d],
	[0x10426, 0x1044e],
	[0x10427, 0x1044f],
	[0x104b0, 0x104d8],
	[0x104b1, 0x104d9],
	[0x104b2, 0x104da],
	[0x104b3, 0x104db],
	[0x104b4, 0x104dc],
	[0x104b5, 0x104dd],
	[0x104b6, 0x104de],
	[0x104b7, 0x104df],
	[0x104b8, 0x104e0],
	[0x104b9, 0x104e1],
	[0x104ba, 0x104e2],
	[0x104bb, 0x104e3],
	[0x104bc, 0x104e4],
	[0x104bd, 0x104e5],
	[0x104be, 0x104e6],
	[0x104bf, 0x104e7],
	[0x104c0, 0x104e8],
	[0x104c1, 0x104e9],
	[0x104c2, 0x104ea],
	[0x104c3, 0x104eb],
	[0x104c4, 0x104ec],
	[0x104c5, 0x104ed],
	[0x104c6, 0x104ee],
	[0x104c7, 0x104ef],
	[0x104c8, 0x104f0],
	[0x104c9, 0x104f1],
	[0x104ca, 0x104f2],
	[0x104cb, 0x104f3],
	[0x104cc, 0x104f4],
	[0x104cd, 0x104f5],
	[0x104ce, 0x104f6],
	[0x104cf, 0x104f7],
	[0x104d0, 0x104f8],
	[0x104d1, 0x104f9],
	[0x104d2, 0x104fa],
	[0x104d3, 0x104fb],
	[0x10c80, 0x10cc0],
	[0x10c81, 0x10cc1],
	[0x10c82, 0x10cc2],
	[0x10c83, 0x10cc3],
	[0x10c84, 0x10cc4],
	[0x10c85, 0x10cc5],
	[0x10c86, 0x10cc6],
	[0x10c87, 0x10cc7],
	[0x10c88, 0x10cc8],
	[0x10c89, 0x10cc9],
	[0x10c8a, 0x10cca],
	[0x10c8b, 0x10ccb],
	[0x10c8c, 0x10ccc],
	[0x10c8d, 0x10ccd],
	[0x10c8e, 0x10cce],
	[0x10c8f, 0x10ccf],
	[0x10c90, 0x10cd0],
	[0x10c91, 0x10cd1],
	[0x10c92, 0x10cd2],
	[0x10c93, 0x10cd3],
	[0x10c94, 0x10cd4],
	[0x10c95, 0x10cd5],
	[0x10c96, 0x10cd6],
	[0x10c97, 0x10cd7],
	[0x10c98, 0x10cd8],
	[0x10c99, 0x10cd9],
	[0x10c9a, 0x10cda],
	[0x10c9b, 0x10cdb],
	[0x10c9c, 0x10cdc],
	[0x10c9d, 0x10cdd],
	[0x10c9e, 0x10cde],
	[0x10c9f, 0x10cdf],
	[0x10ca0, 0x10ce0],
	[0x10ca1, 0x10ce1],
	[0x10ca2, 0x10ce2],
	[0x10ca3, 0x10ce3],
	[0x10ca4, 0x10ce4],
	[0x10ca5, 0x10ce5],
	[0x10ca6, 0x10ce6],
	[0x10ca7, 0x10ce7],
	[0x10ca8, 0x10ce8],
	[0x10ca9, 0x10ce9],
	[0x10caa, 0x10cea],
	[0x10cab, 0x10ceb],
	[0x10cac, 0x10cec],
	[0x10cad, 0x10ced],
	[0x10cae, 0x10cee],
	[0x10caf, 0x10cef],
	[0x10cb0, 0x10cf0],
	[0x10cb1, 0x10cf1],
	[0x10cb2, 0x10cf2],
	[0x118a0, 0x118c0],
	[0x118a1, 0x118c1],
	[0x118a2, 0x118c2],
	[0x118a3, 0x118c3],
	[0x118a4, 0x118c4],
	[0x118a5, 0x118c5],
	[0x118a6, 0x118c6],
	[0x118a7, 0x118c7],
	[0x118a8, 0x118c8],
	[0x118a9, 0x118c9],
	[0x118aa, 0x118ca],
	[0x118ab, 0x118cb],
	[0x118ac, 0x118cc],
	[0x118ad, 0x118cd],
	[0x118ae, 0x118ce],
	[0x118af, 0x118cf],
	[0x118b0, 0x118d0],
	[0x118b1, 0x118d1],
	[0x118b2, 0x118d2],
	[0x118b3, 0x118d3],
	[0x118b4, 0x118d4],
	[0x118b5, 0x118d5],
	[0x118b6, 0x118d6],
	[0x118b7, 0x118d7],
	[0x118b8, 0x118d8],
	[0x118b9, 0x118d9],
	[0x118ba, 0x118da],
	[0x118bb, 0x118db],
	[0x118bc, 0x118dc],
	[0x118bd, 0x118dd],
	[0x118be, 0x118de],
	[0x118bf, 0x118df],
	[0x16e40, 0x16e60],
	[0x16e41, 0x16e61],
	[0x16e42, 0x16e62],
	[0x16e43, 0x16e63],
	[0x16e44, 0x16e64],
	[0x16e45, 0x16e65],
	[0x16e46, 0x16e66],
	[0x16e47, 0x16e67],
	[0x16e48, 0x16e68],
	[0x16e49, 0x16e69],
	[0x16e4a, 0x16e6a],
	[0x16e4b, 0x16e6b],
	[0x16e4c, 0x16e6c],
	[0x16e4d, 0x16e6d],
	[0x16e4e, 0x16e6e],
	[0x16e4f, 0x16e6f],
	[0x16e50, 0x16e70],
	[0x16e51, 0x16e71],
	[0x16e52, 0x16e72],
	[0x16e53, 0x16e73],
	[0x16e54, 0x16e74],
	[0x16e55, 0x16e75],
	[0x16e56, 0x16e76],
	[0x16e57, 0x16e77],
	[0x16e58, 0x16e78],
	[0x16e59, 0x16e79],
	[0x16e5a, 0x16e7a],
	[0x16e5b, 0x16e7b],
	[0x16e5c, 0x16e7c],
	[0x16e5d, 0x16e7d],
	[0x16e5e, 0x16e7e],
	[0x16e5f, 0x16e7f],
	[0x1e900, 0x1e922],
	[0x1e901, 0x1e923],
	[0x1e902, 0x1e924],
	[0x1e903, 0x1e925],
	[0x1e904, 0x1e926],
	[0x1e905, 0x1e927],
	[0x1e906, 0x1e928],
	[0x1e907, 0x1e929],
	[0x1e908, 0x1e92a],
	[0x1e909, 0x1e92b],
	[0x1e90a, 0x1e92c],
	[0x1e90b, 0x1e92d],
	[0x1e90c, 0x1e92e],
	[0x1e90d, 0x1e92f],
	[0x1e90e, 0x1e930],
	[0x1e90f, 0x1e931],
	[0x1e910, 0x1e932],
	[0x1e911, 0x1e933],
	[0x1e912, 0x1e934],
	[0x1e913, 0x1e935],
	[0x1e914, 0x1e936],
	[0x1e915, 0x1e937],
	[0x1e916, 0x1e938],
	[0x1e917, 0x1e939],
	[0x1e918, 0x1e93a],
	[0x1e919, 0x1e93b],
	[0x1e91a, 0x1e93c],
	[0x1e91b, 0x1e93d],
	[0x1e91c, 0x1e93e],
	[0x1e91d, 0x1e93f],
	[0x1e91e, 0x1e940],
	[0x1e91f, 0x1e941],
	[0x1e920, 0x1e942],
	[0x1e921, 0x1e943],
	[0x1e9e, 0xdf],
	[0x1f88, 0x1f80],
	[0x1f89, 0x1f81],
	[0x1f8a, 0x1f82],
	[0x1f8b, 0x1f83],
	[0x1f8c, 0x1f84],
	[0x1f8d, 0x1f85],
	[0x1f8e, 0x1f86],
	[0x1f8f, 0x1f87],
	[0x1f98, 0x1f90],
	[0x1f99, 0x1f91],
	[0x1f9a, 0x1f92],
	[0x1f9b, 0x1f93],
	[0x1f9c, 0x1f94],
	[0x1f9d, 0x1f95],
	[0x1f9e, 0x1f96],
	[0x1f9f, 0x1f97],
	[0x1fa8, 0x1fa0],
	[0x1fa9, 0x1fa1],
	[0x1faa, 0x1fa2],
	[0x1fab, 0x1fa3],
	[0x1fac, 0x1fa4],
	[0x1fad, 0x1fa5],
	[0x1fae, 0x1fa6],
	[0x1faf, 0x1fa7],
	[0x1fbc, 0x1fb3],
	[0x1fcc, 0x1fc3],
	[0x1ffc, 0x1ff3]
]);

export const inverseFoldMap: Map<number, number[]> = new Map();
for (const [c, d] of foldMap) {
	if (!inverseFoldMap.has(d)) {
		inverseFoldMap.set(d, []);
	}
	inverseFoldMap.get(d)!.push(c);
}

export const extraWordCharacters: Set<number> = new Set([0x17f, 0x212a]);

export const category: Map<string, number[]> = new Map();
category.set("Cased_Letter", [
	65,
	91,
	97,
	123,
	181,
	182,
	192,
	215,
	216,
	247,
	248,
	443,
	444,
	448,
	452,
	660,
	661,
	688,
	880,
	884,
	886,
	888,
	891,
	894,
	895,
	896,
	902,
	903,
	904,
	907,
	908,
	909,
	910,
	930,
	931,
	1014,
	1015,
	1154,
	1162,
	1328,
	1329,
	1367,
	1376,
	1417,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	4304,
	4347,
	4349,
	4352,
	5024,
	5110,
	5112,
	5118,
	7296,
	7305,
	7312,
	7355,
	7357,
	7360,
	7424,
	7468,
	7531,
	7544,
	7545,
	7579,
	7680,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8125,
	8126,
	8127,
	8130,
	8133,
	8134,
	8141,
	8144,
	8148,
	8150,
	8156,
	8160,
	8173,
	8178,
	8181,
	8182,
	8189,
	8450,
	8451,
	8455,
	8456,
	8458,
	8468,
	8469,
	8470,
	8473,
	8478,
	8484,
	8485,
	8486,
	8487,
	8488,
	8489,
	8490,
	8494,
	8495,
	8501,
	8505,
	8506,
	8508,
	8512,
	8517,
	8522,
	8526,
	8527,
	8579,
	8581,
	11264,
	11311,
	11312,
	11359,
	11360,
	11388,
	11390,
	11493,
	11499,
	11503,
	11506,
	11508,
	11520,
	11558,
	11559,
	11560,
	11565,
	11566,
	42560,
	42606,
	42624,
	42652,
	42786,
	42864,
	42865,
	42888,
	42891,
	42895,
	42896,
	42944,
	42946,
	42951,
	43002,
	43003,
	43824,
	43867,
	43872,
	43880,
	43888,
	43968,
	64256,
	64263,
	64275,
	64280,
	65313,
	65339,
	65345,
	65371,
	66560,
	66640,
	66736,
	66772,
	66776,
	66812,
	68736,
	68787,
	68800,
	68851,
	71840,
	71904,
	93760,
	93824,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120513,
	120514,
	120539,
	120540,
	120571,
	120572,
	120597,
	120598,
	120629,
	120630,
	120655,
	120656,
	120687,
	120688,
	120713,
	120714,
	120745,
	120746,
	120771,
	120772,
	120780,
	125184,
	125252
]);
category.set("Close_Punctuation", [
	41,
	42,
	93,
	94,
	125,
	126,
	3899,
	3900,
	3901,
	3902,
	5788,
	5789,
	8262,
	8263,
	8318,
	8319,
	8334,
	8335,
	8969,
	8970,
	8971,
	8972,
	9002,
	9003,
	10089,
	10090,
	10091,
	10092,
	10093,
	10094,
	10095,
	10096,
	10097,
	10098,
	10099,
	10100,
	10101,
	10102,
	10182,
	10183,
	10215,
	10216,
	10217,
	10218,
	10219,
	10220,
	10221,
	10222,
	10223,
	10224,
	10628,
	10629,
	10630,
	10631,
	10632,
	10633,
	10634,
	10635,
	10636,
	10637,
	10638,
	10639,
	10640,
	10641,
	10642,
	10643,
	10644,
	10645,
	10646,
	10647,
	10648,
	10649,
	10713,
	10714,
	10715,
	10716,
	10749,
	10750,
	11811,
	11812,
	11813,
	11814,
	11815,
	11816,
	11817,
	11818,
	12297,
	12298,
	12299,
	12300,
	12301,
	12302,
	12303,
	12304,
	12305,
	12306,
	12309,
	12310,
	12311,
	12312,
	12313,
	12314,
	12315,
	12316,
	12318,
	12320,
	64830,
	64831,
	65048,
	65049,
	65078,
	65079,
	65080,
	65081,
	65082,
	65083,
	65084,
	65085,
	65086,
	65087,
	65088,
	65089,
	65090,
	65091,
	65092,
	65093,
	65096,
	65097,
	65114,
	65115,
	65116,
	65117,
	65118,
	65119,
	65289,
	65290,
	65341,
	65342,
	65373,
	65374,
	65376,
	65377,
	65379,
	65380
]);
category.set("Connector_Punctuation", [95, 96, 8255, 8257, 8276, 8277, 65075, 65077, 65101, 65104, 65343, 65344]);
category.set("Control", [0, 32, 127, 160]);
category.set("Currency_Symbol", [
	36,
	37,
	162,
	166,
	1423,
	1424,
	1547,
	1548,
	2046,
	2048,
	2546,
	2548,
	2555,
	2556,
	2801,
	2802,
	3065,
	3066,
	3647,
	3648,
	6107,
	6108,
	8352,
	8384,
	43064,
	43065,
	65020,
	65021,
	65129,
	65130,
	65284,
	65285,
	65504,
	65506,
	65509,
	65511,
	73693,
	73697,
	123647,
	123648,
	126128,
	126129
]);
category.set("Dash_Punctuation", [
	45,
	46,
	1418,
	1419,
	1470,
	1471,
	5120,
	5121,
	6150,
	6151,
	8208,
	8214,
	11799,
	11800,
	11802,
	11803,
	11834,
	11836,
	11840,
	11841,
	12316,
	12317,
	12336,
	12337,
	12448,
	12449,
	65073,
	65075,
	65112,
	65113,
	65123,
	65124,
	65293,
	65294
]);
category.set("Decimal_Number", [
	48,
	58,
	1632,
	1642,
	1776,
	1786,
	1984,
	1994,
	2406,
	2416,
	2534,
	2544,
	2662,
	2672,
	2790,
	2800,
	2918,
	2928,
	3046,
	3056,
	3174,
	3184,
	3302,
	3312,
	3430,
	3440,
	3558,
	3568,
	3664,
	3674,
	3792,
	3802,
	3872,
	3882,
	4160,
	4170,
	4240,
	4250,
	6112,
	6122,
	6160,
	6170,
	6470,
	6480,
	6608,
	6618,
	6784,
	6794,
	6800,
	6810,
	6992,
	7002,
	7088,
	7098,
	7232,
	7242,
	7248,
	7258,
	42528,
	42538,
	43216,
	43226,
	43264,
	43274,
	43472,
	43482,
	43504,
	43514,
	43600,
	43610,
	44016,
	44026,
	65296,
	65306,
	66720,
	66730,
	68912,
	68922,
	69734,
	69744,
	69872,
	69882,
	69942,
	69952,
	70096,
	70106,
	70384,
	70394,
	70736,
	70746,
	70864,
	70874,
	71248,
	71258,
	71360,
	71370,
	71472,
	71482,
	71904,
	71914,
	72784,
	72794,
	73040,
	73050,
	73120,
	73130,
	92768,
	92778,
	93008,
	93018,
	120782,
	120832,
	123200,
	123210,
	123632,
	123642,
	125264,
	125274
]);
category.set("Enclosing_Mark", [1160, 1162, 6846, 6847, 8413, 8417, 8418, 8421, 42608, 42611]);
category.set("Final_Punctuation", [187, 188, 8217, 8218, 8221, 8222, 8250, 8251, 11779, 11780, 11781, 11782, 11786, 11787, 11789, 11790, 11805, 11806, 11809, 11810]);
category.set("Format", [
	173,
	174,
	1536,
	1542,
	1564,
	1565,
	1757,
	1758,
	1807,
	1808,
	2274,
	2275,
	6158,
	6159,
	8203,
	8208,
	8234,
	8239,
	8288,
	8293,
	8294,
	8304,
	65279,
	65280,
	65529,
	65532,
	69821,
	69822,
	69837,
	69838,
	78896,
	78905,
	113824,
	113828,
	119155,
	119163,
	917505,
	917506,
	917536,
	917632
]);
category.set("Initial_Punctuation", [171, 172, 8216, 8217, 8219, 8221, 8223, 8224, 8249, 8250, 11778, 11779, 11780, 11781, 11785, 11786, 11788, 11789, 11804, 11805, 11808, 11809]);
category.set("Letter", [
	65,
	91,
	97,
	123,
	170,
	171,
	181,
	182,
	186,
	187,
	192,
	215,
	216,
	247,
	248,
	706,
	710,
	722,
	736,
	741,
	748,
	749,
	750,
	751,
	880,
	885,
	886,
	888,
	890,
	894,
	895,
	896,
	902,
	903,
	904,
	907,
	908,
	909,
	910,
	930,
	931,
	1014,
	1015,
	1154,
	1162,
	1328,
	1329,
	1367,
	1369,
	1370,
	1376,
	1417,
	1488,
	1515,
	1519,
	1523,
	1568,
	1611,
	1646,
	1648,
	1649,
	1748,
	1749,
	1750,
	1765,
	1767,
	1774,
	1776,
	1786,
	1789,
	1791,
	1792,
	1808,
	1809,
	1810,
	1840,
	1869,
	1958,
	1969,
	1970,
	1994,
	2027,
	2036,
	2038,
	2042,
	2043,
	2048,
	2070,
	2074,
	2075,
	2084,
	2085,
	2088,
	2089,
	2112,
	2137,
	2144,
	2155,
	2208,
	2229,
	2230,
	2238,
	2308,
	2362,
	2365,
	2366,
	2384,
	2385,
	2392,
	2402,
	2417,
	2433,
	2437,
	2445,
	2447,
	2449,
	2451,
	2473,
	2474,
	2481,
	2482,
	2483,
	2486,
	2490,
	2493,
	2494,
	2510,
	2511,
	2524,
	2526,
	2527,
	2530,
	2544,
	2546,
	2556,
	2557,
	2565,
	2571,
	2575,
	2577,
	2579,
	2601,
	2602,
	2609,
	2610,
	2612,
	2613,
	2615,
	2616,
	2618,
	2649,
	2653,
	2654,
	2655,
	2674,
	2677,
	2693,
	2702,
	2703,
	2706,
	2707,
	2729,
	2730,
	2737,
	2738,
	2740,
	2741,
	2746,
	2749,
	2750,
	2768,
	2769,
	2784,
	2786,
	2809,
	2810,
	2821,
	2829,
	2831,
	2833,
	2835,
	2857,
	2858,
	2865,
	2866,
	2868,
	2869,
	2874,
	2877,
	2878,
	2908,
	2910,
	2911,
	2914,
	2929,
	2930,
	2947,
	2948,
	2949,
	2955,
	2958,
	2961,
	2962,
	2966,
	2969,
	2971,
	2972,
	2973,
	2974,
	2976,
	2979,
	2981,
	2984,
	2987,
	2990,
	3002,
	3024,
	3025,
	3077,
	3085,
	3086,
	3089,
	3090,
	3113,
	3114,
	3130,
	3133,
	3134,
	3160,
	3163,
	3168,
	3170,
	3200,
	3201,
	3205,
	3213,
	3214,
	3217,
	3218,
	3241,
	3242,
	3252,
	3253,
	3258,
	3261,
	3262,
	3294,
	3295,
	3296,
	3298,
	3313,
	3315,
	3333,
	3341,
	3342,
	3345,
	3346,
	3387,
	3389,
	3390,
	3406,
	3407,
	3412,
	3415,
	3423,
	3426,
	3450,
	3456,
	3461,
	3479,
	3482,
	3506,
	3507,
	3516,
	3517,
	3518,
	3520,
	3527,
	3585,
	3633,
	3634,
	3636,
	3648,
	3655,
	3713,
	3715,
	3716,
	3717,
	3718,
	3723,
	3724,
	3748,
	3749,
	3750,
	3751,
	3761,
	3762,
	3764,
	3773,
	3774,
	3776,
	3781,
	3782,
	3783,
	3804,
	3808,
	3840,
	3841,
	3904,
	3912,
	3913,
	3949,
	3976,
	3981,
	4096,
	4139,
	4159,
	4160,
	4176,
	4182,
	4186,
	4190,
	4193,
	4194,
	4197,
	4199,
	4206,
	4209,
	4213,
	4226,
	4238,
	4239,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	4304,
	4347,
	4348,
	4681,
	4682,
	4686,
	4688,
	4695,
	4696,
	4697,
	4698,
	4702,
	4704,
	4745,
	4746,
	4750,
	4752,
	4785,
	4786,
	4790,
	4792,
	4799,
	4800,
	4801,
	4802,
	4806,
	4808,
	4823,
	4824,
	4881,
	4882,
	4886,
	4888,
	4955,
	4992,
	5008,
	5024,
	5110,
	5112,
	5118,
	5121,
	5741,
	5743,
	5760,
	5761,
	5787,
	5792,
	5867,
	5873,
	5881,
	5888,
	5901,
	5902,
	5906,
	5920,
	5938,
	5952,
	5970,
	5984,
	5997,
	5998,
	6001,
	6016,
	6068,
	6103,
	6104,
	6108,
	6109,
	6176,
	6265,
	6272,
	6277,
	6279,
	6313,
	6314,
	6315,
	6320,
	6390,
	6400,
	6431,
	6480,
	6510,
	6512,
	6517,
	6528,
	6572,
	6576,
	6602,
	6656,
	6679,
	6688,
	6741,
	6823,
	6824,
	6917,
	6964,
	6981,
	6988,
	7043,
	7073,
	7086,
	7088,
	7098,
	7142,
	7168,
	7204,
	7245,
	7248,
	7258,
	7294,
	7296,
	7305,
	7312,
	7355,
	7357,
	7360,
	7401,
	7405,
	7406,
	7412,
	7413,
	7415,
	7418,
	7419,
	7424,
	7616,
	7680,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8125,
	8126,
	8127,
	8130,
	8133,
	8134,
	8141,
	8144,
	8148,
	8150,
	8156,
	8160,
	8173,
	8178,
	8181,
	8182,
	8189,
	8305,
	8306,
	8319,
	8320,
	8336,
	8349,
	8450,
	8451,
	8455,
	8456,
	8458,
	8468,
	8469,
	8470,
	8473,
	8478,
	8484,
	8485,
	8486,
	8487,
	8488,
	8489,
	8490,
	8494,
	8495,
	8506,
	8508,
	8512,
	8517,
	8522,
	8526,
	8527,
	8579,
	8581,
	11264,
	11311,
	11312,
	11359,
	11360,
	11493,
	11499,
	11503,
	11506,
	11508,
	11520,
	11558,
	11559,
	11560,
	11565,
	11566,
	11568,
	11624,
	11631,
	11632,
	11648,
	11671,
	11680,
	11687,
	11688,
	11695,
	11696,
	11703,
	11704,
	11711,
	11712,
	11719,
	11720,
	11727,
	11728,
	11735,
	11736,
	11743,
	11823,
	11824,
	12293,
	12295,
	12337,
	12342,
	12347,
	12349,
	12353,
	12439,
	12445,
	12448,
	12449,
	12539,
	12540,
	12544,
	12549,
	12592,
	12593,
	12687,
	12704,
	12731,
	12784,
	12800,
	13312,
	19894,
	19968,
	40944,
	40960,
	42125,
	42192,
	42238,
	42240,
	42509,
	42512,
	42528,
	42538,
	42540,
	42560,
	42607,
	42623,
	42654,
	42656,
	42726,
	42775,
	42784,
	42786,
	42889,
	42891,
	42944,
	42946,
	42951,
	42999,
	43010,
	43011,
	43014,
	43015,
	43019,
	43020,
	43043,
	43072,
	43124,
	43138,
	43188,
	43250,
	43256,
	43259,
	43260,
	43261,
	43263,
	43274,
	43302,
	43312,
	43335,
	43360,
	43389,
	43396,
	43443,
	43471,
	43472,
	43488,
	43493,
	43494,
	43504,
	43514,
	43519,
	43520,
	43561,
	43584,
	43587,
	43588,
	43596,
	43616,
	43639,
	43642,
	43643,
	43646,
	43696,
	43697,
	43698,
	43701,
	43703,
	43705,
	43710,
	43712,
	43713,
	43714,
	43715,
	43739,
	43742,
	43744,
	43755,
	43762,
	43765,
	43777,
	43783,
	43785,
	43791,
	43793,
	43799,
	43808,
	43815,
	43816,
	43823,
	43824,
	43867,
	43868,
	43880,
	43888,
	44003,
	44032,
	55204,
	55216,
	55239,
	55243,
	55292,
	63744,
	64110,
	64112,
	64218,
	64256,
	64263,
	64275,
	64280,
	64285,
	64286,
	64287,
	64297,
	64298,
	64311,
	64312,
	64317,
	64318,
	64319,
	64320,
	64322,
	64323,
	64325,
	64326,
	64434,
	64467,
	64830,
	64848,
	64912,
	64914,
	64968,
	65008,
	65020,
	65136,
	65141,
	65142,
	65277,
	65313,
	65339,
	65345,
	65371,
	65382,
	65471,
	65474,
	65480,
	65482,
	65488,
	65490,
	65496,
	65498,
	65501,
	65536,
	65548,
	65549,
	65575,
	65576,
	65595,
	65596,
	65598,
	65599,
	65614,
	65616,
	65630,
	65664,
	65787,
	66176,
	66205,
	66208,
	66257,
	66304,
	66336,
	66349,
	66369,
	66370,
	66378,
	66384,
	66422,
	66432,
	66462,
	66464,
	66500,
	66504,
	66512,
	66560,
	66718,
	66736,
	66772,
	66776,
	66812,
	66816,
	66856,
	66864,
	66916,
	67072,
	67383,
	67392,
	67414,
	67424,
	67432,
	67584,
	67590,
	67592,
	67593,
	67594,
	67638,
	67639,
	67641,
	67644,
	67645,
	67647,
	67670,
	67680,
	67703,
	67712,
	67743,
	67808,
	67827,
	67828,
	67830,
	67840,
	67862,
	67872,
	67898,
	67968,
	68024,
	68030,
	68032,
	68096,
	68097,
	68112,
	68116,
	68117,
	68120,
	68121,
	68150,
	68192,
	68221,
	68224,
	68253,
	68288,
	68296,
	68297,
	68325,
	68352,
	68406,
	68416,
	68438,
	68448,
	68467,
	68480,
	68498,
	68608,
	68681,
	68736,
	68787,
	68800,
	68851,
	68864,
	68900,
	69376,
	69405,
	69415,
	69416,
	69424,
	69446,
	69600,
	69623,
	69635,
	69688,
	69763,
	69808,
	69840,
	69865,
	69891,
	69927,
	69956,
	69957,
	69968,
	70003,
	70006,
	70007,
	70019,
	70067,
	70081,
	70085,
	70106,
	70107,
	70108,
	70109,
	70144,
	70162,
	70163,
	70188,
	70272,
	70279,
	70280,
	70281,
	70282,
	70286,
	70287,
	70302,
	70303,
	70313,
	70320,
	70367,
	70405,
	70413,
	70415,
	70417,
	70419,
	70441,
	70442,
	70449,
	70450,
	70452,
	70453,
	70458,
	70461,
	70462,
	70480,
	70481,
	70493,
	70498,
	70656,
	70709,
	70727,
	70731,
	70751,
	70752,
	70784,
	70832,
	70852,
	70854,
	70855,
	70856,
	71040,
	71087,
	71128,
	71132,
	71168,
	71216,
	71236,
	71237,
	71296,
	71339,
	71352,
	71353,
	71424,
	71451,
	71680,
	71724,
	71840,
	71904,
	71935,
	71936,
	72096,
	72104,
	72106,
	72145,
	72161,
	72162,
	72163,
	72164,
	72192,
	72193,
	72203,
	72243,
	72250,
	72251,
	72272,
	72273,
	72284,
	72330,
	72349,
	72350,
	72384,
	72441,
	72704,
	72713,
	72714,
	72751,
	72768,
	72769,
	72818,
	72848,
	72960,
	72967,
	72968,
	72970,
	72971,
	73009,
	73030,
	73031,
	73056,
	73062,
	73063,
	73065,
	73066,
	73098,
	73112,
	73113,
	73440,
	73459,
	73728,
	74650,
	74880,
	75076,
	77824,
	78895,
	82944,
	83527,
	92160,
	92729,
	92736,
	92767,
	92880,
	92910,
	92928,
	92976,
	92992,
	92996,
	93027,
	93048,
	93053,
	93072,
	93760,
	93824,
	93952,
	94027,
	94032,
	94033,
	94099,
	94112,
	94176,
	94178,
	94179,
	94180,
	94208,
	100344,
	100352,
	101107,
	110592,
	110879,
	110928,
	110931,
	110948,
	110952,
	110960,
	111356,
	113664,
	113771,
	113776,
	113789,
	113792,
	113801,
	113808,
	113818,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120513,
	120514,
	120539,
	120540,
	120571,
	120572,
	120597,
	120598,
	120629,
	120630,
	120655,
	120656,
	120687,
	120688,
	120713,
	120714,
	120745,
	120746,
	120771,
	120772,
	120780,
	123136,
	123181,
	123191,
	123198,
	123214,
	123215,
	123584,
	123628,
	124928,
	125125,
	125184,
	125252,
	125259,
	125260,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457,
	194560,
	195102
]);
category.set("Letter_Number", [
	5870,
	5873,
	8544,
	8579,
	8581,
	8585,
	12295,
	12296,
	12321,
	12330,
	12344,
	12347,
	42726,
	42736,
	65856,
	65909,
	66369,
	66370,
	66378,
	66379,
	66513,
	66518,
	74752,
	74863
]);
category.set("Line_Separator", [8232, 8233]);
category.set("Lowercase_Letter", [
	97,
	123,
	181,
	182,
	223,
	247,
	248,
	256,
	257,
	258,
	259,
	260,
	261,
	262,
	263,
	264,
	265,
	266,
	267,
	268,
	269,
	270,
	271,
	272,
	273,
	274,
	275,
	276,
	277,
	278,
	279,
	280,
	281,
	282,
	283,
	284,
	285,
	286,
	287,
	288,
	289,
	290,
	291,
	292,
	293,
	294,
	295,
	296,
	297,
	298,
	299,
	300,
	301,
	302,
	303,
	304,
	305,
	306,
	307,
	308,
	309,
	310,
	311,
	313,
	314,
	315,
	316,
	317,
	318,
	319,
	320,
	321,
	322,
	323,
	324,
	325,
	326,
	327,
	328,
	330,
	331,
	332,
	333,
	334,
	335,
	336,
	337,
	338,
	339,
	340,
	341,
	342,
	343,
	344,
	345,
	346,
	347,
	348,
	349,
	350,
	351,
	352,
	353,
	354,
	355,
	356,
	357,
	358,
	359,
	360,
	361,
	362,
	363,
	364,
	365,
	366,
	367,
	368,
	369,
	370,
	371,
	372,
	373,
	374,
	375,
	376,
	378,
	379,
	380,
	381,
	382,
	385,
	387,
	388,
	389,
	390,
	392,
	393,
	396,
	398,
	402,
	403,
	405,
	406,
	409,
	412,
	414,
	415,
	417,
	418,
	419,
	420,
	421,
	422,
	424,
	425,
	426,
	428,
	429,
	430,
	432,
	433,
	436,
	437,
	438,
	439,
	441,
	443,
	445,
	448,
	454,
	455,
	457,
	458,
	460,
	461,
	462,
	463,
	464,
	465,
	466,
	467,
	468,
	469,
	470,
	471,
	472,
	473,
	474,
	475,
	476,
	478,
	479,
	480,
	481,
	482,
	483,
	484,
	485,
	486,
	487,
	488,
	489,
	490,
	491,
	492,
	493,
	494,
	495,
	497,
	499,
	500,
	501,
	502,
	505,
	506,
	507,
	508,
	509,
	510,
	511,
	512,
	513,
	514,
	515,
	516,
	517,
	518,
	519,
	520,
	521,
	522,
	523,
	524,
	525,
	526,
	527,
	528,
	529,
	530,
	531,
	532,
	533,
	534,
	535,
	536,
	537,
	538,
	539,
	540,
	541,
	542,
	543,
	544,
	545,
	546,
	547,
	548,
	549,
	550,
	551,
	552,
	553,
	554,
	555,
	556,
	557,
	558,
	559,
	560,
	561,
	562,
	563,
	570,
	572,
	573,
	575,
	577,
	578,
	579,
	583,
	584,
	585,
	586,
	587,
	588,
	589,
	590,
	591,
	660,
	661,
	688,
	881,
	882,
	883,
	884,
	887,
	888,
	891,
	894,
	912,
	913,
	940,
	975,
	976,
	978,
	981,
	984,
	985,
	986,
	987,
	988,
	989,
	990,
	991,
	992,
	993,
	994,
	995,
	996,
	997,
	998,
	999,
	1000,
	1001,
	1002,
	1003,
	1004,
	1005,
	1006,
	1007,
	1012,
	1013,
	1014,
	1016,
	1017,
	1019,
	1021,
	1072,
	1120,
	1121,
	1122,
	1123,
	1124,
	1125,
	1126,
	1127,
	1128,
	1129,
	1130,
	1131,
	1132,
	1133,
	1134,
	1135,
	1136,
	1137,
	1138,
	1139,
	1140,
	1141,
	1142,
	1143,
	1144,
	1145,
	1146,
	1147,
	1148,
	1149,
	1150,
	1151,
	1152,
	1153,
	1154,
	1163,
	1164,
	1165,
	1166,
	1167,
	1168,
	1169,
	1170,
	1171,
	1172,
	1173,
	1174,
	1175,
	1176,
	1177,
	1178,
	1179,
	1180,
	1181,
	1182,
	1183,
	1184,
	1185,
	1186,
	1187,
	1188,
	1189,
	1190,
	1191,
	1192,
	1193,
	1194,
	1195,
	1196,
	1197,
	1198,
	1199,
	1200,
	1201,
	1202,
	1203,
	1204,
	1205,
	1206,
	1207,
	1208,
	1209,
	1210,
	1211,
	1212,
	1213,
	1214,
	1215,
	1216,
	1218,
	1219,
	1220,
	1221,
	1222,
	1223,
	1224,
	1225,
	1226,
	1227,
	1228,
	1229,
	1230,
	1232,
	1233,
	1234,
	1235,
	1236,
	1237,
	1238,
	1239,
	1240,
	1241,
	1242,
	1243,
	1244,
	1245,
	1246,
	1247,
	1248,
	1249,
	1250,
	1251,
	1252,
	1253,
	1254,
	1255,
	1256,
	1257,
	1258,
	1259,
	1260,
	1261,
	1262,
	1263,
	1264,
	1265,
	1266,
	1267,
	1268,
	1269,
	1270,
	1271,
	1272,
	1273,
	1274,
	1275,
	1276,
	1277,
	1278,
	1279,
	1280,
	1281,
	1282,
	1283,
	1284,
	1285,
	1286,
	1287,
	1288,
	1289,
	1290,
	1291,
	1292,
	1293,
	1294,
	1295,
	1296,
	1297,
	1298,
	1299,
	1300,
	1301,
	1302,
	1303,
	1304,
	1305,
	1306,
	1307,
	1308,
	1309,
	1310,
	1311,
	1312,
	1313,
	1314,
	1315,
	1316,
	1317,
	1318,
	1319,
	1320,
	1321,
	1322,
	1323,
	1324,
	1325,
	1326,
	1327,
	1328,
	1376,
	1417,
	4304,
	4347,
	4349,
	4352,
	5112,
	5118,
	7296,
	7305,
	7424,
	7468,
	7531,
	7544,
	7545,
	7579,
	7681,
	7682,
	7683,
	7684,
	7685,
	7686,
	7687,
	7688,
	7689,
	7690,
	7691,
	7692,
	7693,
	7694,
	7695,
	7696,
	7697,
	7698,
	7699,
	7700,
	7701,
	7702,
	7703,
	7704,
	7705,
	7706,
	7707,
	7708,
	7709,
	7710,
	7711,
	7712,
	7713,
	7714,
	7715,
	7716,
	7717,
	7718,
	7719,
	7720,
	7721,
	7722,
	7723,
	7724,
	7725,
	7726,
	7727,
	7728,
	7729,
	7730,
	7731,
	7732,
	7733,
	7734,
	7735,
	7736,
	7737,
	7738,
	7739,
	7740,
	7741,
	7742,
	7743,
	7744,
	7745,
	7746,
	7747,
	7748,
	7749,
	7750,
	7751,
	7752,
	7753,
	7754,
	7755,
	7756,
	7757,
	7758,
	7759,
	7760,
	7761,
	7762,
	7763,
	7764,
	7765,
	7766,
	7767,
	7768,
	7769,
	7770,
	7771,
	7772,
	7773,
	7774,
	7775,
	7776,
	7777,
	7778,
	7779,
	7780,
	7781,
	7782,
	7783,
	7784,
	7785,
	7786,
	7787,
	7788,
	7789,
	7790,
	7791,
	7792,
	7793,
	7794,
	7795,
	7796,
	7797,
	7798,
	7799,
	7800,
	7801,
	7802,
	7803,
	7804,
	7805,
	7806,
	7807,
	7808,
	7809,
	7810,
	7811,
	7812,
	7813,
	7814,
	7815,
	7816,
	7817,
	7818,
	7819,
	7820,
	7821,
	7822,
	7823,
	7824,
	7825,
	7826,
	7827,
	7828,
	7829,
	7838,
	7839,
	7840,
	7841,
	7842,
	7843,
	7844,
	7845,
	7846,
	7847,
	7848,
	7849,
	7850,
	7851,
	7852,
	7853,
	7854,
	7855,
	7856,
	7857,
	7858,
	7859,
	7860,
	7861,
	7862,
	7863,
	7864,
	7865,
	7866,
	7867,
	7868,
	7869,
	7870,
	7871,
	7872,
	7873,
	7874,
	7875,
	7876,
	7877,
	7878,
	7879,
	7880,
	7881,
	7882,
	7883,
	7884,
	7885,
	7886,
	7887,
	7888,
	7889,
	7890,
	7891,
	7892,
	7893,
	7894,
	7895,
	7896,
	7897,
	7898,
	7899,
	7900,
	7901,
	7902,
	7903,
	7904,
	7905,
	7906,
	7907,
	7908,
	7909,
	7910,
	7911,
	7912,
	7913,
	7914,
	7915,
	7916,
	7917,
	7918,
	7919,
	7920,
	7921,
	7922,
	7923,
	7924,
	7925,
	7926,
	7927,
	7928,
	7929,
	7930,
	7931,
	7932,
	7933,
	7934,
	7935,
	7944,
	7952,
	7958,
	7968,
	7976,
	7984,
	7992,
	8000,
	8006,
	8016,
	8024,
	8032,
	8040,
	8048,
	8062,
	8064,
	8072,
	8080,
	8088,
	8096,
	8104,
	8112,
	8117,
	8118,
	8120,
	8126,
	8127,
	8130,
	8133,
	8134,
	8136,
	8144,
	8148,
	8150,
	8152,
	8160,
	8168,
	8178,
	8181,
	8182,
	8184,
	8458,
	8459,
	8462,
	8464,
	8467,
	8468,
	8495,
	8496,
	8500,
	8501,
	8505,
	8506,
	8508,
	8510,
	8518,
	8522,
	8526,
	8527,
	8580,
	8581,
	11312,
	11359,
	11361,
	11362,
	11365,
	11367,
	11368,
	11369,
	11370,
	11371,
	11372,
	11373,
	11377,
	11378,
	11379,
	11381,
	11382,
	11388,
	11393,
	11394,
	11395,
	11396,
	11397,
	11398,
	11399,
	11400,
	11401,
	11402,
	11403,
	11404,
	11405,
	11406,
	11407,
	11408,
	11409,
	11410,
	11411,
	11412,
	11413,
	11414,
	11415,
	11416,
	11417,
	11418,
	11419,
	11420,
	11421,
	11422,
	11423,
	11424,
	11425,
	11426,
	11427,
	11428,
	11429,
	11430,
	11431,
	11432,
	11433,
	11434,
	11435,
	11436,
	11437,
	11438,
	11439,
	11440,
	11441,
	11442,
	11443,
	11444,
	11445,
	11446,
	11447,
	11448,
	11449,
	11450,
	11451,
	11452,
	11453,
	11454,
	11455,
	11456,
	11457,
	11458,
	11459,
	11460,
	11461,
	11462,
	11463,
	11464,
	11465,
	11466,
	11467,
	11468,
	11469,
	11470,
	11471,
	11472,
	11473,
	11474,
	11475,
	11476,
	11477,
	11478,
	11479,
	11480,
	11481,
	11482,
	11483,
	11484,
	11485,
	11486,
	11487,
	11488,
	11489,
	11490,
	11491,
	11493,
	11500,
	11501,
	11502,
	11503,
	11507,
	11508,
	11520,
	11558,
	11559,
	11560,
	11565,
	11566,
	42561,
	42562,
	42563,
	42564,
	42565,
	42566,
	42567,
	42568,
	42569,
	42570,
	42571,
	42572,
	42573,
	42574,
	42575,
	42576,
	42577,
	42578,
	42579,
	42580,
	42581,
	42582,
	42583,
	42584,
	42585,
	42586,
	42587,
	42588,
	42589,
	42590,
	42591,
	42592,
	42593,
	42594,
	42595,
	42596,
	42597,
	42598,
	42599,
	42600,
	42601,
	42602,
	42603,
	42604,
	42605,
	42606,
	42625,
	42626,
	42627,
	42628,
	42629,
	42630,
	42631,
	42632,
	42633,
	42634,
	42635,
	42636,
	42637,
	42638,
	42639,
	42640,
	42641,
	42642,
	42643,
	42644,
	42645,
	42646,
	42647,
	42648,
	42649,
	42650,
	42651,
	42652,
	42787,
	42788,
	42789,
	42790,
	42791,
	42792,
	42793,
	42794,
	42795,
	42796,
	42797,
	42798,
	42799,
	42802,
	42803,
	42804,
	42805,
	42806,
	42807,
	42808,
	42809,
	42810,
	42811,
	42812,
	42813,
	42814,
	42815,
	42816,
	42817,
	42818,
	42819,
	42820,
	42821,
	42822,
	42823,
	42824,
	42825,
	42826,
	42827,
	42828,
	42829,
	42830,
	42831,
	42832,
	42833,
	42834,
	42835,
	42836,
	42837,
	42838,
	42839,
	42840,
	42841,
	42842,
	42843,
	42844,
	42845,
	42846,
	42847,
	42848,
	42849,
	42850,
	42851,
	42852,
	42853,
	42854,
	42855,
	42856,
	42857,
	42858,
	42859,
	42860,
	42861,
	42862,
	42863,
	42864,
	42865,
	42873,
	42874,
	42875,
	42876,
	42877,
	42879,
	42880,
	42881,
	42882,
	42883,
	42884,
	42885,
	42886,
	42887,
	42888,
	42892,
	42893,
	42894,
	42895,
	42897,
	42898,
	42899,
	42902,
	42903,
	42904,
	42905,
	42906,
	42907,
	42908,
	42909,
	42910,
	42911,
	42912,
	42913,
	42914,
	42915,
	42916,
	42917,
	42918,
	42919,
	42920,
	42921,
	42922,
	42927,
	42928,
	42933,
	42934,
	42935,
	42936,
	42937,
	42938,
	42939,
	42940,
	42941,
	42942,
	42943,
	42944,
	42947,
	42948,
	43002,
	43003,
	43824,
	43867,
	43872,
	43880,
	43888,
	43968,
	64256,
	64263,
	64275,
	64280,
	65345,
	65371,
	66600,
	66640,
	66776,
	66812,
	68800,
	68851,
	71872,
	71904,
	93792,
	93824,
	119834,
	119860,
	119886,
	119893,
	119894,
	119912,
	119938,
	119964,
	119990,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120016,
	120042,
	120068,
	120094,
	120120,
	120146,
	120172,
	120198,
	120224,
	120250,
	120276,
	120302,
	120328,
	120354,
	120380,
	120406,
	120432,
	120458,
	120486,
	120514,
	120539,
	120540,
	120546,
	120572,
	120597,
	120598,
	120604,
	120630,
	120655,
	120656,
	120662,
	120688,
	120713,
	120714,
	120720,
	120746,
	120771,
	120772,
	120778,
	120779,
	120780,
	125218,
	125252
]);
category.set("Mark", [
	768,
	880,
	1155,
	1162,
	1425,
	1470,
	1471,
	1472,
	1473,
	1475,
	1476,
	1478,
	1479,
	1480,
	1552,
	1563,
	1611,
	1632,
	1648,
	1649,
	1750,
	1757,
	1759,
	1765,
	1767,
	1769,
	1770,
	1774,
	1809,
	1810,
	1840,
	1867,
	1958,
	1969,
	2027,
	2036,
	2045,
	2046,
	2070,
	2074,
	2075,
	2084,
	2085,
	2088,
	2089,
	2094,
	2137,
	2140,
	2259,
	2274,
	2275,
	2308,
	2362,
	2365,
	2366,
	2384,
	2385,
	2392,
	2402,
	2404,
	2433,
	2436,
	2492,
	2493,
	2494,
	2501,
	2503,
	2505,
	2507,
	2510,
	2519,
	2520,
	2530,
	2532,
	2558,
	2559,
	2561,
	2564,
	2620,
	2621,
	2622,
	2627,
	2631,
	2633,
	2635,
	2638,
	2641,
	2642,
	2672,
	2674,
	2677,
	2678,
	2689,
	2692,
	2748,
	2749,
	2750,
	2758,
	2759,
	2762,
	2763,
	2766,
	2786,
	2788,
	2810,
	2816,
	2817,
	2820,
	2876,
	2877,
	2878,
	2885,
	2887,
	2889,
	2891,
	2894,
	2902,
	2904,
	2914,
	2916,
	2946,
	2947,
	3006,
	3011,
	3014,
	3017,
	3018,
	3022,
	3031,
	3032,
	3072,
	3077,
	3134,
	3141,
	3142,
	3145,
	3146,
	3150,
	3157,
	3159,
	3170,
	3172,
	3201,
	3204,
	3260,
	3261,
	3262,
	3269,
	3270,
	3273,
	3274,
	3278,
	3285,
	3287,
	3298,
	3300,
	3328,
	3332,
	3387,
	3389,
	3390,
	3397,
	3398,
	3401,
	3402,
	3406,
	3415,
	3416,
	3426,
	3428,
	3458,
	3460,
	3530,
	3531,
	3535,
	3541,
	3542,
	3543,
	3544,
	3552,
	3570,
	3572,
	3633,
	3634,
	3636,
	3643,
	3655,
	3663,
	3761,
	3762,
	3764,
	3773,
	3784,
	3790,
	3864,
	3866,
	3893,
	3894,
	3895,
	3896,
	3897,
	3898,
	3902,
	3904,
	3953,
	3973,
	3974,
	3976,
	3981,
	3992,
	3993,
	4029,
	4038,
	4039,
	4139,
	4159,
	4182,
	4186,
	4190,
	4193,
	4194,
	4197,
	4199,
	4206,
	4209,
	4213,
	4226,
	4238,
	4239,
	4240,
	4250,
	4254,
	4957,
	4960,
	5906,
	5909,
	5938,
	5941,
	5970,
	5972,
	6002,
	6004,
	6068,
	6100,
	6109,
	6110,
	6155,
	6158,
	6277,
	6279,
	6313,
	6314,
	6432,
	6444,
	6448,
	6460,
	6679,
	6684,
	6741,
	6751,
	6752,
	6781,
	6783,
	6784,
	6832,
	6847,
	6912,
	6917,
	6964,
	6981,
	7019,
	7028,
	7040,
	7043,
	7073,
	7086,
	7142,
	7156,
	7204,
	7224,
	7376,
	7379,
	7380,
	7401,
	7405,
	7406,
	7412,
	7413,
	7415,
	7418,
	7616,
	7674,
	7675,
	7680,
	8400,
	8433,
	11503,
	11506,
	11647,
	11648,
	11744,
	11776,
	12330,
	12336,
	12441,
	12443,
	42607,
	42611,
	42612,
	42622,
	42654,
	42656,
	42736,
	42738,
	43010,
	43011,
	43014,
	43015,
	43019,
	43020,
	43043,
	43048,
	43136,
	43138,
	43188,
	43206,
	43232,
	43250,
	43263,
	43264,
	43302,
	43310,
	43335,
	43348,
	43392,
	43396,
	43443,
	43457,
	43493,
	43494,
	43561,
	43575,
	43587,
	43588,
	43596,
	43598,
	43643,
	43646,
	43696,
	43697,
	43698,
	43701,
	43703,
	43705,
	43710,
	43712,
	43713,
	43714,
	43755,
	43760,
	43765,
	43767,
	44003,
	44011,
	44012,
	44014,
	64286,
	64287,
	65024,
	65040,
	65056,
	65072,
	66045,
	66046,
	66272,
	66273,
	66422,
	66427,
	68097,
	68100,
	68101,
	68103,
	68108,
	68112,
	68152,
	68155,
	68159,
	68160,
	68325,
	68327,
	68900,
	68904,
	69446,
	69457,
	69632,
	69635,
	69688,
	69703,
	69759,
	69763,
	69808,
	69819,
	69888,
	69891,
	69927,
	69941,
	69957,
	69959,
	70003,
	70004,
	70016,
	70019,
	70067,
	70081,
	70089,
	70093,
	70188,
	70200,
	70206,
	70207,
	70367,
	70379,
	70400,
	70404,
	70459,
	70461,
	70462,
	70469,
	70471,
	70473,
	70475,
	70478,
	70487,
	70488,
	70498,
	70500,
	70502,
	70509,
	70512,
	70517,
	70709,
	70727,
	70750,
	70751,
	70832,
	70852,
	71087,
	71094,
	71096,
	71105,
	71132,
	71134,
	71216,
	71233,
	71339,
	71352,
	71453,
	71468,
	71724,
	71739,
	72145,
	72152,
	72154,
	72161,
	72164,
	72165,
	72193,
	72203,
	72243,
	72250,
	72251,
	72255,
	72263,
	72264,
	72273,
	72284,
	72330,
	72346,
	72751,
	72759,
	72760,
	72768,
	72850,
	72872,
	72873,
	72887,
	73009,
	73015,
	73018,
	73019,
	73020,
	73022,
	73023,
	73030,
	73031,
	73032,
	73098,
	73103,
	73104,
	73106,
	73107,
	73112,
	73459,
	73463,
	92912,
	92917,
	92976,
	92983,
	94031,
	94032,
	94033,
	94088,
	94095,
	94099,
	113821,
	113823,
	119141,
	119146,
	119149,
	119155,
	119163,
	119171,
	119173,
	119180,
	119210,
	119214,
	119362,
	119365,
	121344,
	121399,
	121403,
	121453,
	121461,
	121462,
	121476,
	121477,
	121499,
	121504,
	121505,
	121520,
	122880,
	122887,
	122888,
	122905,
	122907,
	122914,
	122915,
	122917,
	122918,
	122923,
	123184,
	123191,
	123628,
	123632,
	125136,
	125143,
	125252,
	125259,
	917760,
	918000
]);
category.set("Math_Symbol", [
	43,
	44,
	60,
	63,
	124,
	125,
	126,
	127,
	172,
	173,
	177,
	178,
	215,
	216,
	247,
	248,
	1014,
	1015,
	1542,
	1545,
	8260,
	8261,
	8274,
	8275,
	8314,
	8317,
	8330,
	8333,
	8472,
	8473,
	8512,
	8517,
	8523,
	8524,
	8592,
	8597,
	8602,
	8604,
	8608,
	8609,
	8611,
	8612,
	8614,
	8615,
	8622,
	8623,
	8654,
	8656,
	8658,
	8659,
	8660,
	8661,
	8692,
	8960,
	8992,
	8994,
	9084,
	9085,
	9115,
	9140,
	9180,
	9186,
	9655,
	9656,
	9665,
	9666,
	9720,
	9728,
	9839,
	9840,
	10176,
	10181,
	10183,
	10214,
	10224,
	10240,
	10496,
	10627,
	10649,
	10712,
	10716,
	10748,
	10750,
	11008,
	11056,
	11077,
	11079,
	11085,
	64297,
	64298,
	65122,
	65123,
	65124,
	65127,
	65291,
	65292,
	65308,
	65311,
	65372,
	65373,
	65374,
	65375,
	65506,
	65507,
	65513,
	65517,
	120513,
	120514,
	120539,
	120540,
	120571,
	120572,
	120597,
	120598,
	120629,
	120630,
	120655,
	120656,
	120687,
	120688,
	120713,
	120714,
	120745,
	120746,
	120771,
	120772,
	126704,
	126706
]);
category.set("Modifier_Letter", [
	688,
	706,
	710,
	722,
	736,
	741,
	748,
	749,
	750,
	751,
	884,
	885,
	890,
	891,
	1369,
	1370,
	1600,
	1601,
	1765,
	1767,
	2036,
	2038,
	2042,
	2043,
	2074,
	2075,
	2084,
	2085,
	2088,
	2089,
	2417,
	2418,
	3654,
	3655,
	3782,
	3783,
	4348,
	4349,
	6103,
	6104,
	6211,
	6212,
	6823,
	6824,
	7288,
	7294,
	7468,
	7531,
	7544,
	7545,
	7579,
	7616,
	8305,
	8306,
	8319,
	8320,
	8336,
	8349,
	11388,
	11390,
	11631,
	11632,
	11823,
	11824,
	12293,
	12294,
	12337,
	12342,
	12347,
	12348,
	12445,
	12447,
	12540,
	12543,
	40981,
	40982,
	42232,
	42238,
	42508,
	42509,
	42623,
	42624,
	42652,
	42654,
	42775,
	42784,
	42864,
	42865,
	42888,
	42889,
	43000,
	43002,
	43471,
	43472,
	43494,
	43495,
	43632,
	43633,
	43741,
	43742,
	43763,
	43765,
	43868,
	43872,
	65392,
	65393,
	65438,
	65440,
	92992,
	92996,
	94099,
	94112,
	94176,
	94178,
	94179,
	94180,
	123191,
	123198,
	125259,
	125260
]);
category.set("Modifier_Symbol", [
	94,
	95,
	96,
	97,
	168,
	169,
	175,
	176,
	180,
	181,
	184,
	185,
	706,
	710,
	722,
	736,
	741,
	748,
	749,
	750,
	751,
	768,
	885,
	886,
	900,
	902,
	8125,
	8126,
	8127,
	8130,
	8141,
	8144,
	8157,
	8160,
	8173,
	8176,
	8189,
	8191,
	12443,
	12445,
	42752,
	42775,
	42784,
	42786,
	42889,
	42891,
	43867,
	43868,
	64434,
	64450,
	65342,
	65343,
	65344,
	65345,
	65507,
	65508,
	127995,
	128000
]);
category.set("Nonspacing_Mark", [
	768,
	880,
	1155,
	1160,
	1425,
	1470,
	1471,
	1472,
	1473,
	1475,
	1476,
	1478,
	1479,
	1480,
	1552,
	1563,
	1611,
	1632,
	1648,
	1649,
	1750,
	1757,
	1759,
	1765,
	1767,
	1769,
	1770,
	1774,
	1809,
	1810,
	1840,
	1867,
	1958,
	1969,
	2027,
	2036,
	2045,
	2046,
	2070,
	2074,
	2075,
	2084,
	2085,
	2088,
	2089,
	2094,
	2137,
	2140,
	2259,
	2274,
	2275,
	2307,
	2362,
	2363,
	2364,
	2365,
	2369,
	2377,
	2381,
	2382,
	2385,
	2392,
	2402,
	2404,
	2433,
	2434,
	2492,
	2493,
	2497,
	2501,
	2509,
	2510,
	2530,
	2532,
	2558,
	2559,
	2561,
	2563,
	2620,
	2621,
	2625,
	2627,
	2631,
	2633,
	2635,
	2638,
	2641,
	2642,
	2672,
	2674,
	2677,
	2678,
	2689,
	2691,
	2748,
	2749,
	2753,
	2758,
	2759,
	2761,
	2765,
	2766,
	2786,
	2788,
	2810,
	2816,
	2817,
	2818,
	2876,
	2877,
	2879,
	2880,
	2881,
	2885,
	2893,
	2894,
	2902,
	2903,
	2914,
	2916,
	2946,
	2947,
	3008,
	3009,
	3021,
	3022,
	3072,
	3073,
	3076,
	3077,
	3134,
	3137,
	3142,
	3145,
	3146,
	3150,
	3157,
	3159,
	3170,
	3172,
	3201,
	3202,
	3260,
	3261,
	3263,
	3264,
	3270,
	3271,
	3276,
	3278,
	3298,
	3300,
	3328,
	3330,
	3387,
	3389,
	3393,
	3397,
	3405,
	3406,
	3426,
	3428,
	3530,
	3531,
	3538,
	3541,
	3542,
	3543,
	3633,
	3634,
	3636,
	3643,
	3655,
	3663,
	3761,
	3762,
	3764,
	3773,
	3784,
	3790,
	3864,
	3866,
	3893,
	3894,
	3895,
	3896,
	3897,
	3898,
	3953,
	3967,
	3968,
	3973,
	3974,
	3976,
	3981,
	3992,
	3993,
	4029,
	4038,
	4039,
	4141,
	4145,
	4146,
	4152,
	4153,
	4155,
	4157,
	4159,
	4184,
	4186,
	4190,
	4193,
	4209,
	4213,
	4226,
	4227,
	4229,
	4231,
	4237,
	4238,
	4253,
	4254,
	4957,
	4960,
	5906,
	5909,
	5938,
	5941,
	5970,
	5972,
	6002,
	6004,
	6068,
	6070,
	6071,
	6078,
	6086,
	6087,
	6089,
	6100,
	6109,
	6110,
	6155,
	6158,
	6277,
	6279,
	6313,
	6314,
	6432,
	6435,
	6439,
	6441,
	6450,
	6451,
	6457,
	6460,
	6679,
	6681,
	6683,
	6684,
	6742,
	6743,
	6744,
	6751,
	6752,
	6753,
	6754,
	6755,
	6757,
	6765,
	6771,
	6781,
	6783,
	6784,
	6832,
	6846,
	6912,
	6916,
	6964,
	6965,
	6966,
	6971,
	6972,
	6973,
	6978,
	6979,
	7019,
	7028,
	7040,
	7042,
	7074,
	7078,
	7080,
	7082,
	7083,
	7086,
	7142,
	7143,
	7144,
	7146,
	7149,
	7150,
	7151,
	7154,
	7212,
	7220,
	7222,
	7224,
	7376,
	7379,
	7380,
	7393,
	7394,
	7401,
	7405,
	7406,
	7412,
	7413,
	7416,
	7418,
	7616,
	7674,
	7675,
	7680,
	8400,
	8413,
	8417,
	8418,
	8421,
	8433,
	11503,
	11506,
	11647,
	11648,
	11744,
	11776,
	12330,
	12334,
	12441,
	12443,
	42607,
	42608,
	42612,
	42622,
	42654,
	42656,
	42736,
	42738,
	43010,
	43011,
	43014,
	43015,
	43019,
	43020,
	43045,
	43047,
	43204,
	43206,
	43232,
	43250,
	43263,
	43264,
	43302,
	43310,
	43335,
	43346,
	43392,
	43395,
	43443,
	43444,
	43446,
	43450,
	43452,
	43454,
	43493,
	43494,
	43561,
	43567,
	43569,
	43571,
	43573,
	43575,
	43587,
	43588,
	43596,
	43597,
	43644,
	43645,
	43696,
	43697,
	43698,
	43701,
	43703,
	43705,
	43710,
	43712,
	43713,
	43714,
	43756,
	43758,
	43766,
	43767,
	44005,
	44006,
	44008,
	44009,
	44013,
	44014,
	64286,
	64287,
	65024,
	65040,
	65056,
	65072,
	66045,
	66046,
	66272,
	66273,
	66422,
	66427,
	68097,
	68100,
	68101,
	68103,
	68108,
	68112,
	68152,
	68155,
	68159,
	68160,
	68325,
	68327,
	68900,
	68904,
	69446,
	69457,
	69633,
	69634,
	69688,
	69703,
	69759,
	69762,
	69811,
	69815,
	69817,
	69819,
	69888,
	69891,
	69927,
	69932,
	69933,
	69941,
	70003,
	70004,
	70016,
	70018,
	70070,
	70079,
	70089,
	70093,
	70191,
	70194,
	70196,
	70197,
	70198,
	70200,
	70206,
	70207,
	70367,
	70368,
	70371,
	70379,
	70400,
	70402,
	70459,
	70461,
	70464,
	70465,
	70502,
	70509,
	70512,
	70517,
	70712,
	70720,
	70722,
	70725,
	70726,
	70727,
	70750,
	70751,
	70835,
	70841,
	70842,
	70843,
	70847,
	70849,
	70850,
	70852,
	71090,
	71094,
	71100,
	71102,
	71103,
	71105,
	71132,
	71134,
	71219,
	71227,
	71229,
	71230,
	71231,
	71233,
	71339,
	71340,
	71341,
	71342,
	71344,
	71350,
	71351,
	71352,
	71453,
	71456,
	71458,
	71462,
	71463,
	71468,
	71727,
	71736,
	71737,
	71739,
	72148,
	72152,
	72154,
	72156,
	72160,
	72161,
	72193,
	72203,
	72243,
	72249,
	72251,
	72255,
	72263,
	72264,
	72273,
	72279,
	72281,
	72284,
	72330,
	72343,
	72344,
	72346,
	72752,
	72759,
	72760,
	72766,
	72767,
	72768,
	72850,
	72872,
	72874,
	72881,
	72882,
	72884,
	72885,
	72887,
	73009,
	73015,
	73018,
	73019,
	73020,
	73022,
	73023,
	73030,
	73031,
	73032,
	73104,
	73106,
	73109,
	73110,
	73111,
	73112,
	73459,
	73461,
	92912,
	92917,
	92976,
	92983,
	94031,
	94032,
	94095,
	94099,
	113821,
	113823,
	119143,
	119146,
	119163,
	119171,
	119173,
	119180,
	119210,
	119214,
	119362,
	119365,
	121344,
	121399,
	121403,
	121453,
	121461,
	121462,
	121476,
	121477,
	121499,
	121504,
	121505,
	121520,
	122880,
	122887,
	122888,
	122905,
	122907,
	122914,
	122915,
	122917,
	122918,
	122923,
	123184,
	123191,
	123628,
	123632,
	125136,
	125143,
	125252,
	125259,
	917760,
	918000
]);
category.set("Number", [
	48,
	58,
	178,
	180,
	185,
	186,
	188,
	191,
	1632,
	1642,
	1776,
	1786,
	1984,
	1994,
	2406,
	2416,
	2534,
	2544,
	2548,
	2554,
	2662,
	2672,
	2790,
	2800,
	2918,
	2928,
	2930,
	2936,
	3046,
	3059,
	3174,
	3184,
	3192,
	3199,
	3302,
	3312,
	3416,
	3423,
	3430,
	3449,
	3558,
	3568,
	3664,
	3674,
	3792,
	3802,
	3872,
	3892,
	4160,
	4170,
	4240,
	4250,
	4969,
	4989,
	5870,
	5873,
	6112,
	6122,
	6128,
	6138,
	6160,
	6170,
	6470,
	6480,
	6608,
	6619,
	6784,
	6794,
	6800,
	6810,
	6992,
	7002,
	7088,
	7098,
	7232,
	7242,
	7248,
	7258,
	8304,
	8305,
	8308,
	8314,
	8320,
	8330,
	8528,
	8579,
	8581,
	8586,
	9312,
	9372,
	9450,
	9472,
	10102,
	10132,
	11517,
	11518,
	12295,
	12296,
	12321,
	12330,
	12344,
	12347,
	12690,
	12694,
	12832,
	12842,
	12872,
	12880,
	12881,
	12896,
	12928,
	12938,
	12977,
	12992,
	42528,
	42538,
	42726,
	42736,
	43056,
	43062,
	43216,
	43226,
	43264,
	43274,
	43472,
	43482,
	43504,
	43514,
	43600,
	43610,
	44016,
	44026,
	65296,
	65306,
	65799,
	65844,
	65856,
	65913,
	65930,
	65932,
	66273,
	66300,
	66336,
	66340,
	66369,
	66370,
	66378,
	66379,
	66513,
	66518,
	66720,
	66730,
	67672,
	67680,
	67705,
	67712,
	67751,
	67760,
	67835,
	67840,
	67862,
	67868,
	68028,
	68030,
	68032,
	68048,
	68050,
	68096,
	68160,
	68169,
	68221,
	68223,
	68253,
	68256,
	68331,
	68336,
	68440,
	68448,
	68472,
	68480,
	68521,
	68528,
	68858,
	68864,
	68912,
	68922,
	69216,
	69247,
	69405,
	69415,
	69457,
	69461,
	69714,
	69744,
	69872,
	69882,
	69942,
	69952,
	70096,
	70106,
	70113,
	70133,
	70384,
	70394,
	70736,
	70746,
	70864,
	70874,
	71248,
	71258,
	71360,
	71370,
	71472,
	71484,
	71904,
	71923,
	72784,
	72813,
	73040,
	73050,
	73120,
	73130,
	73664,
	73685,
	74752,
	74863,
	92768,
	92778,
	93008,
	93018,
	93019,
	93026,
	93824,
	93847,
	119520,
	119540,
	119648,
	119673,
	120782,
	120832,
	123200,
	123210,
	123632,
	123642,
	125127,
	125136,
	125264,
	125274,
	126065,
	126124,
	126125,
	126128,
	126129,
	126133,
	126209,
	126254,
	126255,
	126270,
	127232,
	127245
]);
category.set("Open_Punctuation", [
	40,
	41,
	91,
	92,
	123,
	124,
	3898,
	3899,
	3900,
	3901,
	5787,
	5788,
	8218,
	8219,
	8222,
	8223,
	8261,
	8262,
	8317,
	8318,
	8333,
	8334,
	8968,
	8969,
	8970,
	8971,
	9001,
	9002,
	10088,
	10089,
	10090,
	10091,
	10092,
	10093,
	10094,
	10095,
	10096,
	10097,
	10098,
	10099,
	10100,
	10101,
	10181,
	10182,
	10214,
	10215,
	10216,
	10217,
	10218,
	10219,
	10220,
	10221,
	10222,
	10223,
	10627,
	10628,
	10629,
	10630,
	10631,
	10632,
	10633,
	10634,
	10635,
	10636,
	10637,
	10638,
	10639,
	10640,
	10641,
	10642,
	10643,
	10644,
	10645,
	10646,
	10647,
	10648,
	10712,
	10713,
	10714,
	10715,
	10748,
	10749,
	11810,
	11811,
	11812,
	11813,
	11814,
	11815,
	11816,
	11817,
	11842,
	11843,
	12296,
	12297,
	12298,
	12299,
	12300,
	12301,
	12302,
	12303,
	12304,
	12305,
	12308,
	12309,
	12310,
	12311,
	12312,
	12313,
	12314,
	12315,
	12317,
	12318,
	64831,
	64832,
	65047,
	65048,
	65077,
	65078,
	65079,
	65080,
	65081,
	65082,
	65083,
	65084,
	65085,
	65086,
	65087,
	65088,
	65089,
	65090,
	65091,
	65092,
	65095,
	65096,
	65113,
	65114,
	65115,
	65116,
	65117,
	65118,
	65288,
	65289,
	65339,
	65340,
	65371,
	65372,
	65375,
	65376,
	65378,
	65379
]);
category.set("Other", [
	0,
	32,
	127,
	160,
	173,
	174,
	888,
	890,
	896,
	900,
	907,
	908,
	909,
	910,
	930,
	931,
	1328,
	1329,
	1367,
	1369,
	1419,
	1421,
	1424,
	1425,
	1480,
	1488,
	1515,
	1519,
	1525,
	1542,
	1564,
	1566,
	1757,
	1758,
	1806,
	1808,
	1867,
	1869,
	1970,
	1984,
	2043,
	2045,
	2094,
	2096,
	2111,
	2112,
	2140,
	2142,
	2143,
	2144,
	2155,
	2208,
	2229,
	2230,
	2238,
	2259,
	2274,
	2275,
	2436,
	2437,
	2445,
	2447,
	2449,
	2451,
	2473,
	2474,
	2481,
	2482,
	2483,
	2486,
	2490,
	2492,
	2501,
	2503,
	2505,
	2507,
	2511,
	2519,
	2520,
	2524,
	2526,
	2527,
	2532,
	2534,
	2559,
	2561,
	2564,
	2565,
	2571,
	2575,
	2577,
	2579,
	2601,
	2602,
	2609,
	2610,
	2612,
	2613,
	2615,
	2616,
	2618,
	2620,
	2621,
	2622,
	2627,
	2631,
	2633,
	2635,
	2638,
	2641,
	2642,
	2649,
	2653,
	2654,
	2655,
	2662,
	2679,
	2689,
	2692,
	2693,
	2702,
	2703,
	2706,
	2707,
	2729,
	2730,
	2737,
	2738,
	2740,
	2741,
	2746,
	2748,
	2758,
	2759,
	2762,
	2763,
	2766,
	2768,
	2769,
	2784,
	2788,
	2790,
	2802,
	2809,
	2816,
	2817,
	2820,
	2821,
	2829,
	2831,
	2833,
	2835,
	2857,
	2858,
	2865,
	2866,
	2868,
	2869,
	2874,
	2876,
	2885,
	2887,
	2889,
	2891,
	2894,
	2902,
	2904,
	2908,
	2910,
	2911,
	2916,
	2918,
	2936,
	2946,
	2948,
	2949,
	2955,
	2958,
	2961,
	2962,
	2966,
	2969,
	2971,
	2972,
	2973,
	2974,
	2976,
	2979,
	2981,
	2984,
	2987,
	2990,
	3002,
	3006,
	3011,
	3014,
	3017,
	3018,
	3022,
	3024,
	3025,
	3031,
	3032,
	3046,
	3067,
	3072,
	3085,
	3086,
	3089,
	3090,
	3113,
	3114,
	3130,
	3133,
	3141,
	3142,
	3145,
	3146,
	3150,
	3157,
	3159,
	3160,
	3163,
	3168,
	3172,
	3174,
	3184,
	3191,
	3213,
	3214,
	3217,
	3218,
	3241,
	3242,
	3252,
	3253,
	3258,
	3260,
	3269,
	3270,
	3273,
	3274,
	3278,
	3285,
	3287,
	3294,
	3295,
	3296,
	3300,
	3302,
	3312,
	3313,
	3315,
	3328,
	3332,
	3333,
	3341,
	3342,
	3345,
	3346,
	3397,
	3398,
	3401,
	3402,
	3408,
	3412,
	3428,
	3430,
	3456,
	3458,
	3460,
	3461,
	3479,
	3482,
	3506,
	3507,
	3516,
	3517,
	3518,
	3520,
	3527,
	3530,
	3531,
	3535,
	3541,
	3542,
	3543,
	3544,
	3552,
	3558,
	3568,
	3570,
	3573,
	3585,
	3643,
	3647,
	3676,
	3713,
	3715,
	3716,
	3717,
	3718,
	3723,
	3724,
	3748,
	3749,
	3750,
	3751,
	3774,
	3776,
	3781,
	3782,
	3783,
	3784,
	3790,
	3792,
	3802,
	3804,
	3808,
	3840,
	3912,
	3913,
	3949,
	3953,
	3992,
	3993,
	4029,
	4030,
	4045,
	4046,
	4059,
	4096,
	4294,
	4295,
	4296,
	4301,
	4302,
	4304,
	4681,
	4682,
	4686,
	4688,
	4695,
	4696,
	4697,
	4698,
	4702,
	4704,
	4745,
	4746,
	4750,
	4752,
	4785,
	4786,
	4790,
	4792,
	4799,
	4800,
	4801,
	4802,
	4806,
	4808,
	4823,
	4824,
	4881,
	4882,
	4886,
	4888,
	4955,
	4957,
	4989,
	4992,
	5018,
	5024,
	5110,
	5112,
	5118,
	5120,
	5789,
	5792,
	5881,
	5888,
	5901,
	5902,
	5909,
	5920,
	5943,
	5952,
	5972,
	5984,
	5997,
	5998,
	6001,
	6002,
	6004,
	6016,
	6110,
	6112,
	6122,
	6128,
	6138,
	6144,
	6158,
	6160,
	6170,
	6176,
	6265,
	6272,
	6315,
	6320,
	6390,
	6400,
	6431,
	6432,
	6444,
	6448,
	6460,
	6464,
	6465,
	6468,
	6510,
	6512,
	6517,
	6528,
	6572,
	6576,
	6602,
	6608,
	6619,
	6622,
	6684,
	6686,
	6751,
	6752,
	6781,
	6783,
	6794,
	6800,
	6810,
	6816,
	6830,
	6832,
	6847,
	6912,
	6988,
	6992,
	7037,
	7040,
	7156,
	7164,
	7224,
	7227,
	7242,
	7245,
	7305,
	7312,
	7355,
	7357,
	7368,
	7376,
	7419,
	7424,
	7674,
	7675,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8133,
	8134,
	8148,
	8150,
	8156,
	8157,
	8176,
	8178,
	8181,
	8182,
	8191,
	8192,
	8203,
	8208,
	8234,
	8239,
	8288,
	8304,
	8306,
	8308,
	8335,
	8336,
	8349,
	8352,
	8384,
	8400,
	8433,
	8448,
	8588,
	8592,
	9255,
	9280,
	9291,
	9312,
	11124,
	11126,
	11158,
	11160,
	11311,
	11312,
	11359,
	11360,
	11508,
	11513,
	11558,
	11559,
	11560,
	11565,
	11566,
	11568,
	11624,
	11631,
	11633,
	11647,
	11671,
	11680,
	11687,
	11688,
	11695,
	11696,
	11703,
	11704,
	11711,
	11712,
	11719,
	11720,
	11727,
	11728,
	11735,
	11736,
	11743,
	11744,
	11856,
	11904,
	11930,
	11931,
	12020,
	12032,
	12246,
	12272,
	12284,
	12288,
	12352,
	12353,
	12439,
	12441,
	12544,
	12549,
	12592,
	12593,
	12687,
	12688,
	12731,
	12736,
	12772,
	12784,
	12831,
	12832,
	13055,
	13056,
	19894,
	19904,
	40944,
	40960,
	42125,
	42128,
	42183,
	42192,
	42540,
	42560,
	42744,
	42752,
	42944,
	42946,
	42951,
	42999,
	43052,
	43056,
	43066,
	43072,
	43128,
	43136,
	43206,
	43214,
	43226,
	43232,
	43348,
	43359,
	43389,
	43392,
	43470,
	43471,
	43482,
	43486,
	43519,
	43520,
	43575,
	43584,
	43598,
	43600,
	43610,
	43612,
	43715,
	43739,
	43767,
	43777,
	43783,
	43785,
	43791,
	43793,
	43799,
	43808,
	43815,
	43816,
	43823,
	43824,
	43880,
	43888,
	44014,
	44016,
	44026,
	44032,
	55204,
	55216,
	55239,
	55243,
	55292,
	63744,
	64110,
	64112,
	64218,
	64256,
	64263,
	64275,
	64280,
	64285,
	64311,
	64312,
	64317,
	64318,
	64319,
	64320,
	64322,
	64323,
	64325,
	64326,
	64450,
	64467,
	64832,
	64848,
	64912,
	64914,
	64968,
	65008,
	65022,
	65024,
	65050,
	65056,
	65107,
	65108,
	65127,
	65128,
	65132,
	65136,
	65141,
	65142,
	65277,
	65281,
	65471,
	65474,
	65480,
	65482,
	65488,
	65490,
	65496,
	65498,
	65501,
	65504,
	65511,
	65512,
	65519,
	65532,
	65534,
	65536,
	65548,
	65549,
	65575,
	65576,
	65595,
	65596,
	65598,
	65599,
	65614,
	65616,
	65630,
	65664,
	65787,
	65792,
	65795,
	65799,
	65844,
	65847,
	65935,
	65936,
	65948,
	65952,
	65953,
	66000,
	66046,
	66176,
	66205,
	66208,
	66257,
	66272,
	66300,
	66304,
	66340,
	66349,
	66379,
	66384,
	66427,
	66432,
	66462,
	66463,
	66500,
	66504,
	66518,
	66560,
	66718,
	66720,
	66730,
	66736,
	66772,
	66776,
	66812,
	66816,
	66856,
	66864,
	66916,
	66927,
	66928,
	67072,
	67383,
	67392,
	67414,
	67424,
	67432,
	67584,
	67590,
	67592,
	67593,
	67594,
	67638,
	67639,
	67641,
	67644,
	67645,
	67647,
	67670,
	67671,
	67743,
	67751,
	67760,
	67808,
	67827,
	67828,
	67830,
	67835,
	67868,
	67871,
	67898,
	67903,
	67904,
	67968,
	68024,
	68028,
	68048,
	68050,
	68100,
	68101,
	68103,
	68108,
	68116,
	68117,
	68120,
	68121,
	68150,
	68152,
	68155,
	68159,
	68169,
	68176,
	68185,
	68192,
	68256,
	68288,
	68327,
	68331,
	68343,
	68352,
	68406,
	68409,
	68438,
	68440,
	68467,
	68472,
	68498,
	68505,
	68509,
	68521,
	68528,
	68608,
	68681,
	68736,
	68787,
	68800,
	68851,
	68858,
	68904,
	68912,
	68922,
	69216,
	69247,
	69376,
	69416,
	69424,
	69466,
	69600,
	69623,
	69632,
	69710,
	69714,
	69744,
	69759,
	69821,
	69822,
	69826,
	69840,
	69865,
	69872,
	69882,
	69888,
	69941,
	69942,
	69959,
	69968,
	70007,
	70016,
	70094,
	70096,
	70112,
	70113,
	70133,
	70144,
	70162,
	70163,
	70207,
	70272,
	70279,
	70280,
	70281,
	70282,
	70286,
	70287,
	70302,
	70303,
	70314,
	70320,
	70379,
	70384,
	70394,
	70400,
	70404,
	70405,
	70413,
	70415,
	70417,
	70419,
	70441,
	70442,
	70449,
	70450,
	70452,
	70453,
	70458,
	70459,
	70469,
	70471,
	70473,
	70475,
	70478,
	70480,
	70481,
	70487,
	70488,
	70493,
	70500,
	70502,
	70509,
	70512,
	70517,
	70656,
	70746,
	70747,
	70748,
	70749,
	70752,
	70784,
	70856,
	70864,
	70874,
	71040,
	71094,
	71096,
	71134,
	71168,
	71237,
	71248,
	71258,
	71264,
	71277,
	71296,
	71353,
	71360,
	71370,
	71424,
	71451,
	71453,
	71468,
	71472,
	71488,
	71680,
	71740,
	71840,
	71923,
	71935,
	71936,
	72096,
	72104,
	72106,
	72152,
	72154,
	72165,
	72192,
	72264,
	72272,
	72355,
	72384,
	72441,
	72704,
	72713,
	72714,
	72759,
	72760,
	72774,
	72784,
	72813,
	72816,
	72848,
	72850,
	72872,
	72873,
	72887,
	72960,
	72967,
	72968,
	72970,
	72971,
	73015,
	73018,
	73019,
	73020,
	73022,
	73023,
	73032,
	73040,
	73050,
	73056,
	73062,
	73063,
	73065,
	73066,
	73103,
	73104,
	73106,
	73107,
	73113,
	73120,
	73130,
	73440,
	73465,
	73664,
	73714,
	73727,
	74650,
	74752,
	74863,
	74864,
	74869,
	74880,
	75076,
	77824,
	78895,
	82944,
	83527,
	92160,
	92729,
	92736,
	92767,
	92768,
	92778,
	92782,
	92784,
	92880,
	92910,
	92912,
	92918,
	92928,
	92998,
	93008,
	93018,
	93019,
	93026,
	93027,
	93048,
	93053,
	93072,
	93760,
	93851,
	93952,
	94027,
	94031,
	94088,
	94095,
	94112,
	94176,
	94180,
	94208,
	100344,
	100352,
	101107,
	110592,
	110879,
	110928,
	110931,
	110948,
	110952,
	110960,
	111356,
	113664,
	113771,
	113776,
	113789,
	113792,
	113801,
	113808,
	113818,
	113820,
	113824,
	118784,
	119030,
	119040,
	119079,
	119081,
	119155,
	119163,
	119273,
	119296,
	119366,
	119520,
	119540,
	119552,
	119639,
	119648,
	119673,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120780,
	120782,
	121484,
	121499,
	121504,
	121505,
	121520,
	122880,
	122887,
	122888,
	122905,
	122907,
	122914,
	122915,
	122917,
	122918,
	122923,
	123136,
	123181,
	123184,
	123198,
	123200,
	123210,
	123214,
	123216,
	123584,
	123642,
	123647,
	123648,
	124928,
	125125,
	125127,
	125143,
	125184,
	125260,
	125264,
	125274,
	125278,
	125280,
	126065,
	126133,
	126209,
	126270,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	126704,
	126706,
	126976,
	127020,
	127024,
	127124,
	127136,
	127151,
	127153,
	127168,
	127169,
	127184,
	127185,
	127222,
	127232,
	127245,
	127248,
	127341,
	127344,
	127405,
	127462,
	127491,
	127504,
	127548,
	127552,
	127561,
	127568,
	127570,
	127584,
	127590,
	127744,
	128726,
	128736,
	128749,
	128752,
	128763,
	128768,
	128884,
	128896,
	128985,
	128992,
	129004,
	129024,
	129036,
	129040,
	129096,
	129104,
	129114,
	129120,
	129160,
	129168,
	129198,
	129280,
	129292,
	129293,
	129394,
	129395,
	129399,
	129402,
	129443,
	129445,
	129451,
	129454,
	129483,
	129485,
	129620,
	129632,
	129646,
	129648,
	129652,
	129656,
	129659,
	129664,
	129667,
	129680,
	129686,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457,
	194560,
	195102,
	917760,
	918000,
	1114112
]);
category.set("Other_Letter", [
	170,
	171,
	186,
	187,
	443,
	444,
	448,
	452,
	660,
	661,
	1488,
	1515,
	1519,
	1523,
	1568,
	1600,
	1601,
	1611,
	1646,
	1648,
	1649,
	1748,
	1749,
	1750,
	1774,
	1776,
	1786,
	1789,
	1791,
	1792,
	1808,
	1809,
	1810,
	1840,
	1869,
	1958,
	1969,
	1970,
	1994,
	2027,
	2048,
	2070,
	2112,
	2137,
	2144,
	2155,
	2208,
	2229,
	2230,
	2238,
	2308,
	2362,
	2365,
	2366,
	2384,
	2385,
	2392,
	2402,
	2418,
	2433,
	2437,
	2445,
	2447,
	2449,
	2451,
	2473,
	2474,
	2481,
	2482,
	2483,
	2486,
	2490,
	2493,
	2494,
	2510,
	2511,
	2524,
	2526,
	2527,
	2530,
	2544,
	2546,
	2556,
	2557,
	2565,
	2571,
	2575,
	2577,
	2579,
	2601,
	2602,
	2609,
	2610,
	2612,
	2613,
	2615,
	2616,
	2618,
	2649,
	2653,
	2654,
	2655,
	2674,
	2677,
	2693,
	2702,
	2703,
	2706,
	2707,
	2729,
	2730,
	2737,
	2738,
	2740,
	2741,
	2746,
	2749,
	2750,
	2768,
	2769,
	2784,
	2786,
	2809,
	2810,
	2821,
	2829,
	2831,
	2833,
	2835,
	2857,
	2858,
	2865,
	2866,
	2868,
	2869,
	2874,
	2877,
	2878,
	2908,
	2910,
	2911,
	2914,
	2929,
	2930,
	2947,
	2948,
	2949,
	2955,
	2958,
	2961,
	2962,
	2966,
	2969,
	2971,
	2972,
	2973,
	2974,
	2976,
	2979,
	2981,
	2984,
	2987,
	2990,
	3002,
	3024,
	3025,
	3077,
	3085,
	3086,
	3089,
	3090,
	3113,
	3114,
	3130,
	3133,
	3134,
	3160,
	3163,
	3168,
	3170,
	3200,
	3201,
	3205,
	3213,
	3214,
	3217,
	3218,
	3241,
	3242,
	3252,
	3253,
	3258,
	3261,
	3262,
	3294,
	3295,
	3296,
	3298,
	3313,
	3315,
	3333,
	3341,
	3342,
	3345,
	3346,
	3387,
	3389,
	3390,
	3406,
	3407,
	3412,
	3415,
	3423,
	3426,
	3450,
	3456,
	3461,
	3479,
	3482,
	3506,
	3507,
	3516,
	3517,
	3518,
	3520,
	3527,
	3585,
	3633,
	3634,
	3636,
	3648,
	3654,
	3713,
	3715,
	3716,
	3717,
	3718,
	3723,
	3724,
	3748,
	3749,
	3750,
	3751,
	3761,
	3762,
	3764,
	3773,
	3774,
	3776,
	3781,
	3804,
	3808,
	3840,
	3841,
	3904,
	3912,
	3913,
	3949,
	3976,
	3981,
	4096,
	4139,
	4159,
	4160,
	4176,
	4182,
	4186,
	4190,
	4193,
	4194,
	4197,
	4199,
	4206,
	4209,
	4213,
	4226,
	4238,
	4239,
	4352,
	4681,
	4682,
	4686,
	4688,
	4695,
	4696,
	4697,
	4698,
	4702,
	4704,
	4745,
	4746,
	4750,
	4752,
	4785,
	4786,
	4790,
	4792,
	4799,
	4800,
	4801,
	4802,
	4806,
	4808,
	4823,
	4824,
	4881,
	4882,
	4886,
	4888,
	4955,
	4992,
	5008,
	5121,
	5741,
	5743,
	5760,
	5761,
	5787,
	5792,
	5867,
	5873,
	5881,
	5888,
	5901,
	5902,
	5906,
	5920,
	5938,
	5952,
	5970,
	5984,
	5997,
	5998,
	6001,
	6016,
	6068,
	6108,
	6109,
	6176,
	6211,
	6212,
	6265,
	6272,
	6277,
	6279,
	6313,
	6314,
	6315,
	6320,
	6390,
	6400,
	6431,
	6480,
	6510,
	6512,
	6517,
	6528,
	6572,
	6576,
	6602,
	6656,
	6679,
	6688,
	6741,
	6917,
	6964,
	6981,
	6988,
	7043,
	7073,
	7086,
	7088,
	7098,
	7142,
	7168,
	7204,
	7245,
	7248,
	7258,
	7288,
	7401,
	7405,
	7406,
	7412,
	7413,
	7415,
	7418,
	7419,
	8501,
	8505,
	11568,
	11624,
	11648,
	11671,
	11680,
	11687,
	11688,
	11695,
	11696,
	11703,
	11704,
	11711,
	11712,
	11719,
	11720,
	11727,
	11728,
	11735,
	11736,
	11743,
	12294,
	12295,
	12348,
	12349,
	12353,
	12439,
	12447,
	12448,
	12449,
	12539,
	12543,
	12544,
	12549,
	12592,
	12593,
	12687,
	12704,
	12731,
	12784,
	12800,
	13312,
	19894,
	19968,
	40944,
	40960,
	40981,
	40982,
	42125,
	42192,
	42232,
	42240,
	42508,
	42512,
	42528,
	42538,
	42540,
	42606,
	42607,
	42656,
	42726,
	42895,
	42896,
	42999,
	43000,
	43003,
	43010,
	43011,
	43014,
	43015,
	43019,
	43020,
	43043,
	43072,
	43124,
	43138,
	43188,
	43250,
	43256,
	43259,
	43260,
	43261,
	43263,
	43274,
	43302,
	43312,
	43335,
	43360,
	43389,
	43396,
	43443,
	43488,
	43493,
	43495,
	43504,
	43514,
	43519,
	43520,
	43561,
	43584,
	43587,
	43588,
	43596,
	43616,
	43632,
	43633,
	43639,
	43642,
	43643,
	43646,
	43696,
	43697,
	43698,
	43701,
	43703,
	43705,
	43710,
	43712,
	43713,
	43714,
	43715,
	43739,
	43741,
	43744,
	43755,
	43762,
	43763,
	43777,
	43783,
	43785,
	43791,
	43793,
	43799,
	43808,
	43815,
	43816,
	43823,
	43968,
	44003,
	44032,
	55204,
	55216,
	55239,
	55243,
	55292,
	63744,
	64110,
	64112,
	64218,
	64285,
	64286,
	64287,
	64297,
	64298,
	64311,
	64312,
	64317,
	64318,
	64319,
	64320,
	64322,
	64323,
	64325,
	64326,
	64434,
	64467,
	64830,
	64848,
	64912,
	64914,
	64968,
	65008,
	65020,
	65136,
	65141,
	65142,
	65277,
	65382,
	65392,
	65393,
	65438,
	65440,
	65471,
	65474,
	65480,
	65482,
	65488,
	65490,
	65496,
	65498,
	65501,
	65536,
	65548,
	65549,
	65575,
	65576,
	65595,
	65596,
	65598,
	65599,
	65614,
	65616,
	65630,
	65664,
	65787,
	66176,
	66205,
	66208,
	66257,
	66304,
	66336,
	66349,
	66369,
	66370,
	66378,
	66384,
	66422,
	66432,
	66462,
	66464,
	66500,
	66504,
	66512,
	66640,
	66718,
	66816,
	66856,
	66864,
	66916,
	67072,
	67383,
	67392,
	67414,
	67424,
	67432,
	67584,
	67590,
	67592,
	67593,
	67594,
	67638,
	67639,
	67641,
	67644,
	67645,
	67647,
	67670,
	67680,
	67703,
	67712,
	67743,
	67808,
	67827,
	67828,
	67830,
	67840,
	67862,
	67872,
	67898,
	67968,
	68024,
	68030,
	68032,
	68096,
	68097,
	68112,
	68116,
	68117,
	68120,
	68121,
	68150,
	68192,
	68221,
	68224,
	68253,
	68288,
	68296,
	68297,
	68325,
	68352,
	68406,
	68416,
	68438,
	68448,
	68467,
	68480,
	68498,
	68608,
	68681,
	68864,
	68900,
	69376,
	69405,
	69415,
	69416,
	69424,
	69446,
	69600,
	69623,
	69635,
	69688,
	69763,
	69808,
	69840,
	69865,
	69891,
	69927,
	69956,
	69957,
	69968,
	70003,
	70006,
	70007,
	70019,
	70067,
	70081,
	70085,
	70106,
	70107,
	70108,
	70109,
	70144,
	70162,
	70163,
	70188,
	70272,
	70279,
	70280,
	70281,
	70282,
	70286,
	70287,
	70302,
	70303,
	70313,
	70320,
	70367,
	70405,
	70413,
	70415,
	70417,
	70419,
	70441,
	70442,
	70449,
	70450,
	70452,
	70453,
	70458,
	70461,
	70462,
	70480,
	70481,
	70493,
	70498,
	70656,
	70709,
	70727,
	70731,
	70751,
	70752,
	70784,
	70832,
	70852,
	70854,
	70855,
	70856,
	71040,
	71087,
	71128,
	71132,
	71168,
	71216,
	71236,
	71237,
	71296,
	71339,
	71352,
	71353,
	71424,
	71451,
	71680,
	71724,
	71935,
	71936,
	72096,
	72104,
	72106,
	72145,
	72161,
	72162,
	72163,
	72164,
	72192,
	72193,
	72203,
	72243,
	72250,
	72251,
	72272,
	72273,
	72284,
	72330,
	72349,
	72350,
	72384,
	72441,
	72704,
	72713,
	72714,
	72751,
	72768,
	72769,
	72818,
	72848,
	72960,
	72967,
	72968,
	72970,
	72971,
	73009,
	73030,
	73031,
	73056,
	73062,
	73063,
	73065,
	73066,
	73098,
	73112,
	73113,
	73440,
	73459,
	73728,
	74650,
	74880,
	75076,
	77824,
	78895,
	82944,
	83527,
	92160,
	92729,
	92736,
	92767,
	92880,
	92910,
	92928,
	92976,
	93027,
	93048,
	93053,
	93072,
	93952,
	94027,
	94032,
	94033,
	94208,
	100344,
	100352,
	101107,
	110592,
	110879,
	110928,
	110931,
	110948,
	110952,
	110960,
	111356,
	113664,
	113771,
	113776,
	113789,
	113792,
	113801,
	113808,
	113818,
	123136,
	123181,
	123214,
	123215,
	123584,
	123628,
	124928,
	125125,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457,
	194560,
	195102
]);
category.set("Other_Number", [
	178,
	180,
	185,
	186,
	188,
	191,
	2548,
	2554,
	2930,
	2936,
	3056,
	3059,
	3192,
	3199,
	3416,
	3423,
	3440,
	3449,
	3882,
	3892,
	4969,
	4989,
	6128,
	6138,
	6618,
	6619,
	8304,
	8305,
	8308,
	8314,
	8320,
	8330,
	8528,
	8544,
	8585,
	8586,
	9312,
	9372,
	9450,
	9472,
	10102,
	10132,
	11517,
	11518,
	12690,
	12694,
	12832,
	12842,
	12872,
	12880,
	12881,
	12896,
	12928,
	12938,
	12977,
	12992,
	43056,
	43062,
	65799,
	65844,
	65909,
	65913,
	65930,
	65932,
	66273,
	66300,
	66336,
	66340,
	67672,
	67680,
	67705,
	67712,
	67751,
	67760,
	67835,
	67840,
	67862,
	67868,
	68028,
	68030,
	68032,
	68048,
	68050,
	68096,
	68160,
	68169,
	68221,
	68223,
	68253,
	68256,
	68331,
	68336,
	68440,
	68448,
	68472,
	68480,
	68521,
	68528,
	68858,
	68864,
	69216,
	69247,
	69405,
	69415,
	69457,
	69461,
	69714,
	69734,
	70113,
	70133,
	71482,
	71484,
	71914,
	71923,
	72794,
	72813,
	73664,
	73685,
	93019,
	93026,
	93824,
	93847,
	119520,
	119540,
	119648,
	119673,
	125127,
	125136,
	126065,
	126124,
	126125,
	126128,
	126129,
	126133,
	126209,
	126254,
	126255,
	126270,
	127232,
	127245
]);
category.set("Other_Punctuation", [
	33,
	36,
	37,
	40,
	42,
	43,
	44,
	45,
	46,
	48,
	58,
	60,
	63,
	65,
	92,
	93,
	161,
	162,
	167,
	168,
	182,
	184,
	191,
	192,
	894,
	895,
	903,
	904,
	1370,
	1376,
	1417,
	1418,
	1472,
	1473,
	1475,
	1476,
	1478,
	1479,
	1523,
	1525,
	1545,
	1547,
	1548,
	1550,
	1563,
	1564,
	1566,
	1568,
	1642,
	1646,
	1748,
	1749,
	1792,
	1806,
	2039,
	2042,
	2096,
	2111,
	2142,
	2143,
	2404,
	2406,
	2416,
	2417,
	2557,
	2558,
	2678,
	2679,
	2800,
	2801,
	3191,
	3192,
	3204,
	3205,
	3572,
	3573,
	3663,
	3664,
	3674,
	3676,
	3844,
	3859,
	3860,
	3861,
	3973,
	3974,
	4048,
	4053,
	4057,
	4059,
	4170,
	4176,
	4347,
	4348,
	4960,
	4969,
	5742,
	5743,
	5867,
	5870,
	5941,
	5943,
	6100,
	6103,
	6104,
	6107,
	6144,
	6150,
	6151,
	6155,
	6468,
	6470,
	6686,
	6688,
	6816,
	6823,
	6824,
	6830,
	7002,
	7009,
	7164,
	7168,
	7227,
	7232,
	7294,
	7296,
	7360,
	7368,
	7379,
	7380,
	8214,
	8216,
	8224,
	8232,
	8240,
	8249,
	8251,
	8255,
	8257,
	8260,
	8263,
	8274,
	8275,
	8276,
	8277,
	8287,
	11513,
	11517,
	11518,
	11520,
	11632,
	11633,
	11776,
	11778,
	11782,
	11785,
	11787,
	11788,
	11790,
	11799,
	11800,
	11802,
	11803,
	11804,
	11806,
	11808,
	11818,
	11823,
	11824,
	11834,
	11836,
	11840,
	11841,
	11842,
	11843,
	11856,
	12289,
	12292,
	12349,
	12350,
	12539,
	12540,
	42238,
	42240,
	42509,
	42512,
	42611,
	42612,
	42622,
	42623,
	42738,
	42744,
	43124,
	43128,
	43214,
	43216,
	43256,
	43259,
	43260,
	43261,
	43310,
	43312,
	43359,
	43360,
	43457,
	43470,
	43486,
	43488,
	43612,
	43616,
	43742,
	43744,
	43760,
	43762,
	44011,
	44012,
	65040,
	65047,
	65049,
	65050,
	65072,
	65073,
	65093,
	65095,
	65097,
	65101,
	65104,
	65107,
	65108,
	65112,
	65119,
	65122,
	65128,
	65129,
	65130,
	65132,
	65281,
	65284,
	65285,
	65288,
	65290,
	65291,
	65292,
	65293,
	65294,
	65296,
	65306,
	65308,
	65311,
	65313,
	65340,
	65341,
	65377,
	65378,
	65380,
	65382,
	65792,
	65795,
	66463,
	66464,
	66512,
	66513,
	66927,
	66928,
	67671,
	67672,
	67871,
	67872,
	67903,
	67904,
	68176,
	68185,
	68223,
	68224,
	68336,
	68343,
	68409,
	68416,
	68505,
	68509,
	69461,
	69466,
	69703,
	69710,
	69819,
	69821,
	69822,
	69826,
	69952,
	69956,
	70004,
	70006,
	70085,
	70089,
	70093,
	70094,
	70107,
	70108,
	70109,
	70112,
	70200,
	70206,
	70313,
	70314,
	70731,
	70736,
	70747,
	70748,
	70749,
	70750,
	70854,
	70855,
	71105,
	71128,
	71233,
	71236,
	71264,
	71277,
	71484,
	71487,
	71739,
	71740,
	72162,
	72163,
	72255,
	72263,
	72346,
	72349,
	72350,
	72355,
	72769,
	72774,
	72816,
	72818,
	73463,
	73465,
	73727,
	73728,
	74864,
	74869,
	92782,
	92784,
	92917,
	92918,
	92983,
	92988,
	92996,
	92997,
	93847,
	93851,
	94178,
	94179,
	113823,
	113824,
	121479,
	121484,
	125278,
	125280
]);
category.set("Other_Symbol", [
	166,
	167,
	169,
	170,
	174,
	175,
	176,
	177,
	1154,
	1155,
	1421,
	1423,
	1550,
	1552,
	1758,
	1759,
	1769,
	1770,
	1789,
	1791,
	2038,
	2039,
	2554,
	2555,
	2928,
	2929,
	3059,
	3065,
	3066,
	3067,
	3199,
	3200,
	3407,
	3408,
	3449,
	3450,
	3841,
	3844,
	3859,
	3860,
	3861,
	3864,
	3866,
	3872,
	3892,
	3893,
	3894,
	3895,
	3896,
	3897,
	4030,
	4038,
	4039,
	4045,
	4046,
	4048,
	4053,
	4057,
	4254,
	4256,
	5008,
	5018,
	5741,
	5742,
	6464,
	6465,
	6622,
	6656,
	7009,
	7019,
	7028,
	7037,
	8448,
	8450,
	8451,
	8455,
	8456,
	8458,
	8468,
	8469,
	8470,
	8472,
	8478,
	8484,
	8485,
	8486,
	8487,
	8488,
	8489,
	8490,
	8494,
	8495,
	8506,
	8508,
	8522,
	8523,
	8524,
	8526,
	8527,
	8528,
	8586,
	8588,
	8597,
	8602,
	8604,
	8608,
	8609,
	8611,
	8612,
	8614,
	8615,
	8622,
	8623,
	8654,
	8656,
	8658,
	8659,
	8660,
	8661,
	8692,
	8960,
	8968,
	8972,
	8992,
	8994,
	9001,
	9003,
	9084,
	9085,
	9115,
	9140,
	9180,
	9186,
	9255,
	9280,
	9291,
	9372,
	9450,
	9472,
	9655,
	9656,
	9665,
	9666,
	9720,
	9728,
	9839,
	9840,
	10088,
	10132,
	10176,
	10240,
	10496,
	11008,
	11056,
	11077,
	11079,
	11085,
	11124,
	11126,
	11158,
	11160,
	11264,
	11493,
	11499,
	11904,
	11930,
	11931,
	12020,
	12032,
	12246,
	12272,
	12284,
	12292,
	12293,
	12306,
	12308,
	12320,
	12321,
	12342,
	12344,
	12350,
	12352,
	12688,
	12690,
	12694,
	12704,
	12736,
	12772,
	12800,
	12831,
	12842,
	12872,
	12880,
	12881,
	12896,
	12928,
	12938,
	12977,
	12992,
	13055,
	13056,
	13312,
	19904,
	19968,
	42128,
	42183,
	43048,
	43052,
	43062,
	43064,
	43065,
	43066,
	43639,
	43642,
	65021,
	65022,
	65508,
	65509,
	65512,
	65513,
	65517,
	65519,
	65532,
	65534,
	65847,
	65856,
	65913,
	65930,
	65932,
	65935,
	65936,
	65948,
	65952,
	65953,
	66000,
	66045,
	67703,
	67705,
	68296,
	68297,
	71487,
	71488,
	73685,
	73693,
	73697,
	73714,
	92988,
	92992,
	92997,
	92998,
	113820,
	113821,
	118784,
	119030,
	119040,
	119079,
	119081,
	119141,
	119146,
	119149,
	119171,
	119173,
	119180,
	119210,
	119214,
	119273,
	119296,
	119362,
	119365,
	119366,
	119552,
	119639,
	120832,
	121344,
	121399,
	121403,
	121453,
	121461,
	121462,
	121476,
	121477,
	121479,
	123215,
	123216,
	126124,
	126125,
	126254,
	126255,
	126976,
	127020,
	127024,
	127124,
	127136,
	127151,
	127153,
	127168,
	127169,
	127184,
	127185,
	127222,
	127248,
	127341,
	127344,
	127405,
	127462,
	127491,
	127504,
	127548,
	127552,
	127561,
	127568,
	127570,
	127584,
	127590,
	127744,
	127995,
	128000,
	128726,
	128736,
	128749,
	128752,
	128763,
	128768,
	128884,
	128896,
	128985,
	128992,
	129004,
	129024,
	129036,
	129040,
	129096,
	129104,
	129114,
	129120,
	129160,
	129168,
	129198,
	129280,
	129292,
	129293,
	129394,
	129395,
	129399,
	129402,
	129443,
	129445,
	129451,
	129454,
	129483,
	129485,
	129620,
	129632,
	129646,
	129648,
	129652,
	129656,
	129659,
	129664,
	129667,
	129680,
	129686
]);
category.set("Paragraph_Separator", [8233, 8234]);
category.set("Private_Use", [57344, 63744, 983040, 1048574, 1048576, 1114110]);
category.set("Punctuation", [
	33,
	36,
	37,
	43,
	44,
	48,
	58,
	60,
	63,
	65,
	91,
	94,
	95,
	96,
	123,
	124,
	125,
	126,
	161,
	162,
	167,
	168,
	171,
	172,
	182,
	184,
	187,
	188,
	191,
	192,
	894,
	895,
	903,
	904,
	1370,
	1376,
	1417,
	1419,
	1470,
	1471,
	1472,
	1473,
	1475,
	1476,
	1478,
	1479,
	1523,
	1525,
	1545,
	1547,
	1548,
	1550,
	1563,
	1564,
	1566,
	1568,
	1642,
	1646,
	1748,
	1749,
	1792,
	1806,
	2039,
	2042,
	2096,
	2111,
	2142,
	2143,
	2404,
	2406,
	2416,
	2417,
	2557,
	2558,
	2678,
	2679,
	2800,
	2801,
	3191,
	3192,
	3204,
	3205,
	3572,
	3573,
	3663,
	3664,
	3674,
	3676,
	3844,
	3859,
	3860,
	3861,
	3898,
	3902,
	3973,
	3974,
	4048,
	4053,
	4057,
	4059,
	4170,
	4176,
	4347,
	4348,
	4960,
	4969,
	5120,
	5121,
	5742,
	5743,
	5787,
	5789,
	5867,
	5870,
	5941,
	5943,
	6100,
	6103,
	6104,
	6107,
	6144,
	6155,
	6468,
	6470,
	6686,
	6688,
	6816,
	6823,
	6824,
	6830,
	7002,
	7009,
	7164,
	7168,
	7227,
	7232,
	7294,
	7296,
	7360,
	7368,
	7379,
	7380,
	8208,
	8232,
	8240,
	8260,
	8261,
	8274,
	8275,
	8287,
	8317,
	8319,
	8333,
	8335,
	8968,
	8972,
	9001,
	9003,
	10088,
	10102,
	10181,
	10183,
	10214,
	10224,
	10627,
	10649,
	10712,
	10716,
	10748,
	10750,
	11513,
	11517,
	11518,
	11520,
	11632,
	11633,
	11776,
	11823,
	11824,
	11856,
	12289,
	12292,
	12296,
	12306,
	12308,
	12320,
	12336,
	12337,
	12349,
	12350,
	12448,
	12449,
	12539,
	12540,
	42238,
	42240,
	42509,
	42512,
	42611,
	42612,
	42622,
	42623,
	42738,
	42744,
	43124,
	43128,
	43214,
	43216,
	43256,
	43259,
	43260,
	43261,
	43310,
	43312,
	43359,
	43360,
	43457,
	43470,
	43486,
	43488,
	43612,
	43616,
	43742,
	43744,
	43760,
	43762,
	44011,
	44012,
	64830,
	64832,
	65040,
	65050,
	65072,
	65107,
	65108,
	65122,
	65123,
	65124,
	65128,
	65129,
	65130,
	65132,
	65281,
	65284,
	65285,
	65291,
	65292,
	65296,
	65306,
	65308,
	65311,
	65313,
	65339,
	65342,
	65343,
	65344,
	65371,
	65372,
	65373,
	65374,
	65375,
	65382,
	65792,
	65795,
	66463,
	66464,
	66512,
	66513,
	66927,
	66928,
	67671,
	67672,
	67871,
	67872,
	67903,
	67904,
	68176,
	68185,
	68223,
	68224,
	68336,
	68343,
	68409,
	68416,
	68505,
	68509,
	69461,
	69466,
	69703,
	69710,
	69819,
	69821,
	69822,
	69826,
	69952,
	69956,
	70004,
	70006,
	70085,
	70089,
	70093,
	70094,
	70107,
	70108,
	70109,
	70112,
	70200,
	70206,
	70313,
	70314,
	70731,
	70736,
	70747,
	70748,
	70749,
	70750,
	70854,
	70855,
	71105,
	71128,
	71233,
	71236,
	71264,
	71277,
	71484,
	71487,
	71739,
	71740,
	72162,
	72163,
	72255,
	72263,
	72346,
	72349,
	72350,
	72355,
	72769,
	72774,
	72816,
	72818,
	73463,
	73465,
	73727,
	73728,
	74864,
	74869,
	92782,
	92784,
	92917,
	92918,
	92983,
	92988,
	92996,
	92997,
	93847,
	93851,
	94178,
	94179,
	113823,
	113824,
	121479,
	121484,
	125278,
	125280
]);
category.set("Separator", [32, 33, 160, 161, 5760, 5761, 8192, 8203, 8232, 8234, 8239, 8240, 8287, 8288, 12288, 12289]);
category.set("Space_Separator", [32, 33, 160, 161, 5760, 5761, 8192, 8203, 8239, 8240, 8287, 8288, 12288, 12289]);
category.set("Spacing_Mark", [
	2307,
	2308,
	2363,
	2364,
	2366,
	2369,
	2377,
	2381,
	2382,
	2384,
	2434,
	2436,
	2494,
	2497,
	2503,
	2505,
	2507,
	2509,
	2519,
	2520,
	2563,
	2564,
	2622,
	2625,
	2691,
	2692,
	2750,
	2753,
	2761,
	2762,
	2763,
	2765,
	2818,
	2820,
	2878,
	2879,
	2880,
	2881,
	2887,
	2889,
	2891,
	2893,
	2903,
	2904,
	3006,
	3008,
	3009,
	3011,
	3014,
	3017,
	3018,
	3021,
	3031,
	3032,
	3073,
	3076,
	3137,
	3141,
	3202,
	3204,
	3262,
	3263,
	3264,
	3269,
	3271,
	3273,
	3274,
	3276,
	3285,
	3287,
	3330,
	3332,
	3390,
	3393,
	3398,
	3401,
	3402,
	3405,
	3415,
	3416,
	3458,
	3460,
	3535,
	3538,
	3544,
	3552,
	3570,
	3572,
	3902,
	3904,
	3967,
	3968,
	4139,
	4141,
	4145,
	4146,
	4152,
	4153,
	4155,
	4157,
	4182,
	4184,
	4194,
	4197,
	4199,
	4206,
	4227,
	4229,
	4231,
	4237,
	4239,
	4240,
	4250,
	4253,
	6070,
	6071,
	6078,
	6086,
	6087,
	6089,
	6435,
	6439,
	6441,
	6444,
	6448,
	6450,
	6451,
	6457,
	6681,
	6683,
	6741,
	6742,
	6743,
	6744,
	6753,
	6754,
	6755,
	6757,
	6765,
	6771,
	6916,
	6917,
	6965,
	6966,
	6971,
	6972,
	6973,
	6978,
	6979,
	6981,
	7042,
	7043,
	7073,
	7074,
	7078,
	7080,
	7082,
	7083,
	7143,
	7144,
	7146,
	7149,
	7150,
	7151,
	7154,
	7156,
	7204,
	7212,
	7220,
	7222,
	7393,
	7394,
	7415,
	7416,
	12334,
	12336,
	43043,
	43045,
	43047,
	43048,
	43136,
	43138,
	43188,
	43204,
	43346,
	43348,
	43395,
	43396,
	43444,
	43446,
	43450,
	43452,
	43454,
	43457,
	43567,
	43569,
	43571,
	43573,
	43597,
	43598,
	43643,
	43644,
	43645,
	43646,
	43755,
	43756,
	43758,
	43760,
	43765,
	43766,
	44003,
	44005,
	44006,
	44008,
	44009,
	44011,
	44012,
	44013,
	69632,
	69633,
	69634,
	69635,
	69762,
	69763,
	69808,
	69811,
	69815,
	69817,
	69932,
	69933,
	69957,
	69959,
	70018,
	70019,
	70067,
	70070,
	70079,
	70081,
	70188,
	70191,
	70194,
	70196,
	70197,
	70198,
	70368,
	70371,
	70402,
	70404,
	70462,
	70464,
	70465,
	70469,
	70471,
	70473,
	70475,
	70478,
	70487,
	70488,
	70498,
	70500,
	70709,
	70712,
	70720,
	70722,
	70725,
	70726,
	70832,
	70835,
	70841,
	70842,
	70843,
	70847,
	70849,
	70850,
	71087,
	71090,
	71096,
	71100,
	71102,
	71103,
	71216,
	71219,
	71227,
	71229,
	71230,
	71231,
	71340,
	71341,
	71342,
	71344,
	71350,
	71351,
	71456,
	71458,
	71462,
	71463,
	71724,
	71727,
	71736,
	71737,
	72145,
	72148,
	72156,
	72160,
	72164,
	72165,
	72249,
	72250,
	72279,
	72281,
	72343,
	72344,
	72751,
	72752,
	72766,
	72767,
	72873,
	72874,
	72881,
	72882,
	72884,
	72885,
	73098,
	73103,
	73107,
	73109,
	73110,
	73111,
	73461,
	73463,
	94033,
	94088,
	119141,
	119143,
	119149,
	119155
]);
category.set("Surrogate", [55296, 57344]);
category.set("Symbol", [
	36,
	37,
	43,
	44,
	60,
	63,
	94,
	95,
	96,
	97,
	124,
	125,
	126,
	127,
	162,
	167,
	168,
	170,
	172,
	173,
	174,
	178,
	180,
	181,
	184,
	185,
	215,
	216,
	247,
	248,
	706,
	710,
	722,
	736,
	741,
	748,
	749,
	750,
	751,
	768,
	885,
	886,
	900,
	902,
	1014,
	1015,
	1154,
	1155,
	1421,
	1424,
	1542,
	1545,
	1547,
	1548,
	1550,
	1552,
	1758,
	1759,
	1769,
	1770,
	1789,
	1791,
	2038,
	2039,
	2046,
	2048,
	2546,
	2548,
	2554,
	2556,
	2801,
	2802,
	2928,
	2929,
	3059,
	3067,
	3199,
	3200,
	3407,
	3408,
	3449,
	3450,
	3647,
	3648,
	3841,
	3844,
	3859,
	3860,
	3861,
	3864,
	3866,
	3872,
	3892,
	3893,
	3894,
	3895,
	3896,
	3897,
	4030,
	4038,
	4039,
	4045,
	4046,
	4048,
	4053,
	4057,
	4254,
	4256,
	5008,
	5018,
	5741,
	5742,
	6107,
	6108,
	6464,
	6465,
	6622,
	6656,
	7009,
	7019,
	7028,
	7037,
	8125,
	8126,
	8127,
	8130,
	8141,
	8144,
	8157,
	8160,
	8173,
	8176,
	8189,
	8191,
	8260,
	8261,
	8274,
	8275,
	8314,
	8317,
	8330,
	8333,
	8352,
	8384,
	8448,
	8450,
	8451,
	8455,
	8456,
	8458,
	8468,
	8469,
	8470,
	8473,
	8478,
	8484,
	8485,
	8486,
	8487,
	8488,
	8489,
	8490,
	8494,
	8495,
	8506,
	8508,
	8512,
	8517,
	8522,
	8526,
	8527,
	8528,
	8586,
	8588,
	8592,
	8968,
	8972,
	9001,
	9003,
	9255,
	9280,
	9291,
	9372,
	9450,
	9472,
	10088,
	10132,
	10181,
	10183,
	10214,
	10224,
	10627,
	10649,
	10712,
	10716,
	10748,
	10750,
	11124,
	11126,
	11158,
	11160,
	11264,
	11493,
	11499,
	11904,
	11930,
	11931,
	12020,
	12032,
	12246,
	12272,
	12284,
	12292,
	12293,
	12306,
	12308,
	12320,
	12321,
	12342,
	12344,
	12350,
	12352,
	12443,
	12445,
	12688,
	12690,
	12694,
	12704,
	12736,
	12772,
	12800,
	12831,
	12842,
	12872,
	12880,
	12881,
	12896,
	12928,
	12938,
	12977,
	12992,
	13055,
	13056,
	13312,
	19904,
	19968,
	42128,
	42183,
	42752,
	42775,
	42784,
	42786,
	42889,
	42891,
	43048,
	43052,
	43062,
	43066,
	43639,
	43642,
	43867,
	43868,
	64297,
	64298,
	64434,
	64450,
	65020,
	65022,
	65122,
	65123,
	65124,
	65127,
	65129,
	65130,
	65284,
	65285,
	65291,
	65292,
	65308,
	65311,
	65342,
	65343,
	65344,
	65345,
	65372,
	65373,
	65374,
	65375,
	65504,
	65511,
	65512,
	65519,
	65532,
	65534,
	65847,
	65856,
	65913,
	65930,
	65932,
	65935,
	65936,
	65948,
	65952,
	65953,
	66000,
	66045,
	67703,
	67705,
	68296,
	68297,
	71487,
	71488,
	73685,
	73714,
	92988,
	92992,
	92997,
	92998,
	113820,
	113821,
	118784,
	119030,
	119040,
	119079,
	119081,
	119141,
	119146,
	119149,
	119171,
	119173,
	119180,
	119210,
	119214,
	119273,
	119296,
	119362,
	119365,
	119366,
	119552,
	119639,
	120513,
	120514,
	120539,
	120540,
	120571,
	120572,
	120597,
	120598,
	120629,
	120630,
	120655,
	120656,
	120687,
	120688,
	120713,
	120714,
	120745,
	120746,
	120771,
	120772,
	120832,
	121344,
	121399,
	121403,
	121453,
	121461,
	121462,
	121476,
	121477,
	121479,
	123215,
	123216,
	123647,
	123648,
	126124,
	126125,
	126128,
	126129,
	126254,
	126255,
	126704,
	126706,
	126976,
	127020,
	127024,
	127124,
	127136,
	127151,
	127153,
	127168,
	127169,
	127184,
	127185,
	127222,
	127248,
	127341,
	127344,
	127405,
	127462,
	127491,
	127504,
	127548,
	127552,
	127561,
	127568,
	127570,
	127584,
	127590,
	127744,
	128726,
	128736,
	128749,
	128752,
	128763,
	128768,
	128884,
	128896,
	128985,
	128992,
	129004,
	129024,
	129036,
	129040,
	129096,
	129104,
	129114,
	129120,
	129160,
	129168,
	129198,
	129280,
	129292,
	129293,
	129394,
	129395,
	129399,
	129402,
	129443,
	129445,
	129451,
	129454,
	129483,
	129485,
	129620,
	129632,
	129646,
	129648,
	129652,
	129656,
	129659,
	129664,
	129667,
	129680,
	129686
]);
category.set("Titlecase_Letter", [453, 454, 456, 457, 459, 460, 498, 499, 8072, 8080, 8088, 8096, 8104, 8112, 8124, 8125, 8140, 8141, 8188, 8189]);
category.set("Unassigned", [
	888,
	890,
	896,
	900,
	907,
	908,
	909,
	910,
	930,
	931,
	1328,
	1329,
	1367,
	1369,
	1419,
	1421,
	1424,
	1425,
	1480,
	1488,
	1515,
	1519,
	1525,
	1536,
	1565,
	1566,
	1806,
	1807,
	1867,
	1869,
	1970,
	1984,
	2043,
	2045,
	2094,
	2096,
	2111,
	2112,
	2140,
	2142,
	2143,
	2144,
	2155,
	2208,
	2229,
	2230,
	2238,
	2259,
	2436,
	2437,
	2445,
	2447,
	2449,
	2451,
	2473,
	2474,
	2481,
	2482,
	2483,
	2486,
	2490,
	2492,
	2501,
	2503,
	2505,
	2507,
	2511,
	2519,
	2520,
	2524,
	2526,
	2527,
	2532,
	2534,
	2559,
	2561,
	2564,
	2565,
	2571,
	2575,
	2577,
	2579,
	2601,
	2602,
	2609,
	2610,
	2612,
	2613,
	2615,
	2616,
	2618,
	2620,
	2621,
	2622,
	2627,
	2631,
	2633,
	2635,
	2638,
	2641,
	2642,
	2649,
	2653,
	2654,
	2655,
	2662,
	2679,
	2689,
	2692,
	2693,
	2702,
	2703,
	2706,
	2707,
	2729,
	2730,
	2737,
	2738,
	2740,
	2741,
	2746,
	2748,
	2758,
	2759,
	2762,
	2763,
	2766,
	2768,
	2769,
	2784,
	2788,
	2790,
	2802,
	2809,
	2816,
	2817,
	2820,
	2821,
	2829,
	2831,
	2833,
	2835,
	2857,
	2858,
	2865,
	2866,
	2868,
	2869,
	2874,
	2876,
	2885,
	2887,
	2889,
	2891,
	2894,
	2902,
	2904,
	2908,
	2910,
	2911,
	2916,
	2918,
	2936,
	2946,
	2948,
	2949,
	2955,
	2958,
	2961,
	2962,
	2966,
	2969,
	2971,
	2972,
	2973,
	2974,
	2976,
	2979,
	2981,
	2984,
	2987,
	2990,
	3002,
	3006,
	3011,
	3014,
	3017,
	3018,
	3022,
	3024,
	3025,
	3031,
	3032,
	3046,
	3067,
	3072,
	3085,
	3086,
	3089,
	3090,
	3113,
	3114,
	3130,
	3133,
	3141,
	3142,
	3145,
	3146,
	3150,
	3157,
	3159,
	3160,
	3163,
	3168,
	3172,
	3174,
	3184,
	3191,
	3213,
	3214,
	3217,
	3218,
	3241,
	3242,
	3252,
	3253,
	3258,
	3260,
	3269,
	3270,
	3273,
	3274,
	3278,
	3285,
	3287,
	3294,
	3295,
	3296,
	3300,
	3302,
	3312,
	3313,
	3315,
	3328,
	3332,
	3333,
	3341,
	3342,
	3345,
	3346,
	3397,
	3398,
	3401,
	3402,
	3408,
	3412,
	3428,
	3430,
	3456,
	3458,
	3460,
	3461,
	3479,
	3482,
	3506,
	3507,
	3516,
	3517,
	3518,
	3520,
	3527,
	3530,
	3531,
	3535,
	3541,
	3542,
	3543,
	3544,
	3552,
	3558,
	3568,
	3570,
	3573,
	3585,
	3643,
	3647,
	3676,
	3713,
	3715,
	3716,
	3717,
	3718,
	3723,
	3724,
	3748,
	3749,
	3750,
	3751,
	3774,
	3776,
	3781,
	3782,
	3783,
	3784,
	3790,
	3792,
	3802,
	3804,
	3808,
	3840,
	3912,
	3913,
	3949,
	3953,
	3992,
	3993,
	4029,
	4030,
	4045,
	4046,
	4059,
	4096,
	4294,
	4295,
	4296,
	4301,
	4302,
	4304,
	4681,
	4682,
	4686,
	4688,
	4695,
	4696,
	4697,
	4698,
	4702,
	4704,
	4745,
	4746,
	4750,
	4752,
	4785,
	4786,
	4790,
	4792,
	4799,
	4800,
	4801,
	4802,
	4806,
	4808,
	4823,
	4824,
	4881,
	4882,
	4886,
	4888,
	4955,
	4957,
	4989,
	4992,
	5018,
	5024,
	5110,
	5112,
	5118,
	5120,
	5789,
	5792,
	5881,
	5888,
	5901,
	5902,
	5909,
	5920,
	5943,
	5952,
	5972,
	5984,
	5997,
	5998,
	6001,
	6002,
	6004,
	6016,
	6110,
	6112,
	6122,
	6128,
	6138,
	6144,
	6159,
	6160,
	6170,
	6176,
	6265,
	6272,
	6315,
	6320,
	6390,
	6400,
	6431,
	6432,
	6444,
	6448,
	6460,
	6464,
	6465,
	6468,
	6510,
	6512,
	6517,
	6528,
	6572,
	6576,
	6602,
	6608,
	6619,
	6622,
	6684,
	6686,
	6751,
	6752,
	6781,
	6783,
	6794,
	6800,
	6810,
	6816,
	6830,
	6832,
	6847,
	6912,
	6988,
	6992,
	7037,
	7040,
	7156,
	7164,
	7224,
	7227,
	7242,
	7245,
	7305,
	7312,
	7355,
	7357,
	7368,
	7376,
	7419,
	7424,
	7674,
	7675,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8133,
	8134,
	8148,
	8150,
	8156,
	8157,
	8176,
	8178,
	8181,
	8182,
	8191,
	8192,
	8293,
	8294,
	8306,
	8308,
	8335,
	8336,
	8349,
	8352,
	8384,
	8400,
	8433,
	8448,
	8588,
	8592,
	9255,
	9280,
	9291,
	9312,
	11124,
	11126,
	11158,
	11160,
	11311,
	11312,
	11359,
	11360,
	11508,
	11513,
	11558,
	11559,
	11560,
	11565,
	11566,
	11568,
	11624,
	11631,
	11633,
	11647,
	11671,
	11680,
	11687,
	11688,
	11695,
	11696,
	11703,
	11704,
	11711,
	11712,
	11719,
	11720,
	11727,
	11728,
	11735,
	11736,
	11743,
	11744,
	11856,
	11904,
	11930,
	11931,
	12020,
	12032,
	12246,
	12272,
	12284,
	12288,
	12352,
	12353,
	12439,
	12441,
	12544,
	12549,
	12592,
	12593,
	12687,
	12688,
	12731,
	12736,
	12772,
	12784,
	12831,
	12832,
	13055,
	13056,
	19894,
	19904,
	40944,
	40960,
	42125,
	42128,
	42183,
	42192,
	42540,
	42560,
	42744,
	42752,
	42944,
	42946,
	42951,
	42999,
	43052,
	43056,
	43066,
	43072,
	43128,
	43136,
	43206,
	43214,
	43226,
	43232,
	43348,
	43359,
	43389,
	43392,
	43470,
	43471,
	43482,
	43486,
	43519,
	43520,
	43575,
	43584,
	43598,
	43600,
	43610,
	43612,
	43715,
	43739,
	43767,
	43777,
	43783,
	43785,
	43791,
	43793,
	43799,
	43808,
	43815,
	43816,
	43823,
	43824,
	43880,
	43888,
	44014,
	44016,
	44026,
	44032,
	55204,
	55216,
	55239,
	55243,
	55292,
	55296,
	64110,
	64112,
	64218,
	64256,
	64263,
	64275,
	64280,
	64285,
	64311,
	64312,
	64317,
	64318,
	64319,
	64320,
	64322,
	64323,
	64325,
	64326,
	64450,
	64467,
	64832,
	64848,
	64912,
	64914,
	64968,
	65008,
	65022,
	65024,
	65050,
	65056,
	65107,
	65108,
	65127,
	65128,
	65132,
	65136,
	65141,
	65142,
	65277,
	65279,
	65280,
	65281,
	65471,
	65474,
	65480,
	65482,
	65488,
	65490,
	65496,
	65498,
	65501,
	65504,
	65511,
	65512,
	65519,
	65529,
	65534,
	65536,
	65548,
	65549,
	65575,
	65576,
	65595,
	65596,
	65598,
	65599,
	65614,
	65616,
	65630,
	65664,
	65787,
	65792,
	65795,
	65799,
	65844,
	65847,
	65935,
	65936,
	65948,
	65952,
	65953,
	66000,
	66046,
	66176,
	66205,
	66208,
	66257,
	66272,
	66300,
	66304,
	66340,
	66349,
	66379,
	66384,
	66427,
	66432,
	66462,
	66463,
	66500,
	66504,
	66518,
	66560,
	66718,
	66720,
	66730,
	66736,
	66772,
	66776,
	66812,
	66816,
	66856,
	66864,
	66916,
	66927,
	66928,
	67072,
	67383,
	67392,
	67414,
	67424,
	67432,
	67584,
	67590,
	67592,
	67593,
	67594,
	67638,
	67639,
	67641,
	67644,
	67645,
	67647,
	67670,
	67671,
	67743,
	67751,
	67760,
	67808,
	67827,
	67828,
	67830,
	67835,
	67868,
	67871,
	67898,
	67903,
	67904,
	67968,
	68024,
	68028,
	68048,
	68050,
	68100,
	68101,
	68103,
	68108,
	68116,
	68117,
	68120,
	68121,
	68150,
	68152,
	68155,
	68159,
	68169,
	68176,
	68185,
	68192,
	68256,
	68288,
	68327,
	68331,
	68343,
	68352,
	68406,
	68409,
	68438,
	68440,
	68467,
	68472,
	68498,
	68505,
	68509,
	68521,
	68528,
	68608,
	68681,
	68736,
	68787,
	68800,
	68851,
	68858,
	68904,
	68912,
	68922,
	69216,
	69247,
	69376,
	69416,
	69424,
	69466,
	69600,
	69623,
	69632,
	69710,
	69714,
	69744,
	69759,
	69826,
	69837,
	69838,
	69840,
	69865,
	69872,
	69882,
	69888,
	69941,
	69942,
	69959,
	69968,
	70007,
	70016,
	70094,
	70096,
	70112,
	70113,
	70133,
	70144,
	70162,
	70163,
	70207,
	70272,
	70279,
	70280,
	70281,
	70282,
	70286,
	70287,
	70302,
	70303,
	70314,
	70320,
	70379,
	70384,
	70394,
	70400,
	70404,
	70405,
	70413,
	70415,
	70417,
	70419,
	70441,
	70442,
	70449,
	70450,
	70452,
	70453,
	70458,
	70459,
	70469,
	70471,
	70473,
	70475,
	70478,
	70480,
	70481,
	70487,
	70488,
	70493,
	70500,
	70502,
	70509,
	70512,
	70517,
	70656,
	70746,
	70747,
	70748,
	70749,
	70752,
	70784,
	70856,
	70864,
	70874,
	71040,
	71094,
	71096,
	71134,
	71168,
	71237,
	71248,
	71258,
	71264,
	71277,
	71296,
	71353,
	71360,
	71370,
	71424,
	71451,
	71453,
	71468,
	71472,
	71488,
	71680,
	71740,
	71840,
	71923,
	71935,
	71936,
	72096,
	72104,
	72106,
	72152,
	72154,
	72165,
	72192,
	72264,
	72272,
	72355,
	72384,
	72441,
	72704,
	72713,
	72714,
	72759,
	72760,
	72774,
	72784,
	72813,
	72816,
	72848,
	72850,
	72872,
	72873,
	72887,
	72960,
	72967,
	72968,
	72970,
	72971,
	73015,
	73018,
	73019,
	73020,
	73022,
	73023,
	73032,
	73040,
	73050,
	73056,
	73062,
	73063,
	73065,
	73066,
	73103,
	73104,
	73106,
	73107,
	73113,
	73120,
	73130,
	73440,
	73465,
	73664,
	73714,
	73727,
	74650,
	74752,
	74863,
	74864,
	74869,
	74880,
	75076,
	77824,
	78895,
	78896,
	78905,
	82944,
	83527,
	92160,
	92729,
	92736,
	92767,
	92768,
	92778,
	92782,
	92784,
	92880,
	92910,
	92912,
	92918,
	92928,
	92998,
	93008,
	93018,
	93019,
	93026,
	93027,
	93048,
	93053,
	93072,
	93760,
	93851,
	93952,
	94027,
	94031,
	94088,
	94095,
	94112,
	94176,
	94180,
	94208,
	100344,
	100352,
	101107,
	110592,
	110879,
	110928,
	110931,
	110948,
	110952,
	110960,
	111356,
	113664,
	113771,
	113776,
	113789,
	113792,
	113801,
	113808,
	113818,
	113820,
	113828,
	118784,
	119030,
	119040,
	119079,
	119081,
	119273,
	119296,
	119366,
	119520,
	119540,
	119552,
	119639,
	119648,
	119673,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120780,
	120782,
	121484,
	121499,
	121504,
	121505,
	121520,
	122880,
	122887,
	122888,
	122905,
	122907,
	122914,
	122915,
	122917,
	122918,
	122923,
	123136,
	123181,
	123184,
	123198,
	123200,
	123210,
	123214,
	123216,
	123584,
	123642,
	123647,
	123648,
	124928,
	125125,
	125127,
	125143,
	125184,
	125260,
	125264,
	125274,
	125278,
	125280,
	126065,
	126133,
	126209,
	126270,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	126704,
	126706,
	126976,
	127020,
	127024,
	127124,
	127136,
	127151,
	127153,
	127168,
	127169,
	127184,
	127185,
	127222,
	127232,
	127245,
	127248,
	127341,
	127344,
	127405,
	127462,
	127491,
	127504,
	127548,
	127552,
	127561,
	127568,
	127570,
	127584,
	127590,
	127744,
	128726,
	128736,
	128749,
	128752,
	128763,
	128768,
	128884,
	128896,
	128985,
	128992,
	129004,
	129024,
	129036,
	129040,
	129096,
	129104,
	129114,
	129120,
	129160,
	129168,
	129198,
	129280,
	129292,
	129293,
	129394,
	129395,
	129399,
	129402,
	129443,
	129445,
	129451,
	129454,
	129483,
	129485,
	129620,
	129632,
	129646,
	129648,
	129652,
	129656,
	129659,
	129664,
	129667,
	129680,
	129686,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457,
	194560,
	195102,
	917505,
	917506,
	917536,
	917632,
	917760,
	918000,
	983040,
	1048574,
	1048576,
	1114110,
	1114112
]);
category.set("Uppercase_Letter", [
	65,
	91,
	192,
	215,
	216,
	223,
	256,
	257,
	258,
	259,
	260,
	261,
	262,
	263,
	264,
	265,
	266,
	267,
	268,
	269,
	270,
	271,
	272,
	273,
	274,
	275,
	276,
	277,
	278,
	279,
	280,
	281,
	282,
	283,
	284,
	285,
	286,
	287,
	288,
	289,
	290,
	291,
	292,
	293,
	294,
	295,
	296,
	297,
	298,
	299,
	300,
	301,
	302,
	303,
	304,
	305,
	306,
	307,
	308,
	309,
	310,
	311,
	313,
	314,
	315,
	316,
	317,
	318,
	319,
	320,
	321,
	322,
	323,
	324,
	325,
	326,
	327,
	328,
	330,
	331,
	332,
	333,
	334,
	335,
	336,
	337,
	338,
	339,
	340,
	341,
	342,
	343,
	344,
	345,
	346,
	347,
	348,
	349,
	350,
	351,
	352,
	353,
	354,
	355,
	356,
	357,
	358,
	359,
	360,
	361,
	362,
	363,
	364,
	365,
	366,
	367,
	368,
	369,
	370,
	371,
	372,
	373,
	374,
	375,
	376,
	378,
	379,
	380,
	381,
	382,
	385,
	387,
	388,
	389,
	390,
	392,
	393,
	396,
	398,
	402,
	403,
	405,
	406,
	409,
	412,
	414,
	415,
	417,
	418,
	419,
	420,
	421,
	422,
	424,
	425,
	426,
	428,
	429,
	430,
	432,
	433,
	436,
	437,
	438,
	439,
	441,
	444,
	445,
	452,
	453,
	455,
	456,
	458,
	459,
	461,
	462,
	463,
	464,
	465,
	466,
	467,
	468,
	469,
	470,
	471,
	472,
	473,
	474,
	475,
	476,
	478,
	479,
	480,
	481,
	482,
	483,
	484,
	485,
	486,
	487,
	488,
	489,
	490,
	491,
	492,
	493,
	494,
	495,
	497,
	498,
	500,
	501,
	502,
	505,
	506,
	507,
	508,
	509,
	510,
	511,
	512,
	513,
	514,
	515,
	516,
	517,
	518,
	519,
	520,
	521,
	522,
	523,
	524,
	525,
	526,
	527,
	528,
	529,
	530,
	531,
	532,
	533,
	534,
	535,
	536,
	537,
	538,
	539,
	540,
	541,
	542,
	543,
	544,
	545,
	546,
	547,
	548,
	549,
	550,
	551,
	552,
	553,
	554,
	555,
	556,
	557,
	558,
	559,
	560,
	561,
	562,
	563,
	570,
	572,
	573,
	575,
	577,
	578,
	579,
	583,
	584,
	585,
	586,
	587,
	588,
	589,
	590,
	591,
	880,
	881,
	882,
	883,
	886,
	887,
	895,
	896,
	902,
	903,
	904,
	907,
	908,
	909,
	910,
	912,
	913,
	930,
	931,
	940,
	975,
	976,
	978,
	981,
	984,
	985,
	986,
	987,
	988,
	989,
	990,
	991,
	992,
	993,
	994,
	995,
	996,
	997,
	998,
	999,
	1000,
	1001,
	1002,
	1003,
	1004,
	1005,
	1006,
	1007,
	1012,
	1013,
	1015,
	1016,
	1017,
	1019,
	1021,
	1072,
	1120,
	1121,
	1122,
	1123,
	1124,
	1125,
	1126,
	1127,
	1128,
	1129,
	1130,
	1131,
	1132,
	1133,
	1134,
	1135,
	1136,
	1137,
	1138,
	1139,
	1140,
	1141,
	1142,
	1143,
	1144,
	1145,
	1146,
	1147,
	1148,
	1149,
	1150,
	1151,
	1152,
	1153,
	1162,
	1163,
	1164,
	1165,
	1166,
	1167,
	1168,
	1169,
	1170,
	1171,
	1172,
	1173,
	1174,
	1175,
	1176,
	1177,
	1178,
	1179,
	1180,
	1181,
	1182,
	1183,
	1184,
	1185,
	1186,
	1187,
	1188,
	1189,
	1190,
	1191,
	1192,
	1193,
	1194,
	1195,
	1196,
	1197,
	1198,
	1199,
	1200,
	1201,
	1202,
	1203,
	1204,
	1205,
	1206,
	1207,
	1208,
	1209,
	1210,
	1211,
	1212,
	1213,
	1214,
	1215,
	1216,
	1218,
	1219,
	1220,
	1221,
	1222,
	1223,
	1224,
	1225,
	1226,
	1227,
	1228,
	1229,
	1230,
	1232,
	1233,
	1234,
	1235,
	1236,
	1237,
	1238,
	1239,
	1240,
	1241,
	1242,
	1243,
	1244,
	1245,
	1246,
	1247,
	1248,
	1249,
	1250,
	1251,
	1252,
	1253,
	1254,
	1255,
	1256,
	1257,
	1258,
	1259,
	1260,
	1261,
	1262,
	1263,
	1264,
	1265,
	1266,
	1267,
	1268,
	1269,
	1270,
	1271,
	1272,
	1273,
	1274,
	1275,
	1276,
	1277,
	1278,
	1279,
	1280,
	1281,
	1282,
	1283,
	1284,
	1285,
	1286,
	1287,
	1288,
	1289,
	1290,
	1291,
	1292,
	1293,
	1294,
	1295,
	1296,
	1297,
	1298,
	1299,
	1300,
	1301,
	1302,
	1303,
	1304,
	1305,
	1306,
	1307,
	1308,
	1309,
	1310,
	1311,
	1312,
	1313,
	1314,
	1315,
	1316,
	1317,
	1318,
	1319,
	1320,
	1321,
	1322,
	1323,
	1324,
	1325,
	1326,
	1327,
	1329,
	1367,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	5024,
	5110,
	7312,
	7355,
	7357,
	7360,
	7680,
	7681,
	7682,
	7683,
	7684,
	7685,
	7686,
	7687,
	7688,
	7689,
	7690,
	7691,
	7692,
	7693,
	7694,
	7695,
	7696,
	7697,
	7698,
	7699,
	7700,
	7701,
	7702,
	7703,
	7704,
	7705,
	7706,
	7707,
	7708,
	7709,
	7710,
	7711,
	7712,
	7713,
	7714,
	7715,
	7716,
	7717,
	7718,
	7719,
	7720,
	7721,
	7722,
	7723,
	7724,
	7725,
	7726,
	7727,
	7728,
	7729,
	7730,
	7731,
	7732,
	7733,
	7734,
	7735,
	7736,
	7737,
	7738,
	7739,
	7740,
	7741,
	7742,
	7743,
	7744,
	7745,
	7746,
	7747,
	7748,
	7749,
	7750,
	7751,
	7752,
	7753,
	7754,
	7755,
	7756,
	7757,
	7758,
	7759,
	7760,
	7761,
	7762,
	7763,
	7764,
	7765,
	7766,
	7767,
	7768,
	7769,
	7770,
	7771,
	7772,
	7773,
	7774,
	7775,
	7776,
	7777,
	7778,
	7779,
	7780,
	7781,
	7782,
	7783,
	7784,
	7785,
	7786,
	7787,
	7788,
	7789,
	7790,
	7791,
	7792,
	7793,
	7794,
	7795,
	7796,
	7797,
	7798,
	7799,
	7800,
	7801,
	7802,
	7803,
	7804,
	7805,
	7806,
	7807,
	7808,
	7809,
	7810,
	7811,
	7812,
	7813,
	7814,
	7815,
	7816,
	7817,
	7818,
	7819,
	7820,
	7821,
	7822,
	7823,
	7824,
	7825,
	7826,
	7827,
	7828,
	7829,
	7838,
	7839,
	7840,
	7841,
	7842,
	7843,
	7844,
	7845,
	7846,
	7847,
	7848,
	7849,
	7850,
	7851,
	7852,
	7853,
	7854,
	7855,
	7856,
	7857,
	7858,
	7859,
	7860,
	7861,
	7862,
	7863,
	7864,
	7865,
	7866,
	7867,
	7868,
	7869,
	7870,
	7871,
	7872,
	7873,
	7874,
	7875,
	7876,
	7877,
	7878,
	7879,
	7880,
	7881,
	7882,
	7883,
	7884,
	7885,
	7886,
	7887,
	7888,
	7889,
	7890,
	7891,
	7892,
	7893,
	7894,
	7895,
	7896,
	7897,
	7898,
	7899,
	7900,
	7901,
	7902,
	7903,
	7904,
	7905,
	7906,
	7907,
	7908,
	7909,
	7910,
	7911,
	7912,
	7913,
	7914,
	7915,
	7916,
	7917,
	7918,
	7919,
	7920,
	7921,
	7922,
	7923,
	7924,
	7925,
	7926,
	7927,
	7928,
	7929,
	7930,
	7931,
	7932,
	7933,
	7934,
	7935,
	7944,
	7952,
	7960,
	7966,
	7976,
	7984,
	7992,
	8000,
	8008,
	8014,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8032,
	8040,
	8048,
	8120,
	8124,
	8136,
	8140,
	8152,
	8156,
	8168,
	8173,
	8184,
	8188,
	8450,
	8451,
	8455,
	8456,
	8459,
	8462,
	8464,
	8467,
	8469,
	8470,
	8473,
	8478,
	8484,
	8485,
	8486,
	8487,
	8488,
	8489,
	8490,
	8494,
	8496,
	8500,
	8510,
	8512,
	8517,
	8518,
	8579,
	8580,
	11264,
	11311,
	11360,
	11361,
	11362,
	11365,
	11367,
	11368,
	11369,
	11370,
	11371,
	11372,
	11373,
	11377,
	11378,
	11379,
	11381,
	11382,
	11390,
	11393,
	11394,
	11395,
	11396,
	11397,
	11398,
	11399,
	11400,
	11401,
	11402,
	11403,
	11404,
	11405,
	11406,
	11407,
	11408,
	11409,
	11410,
	11411,
	11412,
	11413,
	11414,
	11415,
	11416,
	11417,
	11418,
	11419,
	11420,
	11421,
	11422,
	11423,
	11424,
	11425,
	11426,
	11427,
	11428,
	11429,
	11430,
	11431,
	11432,
	11433,
	11434,
	11435,
	11436,
	11437,
	11438,
	11439,
	11440,
	11441,
	11442,
	11443,
	11444,
	11445,
	11446,
	11447,
	11448,
	11449,
	11450,
	11451,
	11452,
	11453,
	11454,
	11455,
	11456,
	11457,
	11458,
	11459,
	11460,
	11461,
	11462,
	11463,
	11464,
	11465,
	11466,
	11467,
	11468,
	11469,
	11470,
	11471,
	11472,
	11473,
	11474,
	11475,
	11476,
	11477,
	11478,
	11479,
	11480,
	11481,
	11482,
	11483,
	11484,
	11485,
	11486,
	11487,
	11488,
	11489,
	11490,
	11491,
	11499,
	11500,
	11501,
	11502,
	11506,
	11507,
	42560,
	42561,
	42562,
	42563,
	42564,
	42565,
	42566,
	42567,
	42568,
	42569,
	42570,
	42571,
	42572,
	42573,
	42574,
	42575,
	42576,
	42577,
	42578,
	42579,
	42580,
	42581,
	42582,
	42583,
	42584,
	42585,
	42586,
	42587,
	42588,
	42589,
	42590,
	42591,
	42592,
	42593,
	42594,
	42595,
	42596,
	42597,
	42598,
	42599,
	42600,
	42601,
	42602,
	42603,
	42604,
	42605,
	42624,
	42625,
	42626,
	42627,
	42628,
	42629,
	42630,
	42631,
	42632,
	42633,
	42634,
	42635,
	42636,
	42637,
	42638,
	42639,
	42640,
	42641,
	42642,
	42643,
	42644,
	42645,
	42646,
	42647,
	42648,
	42649,
	42650,
	42651,
	42786,
	42787,
	42788,
	42789,
	42790,
	42791,
	42792,
	42793,
	42794,
	42795,
	42796,
	42797,
	42798,
	42799,
	42802,
	42803,
	42804,
	42805,
	42806,
	42807,
	42808,
	42809,
	42810,
	42811,
	42812,
	42813,
	42814,
	42815,
	42816,
	42817,
	42818,
	42819,
	42820,
	42821,
	42822,
	42823,
	42824,
	42825,
	42826,
	42827,
	42828,
	42829,
	42830,
	42831,
	42832,
	42833,
	42834,
	42835,
	42836,
	42837,
	42838,
	42839,
	42840,
	42841,
	42842,
	42843,
	42844,
	42845,
	42846,
	42847,
	42848,
	42849,
	42850,
	42851,
	42852,
	42853,
	42854,
	42855,
	42856,
	42857,
	42858,
	42859,
	42860,
	42861,
	42862,
	42863,
	42873,
	42874,
	42875,
	42876,
	42877,
	42879,
	42880,
	42881,
	42882,
	42883,
	42884,
	42885,
	42886,
	42887,
	42891,
	42892,
	42893,
	42894,
	42896,
	42897,
	42898,
	42899,
	42902,
	42903,
	42904,
	42905,
	42906,
	42907,
	42908,
	42909,
	42910,
	42911,
	42912,
	42913,
	42914,
	42915,
	42916,
	42917,
	42918,
	42919,
	42920,
	42921,
	42922,
	42927,
	42928,
	42933,
	42934,
	42935,
	42936,
	42937,
	42938,
	42939,
	42940,
	42941,
	42942,
	42943,
	42946,
	42947,
	42948,
	42951,
	65313,
	65339,
	66560,
	66600,
	66736,
	66772,
	68736,
	68787,
	71840,
	71872,
	93760,
	93792,
	119808,
	119834,
	119860,
	119886,
	119912,
	119938,
	119964,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119990,
	120016,
	120042,
	120068,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120120,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120172,
	120198,
	120224,
	120250,
	120276,
	120302,
	120328,
	120354,
	120380,
	120406,
	120432,
	120458,
	120488,
	120513,
	120546,
	120571,
	120604,
	120629,
	120662,
	120687,
	120720,
	120745,
	120778,
	120779,
	125184,
	125218
]);

export const property: Map<string, number[]> = new Map();
property.set("ASCII", [0, 128]);
property.set("ASCII_Hex_Digit", [48, 58, 65, 71, 97, 103]);
property.set("Alphabetic", [
	65,
	91,
	97,
	123,
	170,
	171,
	181,
	182,
	186,
	187,
	192,
	215,
	216,
	247,
	248,
	706,
	710,
	722,
	736,
	741,
	748,
	749,
	750,
	751,
	837,
	838,
	880,
	885,
	886,
	888,
	890,
	894,
	895,
	896,
	902,
	903,
	904,
	907,
	908,
	909,
	910,
	930,
	931,
	1014,
	1015,
	1154,
	1162,
	1328,
	1329,
	1367,
	1369,
	1370,
	1376,
	1417,
	1456,
	1470,
	1471,
	1472,
	1473,
	1475,
	1476,
	1478,
	1479,
	1480,
	1488,
	1515,
	1519,
	1523,
	1552,
	1563,
	1568,
	1624,
	1625,
	1632,
	1646,
	1748,
	1749,
	1757,
	1761,
	1769,
	1773,
	1776,
	1786,
	1789,
	1791,
	1792,
	1808,
	1856,
	1869,
	1970,
	1994,
	2027,
	2036,
	2038,
	2042,
	2043,
	2048,
	2072,
	2074,
	2093,
	2112,
	2137,
	2144,
	2155,
	2208,
	2229,
	2230,
	2238,
	2260,
	2272,
	2275,
	2282,
	2288,
	2364,
	2365,
	2381,
	2382,
	2385,
	2389,
	2404,
	2417,
	2436,
	2437,
	2445,
	2447,
	2449,
	2451,
	2473,
	2474,
	2481,
	2482,
	2483,
	2486,
	2490,
	2493,
	2501,
	2503,
	2505,
	2507,
	2509,
	2510,
	2511,
	2519,
	2520,
	2524,
	2526,
	2527,
	2532,
	2544,
	2546,
	2556,
	2557,
	2561,
	2564,
	2565,
	2571,
	2575,
	2577,
	2579,
	2601,
	2602,
	2609,
	2610,
	2612,
	2613,
	2615,
	2616,
	2618,
	2622,
	2627,
	2631,
	2633,
	2635,
	2637,
	2641,
	2642,
	2649,
	2653,
	2654,
	2655,
	2672,
	2678,
	2689,
	2692,
	2693,
	2702,
	2703,
	2706,
	2707,
	2729,
	2730,
	2737,
	2738,
	2740,
	2741,
	2746,
	2749,
	2758,
	2759,
	2762,
	2763,
	2765,
	2768,
	2769,
	2784,
	2788,
	2809,
	2813,
	2817,
	2820,
	2821,
	2829,
	2831,
	2833,
	2835,
	2857,
	2858,
	2865,
	2866,
	2868,
	2869,
	2874,
	2877,
	2885,
	2887,
	2889,
	2891,
	2893,
	2902,
	2904,
	2908,
	2910,
	2911,
	2916,
	2929,
	2930,
	2946,
	2948,
	2949,
	2955,
	2958,
	2961,
	2962,
	2966,
	2969,
	2971,
	2972,
	2973,
	2974,
	2976,
	2979,
	2981,
	2984,
	2987,
	2990,
	3002,
	3006,
	3011,
	3014,
	3017,
	3018,
	3021,
	3024,
	3025,
	3031,
	3032,
	3072,
	3076,
	3077,
	3085,
	3086,
	3089,
	3090,
	3113,
	3114,
	3130,
	3133,
	3141,
	3142,
	3145,
	3146,
	3149,
	3157,
	3159,
	3160,
	3163,
	3168,
	3172,
	3200,
	3204,
	3205,
	3213,
	3214,
	3217,
	3218,
	3241,
	3242,
	3252,
	3253,
	3258,
	3261,
	3269,
	3270,
	3273,
	3274,
	3277,
	3285,
	3287,
	3294,
	3295,
	3296,
	3300,
	3313,
	3315,
	3328,
	3332,
	3333,
	3341,
	3342,
	3345,
	3346,
	3387,
	3389,
	3397,
	3398,
	3401,
	3402,
	3405,
	3406,
	3407,
	3412,
	3416,
	3423,
	3428,
	3450,
	3456,
	3458,
	3460,
	3461,
	3479,
	3482,
	3506,
	3507,
	3516,
	3517,
	3518,
	3520,
	3527,
	3535,
	3541,
	3542,
	3543,
	3544,
	3552,
	3570,
	3572,
	3585,
	3643,
	3648,
	3655,
	3661,
	3662,
	3713,
	3715,
	3716,
	3717,
	3718,
	3723,
	3724,
	3748,
	3749,
	3750,
	3751,
	3770,
	3771,
	3774,
	3776,
	3781,
	3782,
	3783,
	3789,
	3790,
	3804,
	3808,
	3840,
	3841,
	3904,
	3912,
	3913,
	3949,
	3953,
	3970,
	3976,
	3992,
	3993,
	4029,
	4096,
	4151,
	4152,
	4153,
	4155,
	4160,
	4176,
	4240,
	4250,
	4254,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	4304,
	4347,
	4348,
	4681,
	4682,
	4686,
	4688,
	4695,
	4696,
	4697,
	4698,
	4702,
	4704,
	4745,
	4746,
	4750,
	4752,
	4785,
	4786,
	4790,
	4792,
	4799,
	4800,
	4801,
	4802,
	4806,
	4808,
	4823,
	4824,
	4881,
	4882,
	4886,
	4888,
	4955,
	4992,
	5008,
	5024,
	5110,
	5112,
	5118,
	5121,
	5741,
	5743,
	5760,
	5761,
	5787,
	5792,
	5867,
	5870,
	5881,
	5888,
	5901,
	5902,
	5908,
	5920,
	5940,
	5952,
	5972,
	5984,
	5997,
	5998,
	6001,
	6002,
	6004,
	6016,
	6068,
	6070,
	6089,
	6103,
	6104,
	6108,
	6109,
	6176,
	6265,
	6272,
	6315,
	6320,
	6390,
	6400,
	6431,
	6432,
	6444,
	6448,
	6457,
	6480,
	6510,
	6512,
	6517,
	6528,
	6572,
	6576,
	6602,
	6656,
	6684,
	6688,
	6751,
	6753,
	6773,
	6823,
	6824,
	6912,
	6964,
	6965,
	6980,
	6981,
	6988,
	7040,
	7082,
	7084,
	7088,
	7098,
	7142,
	7143,
	7154,
	7168,
	7223,
	7245,
	7248,
	7258,
	7294,
	7296,
	7305,
	7312,
	7355,
	7357,
	7360,
	7401,
	7405,
	7406,
	7412,
	7413,
	7415,
	7418,
	7419,
	7424,
	7616,
	7655,
	7669,
	7680,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8125,
	8126,
	8127,
	8130,
	8133,
	8134,
	8141,
	8144,
	8148,
	8150,
	8156,
	8160,
	8173,
	8178,
	8181,
	8182,
	8189,
	8305,
	8306,
	8319,
	8320,
	8336,
	8349,
	8450,
	8451,
	8455,
	8456,
	8458,
	8468,
	8469,
	8470,
	8473,
	8478,
	8484,
	8485,
	8486,
	8487,
	8488,
	8489,
	8490,
	8494,
	8495,
	8506,
	8508,
	8512,
	8517,
	8522,
	8526,
	8527,
	8544,
	8585,
	9398,
	9450,
	11264,
	11311,
	11312,
	11359,
	11360,
	11493,
	11499,
	11503,
	11506,
	11508,
	11520,
	11558,
	11559,
	11560,
	11565,
	11566,
	11568,
	11624,
	11631,
	11632,
	11648,
	11671,
	11680,
	11687,
	11688,
	11695,
	11696,
	11703,
	11704,
	11711,
	11712,
	11719,
	11720,
	11727,
	11728,
	11735,
	11736,
	11743,
	11744,
	11776,
	11823,
	11824,
	12293,
	12296,
	12321,
	12330,
	12337,
	12342,
	12344,
	12349,
	12353,
	12439,
	12445,
	12448,
	12449,
	12539,
	12540,
	12544,
	12549,
	12592,
	12593,
	12687,
	12704,
	12731,
	12784,
	12800,
	13312,
	19894,
	19968,
	40944,
	40960,
	42125,
	42192,
	42238,
	42240,
	42509,
	42512,
	42528,
	42538,
	42540,
	42560,
	42607,
	42612,
	42620,
	42623,
	42736,
	42775,
	42784,
	42786,
	42889,
	42891,
	42944,
	42946,
	42951,
	42999,
	43014,
	43015,
	43048,
	43072,
	43124,
	43136,
	43204,
	43205,
	43206,
	43250,
	43256,
	43259,
	43260,
	43261,
	43264,
	43274,
	43307,
	43312,
	43347,
	43360,
	43389,
	43392,
	43443,
	43444,
	43456,
	43471,
	43472,
	43488,
	43504,
	43514,
	43519,
	43520,
	43575,
	43584,
	43598,
	43616,
	43639,
	43642,
	43711,
	43712,
	43713,
	43714,
	43715,
	43739,
	43742,
	43744,
	43760,
	43762,
	43766,
	43777,
	43783,
	43785,
	43791,
	43793,
	43799,
	43808,
	43815,
	43816,
	43823,
	43824,
	43867,
	43868,
	43880,
	43888,
	44011,
	44032,
	55204,
	55216,
	55239,
	55243,
	55292,
	63744,
	64110,
	64112,
	64218,
	64256,
	64263,
	64275,
	64280,
	64285,
	64297,
	64298,
	64311,
	64312,
	64317,
	64318,
	64319,
	64320,
	64322,
	64323,
	64325,
	64326,
	64434,
	64467,
	64830,
	64848,
	64912,
	64914,
	64968,
	65008,
	65020,
	65136,
	65141,
	65142,
	65277,
	65313,
	65339,
	65345,
	65371,
	65382,
	65471,
	65474,
	65480,
	65482,
	65488,
	65490,
	65496,
	65498,
	65501,
	65536,
	65548,
	65549,
	65575,
	65576,
	65595,
	65596,
	65598,
	65599,
	65614,
	65616,
	65630,
	65664,
	65787,
	65856,
	65909,
	66176,
	66205,
	66208,
	66257,
	66304,
	66336,
	66349,
	66379,
	66384,
	66427,
	66432,
	66462,
	66464,
	66500,
	66504,
	66512,
	66513,
	66518,
	66560,
	66718,
	66736,
	66772,
	66776,
	66812,
	66816,
	66856,
	66864,
	66916,
	67072,
	67383,
	67392,
	67414,
	67424,
	67432,
	67584,
	67590,
	67592,
	67593,
	67594,
	67638,
	67639,
	67641,
	67644,
	67645,
	67647,
	67670,
	67680,
	67703,
	67712,
	67743,
	67808,
	67827,
	67828,
	67830,
	67840,
	67862,
	67872,
	67898,
	67968,
	68024,
	68030,
	68032,
	68096,
	68100,
	68101,
	68103,
	68108,
	68116,
	68117,
	68120,
	68121,
	68150,
	68192,
	68221,
	68224,
	68253,
	68288,
	68296,
	68297,
	68325,
	68352,
	68406,
	68416,
	68438,
	68448,
	68467,
	68480,
	68498,
	68608,
	68681,
	68736,
	68787,
	68800,
	68851,
	68864,
	68904,
	69376,
	69405,
	69415,
	69416,
	69424,
	69446,
	69600,
	69623,
	69632,
	69702,
	69762,
	69817,
	69840,
	69865,
	69888,
	69939,
	69956,
	69959,
	69968,
	70003,
	70006,
	70007,
	70016,
	70080,
	70081,
	70085,
	70106,
	70107,
	70108,
	70109,
	70144,
	70162,
	70163,
	70197,
	70199,
	70200,
	70206,
	70207,
	70272,
	70279,
	70280,
	70281,
	70282,
	70286,
	70287,
	70302,
	70303,
	70313,
	70320,
	70377,
	70400,
	70404,
	70405,
	70413,
	70415,
	70417,
	70419,
	70441,
	70442,
	70449,
	70450,
	70452,
	70453,
	70458,
	70461,
	70469,
	70471,
	70473,
	70475,
	70477,
	70480,
	70481,
	70487,
	70488,
	70493,
	70500,
	70656,
	70722,
	70723,
	70726,
	70727,
	70731,
	70751,
	70752,
	70784,
	70850,
	70852,
	70854,
	70855,
	70856,
	71040,
	71094,
	71096,
	71103,
	71128,
	71134,
	71168,
	71231,
	71232,
	71233,
	71236,
	71237,
	71296,
	71350,
	71352,
	71353,
	71424,
	71451,
	71453,
	71467,
	71680,
	71737,
	71840,
	71904,
	71935,
	71936,
	72096,
	72104,
	72106,
	72152,
	72154,
	72160,
	72161,
	72162,
	72163,
	72165,
	72192,
	72243,
	72245,
	72255,
	72272,
	72344,
	72349,
	72350,
	72384,
	72441,
	72704,
	72713,
	72714,
	72759,
	72760,
	72767,
	72768,
	72769,
	72818,
	72848,
	72850,
	72872,
	72873,
	72887,
	72960,
	72967,
	72968,
	72970,
	72971,
	73015,
	73018,
	73019,
	73020,
	73022,
	73023,
	73026,
	73027,
	73028,
	73030,
	73032,
	73056,
	73062,
	73063,
	73065,
	73066,
	73103,
	73104,
	73106,
	73107,
	73111,
	73112,
	73113,
	73440,
	73463,
	73728,
	74650,
	74752,
	74863,
	74880,
	75076,
	77824,
	78895,
	82944,
	83527,
	92160,
	92729,
	92736,
	92767,
	92880,
	92910,
	92928,
	92976,
	92992,
	92996,
	93027,
	93048,
	93053,
	93072,
	93760,
	93824,
	93952,
	94027,
	94031,
	94088,
	94095,
	94112,
	94176,
	94178,
	94179,
	94180,
	94208,
	100344,
	100352,
	101107,
	110592,
	110879,
	110928,
	110931,
	110948,
	110952,
	110960,
	111356,
	113664,
	113771,
	113776,
	113789,
	113792,
	113801,
	113808,
	113818,
	113822,
	113823,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120513,
	120514,
	120539,
	120540,
	120571,
	120572,
	120597,
	120598,
	120629,
	120630,
	120655,
	120656,
	120687,
	120688,
	120713,
	120714,
	120745,
	120746,
	120771,
	120772,
	120780,
	122880,
	122887,
	122888,
	122905,
	122907,
	122914,
	122915,
	122917,
	122918,
	122923,
	123136,
	123181,
	123191,
	123198,
	123214,
	123215,
	123584,
	123628,
	124928,
	125125,
	125184,
	125252,
	125255,
	125256,
	125259,
	125260,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	127280,
	127306,
	127312,
	127338,
	127344,
	127370,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457,
	194560,
	195102
]);
property.set("Any", [0, 1114112]);
property.set("Assigned", [
	0,
	888,
	890,
	896,
	900,
	907,
	908,
	909,
	910,
	930,
	931,
	1328,
	1329,
	1367,
	1369,
	1419,
	1421,
	1424,
	1425,
	1480,
	1488,
	1515,
	1519,
	1525,
	1536,
	1565,
	1566,
	1806,
	1807,
	1867,
	1869,
	1970,
	1984,
	2043,
	2045,
	2094,
	2096,
	2111,
	2112,
	2140,
	2142,
	2143,
	2144,
	2155,
	2208,
	2229,
	2230,
	2238,
	2259,
	2436,
	2437,
	2445,
	2447,
	2449,
	2451,
	2473,
	2474,
	2481,
	2482,
	2483,
	2486,
	2490,
	2492,
	2501,
	2503,
	2505,
	2507,
	2511,
	2519,
	2520,
	2524,
	2526,
	2527,
	2532,
	2534,
	2559,
	2561,
	2564,
	2565,
	2571,
	2575,
	2577,
	2579,
	2601,
	2602,
	2609,
	2610,
	2612,
	2613,
	2615,
	2616,
	2618,
	2620,
	2621,
	2622,
	2627,
	2631,
	2633,
	2635,
	2638,
	2641,
	2642,
	2649,
	2653,
	2654,
	2655,
	2662,
	2679,
	2689,
	2692,
	2693,
	2702,
	2703,
	2706,
	2707,
	2729,
	2730,
	2737,
	2738,
	2740,
	2741,
	2746,
	2748,
	2758,
	2759,
	2762,
	2763,
	2766,
	2768,
	2769,
	2784,
	2788,
	2790,
	2802,
	2809,
	2816,
	2817,
	2820,
	2821,
	2829,
	2831,
	2833,
	2835,
	2857,
	2858,
	2865,
	2866,
	2868,
	2869,
	2874,
	2876,
	2885,
	2887,
	2889,
	2891,
	2894,
	2902,
	2904,
	2908,
	2910,
	2911,
	2916,
	2918,
	2936,
	2946,
	2948,
	2949,
	2955,
	2958,
	2961,
	2962,
	2966,
	2969,
	2971,
	2972,
	2973,
	2974,
	2976,
	2979,
	2981,
	2984,
	2987,
	2990,
	3002,
	3006,
	3011,
	3014,
	3017,
	3018,
	3022,
	3024,
	3025,
	3031,
	3032,
	3046,
	3067,
	3072,
	3085,
	3086,
	3089,
	3090,
	3113,
	3114,
	3130,
	3133,
	3141,
	3142,
	3145,
	3146,
	3150,
	3157,
	3159,
	3160,
	3163,
	3168,
	3172,
	3174,
	3184,
	3191,
	3213,
	3214,
	3217,
	3218,
	3241,
	3242,
	3252,
	3253,
	3258,
	3260,
	3269,
	3270,
	3273,
	3274,
	3278,
	3285,
	3287,
	3294,
	3295,
	3296,
	3300,
	3302,
	3312,
	3313,
	3315,
	3328,
	3332,
	3333,
	3341,
	3342,
	3345,
	3346,
	3397,
	3398,
	3401,
	3402,
	3408,
	3412,
	3428,
	3430,
	3456,
	3458,
	3460,
	3461,
	3479,
	3482,
	3506,
	3507,
	3516,
	3517,
	3518,
	3520,
	3527,
	3530,
	3531,
	3535,
	3541,
	3542,
	3543,
	3544,
	3552,
	3558,
	3568,
	3570,
	3573,
	3585,
	3643,
	3647,
	3676,
	3713,
	3715,
	3716,
	3717,
	3718,
	3723,
	3724,
	3748,
	3749,
	3750,
	3751,
	3774,
	3776,
	3781,
	3782,
	3783,
	3784,
	3790,
	3792,
	3802,
	3804,
	3808,
	3840,
	3912,
	3913,
	3949,
	3953,
	3992,
	3993,
	4029,
	4030,
	4045,
	4046,
	4059,
	4096,
	4294,
	4295,
	4296,
	4301,
	4302,
	4304,
	4681,
	4682,
	4686,
	4688,
	4695,
	4696,
	4697,
	4698,
	4702,
	4704,
	4745,
	4746,
	4750,
	4752,
	4785,
	4786,
	4790,
	4792,
	4799,
	4800,
	4801,
	4802,
	4806,
	4808,
	4823,
	4824,
	4881,
	4882,
	4886,
	4888,
	4955,
	4957,
	4989,
	4992,
	5018,
	5024,
	5110,
	5112,
	5118,
	5120,
	5789,
	5792,
	5881,
	5888,
	5901,
	5902,
	5909,
	5920,
	5943,
	5952,
	5972,
	5984,
	5997,
	5998,
	6001,
	6002,
	6004,
	6016,
	6110,
	6112,
	6122,
	6128,
	6138,
	6144,
	6159,
	6160,
	6170,
	6176,
	6265,
	6272,
	6315,
	6320,
	6390,
	6400,
	6431,
	6432,
	6444,
	6448,
	6460,
	6464,
	6465,
	6468,
	6510,
	6512,
	6517,
	6528,
	6572,
	6576,
	6602,
	6608,
	6619,
	6622,
	6684,
	6686,
	6751,
	6752,
	6781,
	6783,
	6794,
	6800,
	6810,
	6816,
	6830,
	6832,
	6847,
	6912,
	6988,
	6992,
	7037,
	7040,
	7156,
	7164,
	7224,
	7227,
	7242,
	7245,
	7305,
	7312,
	7355,
	7357,
	7368,
	7376,
	7419,
	7424,
	7674,
	7675,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8133,
	8134,
	8148,
	8150,
	8156,
	8157,
	8176,
	8178,
	8181,
	8182,
	8191,
	8192,
	8293,
	8294,
	8306,
	8308,
	8335,
	8336,
	8349,
	8352,
	8384,
	8400,
	8433,
	8448,
	8588,
	8592,
	9255,
	9280,
	9291,
	9312,
	11124,
	11126,
	11158,
	11160,
	11311,
	11312,
	11359,
	11360,
	11508,
	11513,
	11558,
	11559,
	11560,
	11565,
	11566,
	11568,
	11624,
	11631,
	11633,
	11647,
	11671,
	11680,
	11687,
	11688,
	11695,
	11696,
	11703,
	11704,
	11711,
	11712,
	11719,
	11720,
	11727,
	11728,
	11735,
	11736,
	11743,
	11744,
	11856,
	11904,
	11930,
	11931,
	12020,
	12032,
	12246,
	12272,
	12284,
	12288,
	12352,
	12353,
	12439,
	12441,
	12544,
	12549,
	12592,
	12593,
	12687,
	12688,
	12731,
	12736,
	12772,
	12784,
	12831,
	12832,
	13055,
	13056,
	19894,
	19904,
	40944,
	40960,
	42125,
	42128,
	42183,
	42192,
	42540,
	42560,
	42744,
	42752,
	42944,
	42946,
	42951,
	42999,
	43052,
	43056,
	43066,
	43072,
	43128,
	43136,
	43206,
	43214,
	43226,
	43232,
	43348,
	43359,
	43389,
	43392,
	43470,
	43471,
	43482,
	43486,
	43519,
	43520,
	43575,
	43584,
	43598,
	43600,
	43610,
	43612,
	43715,
	43739,
	43767,
	43777,
	43783,
	43785,
	43791,
	43793,
	43799,
	43808,
	43815,
	43816,
	43823,
	43824,
	43880,
	43888,
	44014,
	44016,
	44026,
	44032,
	55204,
	55216,
	55239,
	55243,
	55292,
	55296,
	64110,
	64112,
	64218,
	64256,
	64263,
	64275,
	64280,
	64285,
	64311,
	64312,
	64317,
	64318,
	64319,
	64320,
	64322,
	64323,
	64325,
	64326,
	64450,
	64467,
	64832,
	64848,
	64912,
	64914,
	64968,
	65008,
	65022,
	65024,
	65050,
	65056,
	65107,
	65108,
	65127,
	65128,
	65132,
	65136,
	65141,
	65142,
	65277,
	65279,
	65280,
	65281,
	65471,
	65474,
	65480,
	65482,
	65488,
	65490,
	65496,
	65498,
	65501,
	65504,
	65511,
	65512,
	65519,
	65529,
	65534,
	65536,
	65548,
	65549,
	65575,
	65576,
	65595,
	65596,
	65598,
	65599,
	65614,
	65616,
	65630,
	65664,
	65787,
	65792,
	65795,
	65799,
	65844,
	65847,
	65935,
	65936,
	65948,
	65952,
	65953,
	66000,
	66046,
	66176,
	66205,
	66208,
	66257,
	66272,
	66300,
	66304,
	66340,
	66349,
	66379,
	66384,
	66427,
	66432,
	66462,
	66463,
	66500,
	66504,
	66518,
	66560,
	66718,
	66720,
	66730,
	66736,
	66772,
	66776,
	66812,
	66816,
	66856,
	66864,
	66916,
	66927,
	66928,
	67072,
	67383,
	67392,
	67414,
	67424,
	67432,
	67584,
	67590,
	67592,
	67593,
	67594,
	67638,
	67639,
	67641,
	67644,
	67645,
	67647,
	67670,
	67671,
	67743,
	67751,
	67760,
	67808,
	67827,
	67828,
	67830,
	67835,
	67868,
	67871,
	67898,
	67903,
	67904,
	67968,
	68024,
	68028,
	68048,
	68050,
	68100,
	68101,
	68103,
	68108,
	68116,
	68117,
	68120,
	68121,
	68150,
	68152,
	68155,
	68159,
	68169,
	68176,
	68185,
	68192,
	68256,
	68288,
	68327,
	68331,
	68343,
	68352,
	68406,
	68409,
	68438,
	68440,
	68467,
	68472,
	68498,
	68505,
	68509,
	68521,
	68528,
	68608,
	68681,
	68736,
	68787,
	68800,
	68851,
	68858,
	68904,
	68912,
	68922,
	69216,
	69247,
	69376,
	69416,
	69424,
	69466,
	69600,
	69623,
	69632,
	69710,
	69714,
	69744,
	69759,
	69826,
	69837,
	69838,
	69840,
	69865,
	69872,
	69882,
	69888,
	69941,
	69942,
	69959,
	69968,
	70007,
	70016,
	70094,
	70096,
	70112,
	70113,
	70133,
	70144,
	70162,
	70163,
	70207,
	70272,
	70279,
	70280,
	70281,
	70282,
	70286,
	70287,
	70302,
	70303,
	70314,
	70320,
	70379,
	70384,
	70394,
	70400,
	70404,
	70405,
	70413,
	70415,
	70417,
	70419,
	70441,
	70442,
	70449,
	70450,
	70452,
	70453,
	70458,
	70459,
	70469,
	70471,
	70473,
	70475,
	70478,
	70480,
	70481,
	70487,
	70488,
	70493,
	70500,
	70502,
	70509,
	70512,
	70517,
	70656,
	70746,
	70747,
	70748,
	70749,
	70752,
	70784,
	70856,
	70864,
	70874,
	71040,
	71094,
	71096,
	71134,
	71168,
	71237,
	71248,
	71258,
	71264,
	71277,
	71296,
	71353,
	71360,
	71370,
	71424,
	71451,
	71453,
	71468,
	71472,
	71488,
	71680,
	71740,
	71840,
	71923,
	71935,
	71936,
	72096,
	72104,
	72106,
	72152,
	72154,
	72165,
	72192,
	72264,
	72272,
	72355,
	72384,
	72441,
	72704,
	72713,
	72714,
	72759,
	72760,
	72774,
	72784,
	72813,
	72816,
	72848,
	72850,
	72872,
	72873,
	72887,
	72960,
	72967,
	72968,
	72970,
	72971,
	73015,
	73018,
	73019,
	73020,
	73022,
	73023,
	73032,
	73040,
	73050,
	73056,
	73062,
	73063,
	73065,
	73066,
	73103,
	73104,
	73106,
	73107,
	73113,
	73120,
	73130,
	73440,
	73465,
	73664,
	73714,
	73727,
	74650,
	74752,
	74863,
	74864,
	74869,
	74880,
	75076,
	77824,
	78895,
	78896,
	78905,
	82944,
	83527,
	92160,
	92729,
	92736,
	92767,
	92768,
	92778,
	92782,
	92784,
	92880,
	92910,
	92912,
	92918,
	92928,
	92998,
	93008,
	93018,
	93019,
	93026,
	93027,
	93048,
	93053,
	93072,
	93760,
	93851,
	93952,
	94027,
	94031,
	94088,
	94095,
	94112,
	94176,
	94180,
	94208,
	100344,
	100352,
	101107,
	110592,
	110879,
	110928,
	110931,
	110948,
	110952,
	110960,
	111356,
	113664,
	113771,
	113776,
	113789,
	113792,
	113801,
	113808,
	113818,
	113820,
	113828,
	118784,
	119030,
	119040,
	119079,
	119081,
	119273,
	119296,
	119366,
	119520,
	119540,
	119552,
	119639,
	119648,
	119673,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120780,
	120782,
	121484,
	121499,
	121504,
	121505,
	121520,
	122880,
	122887,
	122888,
	122905,
	122907,
	122914,
	122915,
	122917,
	122918,
	122923,
	123136,
	123181,
	123184,
	123198,
	123200,
	123210,
	123214,
	123216,
	123584,
	123642,
	123647,
	123648,
	124928,
	125125,
	125127,
	125143,
	125184,
	125260,
	125264,
	125274,
	125278,
	125280,
	126065,
	126133,
	126209,
	126270,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	126704,
	126706,
	126976,
	127020,
	127024,
	127124,
	127136,
	127151,
	127153,
	127168,
	127169,
	127184,
	127185,
	127222,
	127232,
	127245,
	127248,
	127341,
	127344,
	127405,
	127462,
	127491,
	127504,
	127548,
	127552,
	127561,
	127568,
	127570,
	127584,
	127590,
	127744,
	128726,
	128736,
	128749,
	128752,
	128763,
	128768,
	128884,
	128896,
	128985,
	128992,
	129004,
	129024,
	129036,
	129040,
	129096,
	129104,
	129114,
	129120,
	129160,
	129168,
	129198,
	129280,
	129292,
	129293,
	129394,
	129395,
	129399,
	129402,
	129443,
	129445,
	129451,
	129454,
	129483,
	129485,
	129620,
	129632,
	129646,
	129648,
	129652,
	129656,
	129659,
	129664,
	129667,
	129680,
	129686,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457,
	194560,
	195102,
	917505,
	917506,
	917536,
	917632,
	917760,
	918000,
	983040,
	1048574,
	1048576,
	1114110
]);
property.set("Bidi_Control", [1564, 1565, 8206, 8208, 8234, 8239, 8294, 8298]);
property.set("Bidi_Mirrored", [
	40,
	42,
	60,
	61,
	62,
	63,
	91,
	92,
	93,
	94,
	123,
	124,
	125,
	126,
	171,
	172,
	187,
	188,
	3898,
	3902,
	5787,
	5789,
	8249,
	8251,
	8261,
	8263,
	8317,
	8319,
	8333,
	8335,
	8512,
	8513,
	8705,
	8709,
	8712,
	8718,
	8721,
	8722,
	8725,
	8727,
	8730,
	8734,
	8735,
	8739,
	8740,
	8741,
	8742,
	8743,
	8747,
	8756,
	8761,
	8762,
	8763,
	8781,
	8786,
	8790,
	8799,
	8801,
	8802,
	8803,
	8804,
	8812,
	8814,
	8845,
	8847,
	8851,
	8856,
	8857,
	8866,
	8868,
	8870,
	8889,
	8894,
	8896,
	8905,
	8910,
	8912,
	8914,
	8918,
	8942,
	8944,
	8960,
	8968,
	8972,
	8992,
	8994,
	9001,
	9003,
	10088,
	10102,
	10176,
	10177,
	10179,
	10183,
	10184,
	10186,
	10187,
	10190,
	10195,
	10199,
	10204,
	10207,
	10210,
	10224,
	10627,
	10649,
	10651,
	10657,
	10658,
	10672,
	10680,
	10681,
	10688,
	10694,
	10697,
	10698,
	10702,
	10707,
	10708,
	10710,
	10712,
	10717,
	10721,
	10722,
	10723,
	10726,
	10728,
	10730,
	10740,
	10746,
	10748,
	10750,
	10762,
	10781,
	10782,
	10786,
	10788,
	10789,
	10790,
	10791,
	10793,
	10794,
	10795,
	10799,
	10804,
	10806,
	10812,
	10815,
	10839,
	10841,
	10852,
	10854,
	10858,
	10862,
	10863,
	10865,
	10867,
	10869,
	10873,
	10916,
	10918,
	10926,
	10927,
	10967,
	10972,
	10973,
	10974,
	10975,
	10978,
	10983,
	10988,
	10991,
	10995,
	10996,
	10999,
	11004,
	11005,
	11006,
	11262,
	11263,
	11778,
	11782,
	11785,
	11787,
	11788,
	11790,
	11804,
	11806,
	11808,
	11818,
	12296,
	12306,
	12308,
	12316,
	65113,
	65119,
	65124,
	65126,
	65288,
	65290,
	65308,
	65309,
	65310,
	65311,
	65339,
	65340,
	65341,
	65342,
	65371,
	65372,
	65373,
	65374,
	65375,
	65377,
	65378,
	65380,
	120539,
	120540,
	120597,
	120598,
	120655,
	120656,
	120713,
	120714,
	120771,
	120772
]);
property.set("Case_Ignorable", [
	39,
	40,
	46,
	47,
	58,
	59,
	94,
	95,
	96,
	97,
	168,
	169,
	173,
	174,
	175,
	176,
	180,
	181,
	183,
	185,
	688,
	880,
	884,
	886,
	890,
	891,
	900,
	902,
	903,
	904,
	1155,
	1162,
	1369,
	1370,
	1425,
	1470,
	1471,
	1472,
	1473,
	1475,
	1476,
	1478,
	1479,
	1480,
	1524,
	1525,
	1536,
	1542,
	1552,
	1563,
	1564,
	1565,
	1600,
	1601,
	1611,
	1632,
	1648,
	1649,
	1750,
	1758,
	1759,
	1769,
	1770,
	1774,
	1807,
	1808,
	1809,
	1810,
	1840,
	1867,
	1958,
	1969,
	2027,
	2038,
	2042,
	2043,
	2045,
	2046,
	2070,
	2094,
	2137,
	2140,
	2259,
	2307,
	2362,
	2363,
	2364,
	2365,
	2369,
	2377,
	2381,
	2382,
	2385,
	2392,
	2402,
	2404,
	2417,
	2418,
	2433,
	2434,
	2492,
	2493,
	2497,
	2501,
	2509,
	2510,
	2530,
	2532,
	2558,
	2559,
	2561,
	2563,
	2620,
	2621,
	2625,
	2627,
	2631,
	2633,
	2635,
	2638,
	2641,
	2642,
	2672,
	2674,
	2677,
	2678,
	2689,
	2691,
	2748,
	2749,
	2753,
	2758,
	2759,
	2761,
	2765,
	2766,
	2786,
	2788,
	2810,
	2816,
	2817,
	2818,
	2876,
	2877,
	2879,
	2880,
	2881,
	2885,
	2893,
	2894,
	2902,
	2903,
	2914,
	2916,
	2946,
	2947,
	3008,
	3009,
	3021,
	3022,
	3072,
	3073,
	3076,
	3077,
	3134,
	3137,
	3142,
	3145,
	3146,
	3150,
	3157,
	3159,
	3170,
	3172,
	3201,
	3202,
	3260,
	3261,
	3263,
	3264,
	3270,
	3271,
	3276,
	3278,
	3298,
	3300,
	3328,
	3330,
	3387,
	3389,
	3393,
	3397,
	3405,
	3406,
	3426,
	3428,
	3530,
	3531,
	3538,
	3541,
	3542,
	3543,
	3633,
	3634,
	3636,
	3643,
	3654,
	3663,
	3761,
	3762,
	3764,
	3773,
	3782,
	3783,
	3784,
	3790,
	3864,
	3866,
	3893,
	3894,
	3895,
	3896,
	3897,
	3898,
	3953,
	3967,
	3968,
	3973,
	3974,
	3976,
	3981,
	3992,
	3993,
	4029,
	4038,
	4039,
	4141,
	4145,
	4146,
	4152,
	4153,
	4155,
	4157,
	4159,
	4184,
	4186,
	4190,
	4193,
	4209,
	4213,
	4226,
	4227,
	4229,
	4231,
	4237,
	4238,
	4253,
	4254,
	4348,
	4349,
	4957,
	4960,
	5906,
	5909,
	5938,
	5941,
	5970,
	5972,
	6002,
	6004,
	6068,
	6070,
	6071,
	6078,
	6086,
	6087,
	6089,
	6100,
	6103,
	6104,
	6109,
	6110,
	6155,
	6159,
	6211,
	6212,
	6277,
	6279,
	6313,
	6314,
	6432,
	6435,
	6439,
	6441,
	6450,
	6451,
	6457,
	6460,
	6679,
	6681,
	6683,
	6684,
	6742,
	6743,
	6744,
	6751,
	6752,
	6753,
	6754,
	6755,
	6757,
	6765,
	6771,
	6781,
	6783,
	6784,
	6823,
	6824,
	6832,
	6847,
	6912,
	6916,
	6964,
	6965,
	6966,
	6971,
	6972,
	6973,
	6978,
	6979,
	7019,
	7028,
	7040,
	7042,
	7074,
	7078,
	7080,
	7082,
	7083,
	7086,
	7142,
	7143,
	7144,
	7146,
	7149,
	7150,
	7151,
	7154,
	7212,
	7220,
	7222,
	7224,
	7288,
	7294,
	7376,
	7379,
	7380,
	7393,
	7394,
	7401,
	7405,
	7406,
	7412,
	7413,
	7416,
	7418,
	7468,
	7531,
	7544,
	7545,
	7579,
	7674,
	7675,
	7680,
	8125,
	8126,
	8127,
	8130,
	8141,
	8144,
	8157,
	8160,
	8173,
	8176,
	8189,
	8191,
	8203,
	8208,
	8216,
	8218,
	8228,
	8229,
	8231,
	8232,
	8234,
	8239,
	8288,
	8293,
	8294,
	8304,
	8305,
	8306,
	8319,
	8320,
	8336,
	8349,
	8400,
	8433,
	11388,
	11390,
	11503,
	11506,
	11631,
	11632,
	11647,
	11648,
	11744,
	11776,
	11823,
	11824,
	12293,
	12294,
	12330,
	12334,
	12337,
	12342,
	12347,
	12348,
	12441,
	12447,
	12540,
	12543,
	40981,
	40982,
	42232,
	42238,
	42508,
	42509,
	42607,
	42611,
	42612,
	42622,
	42623,
	42624,
	42652,
	42656,
	42736,
	42738,
	42752,
	42786,
	42864,
	42865,
	42888,
	42891,
	43000,
	43002,
	43010,
	43011,
	43014,
	43015,
	43019,
	43020,
	43045,
	43047,
	43204,
	43206,
	43232,
	43250,
	43263,
	43264,
	43302,
	43310,
	43335,
	43346,
	43392,
	43395,
	43443,
	43444,
	43446,
	43450,
	43452,
	43454,
	43471,
	43472,
	43493,
	43495,
	43561,
	43567,
	43569,
	43571,
	43573,
	43575,
	43587,
	43588,
	43596,
	43597,
	43632,
	43633,
	43644,
	43645,
	43696,
	43697,
	43698,
	43701,
	43703,
	43705,
	43710,
	43712,
	43713,
	43714,
	43741,
	43742,
	43756,
	43758,
	43763,
	43765,
	43766,
	43767,
	43867,
	43872,
	44005,
	44006,
	44008,
	44009,
	44013,
	44014,
	64286,
	64287,
	64434,
	64450,
	65024,
	65040,
	65043,
	65044,
	65056,
	65072,
	65106,
	65107,
	65109,
	65110,
	65279,
	65280,
	65287,
	65288,
	65294,
	65295,
	65306,
	65307,
	65342,
	65343,
	65344,
	65345,
	65392,
	65393,
	65438,
	65440,
	65507,
	65508,
	65529,
	65532,
	66045,
	66046,
	66272,
	66273,
	66422,
	66427,
	68097,
	68100,
	68101,
	68103,
	68108,
	68112,
	68152,
	68155,
	68159,
	68160,
	68325,
	68327,
	68900,
	68904,
	69446,
	69457,
	69633,
	69634,
	69688,
	69703,
	69759,
	69762,
	69811,
	69815,
	69817,
	69819,
	69821,
	69822,
	69837,
	69838,
	69888,
	69891,
	69927,
	69932,
	69933,
	69941,
	70003,
	70004,
	70016,
	70018,
	70070,
	70079,
	70089,
	70093,
	70191,
	70194,
	70196,
	70197,
	70198,
	70200,
	70206,
	70207,
	70367,
	70368,
	70371,
	70379,
	70400,
	70402,
	70459,
	70461,
	70464,
	70465,
	70502,
	70509,
	70512,
	70517,
	70712,
	70720,
	70722,
	70725,
	70726,
	70727,
	70750,
	70751,
	70835,
	70841,
	70842,
	70843,
	70847,
	70849,
	70850,
	70852,
	71090,
	71094,
	71100,
	71102,
	71103,
	71105,
	71132,
	71134,
	71219,
	71227,
	71229,
	71230,
	71231,
	71233,
	71339,
	71340,
	71341,
	71342,
	71344,
	71350,
	71351,
	71352,
	71453,
	71456,
	71458,
	71462,
	71463,
	71468,
	71727,
	71736,
	71737,
	71739,
	72148,
	72152,
	72154,
	72156,
	72160,
	72161,
	72193,
	72203,
	72243,
	72249,
	72251,
	72255,
	72263,
	72264,
	72273,
	72279,
	72281,
	72284,
	72330,
	72343,
	72344,
	72346,
	72752,
	72759,
	72760,
	72766,
	72767,
	72768,
	72850,
	72872,
	72874,
	72881,
	72882,
	72884,
	72885,
	72887,
	73009,
	73015,
	73018,
	73019,
	73020,
	73022,
	73023,
	73030,
	73031,
	73032,
	73104,
	73106,
	73109,
	73110,
	73111,
	73112,
	73459,
	73461,
	78896,
	78905,
	92912,
	92917,
	92976,
	92983,
	92992,
	92996,
	94031,
	94032,
	94095,
	94112,
	94176,
	94178,
	94179,
	94180,
	113821,
	113823,
	113824,
	113828,
	119143,
	119146,
	119155,
	119171,
	119173,
	119180,
	119210,
	119214,
	119362,
	119365,
	121344,
	121399,
	121403,
	121453,
	121461,
	121462,
	121476,
	121477,
	121499,
	121504,
	121505,
	121520,
	122880,
	122887,
	122888,
	122905,
	122907,
	122914,
	122915,
	122917,
	122918,
	122923,
	123184,
	123198,
	123628,
	123632,
	125136,
	125143,
	125252,
	125260,
	127995,
	128000,
	917505,
	917506,
	917536,
	917632,
	917760,
	918000
]);
property.set("Cased", [
	65,
	91,
	97,
	123,
	170,
	171,
	181,
	182,
	186,
	187,
	192,
	215,
	216,
	247,
	248,
	443,
	444,
	448,
	452,
	660,
	661,
	697,
	704,
	706,
	736,
	741,
	837,
	838,
	880,
	884,
	886,
	888,
	890,
	894,
	895,
	896,
	902,
	903,
	904,
	907,
	908,
	909,
	910,
	930,
	931,
	1014,
	1015,
	1154,
	1162,
	1328,
	1329,
	1367,
	1376,
	1417,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	4304,
	4347,
	4349,
	4352,
	5024,
	5110,
	5112,
	5118,
	7296,
	7305,
	7312,
	7355,
	7357,
	7360,
	7424,
	7616,
	7680,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8125,
	8126,
	8127,
	8130,
	8133,
	8134,
	8141,
	8144,
	8148,
	8150,
	8156,
	8160,
	8173,
	8178,
	8181,
	8182,
	8189,
	8305,
	8306,
	8319,
	8320,
	8336,
	8349,
	8450,
	8451,
	8455,
	8456,
	8458,
	8468,
	8469,
	8470,
	8473,
	8478,
	8484,
	8485,
	8486,
	8487,
	8488,
	8489,
	8490,
	8494,
	8495,
	8501,
	8505,
	8506,
	8508,
	8512,
	8517,
	8522,
	8526,
	8527,
	8544,
	8576,
	8579,
	8581,
	9398,
	9450,
	11264,
	11311,
	11312,
	11359,
	11360,
	11493,
	11499,
	11503,
	11506,
	11508,
	11520,
	11558,
	11559,
	11560,
	11565,
	11566,
	42560,
	42606,
	42624,
	42654,
	42786,
	42888,
	42891,
	42895,
	42896,
	42944,
	42946,
	42951,
	43000,
	43003,
	43824,
	43867,
	43868,
	43880,
	43888,
	43968,
	64256,
	64263,
	64275,
	64280,
	65313,
	65339,
	65345,
	65371,
	66560,
	66640,
	66736,
	66772,
	66776,
	66812,
	68736,
	68787,
	68800,
	68851,
	71840,
	71904,
	93760,
	93824,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120513,
	120514,
	120539,
	120540,
	120571,
	120572,
	120597,
	120598,
	120629,
	120630,
	120655,
	120656,
	120687,
	120688,
	120713,
	120714,
	120745,
	120746,
	120771,
	120772,
	120780,
	125184,
	125252,
	127280,
	127306,
	127312,
	127338,
	127344,
	127370
]);
property.set("Changes_When_Casefolded", [
	65,
	91,
	181,
	182,
	192,
	215,
	216,
	224,
	256,
	257,
	258,
	259,
	260,
	261,
	262,
	263,
	264,
	265,
	266,
	267,
	268,
	269,
	270,
	271,
	272,
	273,
	274,
	275,
	276,
	277,
	278,
	279,
	280,
	281,
	282,
	283,
	284,
	285,
	286,
	287,
	288,
	289,
	290,
	291,
	292,
	293,
	294,
	295,
	296,
	297,
	298,
	299,
	300,
	301,
	302,
	303,
	304,
	305,
	306,
	307,
	308,
	309,
	310,
	311,
	313,
	314,
	315,
	316,
	317,
	318,
	319,
	320,
	321,
	322,
	323,
	324,
	325,
	326,
	327,
	328,
	329,
	331,
	332,
	333,
	334,
	335,
	336,
	337,
	338,
	339,
	340,
	341,
	342,
	343,
	344,
	345,
	346,
	347,
	348,
	349,
	350,
	351,
	352,
	353,
	354,
	355,
	356,
	357,
	358,
	359,
	360,
	361,
	362,
	363,
	364,
	365,
	366,
	367,
	368,
	369,
	370,
	371,
	372,
	373,
	374,
	375,
	376,
	378,
	379,
	380,
	381,
	382,
	383,
	384,
	385,
	387,
	388,
	389,
	390,
	392,
	393,
	396,
	398,
	402,
	403,
	405,
	406,
	409,
	412,
	414,
	415,
	417,
	418,
	419,
	420,
	421,
	422,
	424,
	425,
	426,
	428,
	429,
	430,
	432,
	433,
	436,
	437,
	438,
	439,
	441,
	444,
	445,
	452,
	454,
	455,
	457,
	458,
	460,
	461,
	462,
	463,
	464,
	465,
	466,
	467,
	468,
	469,
	470,
	471,
	472,
	473,
	474,
	475,
	476,
	478,
	479,
	480,
	481,
	482,
	483,
	484,
	485,
	486,
	487,
	488,
	489,
	490,
	491,
	492,
	493,
	494,
	495,
	497,
	499,
	500,
	501,
	502,
	505,
	506,
	507,
	508,
	509,
	510,
	511,
	512,
	513,
	514,
	515,
	516,
	517,
	518,
	519,
	520,
	521,
	522,
	523,
	524,
	525,
	526,
	527,
	528,
	529,
	530,
	531,
	532,
	533,
	534,
	535,
	536,
	537,
	538,
	539,
	540,
	541,
	542,
	543,
	544,
	545,
	546,
	547,
	548,
	549,
	550,
	551,
	552,
	553,
	554,
	555,
	556,
	557,
	558,
	559,
	560,
	561,
	562,
	563,
	570,
	572,
	573,
	575,
	577,
	578,
	579,
	583,
	584,
	585,
	586,
	587,
	588,
	589,
	590,
	591,
	837,
	838,
	880,
	881,
	882,
	883,
	886,
	887,
	895,
	896,
	902,
	903,
	904,
	907,
	908,
	909,
	910,
	912,
	913,
	930,
	931,
	940,
	962,
	963,
	975,
	978,
	981,
	983,
	984,
	985,
	986,
	987,
	988,
	989,
	990,
	991,
	992,
	993,
	994,
	995,
	996,
	997,
	998,
	999,
	1000,
	1001,
	1002,
	1003,
	1004,
	1005,
	1006,
	1007,
	1008,
	1010,
	1012,
	1014,
	1015,
	1016,
	1017,
	1019,
	1021,
	1072,
	1120,
	1121,
	1122,
	1123,
	1124,
	1125,
	1126,
	1127,
	1128,
	1129,
	1130,
	1131,
	1132,
	1133,
	1134,
	1135,
	1136,
	1137,
	1138,
	1139,
	1140,
	1141,
	1142,
	1143,
	1144,
	1145,
	1146,
	1147,
	1148,
	1149,
	1150,
	1151,
	1152,
	1153,
	1162,
	1163,
	1164,
	1165,
	1166,
	1167,
	1168,
	1169,
	1170,
	1171,
	1172,
	1173,
	1174,
	1175,
	1176,
	1177,
	1178,
	1179,
	1180,
	1181,
	1182,
	1183,
	1184,
	1185,
	1186,
	1187,
	1188,
	1189,
	1190,
	1191,
	1192,
	1193,
	1194,
	1195,
	1196,
	1197,
	1198,
	1199,
	1200,
	1201,
	1202,
	1203,
	1204,
	1205,
	1206,
	1207,
	1208,
	1209,
	1210,
	1211,
	1212,
	1213,
	1214,
	1215,
	1216,
	1218,
	1219,
	1220,
	1221,
	1222,
	1223,
	1224,
	1225,
	1226,
	1227,
	1228,
	1229,
	1230,
	1232,
	1233,
	1234,
	1235,
	1236,
	1237,
	1238,
	1239,
	1240,
	1241,
	1242,
	1243,
	1244,
	1245,
	1246,
	1247,
	1248,
	1249,
	1250,
	1251,
	1252,
	1253,
	1254,
	1255,
	1256,
	1257,
	1258,
	1259,
	1260,
	1261,
	1262,
	1263,
	1264,
	1265,
	1266,
	1267,
	1268,
	1269,
	1270,
	1271,
	1272,
	1273,
	1274,
	1275,
	1276,
	1277,
	1278,
	1279,
	1280,
	1281,
	1282,
	1283,
	1284,
	1285,
	1286,
	1287,
	1288,
	1289,
	1290,
	1291,
	1292,
	1293,
	1294,
	1295,
	1296,
	1297,
	1298,
	1299,
	1300,
	1301,
	1302,
	1303,
	1304,
	1305,
	1306,
	1307,
	1308,
	1309,
	1310,
	1311,
	1312,
	1313,
	1314,
	1315,
	1316,
	1317,
	1318,
	1319,
	1320,
	1321,
	1322,
	1323,
	1324,
	1325,
	1326,
	1327,
	1329,
	1367,
	1415,
	1416,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	5112,
	5118,
	7296,
	7305,
	7312,
	7355,
	7357,
	7360,
	7680,
	7681,
	7682,
	7683,
	7684,
	7685,
	7686,
	7687,
	7688,
	7689,
	7690,
	7691,
	7692,
	7693,
	7694,
	7695,
	7696,
	7697,
	7698,
	7699,
	7700,
	7701,
	7702,
	7703,
	7704,
	7705,
	7706,
	7707,
	7708,
	7709,
	7710,
	7711,
	7712,
	7713,
	7714,
	7715,
	7716,
	7717,
	7718,
	7719,
	7720,
	7721,
	7722,
	7723,
	7724,
	7725,
	7726,
	7727,
	7728,
	7729,
	7730,
	7731,
	7732,
	7733,
	7734,
	7735,
	7736,
	7737,
	7738,
	7739,
	7740,
	7741,
	7742,
	7743,
	7744,
	7745,
	7746,
	7747,
	7748,
	7749,
	7750,
	7751,
	7752,
	7753,
	7754,
	7755,
	7756,
	7757,
	7758,
	7759,
	7760,
	7761,
	7762,
	7763,
	7764,
	7765,
	7766,
	7767,
	7768,
	7769,
	7770,
	7771,
	7772,
	7773,
	7774,
	7775,
	7776,
	7777,
	7778,
	7779,
	7780,
	7781,
	7782,
	7783,
	7784,
	7785,
	7786,
	7787,
	7788,
	7789,
	7790,
	7791,
	7792,
	7793,
	7794,
	7795,
	7796,
	7797,
	7798,
	7799,
	7800,
	7801,
	7802,
	7803,
	7804,
	7805,
	7806,
	7807,
	7808,
	7809,
	7810,
	7811,
	7812,
	7813,
	7814,
	7815,
	7816,
	7817,
	7818,
	7819,
	7820,
	7821,
	7822,
	7823,
	7824,
	7825,
	7826,
	7827,
	7828,
	7829,
	7834,
	7836,
	7838,
	7839,
	7840,
	7841,
	7842,
	7843,
	7844,
	7845,
	7846,
	7847,
	7848,
	7849,
	7850,
	7851,
	7852,
	7853,
	7854,
	7855,
	7856,
	7857,
	7858,
	7859,
	7860,
	7861,
	7862,
	7863,
	7864,
	7865,
	7866,
	7867,
	7868,
	7869,
	7870,
	7871,
	7872,
	7873,
	7874,
	7875,
	7876,
	7877,
	7878,
	7879,
	7880,
	7881,
	7882,
	7883,
	7884,
	7885,
	7886,
	7887,
	7888,
	7889,
	7890,
	7891,
	7892,
	7893,
	7894,
	7895,
	7896,
	7897,
	7898,
	7899,
	7900,
	7901,
	7902,
	7903,
	7904,
	7905,
	7906,
	7907,
	7908,
	7909,
	7910,
	7911,
	7912,
	7913,
	7914,
	7915,
	7916,
	7917,
	7918,
	7919,
	7920,
	7921,
	7922,
	7923,
	7924,
	7925,
	7926,
	7927,
	7928,
	7929,
	7930,
	7931,
	7932,
	7933,
	7934,
	7935,
	7944,
	7952,
	7960,
	7966,
	7976,
	7984,
	7992,
	8000,
	8008,
	8014,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8032,
	8040,
	8048,
	8064,
	8112,
	8114,
	8117,
	8119,
	8125,
	8130,
	8133,
	8135,
	8141,
	8152,
	8156,
	8168,
	8173,
	8178,
	8181,
	8183,
	8189,
	8486,
	8487,
	8490,
	8492,
	8498,
	8499,
	8544,
	8560,
	8579,
	8580,
	9398,
	9424,
	11264,
	11311,
	11360,
	11361,
	11362,
	11365,
	11367,
	11368,
	11369,
	11370,
	11371,
	11372,
	11373,
	11377,
	11378,
	11379,
	11381,
	11382,
	11390,
	11393,
	11394,
	11395,
	11396,
	11397,
	11398,
	11399,
	11400,
	11401,
	11402,
	11403,
	11404,
	11405,
	11406,
	11407,
	11408,
	11409,
	11410,
	11411,
	11412,
	11413,
	11414,
	11415,
	11416,
	11417,
	11418,
	11419,
	11420,
	11421,
	11422,
	11423,
	11424,
	11425,
	11426,
	11427,
	11428,
	11429,
	11430,
	11431,
	11432,
	11433,
	11434,
	11435,
	11436,
	11437,
	11438,
	11439,
	11440,
	11441,
	11442,
	11443,
	11444,
	11445,
	11446,
	11447,
	11448,
	11449,
	11450,
	11451,
	11452,
	11453,
	11454,
	11455,
	11456,
	11457,
	11458,
	11459,
	11460,
	11461,
	11462,
	11463,
	11464,
	11465,
	11466,
	11467,
	11468,
	11469,
	11470,
	11471,
	11472,
	11473,
	11474,
	11475,
	11476,
	11477,
	11478,
	11479,
	11480,
	11481,
	11482,
	11483,
	11484,
	11485,
	11486,
	11487,
	11488,
	11489,
	11490,
	11491,
	11499,
	11500,
	11501,
	11502,
	11506,
	11507,
	42560,
	42561,
	42562,
	42563,
	42564,
	42565,
	42566,
	42567,
	42568,
	42569,
	42570,
	42571,
	42572,
	42573,
	42574,
	42575,
	42576,
	42577,
	42578,
	42579,
	42580,
	42581,
	42582,
	42583,
	42584,
	42585,
	42586,
	42587,
	42588,
	42589,
	42590,
	42591,
	42592,
	42593,
	42594,
	42595,
	42596,
	42597,
	42598,
	42599,
	42600,
	42601,
	42602,
	42603,
	42604,
	42605,
	42624,
	42625,
	42626,
	42627,
	42628,
	42629,
	42630,
	42631,
	42632,
	42633,
	42634,
	42635,
	42636,
	42637,
	42638,
	42639,
	42640,
	42641,
	42642,
	42643,
	42644,
	42645,
	42646,
	42647,
	42648,
	42649,
	42650,
	42651,
	42786,
	42787,
	42788,
	42789,
	42790,
	42791,
	42792,
	42793,
	42794,
	42795,
	42796,
	42797,
	42798,
	42799,
	42802,
	42803,
	42804,
	42805,
	42806,
	42807,
	42808,
	42809,
	42810,
	42811,
	42812,
	42813,
	42814,
	42815,
	42816,
	42817,
	42818,
	42819,
	42820,
	42821,
	42822,
	42823,
	42824,
	42825,
	42826,
	42827,
	42828,
	42829,
	42830,
	42831,
	42832,
	42833,
	42834,
	42835,
	42836,
	42837,
	42838,
	42839,
	42840,
	42841,
	42842,
	42843,
	42844,
	42845,
	42846,
	42847,
	42848,
	42849,
	42850,
	42851,
	42852,
	42853,
	42854,
	42855,
	42856,
	42857,
	42858,
	42859,
	42860,
	42861,
	42862,
	42863,
	42873,
	42874,
	42875,
	42876,
	42877,
	42879,
	42880,
	42881,
	42882,
	42883,
	42884,
	42885,
	42886,
	42887,
	42891,
	42892,
	42893,
	42894,
	42896,
	42897,
	42898,
	42899,
	42902,
	42903,
	42904,
	42905,
	42906,
	42907,
	42908,
	42909,
	42910,
	42911,
	42912,
	42913,
	42914,
	42915,
	42916,
	42917,
	42918,
	42919,
	42920,
	42921,
	42922,
	42927,
	42928,
	42933,
	42934,
	42935,
	42936,
	42937,
	42938,
	42939,
	42940,
	42941,
	42942,
	42943,
	42946,
	42947,
	42948,
	42951,
	43888,
	43968,
	64256,
	64263,
	64275,
	64280,
	65313,
	65339,
	66560,
	66600,
	66736,
	66772,
	68736,
	68787,
	71840,
	71872,
	93760,
	93792,
	125184,
	125218
]);
property.set("Changes_When_Casemapped", [
	65,
	91,
	97,
	123,
	181,
	182,
	192,
	215,
	216,
	247,
	248,
	312,
	313,
	397,
	398,
	411,
	412,
	426,
	428,
	442,
	444,
	446,
	447,
	448,
	452,
	545,
	546,
	564,
	570,
	597,
	598,
	600,
	601,
	602,
	603,
	605,
	608,
	610,
	611,
	612,
	613,
	615,
	616,
	621,
	623,
	624,
	625,
	627,
	629,
	630,
	637,
	638,
	640,
	641,
	642,
	644,
	647,
	653,
	658,
	659,
	669,
	671,
	837,
	838,
	880,
	884,
	886,
	888,
	891,
	894,
	895,
	896,
	902,
	903,
	904,
	907,
	908,
	909,
	910,
	930,
	931,
	978,
	981,
	1014,
	1015,
	1020,
	1021,
	1154,
	1162,
	1328,
	1329,
	1367,
	1377,
	1416,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	4304,
	4347,
	4349,
	4352,
	5024,
	5110,
	5112,
	5118,
	7296,
	7305,
	7312,
	7355,
	7357,
	7360,
	7545,
	7546,
	7549,
	7550,
	7566,
	7567,
	7680,
	7836,
	7838,
	7839,
	7840,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8125,
	8126,
	8127,
	8130,
	8133,
	8134,
	8141,
	8144,
	8148,
	8150,
	8156,
	8160,
	8173,
	8178,
	8181,
	8182,
	8189,
	8486,
	8487,
	8490,
	8492,
	8498,
	8499,
	8526,
	8527,
	8544,
	8576,
	8579,
	8581,
	9398,
	9450,
	11264,
	11311,
	11312,
	11359,
	11360,
	11377,
	11378,
	11380,
	11381,
	11383,
	11390,
	11492,
	11499,
	11503,
	11506,
	11508,
	11520,
	11558,
	11559,
	11560,
	11565,
	11566,
	42560,
	42606,
	42624,
	42652,
	42786,
	42800,
	42802,
	42864,
	42873,
	42888,
	42891,
	42894,
	42896,
	42901,
	42902,
	42927,
	42928,
	42944,
	42946,
	42951,
	43859,
	43860,
	43888,
	43968,
	64256,
	64263,
	64275,
	64280,
	65313,
	65339,
	65345,
	65371,
	66560,
	66640,
	66736,
	66772,
	66776,
	66812,
	68736,
	68787,
	68800,
	68851,
	71840,
	71904,
	93760,
	93824,
	125184,
	125252
]);
property.set("Changes_When_Lowercased", [
	65,
	91,
	192,
	215,
	216,
	223,
	256,
	257,
	258,
	259,
	260,
	261,
	262,
	263,
	264,
	265,
	266,
	267,
	268,
	269,
	270,
	271,
	272,
	273,
	274,
	275,
	276,
	277,
	278,
	279,
	280,
	281,
	282,
	283,
	284,
	285,
	286,
	287,
	288,
	289,
	290,
	291,
	292,
	293,
	294,
	295,
	296,
	297,
	298,
	299,
	300,
	301,
	302,
	303,
	304,
	305,
	306,
	307,
	308,
	309,
	310,
	311,
	313,
	314,
	315,
	316,
	317,
	318,
	319,
	320,
	321,
	322,
	323,
	324,
	325,
	326,
	327,
	328,
	330,
	331,
	332,
	333,
	334,
	335,
	336,
	337,
	338,
	339,
	340,
	341,
	342,
	343,
	344,
	345,
	346,
	347,
	348,
	349,
	350,
	351,
	352,
	353,
	354,
	355,
	356,
	357,
	358,
	359,
	360,
	361,
	362,
	363,
	364,
	365,
	366,
	367,
	368,
	369,
	370,
	371,
	372,
	373,
	374,
	375,
	376,
	378,
	379,
	380,
	381,
	382,
	385,
	387,
	388,
	389,
	390,
	392,
	393,
	396,
	398,
	402,
	403,
	405,
	406,
	409,
	412,
	414,
	415,
	417,
	418,
	419,
	420,
	421,
	422,
	424,
	425,
	426,
	428,
	429,
	430,
	432,
	433,
	436,
	437,
	438,
	439,
	441,
	444,
	445,
	452,
	454,
	455,
	457,
	458,
	460,
	461,
	462,
	463,
	464,
	465,
	466,
	467,
	468,
	469,
	470,
	471,
	472,
	473,
	474,
	475,
	476,
	478,
	479,
	480,
	481,
	482,
	483,
	484,
	485,
	486,
	487,
	488,
	489,
	490,
	491,
	492,
	493,
	494,
	495,
	497,
	499,
	500,
	501,
	502,
	505,
	506,
	507,
	508,
	509,
	510,
	511,
	512,
	513,
	514,
	515,
	516,
	517,
	518,
	519,
	520,
	521,
	522,
	523,
	524,
	525,
	526,
	527,
	528,
	529,
	530,
	531,
	532,
	533,
	534,
	535,
	536,
	537,
	538,
	539,
	540,
	541,
	542,
	543,
	544,
	545,
	546,
	547,
	548,
	549,
	550,
	551,
	552,
	553,
	554,
	555,
	556,
	557,
	558,
	559,
	560,
	561,
	562,
	563,
	570,
	572,
	573,
	575,
	577,
	578,
	579,
	583,
	584,
	585,
	586,
	587,
	588,
	589,
	590,
	591,
	880,
	881,
	882,
	883,
	886,
	887,
	895,
	896,
	902,
	903,
	904,
	907,
	908,
	909,
	910,
	912,
	913,
	930,
	931,
	940,
	975,
	976,
	984,
	985,
	986,
	987,
	988,
	989,
	990,
	991,
	992,
	993,
	994,
	995,
	996,
	997,
	998,
	999,
	1000,
	1001,
	1002,
	1003,
	1004,
	1005,
	1006,
	1007,
	1012,
	1013,
	1015,
	1016,
	1017,
	1019,
	1021,
	1072,
	1120,
	1121,
	1122,
	1123,
	1124,
	1125,
	1126,
	1127,
	1128,
	1129,
	1130,
	1131,
	1132,
	1133,
	1134,
	1135,
	1136,
	1137,
	1138,
	1139,
	1140,
	1141,
	1142,
	1143,
	1144,
	1145,
	1146,
	1147,
	1148,
	1149,
	1150,
	1151,
	1152,
	1153,
	1162,
	1163,
	1164,
	1165,
	1166,
	1167,
	1168,
	1169,
	1170,
	1171,
	1172,
	1173,
	1174,
	1175,
	1176,
	1177,
	1178,
	1179,
	1180,
	1181,
	1182,
	1183,
	1184,
	1185,
	1186,
	1187,
	1188,
	1189,
	1190,
	1191,
	1192,
	1193,
	1194,
	1195,
	1196,
	1197,
	1198,
	1199,
	1200,
	1201,
	1202,
	1203,
	1204,
	1205,
	1206,
	1207,
	1208,
	1209,
	1210,
	1211,
	1212,
	1213,
	1214,
	1215,
	1216,
	1218,
	1219,
	1220,
	1221,
	1222,
	1223,
	1224,
	1225,
	1226,
	1227,
	1228,
	1229,
	1230,
	1232,
	1233,
	1234,
	1235,
	1236,
	1237,
	1238,
	1239,
	1240,
	1241,
	1242,
	1243,
	1244,
	1245,
	1246,
	1247,
	1248,
	1249,
	1250,
	1251,
	1252,
	1253,
	1254,
	1255,
	1256,
	1257,
	1258,
	1259,
	1260,
	1261,
	1262,
	1263,
	1264,
	1265,
	1266,
	1267,
	1268,
	1269,
	1270,
	1271,
	1272,
	1273,
	1274,
	1275,
	1276,
	1277,
	1278,
	1279,
	1280,
	1281,
	1282,
	1283,
	1284,
	1285,
	1286,
	1287,
	1288,
	1289,
	1290,
	1291,
	1292,
	1293,
	1294,
	1295,
	1296,
	1297,
	1298,
	1299,
	1300,
	1301,
	1302,
	1303,
	1304,
	1305,
	1306,
	1307,
	1308,
	1309,
	1310,
	1311,
	1312,
	1313,
	1314,
	1315,
	1316,
	1317,
	1318,
	1319,
	1320,
	1321,
	1322,
	1323,
	1324,
	1325,
	1326,
	1327,
	1329,
	1367,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	5024,
	5110,
	7312,
	7355,
	7357,
	7360,
	7680,
	7681,
	7682,
	7683,
	7684,
	7685,
	7686,
	7687,
	7688,
	7689,
	7690,
	7691,
	7692,
	7693,
	7694,
	7695,
	7696,
	7697,
	7698,
	7699,
	7700,
	7701,
	7702,
	7703,
	7704,
	7705,
	7706,
	7707,
	7708,
	7709,
	7710,
	7711,
	7712,
	7713,
	7714,
	7715,
	7716,
	7717,
	7718,
	7719,
	7720,
	7721,
	7722,
	7723,
	7724,
	7725,
	7726,
	7727,
	7728,
	7729,
	7730,
	7731,
	7732,
	7733,
	7734,
	7735,
	7736,
	7737,
	7738,
	7739,
	7740,
	7741,
	7742,
	7743,
	7744,
	7745,
	7746,
	7747,
	7748,
	7749,
	7750,
	7751,
	7752,
	7753,
	7754,
	7755,
	7756,
	7757,
	7758,
	7759,
	7760,
	7761,
	7762,
	7763,
	7764,
	7765,
	7766,
	7767,
	7768,
	7769,
	7770,
	7771,
	7772,
	7773,
	7774,
	7775,
	7776,
	7777,
	7778,
	7779,
	7780,
	7781,
	7782,
	7783,
	7784,
	7785,
	7786,
	7787,
	7788,
	7789,
	7790,
	7791,
	7792,
	7793,
	7794,
	7795,
	7796,
	7797,
	7798,
	7799,
	7800,
	7801,
	7802,
	7803,
	7804,
	7805,
	7806,
	7807,
	7808,
	7809,
	7810,
	7811,
	7812,
	7813,
	7814,
	7815,
	7816,
	7817,
	7818,
	7819,
	7820,
	7821,
	7822,
	7823,
	7824,
	7825,
	7826,
	7827,
	7828,
	7829,
	7838,
	7839,
	7840,
	7841,
	7842,
	7843,
	7844,
	7845,
	7846,
	7847,
	7848,
	7849,
	7850,
	7851,
	7852,
	7853,
	7854,
	7855,
	7856,
	7857,
	7858,
	7859,
	7860,
	7861,
	7862,
	7863,
	7864,
	7865,
	7866,
	7867,
	7868,
	7869,
	7870,
	7871,
	7872,
	7873,
	7874,
	7875,
	7876,
	7877,
	7878,
	7879,
	7880,
	7881,
	7882,
	7883,
	7884,
	7885,
	7886,
	7887,
	7888,
	7889,
	7890,
	7891,
	7892,
	7893,
	7894,
	7895,
	7896,
	7897,
	7898,
	7899,
	7900,
	7901,
	7902,
	7903,
	7904,
	7905,
	7906,
	7907,
	7908,
	7909,
	7910,
	7911,
	7912,
	7913,
	7914,
	7915,
	7916,
	7917,
	7918,
	7919,
	7920,
	7921,
	7922,
	7923,
	7924,
	7925,
	7926,
	7927,
	7928,
	7929,
	7930,
	7931,
	7932,
	7933,
	7934,
	7935,
	7944,
	7952,
	7960,
	7966,
	7976,
	7984,
	7992,
	8000,
	8008,
	8014,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8032,
	8040,
	8048,
	8072,
	8080,
	8088,
	8096,
	8104,
	8112,
	8120,
	8125,
	8136,
	8141,
	8152,
	8156,
	8168,
	8173,
	8184,
	8189,
	8486,
	8487,
	8490,
	8492,
	8498,
	8499,
	8544,
	8560,
	8579,
	8580,
	9398,
	9424,
	11264,
	11311,
	11360,
	11361,
	11362,
	11365,
	11367,
	11368,
	11369,
	11370,
	11371,
	11372,
	11373,
	11377,
	11378,
	11379,
	11381,
	11382,
	11390,
	11393,
	11394,
	11395,
	11396,
	11397,
	11398,
	11399,
	11400,
	11401,
	11402,
	11403,
	11404,
	11405,
	11406,
	11407,
	11408,
	11409,
	11410,
	11411,
	11412,
	11413,
	11414,
	11415,
	11416,
	11417,
	11418,
	11419,
	11420,
	11421,
	11422,
	11423,
	11424,
	11425,
	11426,
	11427,
	11428,
	11429,
	11430,
	11431,
	11432,
	11433,
	11434,
	11435,
	11436,
	11437,
	11438,
	11439,
	11440,
	11441,
	11442,
	11443,
	11444,
	11445,
	11446,
	11447,
	11448,
	11449,
	11450,
	11451,
	11452,
	11453,
	11454,
	11455,
	11456,
	11457,
	11458,
	11459,
	11460,
	11461,
	11462,
	11463,
	11464,
	11465,
	11466,
	11467,
	11468,
	11469,
	11470,
	11471,
	11472,
	11473,
	11474,
	11475,
	11476,
	11477,
	11478,
	11479,
	11480,
	11481,
	11482,
	11483,
	11484,
	11485,
	11486,
	11487,
	11488,
	11489,
	11490,
	11491,
	11499,
	11500,
	11501,
	11502,
	11506,
	11507,
	42560,
	42561,
	42562,
	42563,
	42564,
	42565,
	42566,
	42567,
	42568,
	42569,
	42570,
	42571,
	42572,
	42573,
	42574,
	42575,
	42576,
	42577,
	42578,
	42579,
	42580,
	42581,
	42582,
	42583,
	42584,
	42585,
	42586,
	42587,
	42588,
	42589,
	42590,
	42591,
	42592,
	42593,
	42594,
	42595,
	42596,
	42597,
	42598,
	42599,
	42600,
	42601,
	42602,
	42603,
	42604,
	42605,
	42624,
	42625,
	42626,
	42627,
	42628,
	42629,
	42630,
	42631,
	42632,
	42633,
	42634,
	42635,
	42636,
	42637,
	42638,
	42639,
	42640,
	42641,
	42642,
	42643,
	42644,
	42645,
	42646,
	42647,
	42648,
	42649,
	42650,
	42651,
	42786,
	42787,
	42788,
	42789,
	42790,
	42791,
	42792,
	42793,
	42794,
	42795,
	42796,
	42797,
	42798,
	42799,
	42802,
	42803,
	42804,
	42805,
	42806,
	42807,
	42808,
	42809,
	42810,
	42811,
	42812,
	42813,
	42814,
	42815,
	42816,
	42817,
	42818,
	42819,
	42820,
	42821,
	42822,
	42823,
	42824,
	42825,
	42826,
	42827,
	42828,
	42829,
	42830,
	42831,
	42832,
	42833,
	42834,
	42835,
	42836,
	42837,
	42838,
	42839,
	42840,
	42841,
	42842,
	42843,
	42844,
	42845,
	42846,
	42847,
	42848,
	42849,
	42850,
	42851,
	42852,
	42853,
	42854,
	42855,
	42856,
	42857,
	42858,
	42859,
	42860,
	42861,
	42862,
	42863,
	42873,
	42874,
	42875,
	42876,
	42877,
	42879,
	42880,
	42881,
	42882,
	42883,
	42884,
	42885,
	42886,
	42887,
	42891,
	42892,
	42893,
	42894,
	42896,
	42897,
	42898,
	42899,
	42902,
	42903,
	42904,
	42905,
	42906,
	42907,
	42908,
	42909,
	42910,
	42911,
	42912,
	42913,
	42914,
	42915,
	42916,
	42917,
	42918,
	42919,
	42920,
	42921,
	42922,
	42927,
	42928,
	42933,
	42934,
	42935,
	42936,
	42937,
	42938,
	42939,
	42940,
	42941,
	42942,
	42943,
	42946,
	42947,
	42948,
	42951,
	65313,
	65339,
	66560,
	66600,
	66736,
	66772,
	68736,
	68787,
	71840,
	71872,
	93760,
	93792,
	125184,
	125218
]);
property.set("Changes_When_NFKC_Casefolded", [
	65,
	91,
	160,
	161,
	168,
	169,
	170,
	171,
	173,
	174,
	175,
	176,
	178,
	182,
	184,
	187,
	188,
	191,
	192,
	215,
	216,
	224,
	256,
	257,
	258,
	259,
	260,
	261,
	262,
	263,
	264,
	265,
	266,
	267,
	268,
	269,
	270,
	271,
	272,
	273,
	274,
	275,
	276,
	277,
	278,
	279,
	280,
	281,
	282,
	283,
	284,
	285,
	286,
	287,
	288,
	289,
	290,
	291,
	292,
	293,
	294,
	295,
	296,
	297,
	298,
	299,
	300,
	301,
	302,
	303,
	304,
	305,
	306,
	309,
	310,
	311,
	313,
	314,
	315,
	316,
	317,
	318,
	319,
	322,
	323,
	324,
	325,
	326,
	327,
	328,
	329,
	331,
	332,
	333,
	334,
	335,
	336,
	337,
	338,
	339,
	340,
	341,
	342,
	343,
	344,
	345,
	346,
	347,
	348,
	349,
	350,
	351,
	352,
	353,
	354,
	355,
	356,
	357,
	358,
	359,
	360,
	361,
	362,
	363,
	364,
	365,
	366,
	367,
	368,
	369,
	370,
	371,
	372,
	373,
	374,
	375,
	376,
	378,
	379,
	380,
	381,
	382,
	383,
	384,
	385,
	387,
	388,
	389,
	390,
	392,
	393,
	396,
	398,
	402,
	403,
	405,
	406,
	409,
	412,
	414,
	415,
	417,
	418,
	419,
	420,
	421,
	422,
	424,
	425,
	426,
	428,
	429,
	430,
	432,
	433,
	436,
	437,
	438,
	439,
	441,
	444,
	445,
	452,
	462,
	463,
	464,
	465,
	466,
	467,
	468,
	469,
	470,
	471,
	472,
	473,
	474,
	475,
	476,
	478,
	479,
	480,
	481,
	482,
	483,
	484,
	485,
	486,
	487,
	488,
	489,
	490,
	491,
	492,
	493,
	494,
	495,
	497,
	501,
	502,
	505,
	506,
	507,
	508,
	509,
	510,
	511,
	512,
	513,
	514,
	515,
	516,
	517,
	518,
	519,
	520,
	521,
	522,
	523,
	524,
	525,
	526,
	527,
	528,
	529,
	530,
	531,
	532,
	533,
	534,
	535,
	536,
	537,
	538,
	539,
	540,
	541,
	542,
	543,
	544,
	545,
	546,
	547,
	548,
	549,
	550,
	551,
	552,
	553,
	554,
	555,
	556,
	557,
	558,
	559,
	560,
	561,
	562,
	563,
	570,
	572,
	573,
	575,
	577,
	578,
	579,
	583,
	584,
	585,
	586,
	587,
	588,
	589,
	590,
	591,
	688,
	697,
	728,
	734,
	736,
	741,
	832,
	834,
	835,
	838,
	847,
	848,
	880,
	881,
	882,
	883,
	884,
	885,
	886,
	887,
	890,
	891,
	894,
	896,
	900,
	907,
	908,
	909,
	910,
	912,
	913,
	930,
	931,
	940,
	962,
	963,
	975,
	983,
	984,
	985,
	986,
	987,
	988,
	989,
	990,
	991,
	992,
	993,
	994,
	995,
	996,
	997,
	998,
	999,
	1000,
	1001,
	1002,
	1003,
	1004,
	1005,
	1006,
	1007,
	1008,
	1011,
	1012,
	1014,
	1015,
	1016,
	1017,
	1019,
	1021,
	1072,
	1120,
	1121,
	1122,
	1123,
	1124,
	1125,
	1126,
	1127,
	1128,
	1129,
	1130,
	1131,
	1132,
	1133,
	1134,
	1135,
	1136,
	1137,
	1138,
	1139,
	1140,
	1141,
	1142,
	1143,
	1144,
	1145,
	1146,
	1147,
	1148,
	1149,
	1150,
	1151,
	1152,
	1153,
	1162,
	1163,
	1164,
	1165,
	1166,
	1167,
	1168,
	1169,
	1170,
	1171,
	1172,
	1173,
	1174,
	1175,
	1176,
	1177,
	1178,
	1179,
	1180,
	1181,
	1182,
	1183,
	1184,
	1185,
	1186,
	1187,
	1188,
	1189,
	1190,
	1191,
	1192,
	1193,
	1194,
	1195,
	1196,
	1197,
	1198,
	1199,
	1200,
	1201,
	1202,
	1203,
	1204,
	1205,
	1206,
	1207,
	1208,
	1209,
	1210,
	1211,
	1212,
	1213,
	1214,
	1215,
	1216,
	1218,
	1219,
	1220,
	1221,
	1222,
	1223,
	1224,
	1225,
	1226,
	1227,
	1228,
	1229,
	1230,
	1232,
	1233,
	1234,
	1235,
	1236,
	1237,
	1238,
	1239,
	1240,
	1241,
	1242,
	1243,
	1244,
	1245,
	1246,
	1247,
	1248,
	1249,
	1250,
	1251,
	1252,
	1253,
	1254,
	1255,
	1256,
	1257,
	1258,
	1259,
	1260,
	1261,
	1262,
	1263,
	1264,
	1265,
	1266,
	1267,
	1268,
	1269,
	1270,
	1271,
	1272,
	1273,
	1274,
	1275,
	1276,
	1277,
	1278,
	1279,
	1280,
	1281,
	1282,
	1283,
	1284,
	1285,
	1286,
	1287,
	1288,
	1289,
	1290,
	1291,
	1292,
	1293,
	1294,
	1295,
	1296,
	1297,
	1298,
	1299,
	1300,
	1301,
	1302,
	1303,
	1304,
	1305,
	1306,
	1307,
	1308,
	1309,
	1310,
	1311,
	1312,
	1313,
	1314,
	1315,
	1316,
	1317,
	1318,
	1319,
	1320,
	1321,
	1322,
	1323,
	1324,
	1325,
	1326,
	1327,
	1329,
	1367,
	1415,
	1416,
	1564,
	1565,
	1653,
	1657,
	2392,
	2400,
	2524,
	2526,
	2527,
	2528,
	2611,
	2612,
	2614,
	2615,
	2649,
	2652,
	2654,
	2655,
	2908,
	2910,
	3635,
	3636,
	3763,
	3764,
	3804,
	3806,
	3852,
	3853,
	3907,
	3908,
	3917,
	3918,
	3922,
	3923,
	3927,
	3928,
	3932,
	3933,
	3945,
	3946,
	3955,
	3956,
	3957,
	3962,
	3969,
	3970,
	3987,
	3988,
	3997,
	3998,
	4002,
	4003,
	4007,
	4008,
	4012,
	4013,
	4025,
	4026,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	4348,
	4349,
	4447,
	4449,
	5112,
	5118,
	6068,
	6070,
	6155,
	6159,
	7296,
	7305,
	7312,
	7355,
	7357,
	7360,
	7468,
	7471,
	7472,
	7483,
	7484,
	7502,
	7503,
	7531,
	7544,
	7545,
	7579,
	7616,
	7680,
	7681,
	7682,
	7683,
	7684,
	7685,
	7686,
	7687,
	7688,
	7689,
	7690,
	7691,
	7692,
	7693,
	7694,
	7695,
	7696,
	7697,
	7698,
	7699,
	7700,
	7701,
	7702,
	7703,
	7704,
	7705,
	7706,
	7707,
	7708,
	7709,
	7710,
	7711,
	7712,
	7713,
	7714,
	7715,
	7716,
	7717,
	7718,
	7719,
	7720,
	7721,
	7722,
	7723,
	7724,
	7725,
	7726,
	7727,
	7728,
	7729,
	7730,
	7731,
	7732,
	7733,
	7734,
	7735,
	7736,
	7737,
	7738,
	7739,
	7740,
	7741,
	7742,
	7743,
	7744,
	7745,
	7746,
	7747,
	7748,
	7749,
	7750,
	7751,
	7752,
	7753,
	7754,
	7755,
	7756,
	7757,
	7758,
	7759,
	7760,
	7761,
	7762,
	7763,
	7764,
	7765,
	7766,
	7767,
	7768,
	7769,
	7770,
	7771,
	7772,
	7773,
	7774,
	7775,
	7776,
	7777,
	7778,
	7779,
	7780,
	7781,
	7782,
	7783,
	7784,
	7785,
	7786,
	7787,
	7788,
	7789,
	7790,
	7791,
	7792,
	7793,
	7794,
	7795,
	7796,
	7797,
	7798,
	7799,
	7800,
	7801,
	7802,
	7803,
	7804,
	7805,
	7806,
	7807,
	7808,
	7809,
	7810,
	7811,
	7812,
	7813,
	7814,
	7815,
	7816,
	7817,
	7818,
	7819,
	7820,
	7821,
	7822,
	7823,
	7824,
	7825,
	7826,
	7827,
	7828,
	7829,
	7834,
	7836,
	7838,
	7839,
	7840,
	7841,
	7842,
	7843,
	7844,
	7845,
	7846,
	7847,
	7848,
	7849,
	7850,
	7851,
	7852,
	7853,
	7854,
	7855,
	7856,
	7857,
	7858,
	7859,
	7860,
	7861,
	7862,
	7863,
	7864,
	7865,
	7866,
	7867,
	7868,
	7869,
	7870,
	7871,
	7872,
	7873,
	7874,
	7875,
	7876,
	7877,
	7878,
	7879,
	7880,
	7881,
	7882,
	7883,
	7884,
	7885,
	7886,
	7887,
	7888,
	7889,
	7890,
	7891,
	7892,
	7893,
	7894,
	7895,
	7896,
	7897,
	7898,
	7899,
	7900,
	7901,
	7902,
	7903,
	7904,
	7905,
	7906,
	7907,
	7908,
	7909,
	7910,
	7911,
	7912,
	7913,
	7914,
	7915,
	7916,
	7917,
	7918,
	7919,
	7920,
	7921,
	7922,
	7923,
	7924,
	7925,
	7926,
	7927,
	7928,
	7929,
	7930,
	7931,
	7932,
	7933,
	7934,
	7935,
	7944,
	7952,
	7960,
	7966,
	7976,
	7984,
	7992,
	8000,
	8008,
	8014,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8032,
	8040,
	8048,
	8049,
	8050,
	8051,
	8052,
	8053,
	8054,
	8055,
	8056,
	8057,
	8058,
	8059,
	8060,
	8061,
	8062,
	8064,
	8112,
	8114,
	8117,
	8119,
	8133,
	8135,
	8144,
	8147,
	8148,
	8152,
	8156,
	8157,
	8160,
	8163,
	8164,
	8168,
	8176,
	8178,
	8181,
	8183,
	8191,
	8192,
	8208,
	8209,
	8210,
	8215,
	8216,
	8228,
	8231,
	8234,
	8240,
	8243,
	8245,
	8246,
	8248,
	8252,
	8253,
	8254,
	8255,
	8263,
	8266,
	8279,
	8280,
	8287,
	8306,
	8308,
	8335,
	8336,
	8349,
	8360,
	8361,
	8448,
	8452,
	8453,
	8456,
	8457,
	8468,
	8469,
	8471,
	8473,
	8478,
	8480,
	8483,
	8484,
	8485,
	8486,
	8487,
	8488,
	8489,
	8490,
	8494,
	8495,
	8506,
	8507,
	8513,
	8517,
	8522,
	8528,
	8576,
	8579,
	8580,
	8585,
	8586,
	8748,
	8750,
	8751,
	8753,
	9001,
	9003,
	9312,
	9451,
	10764,
	10765,
	10868,
	10871,
	10972,
	10973,
	11264,
	11311,
	11360,
	11361,
	11362,
	11365,
	11367,
	11368,
	11369,
	11370,
	11371,
	11372,
	11373,
	11377,
	11378,
	11379,
	11381,
	11382,
	11388,
	11393,
	11394,
	11395,
	11396,
	11397,
	11398,
	11399,
	11400,
	11401,
	11402,
	11403,
	11404,
	11405,
	11406,
	11407,
	11408,
	11409,
	11410,
	11411,
	11412,
	11413,
	11414,
	11415,
	11416,
	11417,
	11418,
	11419,
	11420,
	11421,
	11422,
	11423,
	11424,
	11425,
	11426,
	11427,
	11428,
	11429,
	11430,
	11431,
	11432,
	11433,
	11434,
	11435,
	11436,
	11437,
	11438,
	11439,
	11440,
	11441,
	11442,
	11443,
	11444,
	11445,
	11446,
	11447,
	11448,
	11449,
	11450,
	11451,
	11452,
	11453,
	11454,
	11455,
	11456,
	11457,
	11458,
	11459,
	11460,
	11461,
	11462,
	11463,
	11464,
	11465,
	11466,
	11467,
	11468,
	11469,
	11470,
	11471,
	11472,
	11473,
	11474,
	11475,
	11476,
	11477,
	11478,
	11479,
	11480,
	11481,
	11482,
	11483,
	11484,
	11485,
	11486,
	11487,
	11488,
	11489,
	11490,
	11491,
	11499,
	11500,
	11501,
	11502,
	11506,
	11507,
	11631,
	11632,
	11935,
	11936,
	12019,
	12020,
	12032,
	12246,
	12288,
	12289,
	12342,
	12343,
	12344,
	12347,
	12443,
	12445,
	12447,
	12448,
	12543,
	12544,
	12593,
	12687,
	12690,
	12704,
	12800,
	12831,
	12832,
	12872,
	12880,
	12927,
	12928,
	13055,
	13056,
	13312,
	42560,
	42561,
	42562,
	42563,
	42564,
	42565,
	42566,
	42567,
	42568,
	42569,
	42570,
	42571,
	42572,
	42573,
	42574,
	42575,
	42576,
	42577,
	42578,
	42579,
	42580,
	42581,
	42582,
	42583,
	42584,
	42585,
	42586,
	42587,
	42588,
	42589,
	42590,
	42591,
	42592,
	42593,
	42594,
	42595,
	42596,
	42597,
	42598,
	42599,
	42600,
	42601,
	42602,
	42603,
	42604,
	42605,
	42624,
	42625,
	42626,
	42627,
	42628,
	42629,
	42630,
	42631,
	42632,
	42633,
	42634,
	42635,
	42636,
	42637,
	42638,
	42639,
	42640,
	42641,
	42642,
	42643,
	42644,
	42645,
	42646,
	42647,
	42648,
	42649,
	42650,
	42651,
	42652,
	42654,
	42786,
	42787,
	42788,
	42789,
	42790,
	42791,
	42792,
	42793,
	42794,
	42795,
	42796,
	42797,
	42798,
	42799,
	42802,
	42803,
	42804,
	42805,
	42806,
	42807,
	42808,
	42809,
	42810,
	42811,
	42812,
	42813,
	42814,
	42815,
	42816,
	42817,
	42818,
	42819,
	42820,
	42821,
	42822,
	42823,
	42824,
	42825,
	42826,
	42827,
	42828,
	42829,
	42830,
	42831,
	42832,
	42833,
	42834,
	42835,
	42836,
	42837,
	42838,
	42839,
	42840,
	42841,
	42842,
	42843,
	42844,
	42845,
	42846,
	42847,
	42848,
	42849,
	42850,
	42851,
	42852,
	42853,
	42854,
	42855,
	42856,
	42857,
	42858,
	42859,
	42860,
	42861,
	42862,
	42863,
	42864,
	42865,
	42873,
	42874,
	42875,
	42876,
	42877,
	42879,
	42880,
	42881,
	42882,
	42883,
	42884,
	42885,
	42886,
	42887,
	42891,
	42892,
	42893,
	42894,
	42896,
	42897,
	42898,
	42899,
	42902,
	42903,
	42904,
	42905,
	42906,
	42907,
	42908,
	42909,
	42910,
	42911,
	42912,
	42913,
	42914,
	42915,
	42916,
	42917,
	42918,
	42919,
	42920,
	42921,
	42922,
	42927,
	42928,
	42933,
	42934,
	42935,
	42936,
	42937,
	42938,
	42939,
	42940,
	42941,
	42942,
	42943,
	42946,
	42947,
	42948,
	42951,
	43000,
	43002,
	43868,
	43872,
	43888,
	43968,
	63744,
	64014,
	64016,
	64017,
	64018,
	64019,
	64021,
	64031,
	64032,
	64033,
	64034,
	64035,
	64037,
	64039,
	64042,
	64110,
	64112,
	64218,
	64256,
	64263,
	64275,
	64280,
	64285,
	64286,
	64287,
	64311,
	64312,
	64317,
	64318,
	64319,
	64320,
	64322,
	64323,
	64325,
	64326,
	64434,
	64467,
	64830,
	64848,
	64912,
	64914,
	64968,
	65008,
	65021,
	65024,
	65050,
	65072,
	65093,
	65095,
	65107,
	65108,
	65127,
	65128,
	65132,
	65136,
	65139,
	65140,
	65141,
	65142,
	65277,
	65279,
	65280,
	65281,
	65471,
	65474,
	65480,
	65482,
	65488,
	65490,
	65496,
	65498,
	65501,
	65504,
	65511,
	65512,
	65519,
	65520,
	65529,
	66560,
	66600,
	66736,
	66772,
	68736,
	68787,
	71840,
	71872,
	93760,
	93792,
	113824,
	113828,
	119134,
	119141,
	119155,
	119163,
	119227,
	119233,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120780,
	120782,
	120832,
	125184,
	125218,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	127232,
	127243,
	127248,
	127279,
	127280,
	127312,
	127338,
	127341,
	127376,
	127377,
	127488,
	127491,
	127504,
	127548,
	127552,
	127561,
	127568,
	127570,
	194560,
	195102,
	917504,
	921600
]);
property.set("Changes_When_Titlecased", [
	97,
	123,
	181,
	182,
	223,
	247,
	248,
	256,
	257,
	258,
	259,
	260,
	261,
	262,
	263,
	264,
	265,
	266,
	267,
	268,
	269,
	270,
	271,
	272,
	273,
	274,
	275,
	276,
	277,
	278,
	279,
	280,
	281,
	282,
	283,
	284,
	285,
	286,
	287,
	288,
	289,
	290,
	291,
	292,
	293,
	294,
	295,
	296,
	297,
	298,
	299,
	300,
	301,
	302,
	303,
	304,
	305,
	306,
	307,
	308,
	309,
	310,
	311,
	312,
	314,
	315,
	316,
	317,
	318,
	319,
	320,
	321,
	322,
	323,
	324,
	325,
	326,
	327,
	328,
	330,
	331,
	332,
	333,
	334,
	335,
	336,
	337,
	338,
	339,
	340,
	341,
	342,
	343,
	344,
	345,
	346,
	347,
	348,
	349,
	350,
	351,
	352,
	353,
	354,
	355,
	356,
	357,
	358,
	359,
	360,
	361,
	362,
	363,
	364,
	365,
	366,
	367,
	368,
	369,
	370,
	371,
	372,
	373,
	374,
	375,
	376,
	378,
	379,
	380,
	381,
	382,
	385,
	387,
	388,
	389,
	390,
	392,
	393,
	396,
	397,
	402,
	403,
	405,
	406,
	409,
	411,
	414,
	415,
	417,
	418,
	419,
	420,
	421,
	422,
	424,
	425,
	429,
	430,
	432,
	433,
	436,
	437,
	438,
	439,
	441,
	442,
	445,
	446,
	447,
	448,
	452,
	453,
	454,
	456,
	457,
	459,
	460,
	461,
	462,
	463,
	464,
	465,
	466,
	467,
	468,
	469,
	470,
	471,
	472,
	473,
	474,
	475,
	476,
	478,
	479,
	480,
	481,
	482,
	483,
	484,
	485,
	486,
	487,
	488,
	489,
	490,
	491,
	492,
	493,
	494,
	495,
	498,
	499,
	500,
	501,
	502,
	505,
	506,
	507,
	508,
	509,
	510,
	511,
	512,
	513,
	514,
	515,
	516,
	517,
	518,
	519,
	520,
	521,
	522,
	523,
	524,
	525,
	526,
	527,
	528,
	529,
	530,
	531,
	532,
	533,
	534,
	535,
	536,
	537,
	538,
	539,
	540,
	541,
	542,
	543,
	544,
	547,
	548,
	549,
	550,
	551,
	552,
	553,
	554,
	555,
	556,
	557,
	558,
	559,
	560,
	561,
	562,
	563,
	564,
	572,
	573,
	575,
	577,
	578,
	579,
	583,
	584,
	585,
	586,
	587,
	588,
	589,
	590,
	591,
	597,
	598,
	600,
	601,
	602,
	603,
	605,
	608,
	610,
	611,
	612,
	613,
	615,
	616,
	621,
	623,
	624,
	625,
	627,
	629,
	630,
	637,
	638,
	640,
	641,
	642,
	644,
	647,
	653,
	658,
	659,
	669,
	671,
	837,
	838,
	881,
	882,
	883,
	884,
	887,
	888,
	891,
	894,
	912,
	913,
	940,
	975,
	976,
	978,
	981,
	984,
	985,
	986,
	987,
	988,
	989,
	990,
	991,
	992,
	993,
	994,
	995,
	996,
	997,
	998,
	999,
	1000,
	1001,
	1002,
	1003,
	1004,
	1005,
	1006,
	1007,
	1012,
	1013,
	1014,
	1016,
	1017,
	1019,
	1020,
	1072,
	1120,
	1121,
	1122,
	1123,
	1124,
	1125,
	1126,
	1127,
	1128,
	1129,
	1130,
	1131,
	1132,
	1133,
	1134,
	1135,
	1136,
	1137,
	1138,
	1139,
	1140,
	1141,
	1142,
	1143,
	1144,
	1145,
	1146,
	1147,
	1148,
	1149,
	1150,
	1151,
	1152,
	1153,
	1154,
	1163,
	1164,
	1165,
	1166,
	1167,
	1168,
	1169,
	1170,
	1171,
	1172,
	1173,
	1174,
	1175,
	1176,
	1177,
	1178,
	1179,
	1180,
	1181,
	1182,
	1183,
	1184,
	1185,
	1186,
	1187,
	1188,
	1189,
	1190,
	1191,
	1192,
	1193,
	1194,
	1195,
	1196,
	1197,
	1198,
	1199,
	1200,
	1201,
	1202,
	1203,
	1204,
	1205,
	1206,
	1207,
	1208,
	1209,
	1210,
	1211,
	1212,
	1213,
	1214,
	1215,
	1216,
	1218,
	1219,
	1220,
	1221,
	1222,
	1223,
	1224,
	1225,
	1226,
	1227,
	1228,
	1229,
	1230,
	1232,
	1233,
	1234,
	1235,
	1236,
	1237,
	1238,
	1239,
	1240,
	1241,
	1242,
	1243,
	1244,
	1245,
	1246,
	1247,
	1248,
	1249,
	1250,
	1251,
	1252,
	1253,
	1254,
	1255,
	1256,
	1257,
	1258,
	1259,
	1260,
	1261,
	1262,
	1263,
	1264,
	1265,
	1266,
	1267,
	1268,
	1269,
	1270,
	1271,
	1272,
	1273,
	1274,
	1275,
	1276,
	1277,
	1278,
	1279,
	1280,
	1281,
	1282,
	1283,
	1284,
	1285,
	1286,
	1287,
	1288,
	1289,
	1290,
	1291,
	1292,
	1293,
	1294,
	1295,
	1296,
	1297,
	1298,
	1299,
	1300,
	1301,
	1302,
	1303,
	1304,
	1305,
	1306,
	1307,
	1308,
	1309,
	1310,
	1311,
	1312,
	1313,
	1314,
	1315,
	1316,
	1317,
	1318,
	1319,
	1320,
	1321,
	1322,
	1323,
	1324,
	1325,
	1326,
	1327,
	1328,
	1377,
	1416,
	5112,
	5118,
	7296,
	7305,
	7545,
	7546,
	7549,
	7550,
	7566,
	7567,
	7681,
	7682,
	7683,
	7684,
	7685,
	7686,
	7687,
	7688,
	7689,
	7690,
	7691,
	7692,
	7693,
	7694,
	7695,
	7696,
	7697,
	7698,
	7699,
	7700,
	7701,
	7702,
	7703,
	7704,
	7705,
	7706,
	7707,
	7708,
	7709,
	7710,
	7711,
	7712,
	7713,
	7714,
	7715,
	7716,
	7717,
	7718,
	7719,
	7720,
	7721,
	7722,
	7723,
	7724,
	7725,
	7726,
	7727,
	7728,
	7729,
	7730,
	7731,
	7732,
	7733,
	7734,
	7735,
	7736,
	7737,
	7738,
	7739,
	7740,
	7741,
	7742,
	7743,
	7744,
	7745,
	7746,
	7747,
	7748,
	7749,
	7750,
	7751,
	7752,
	7753,
	7754,
	7755,
	7756,
	7757,
	7758,
	7759,
	7760,
	7761,
	7762,
	7763,
	7764,
	7765,
	7766,
	7767,
	7768,
	7769,
	7770,
	7771,
	7772,
	7773,
	7774,
	7775,
	7776,
	7777,
	7778,
	7779,
	7780,
	7781,
	7782,
	7783,
	7784,
	7785,
	7786,
	7787,
	7788,
	7789,
	7790,
	7791,
	7792,
	7793,
	7794,
	7795,
	7796,
	7797,
	7798,
	7799,
	7800,
	7801,
	7802,
	7803,
	7804,
	7805,
	7806,
	7807,
	7808,
	7809,
	7810,
	7811,
	7812,
	7813,
	7814,
	7815,
	7816,
	7817,
	7818,
	7819,
	7820,
	7821,
	7822,
	7823,
	7824,
	7825,
	7826,
	7827,
	7828,
	7829,
	7836,
	7841,
	7842,
	7843,
	7844,
	7845,
	7846,
	7847,
	7848,
	7849,
	7850,
	7851,
	7852,
	7853,
	7854,
	7855,
	7856,
	7857,
	7858,
	7859,
	7860,
	7861,
	7862,
	7863,
	7864,
	7865,
	7866,
	7867,
	7868,
	7869,
	7870,
	7871,
	7872,
	7873,
	7874,
	7875,
	7876,
	7877,
	7878,
	7879,
	7880,
	7881,
	7882,
	7883,
	7884,
	7885,
	7886,
	7887,
	7888,
	7889,
	7890,
	7891,
	7892,
	7893,
	7894,
	7895,
	7896,
	7897,
	7898,
	7899,
	7900,
	7901,
	7902,
	7903,
	7904,
	7905,
	7906,
	7907,
	7908,
	7909,
	7910,
	7911,
	7912,
	7913,
	7914,
	7915,
	7916,
	7917,
	7918,
	7919,
	7920,
	7921,
	7922,
	7923,
	7924,
	7925,
	7926,
	7927,
	7928,
	7929,
	7930,
	7931,
	7932,
	7933,
	7934,
	7935,
	7944,
	7952,
	7958,
	7968,
	7976,
	7984,
	7992,
	8000,
	8006,
	8016,
	8024,
	8032,
	8040,
	8048,
	8062,
	8064,
	8072,
	8080,
	8088,
	8096,
	8104,
	8112,
	8117,
	8118,
	8120,
	8126,
	8127,
	8130,
	8133,
	8134,
	8136,
	8144,
	8148,
	8150,
	8152,
	8160,
	8168,
	8178,
	8181,
	8182,
	8184,
	8526,
	8527,
	8560,
	8576,
	8580,
	8581,
	9424,
	9450,
	11312,
	11359,
	11361,
	11362,
	11365,
	11367,
	11368,
	11369,
	11370,
	11371,
	11372,
	11373,
	11379,
	11380,
	11382,
	11383,
	11393,
	11394,
	11395,
	11396,
	11397,
	11398,
	11399,
	11400,
	11401,
	11402,
	11403,
	11404,
	11405,
	11406,
	11407,
	11408,
	11409,
	11410,
	11411,
	11412,
	11413,
	11414,
	11415,
	11416,
	11417,
	11418,
	11419,
	11420,
	11421,
	11422,
	11423,
	11424,
	11425,
	11426,
	11427,
	11428,
	11429,
	11430,
	11431,
	11432,
	11433,
	11434,
	11435,
	11436,
	11437,
	11438,
	11439,
	11440,
	11441,
	11442,
	11443,
	11444,
	11445,
	11446,
	11447,
	11448,
	11449,
	11450,
	11451,
	11452,
	11453,
	11454,
	11455,
	11456,
	11457,
	11458,
	11459,
	11460,
	11461,
	11462,
	11463,
	11464,
	11465,
	11466,
	11467,
	11468,
	11469,
	11470,
	11471,
	11472,
	11473,
	11474,
	11475,
	11476,
	11477,
	11478,
	11479,
	11480,
	11481,
	11482,
	11483,
	11484,
	11485,
	11486,
	11487,
	11488,
	11489,
	11490,
	11491,
	11492,
	11500,
	11501,
	11502,
	11503,
	11507,
	11508,
	11520,
	11558,
	11559,
	11560,
	11565,
	11566,
	42561,
	42562,
	42563,
	42564,
	42565,
	42566,
	42567,
	42568,
	42569,
	42570,
	42571,
	42572,
	42573,
	42574,
	42575,
	42576,
	42577,
	42578,
	42579,
	42580,
	42581,
	42582,
	42583,
	42584,
	42585,
	42586,
	42587,
	42588,
	42589,
	42590,
	42591,
	42592,
	42593,
	42594,
	42595,
	42596,
	42597,
	42598,
	42599,
	42600,
	42601,
	42602,
	42603,
	42604,
	42605,
	42606,
	42625,
	42626,
	42627,
	42628,
	42629,
	42630,
	42631,
	42632,
	42633,
	42634,
	42635,
	42636,
	42637,
	42638,
	42639,
	42640,
	42641,
	42642,
	42643,
	42644,
	42645,
	42646,
	42647,
	42648,
	42649,
	42650,
	42651,
	42652,
	42787,
	42788,
	42789,
	42790,
	42791,
	42792,
	42793,
	42794,
	42795,
	42796,
	42797,
	42798,
	42799,
	42800,
	42803,
	42804,
	42805,
	42806,
	42807,
	42808,
	42809,
	42810,
	42811,
	42812,
	42813,
	42814,
	42815,
	42816,
	42817,
	42818,
	42819,
	42820,
	42821,
	42822,
	42823,
	42824,
	42825,
	42826,
	42827,
	42828,
	42829,
	42830,
	42831,
	42832,
	42833,
	42834,
	42835,
	42836,
	42837,
	42838,
	42839,
	42840,
	42841,
	42842,
	42843,
	42844,
	42845,
	42846,
	42847,
	42848,
	42849,
	42850,
	42851,
	42852,
	42853,
	42854,
	42855,
	42856,
	42857,
	42858,
	42859,
	42860,
	42861,
	42862,
	42863,
	42864,
	42874,
	42875,
	42876,
	42877,
	42879,
	42880,
	42881,
	42882,
	42883,
	42884,
	42885,
	42886,
	42887,
	42888,
	42892,
	42893,
	42897,
	42898,
	42899,
	42901,
	42903,
	42904,
	42905,
	42906,
	42907,
	42908,
	42909,
	42910,
	42911,
	42912,
	42913,
	42914,
	42915,
	42916,
	42917,
	42918,
	42919,
	42920,
	42921,
	42922,
	42933,
	42934,
	42935,
	42936,
	42937,
	42938,
	42939,
	42940,
	42941,
	42942,
	42943,
	42944,
	42947,
	42948,
	43859,
	43860,
	43888,
	43968,
	64256,
	64263,
	64275,
	64280,
	65345,
	65371,
	66600,
	66640,
	66776,
	66812,
	68800,
	68851,
	71872,
	71904,
	93792,
	93824,
	125218,
	125252
]);
property.set("Changes_When_Uppercased", [
	97,
	123,
	181,
	182,
	223,
	247,
	248,
	256,
	257,
	258,
	259,
	260,
	261,
	262,
	263,
	264,
	265,
	266,
	267,
	268,
	269,
	270,
	271,
	272,
	273,
	274,
	275,
	276,
	277,
	278,
	279,
	280,
	281,
	282,
	283,
	284,
	285,
	286,
	287,
	288,
	289,
	290,
	291,
	292,
	293,
	294,
	295,
	296,
	297,
	298,
	299,
	300,
	301,
	302,
	303,
	304,
	305,
	306,
	307,
	308,
	309,
	310,
	311,
	312,
	314,
	315,
	316,
	317,
	318,
	319,
	320,
	321,
	322,
	323,
	324,
	325,
	326,
	327,
	328,
	330,
	331,
	332,
	333,
	334,
	335,
	336,
	337,
	338,
	339,
	340,
	341,
	342,
	343,
	344,
	345,
	346,
	347,
	348,
	349,
	350,
	351,
	352,
	353,
	354,
	355,
	356,
	357,
	358,
	359,
	360,
	361,
	362,
	363,
	364,
	365,
	366,
	367,
	368,
	369,
	370,
	371,
	372,
	373,
	374,
	375,
	376,
	378,
	379,
	380,
	381,
	382,
	385,
	387,
	388,
	389,
	390,
	392,
	393,
	396,
	397,
	402,
	403,
	405,
	406,
	409,
	411,
	414,
	415,
	417,
	418,
	419,
	420,
	421,
	422,
	424,
	425,
	429,
	430,
	432,
	433,
	436,
	437,
	438,
	439,
	441,
	442,
	445,
	446,
	447,
	448,
	453,
	455,
	456,
	458,
	459,
	461,
	462,
	463,
	464,
	465,
	466,
	467,
	468,
	469,
	470,
	471,
	472,
	473,
	474,
	475,
	476,
	478,
	479,
	480,
	481,
	482,
	483,
	484,
	485,
	486,
	487,
	488,
	489,
	490,
	491,
	492,
	493,
	494,
	495,
	497,
	498,
	500,
	501,
	502,
	505,
	506,
	507,
	508,
	509,
	510,
	511,
	512,
	513,
	514,
	515,
	516,
	517,
	518,
	519,
	520,
	521,
	522,
	523,
	524,
	525,
	526,
	527,
	528,
	529,
	530,
	531,
	532,
	533,
	534,
	535,
	536,
	537,
	538,
	539,
	540,
	541,
	542,
	543,
	544,
	547,
	548,
	549,
	550,
	551,
	552,
	553,
	554,
	555,
	556,
	557,
	558,
	559,
	560,
	561,
	562,
	563,
	564,
	572,
	573,
	575,
	577,
	578,
	579,
	583,
	584,
	585,
	586,
	587,
	588,
	589,
	590,
	591,
	597,
	598,
	600,
	601,
	602,
	603,
	605,
	608,
	610,
	611,
	612,
	613,
	615,
	616,
	621,
	623,
	624,
	625,
	627,
	629,
	630,
	637,
	638,
	640,
	641,
	642,
	644,
	647,
	653,
	658,
	659,
	669,
	671,
	837,
	838,
	881,
	882,
	883,
	884,
	887,
	888,
	891,
	894,
	912,
	913,
	940,
	975,
	976,
	978,
	981,
	984,
	985,
	986,
	987,
	988,
	989,
	990,
	991,
	992,
	993,
	994,
	995,
	996,
	997,
	998,
	999,
	1000,
	1001,
	1002,
	1003,
	1004,
	1005,
	1006,
	1007,
	1012,
	1013,
	1014,
	1016,
	1017,
	1019,
	1020,
	1072,
	1120,
	1121,
	1122,
	1123,
	1124,
	1125,
	1126,
	1127,
	1128,
	1129,
	1130,
	1131,
	1132,
	1133,
	1134,
	1135,
	1136,
	1137,
	1138,
	1139,
	1140,
	1141,
	1142,
	1143,
	1144,
	1145,
	1146,
	1147,
	1148,
	1149,
	1150,
	1151,
	1152,
	1153,
	1154,
	1163,
	1164,
	1165,
	1166,
	1167,
	1168,
	1169,
	1170,
	1171,
	1172,
	1173,
	1174,
	1175,
	1176,
	1177,
	1178,
	1179,
	1180,
	1181,
	1182,
	1183,
	1184,
	1185,
	1186,
	1187,
	1188,
	1189,
	1190,
	1191,
	1192,
	1193,
	1194,
	1195,
	1196,
	1197,
	1198,
	1199,
	1200,
	1201,
	1202,
	1203,
	1204,
	1205,
	1206,
	1207,
	1208,
	1209,
	1210,
	1211,
	1212,
	1213,
	1214,
	1215,
	1216,
	1218,
	1219,
	1220,
	1221,
	1222,
	1223,
	1224,
	1225,
	1226,
	1227,
	1228,
	1229,
	1230,
	1232,
	1233,
	1234,
	1235,
	1236,
	1237,
	1238,
	1239,
	1240,
	1241,
	1242,
	1243,
	1244,
	1245,
	1246,
	1247,
	1248,
	1249,
	1250,
	1251,
	1252,
	1253,
	1254,
	1255,
	1256,
	1257,
	1258,
	1259,
	1260,
	1261,
	1262,
	1263,
	1264,
	1265,
	1266,
	1267,
	1268,
	1269,
	1270,
	1271,
	1272,
	1273,
	1274,
	1275,
	1276,
	1277,
	1278,
	1279,
	1280,
	1281,
	1282,
	1283,
	1284,
	1285,
	1286,
	1287,
	1288,
	1289,
	1290,
	1291,
	1292,
	1293,
	1294,
	1295,
	1296,
	1297,
	1298,
	1299,
	1300,
	1301,
	1302,
	1303,
	1304,
	1305,
	1306,
	1307,
	1308,
	1309,
	1310,
	1311,
	1312,
	1313,
	1314,
	1315,
	1316,
	1317,
	1318,
	1319,
	1320,
	1321,
	1322,
	1323,
	1324,
	1325,
	1326,
	1327,
	1328,
	1377,
	1416,
	4304,
	4347,
	4349,
	4352,
	5112,
	5118,
	7296,
	7305,
	7545,
	7546,
	7549,
	7550,
	7566,
	7567,
	7681,
	7682,
	7683,
	7684,
	7685,
	7686,
	7687,
	7688,
	7689,
	7690,
	7691,
	7692,
	7693,
	7694,
	7695,
	7696,
	7697,
	7698,
	7699,
	7700,
	7701,
	7702,
	7703,
	7704,
	7705,
	7706,
	7707,
	7708,
	7709,
	7710,
	7711,
	7712,
	7713,
	7714,
	7715,
	7716,
	7717,
	7718,
	7719,
	7720,
	7721,
	7722,
	7723,
	7724,
	7725,
	7726,
	7727,
	7728,
	7729,
	7730,
	7731,
	7732,
	7733,
	7734,
	7735,
	7736,
	7737,
	7738,
	7739,
	7740,
	7741,
	7742,
	7743,
	7744,
	7745,
	7746,
	7747,
	7748,
	7749,
	7750,
	7751,
	7752,
	7753,
	7754,
	7755,
	7756,
	7757,
	7758,
	7759,
	7760,
	7761,
	7762,
	7763,
	7764,
	7765,
	7766,
	7767,
	7768,
	7769,
	7770,
	7771,
	7772,
	7773,
	7774,
	7775,
	7776,
	7777,
	7778,
	7779,
	7780,
	7781,
	7782,
	7783,
	7784,
	7785,
	7786,
	7787,
	7788,
	7789,
	7790,
	7791,
	7792,
	7793,
	7794,
	7795,
	7796,
	7797,
	7798,
	7799,
	7800,
	7801,
	7802,
	7803,
	7804,
	7805,
	7806,
	7807,
	7808,
	7809,
	7810,
	7811,
	7812,
	7813,
	7814,
	7815,
	7816,
	7817,
	7818,
	7819,
	7820,
	7821,
	7822,
	7823,
	7824,
	7825,
	7826,
	7827,
	7828,
	7829,
	7836,
	7841,
	7842,
	7843,
	7844,
	7845,
	7846,
	7847,
	7848,
	7849,
	7850,
	7851,
	7852,
	7853,
	7854,
	7855,
	7856,
	7857,
	7858,
	7859,
	7860,
	7861,
	7862,
	7863,
	7864,
	7865,
	7866,
	7867,
	7868,
	7869,
	7870,
	7871,
	7872,
	7873,
	7874,
	7875,
	7876,
	7877,
	7878,
	7879,
	7880,
	7881,
	7882,
	7883,
	7884,
	7885,
	7886,
	7887,
	7888,
	7889,
	7890,
	7891,
	7892,
	7893,
	7894,
	7895,
	7896,
	7897,
	7898,
	7899,
	7900,
	7901,
	7902,
	7903,
	7904,
	7905,
	7906,
	7907,
	7908,
	7909,
	7910,
	7911,
	7912,
	7913,
	7914,
	7915,
	7916,
	7917,
	7918,
	7919,
	7920,
	7921,
	7922,
	7923,
	7924,
	7925,
	7926,
	7927,
	7928,
	7929,
	7930,
	7931,
	7932,
	7933,
	7934,
	7935,
	7944,
	7952,
	7958,
	7968,
	7976,
	7984,
	7992,
	8000,
	8006,
	8016,
	8024,
	8032,
	8040,
	8048,
	8062,
	8064,
	8117,
	8118,
	8120,
	8124,
	8125,
	8126,
	8127,
	8130,
	8133,
	8134,
	8136,
	8140,
	8141,
	8144,
	8148,
	8150,
	8152,
	8160,
	8168,
	8178,
	8181,
	8182,
	8184,
	8188,
	8189,
	8526,
	8527,
	8560,
	8576,
	8580,
	8581,
	9424,
	9450,
	11312,
	11359,
	11361,
	11362,
	11365,
	11367,
	11368,
	11369,
	11370,
	11371,
	11372,
	11373,
	11379,
	11380,
	11382,
	11383,
	11393,
	11394,
	11395,
	11396,
	11397,
	11398,
	11399,
	11400,
	11401,
	11402,
	11403,
	11404,
	11405,
	11406,
	11407,
	11408,
	11409,
	11410,
	11411,
	11412,
	11413,
	11414,
	11415,
	11416,
	11417,
	11418,
	11419,
	11420,
	11421,
	11422,
	11423,
	11424,
	11425,
	11426,
	11427,
	11428,
	11429,
	11430,
	11431,
	11432,
	11433,
	11434,
	11435,
	11436,
	11437,
	11438,
	11439,
	11440,
	11441,
	11442,
	11443,
	11444,
	11445,
	11446,
	11447,
	11448,
	11449,
	11450,
	11451,
	11452,
	11453,
	11454,
	11455,
	11456,
	11457,
	11458,
	11459,
	11460,
	11461,
	11462,
	11463,
	11464,
	11465,
	11466,
	11467,
	11468,
	11469,
	11470,
	11471,
	11472,
	11473,
	11474,
	11475,
	11476,
	11477,
	11478,
	11479,
	11480,
	11481,
	11482,
	11483,
	11484,
	11485,
	11486,
	11487,
	11488,
	11489,
	11490,
	11491,
	11492,
	11500,
	11501,
	11502,
	11503,
	11507,
	11508,
	11520,
	11558,
	11559,
	11560,
	11565,
	11566,
	42561,
	42562,
	42563,
	42564,
	42565,
	42566,
	42567,
	42568,
	42569,
	42570,
	42571,
	42572,
	42573,
	42574,
	42575,
	42576,
	42577,
	42578,
	42579,
	42580,
	42581,
	42582,
	42583,
	42584,
	42585,
	42586,
	42587,
	42588,
	42589,
	42590,
	42591,
	42592,
	42593,
	42594,
	42595,
	42596,
	42597,
	42598,
	42599,
	42600,
	42601,
	42602,
	42603,
	42604,
	42605,
	42606,
	42625,
	42626,
	42627,
	42628,
	42629,
	42630,
	42631,
	42632,
	42633,
	42634,
	42635,
	42636,
	42637,
	42638,
	42639,
	42640,
	42641,
	42642,
	42643,
	42644,
	42645,
	42646,
	42647,
	42648,
	42649,
	42650,
	42651,
	42652,
	42787,
	42788,
	42789,
	42790,
	42791,
	42792,
	42793,
	42794,
	42795,
	42796,
	42797,
	42798,
	42799,
	42800,
	42803,
	42804,
	42805,
	42806,
	42807,
	42808,
	42809,
	42810,
	42811,
	42812,
	42813,
	42814,
	42815,
	42816,
	42817,
	42818,
	42819,
	42820,
	42821,
	42822,
	42823,
	42824,
	42825,
	42826,
	42827,
	42828,
	42829,
	42830,
	42831,
	42832,
	42833,
	42834,
	42835,
	42836,
	42837,
	42838,
	42839,
	42840,
	42841,
	42842,
	42843,
	42844,
	42845,
	42846,
	42847,
	42848,
	42849,
	42850,
	42851,
	42852,
	42853,
	42854,
	42855,
	42856,
	42857,
	42858,
	42859,
	42860,
	42861,
	42862,
	42863,
	42864,
	42874,
	42875,
	42876,
	42877,
	42879,
	42880,
	42881,
	42882,
	42883,
	42884,
	42885,
	42886,
	42887,
	42888,
	42892,
	42893,
	42897,
	42898,
	42899,
	42901,
	42903,
	42904,
	42905,
	42906,
	42907,
	42908,
	42909,
	42910,
	42911,
	42912,
	42913,
	42914,
	42915,
	42916,
	42917,
	42918,
	42919,
	42920,
	42921,
	42922,
	42933,
	42934,
	42935,
	42936,
	42937,
	42938,
	42939,
	42940,
	42941,
	42942,
	42943,
	42944,
	42947,
	42948,
	43859,
	43860,
	43888,
	43968,
	64256,
	64263,
	64275,
	64280,
	65345,
	65371,
	66600,
	66640,
	66776,
	66812,
	68800,
	68851,
	71872,
	71904,
	93792,
	93824,
	125218,
	125252
]);
property.set("Dash", [
	45,
	46,
	1418,
	1419,
	1470,
	1471,
	5120,
	5121,
	6150,
	6151,
	8208,
	8214,
	8275,
	8276,
	8315,
	8316,
	8331,
	8332,
	8722,
	8723,
	11799,
	11800,
	11802,
	11803,
	11834,
	11836,
	11840,
	11841,
	12316,
	12317,
	12336,
	12337,
	12448,
	12449,
	65073,
	65075,
	65112,
	65113,
	65123,
	65124,
	65293,
	65294
]);
property.set("Default_Ignorable_Code_Point", [
	173,
	174,
	847,
	848,
	1564,
	1565,
	4447,
	4449,
	6068,
	6070,
	6155,
	6159,
	8203,
	8208,
	8234,
	8239,
	8288,
	8304,
	12644,
	12645,
	65024,
	65040,
	65279,
	65280,
	65440,
	65441,
	65520,
	65529,
	113824,
	113828,
	119155,
	119163,
	917504,
	921600
]);
property.set("Deprecated", [329, 330, 1651, 1652, 3959, 3960, 3961, 3962, 6051, 6053, 8298, 8304, 9001, 9003, 917505, 917506]);
property.set("Diacritic", [
	94,
	95,
	96,
	97,
	168,
	169,
	175,
	176,
	180,
	181,
	183,
	185,
	688,
	847,
	848,
	856,
	861,
	867,
	884,
	886,
	890,
	891,
	900,
	902,
	1155,
	1160,
	1369,
	1370,
	1425,
	1442,
	1443,
	1470,
	1471,
	1472,
	1473,
	1475,
	1476,
	1477,
	1611,
	1619,
	1623,
	1625,
	1759,
	1761,
	1765,
	1767,
	1770,
	1773,
	1840,
	1867,
	1958,
	1969,
	2027,
	2038,
	2072,
	2074,
	2275,
	2303,
	2364,
	2365,
	2381,
	2382,
	2385,
	2389,
	2417,
	2418,
	2492,
	2493,
	2509,
	2510,
	2620,
	2621,
	2637,
	2638,
	2748,
	2749,
	2765,
	2766,
	2813,
	2816,
	2876,
	2877,
	2893,
	2894,
	3021,
	3022,
	3149,
	3150,
	3260,
	3261,
	3277,
	3278,
	3387,
	3389,
	3405,
	3406,
	3530,
	3531,
	3655,
	3661,
	3662,
	3663,
	3770,
	3771,
	3784,
	3789,
	3864,
	3866,
	3893,
	3894,
	3895,
	3896,
	3897,
	3898,
	3902,
	3904,
	3970,
	3973,
	3974,
	3976,
	4038,
	4039,
	4151,
	4152,
	4153,
	4155,
	4195,
	4197,
	4201,
	4206,
	4231,
	4238,
	4239,
	4240,
	4250,
	4252,
	4957,
	4960,
	6089,
	6100,
	6109,
	6110,
	6457,
	6460,
	6773,
	6781,
	6783,
	6784,
	6832,
	6846,
	6964,
	6965,
	6980,
	6981,
	7019,
	7028,
	7082,
	7084,
	7222,
	7224,
	7288,
	7294,
	7376,
	7401,
	7405,
	7406,
	7412,
	7413,
	7415,
	7418,
	7468,
	7531,
	7620,
	7632,
	7669,
	7674,
	7677,
	7680,
	8125,
	8126,
	8127,
	8130,
	8141,
	8144,
	8157,
	8160,
	8173,
	8176,
	8189,
	8191,
	11503,
	11506,
	11823,
	11824,
	12330,
	12336,
	12441,
	12445,
	12540,
	12541,
	42607,
	42608,
	42620,
	42622,
	42623,
	42624,
	42652,
	42654,
	42736,
	42738,
	42752,
	42786,
	42888,
	42891,
	43000,
	43002,
	43204,
	43205,
	43232,
	43250,
	43307,
	43311,
	43347,
	43348,
	43443,
	43444,
	43456,
	43457,
	43493,
	43494,
	43643,
	43646,
	43711,
	43715,
	43766,
	43767,
	43867,
	43872,
	44012,
	44014,
	64286,
	64287,
	65056,
	65072,
	65342,
	65343,
	65344,
	65345,
	65392,
	65393,
	65438,
	65440,
	65507,
	65508,
	66272,
	66273,
	68325,
	68327,
	68898,
	68904,
	69446,
	69457,
	69817,
	69819,
	69939,
	69941,
	70003,
	70004,
	70080,
	70081,
	70090,
	70093,
	70197,
	70199,
	70377,
	70379,
	70460,
	70461,
	70477,
	70478,
	70502,
	70509,
	70512,
	70517,
	70722,
	70723,
	70726,
	70727,
	70850,
	70852,
	71103,
	71105,
	71231,
	71232,
	71350,
	71352,
	71467,
	71468,
	71737,
	71739,
	72160,
	72161,
	72244,
	72245,
	72263,
	72264,
	72345,
	72346,
	72767,
	72768,
	73026,
	73027,
	73028,
	73030,
	73111,
	73112,
	92912,
	92917,
	92976,
	92983,
	94095,
	94112,
	119143,
	119146,
	119149,
	119155,
	119163,
	119171,
	119173,
	119180,
	119210,
	119214,
	123184,
	123191,
	123628,
	123632,
	125136,
	125143,
	125252,
	125255,
	125256,
	125259
]);
property.set("Emoji", [
	35,
	36,
	42,
	43,
	48,
	58,
	169,
	170,
	174,
	175,
	8252,
	8253,
	8265,
	8266,
	8482,
	8483,
	8505,
	8506,
	8596,
	8602,
	8617,
	8619,
	8986,
	8988,
	9000,
	9001,
	9167,
	9168,
	9193,
	9204,
	9208,
	9211,
	9410,
	9411,
	9642,
	9644,
	9654,
	9655,
	9664,
	9665,
	9723,
	9727,
	9728,
	9733,
	9742,
	9743,
	9745,
	9746,
	9748,
	9750,
	9752,
	9753,
	9757,
	9758,
	9760,
	9761,
	9762,
	9764,
	9766,
	9767,
	9770,
	9771,
	9774,
	9776,
	9784,
	9787,
	9792,
	9793,
	9794,
	9795,
	9800,
	9812,
	9823,
	9825,
	9827,
	9828,
	9829,
	9831,
	9832,
	9833,
	9851,
	9852,
	9854,
	9856,
	9874,
	9880,
	9881,
	9882,
	9883,
	9885,
	9888,
	9890,
	9898,
	9900,
	9904,
	9906,
	9917,
	9919,
	9924,
	9926,
	9928,
	9929,
	9934,
	9936,
	9937,
	9938,
	9939,
	9941,
	9961,
	9963,
	9968,
	9974,
	9975,
	9979,
	9981,
	9982,
	9986,
	9987,
	9989,
	9990,
	9992,
	9998,
	9999,
	10000,
	10002,
	10003,
	10004,
	10005,
	10006,
	10007,
	10013,
	10014,
	10017,
	10018,
	10024,
	10025,
	10035,
	10037,
	10052,
	10053,
	10055,
	10056,
	10060,
	10061,
	10062,
	10063,
	10067,
	10070,
	10071,
	10072,
	10083,
	10085,
	10133,
	10136,
	10145,
	10146,
	10160,
	10161,
	10175,
	10176,
	10548,
	10550,
	11013,
	11016,
	11035,
	11037,
	11088,
	11089,
	11093,
	11094,
	12336,
	12337,
	12349,
	12350,
	12951,
	12952,
	12953,
	12954,
	126980,
	126981,
	127183,
	127184,
	127344,
	127346,
	127358,
	127360,
	127374,
	127375,
	127377,
	127387,
	127462,
	127488,
	127489,
	127491,
	127514,
	127515,
	127535,
	127536,
	127538,
	127547,
	127568,
	127570,
	127744,
	127778,
	127780,
	127892,
	127894,
	127896,
	127897,
	127900,
	127902,
	127985,
	127987,
	127990,
	127991,
	128254,
	128255,
	128318,
	128329,
	128335,
	128336,
	128360,
	128367,
	128369,
	128371,
	128379,
	128391,
	128392,
	128394,
	128398,
	128400,
	128401,
	128405,
	128407,
	128420,
	128422,
	128424,
	128425,
	128433,
	128435,
	128444,
	128445,
	128450,
	128453,
	128465,
	128468,
	128476,
	128479,
	128481,
	128482,
	128483,
	128484,
	128488,
	128489,
	128495,
	128496,
	128499,
	128500,
	128506,
	128592,
	128640,
	128710,
	128715,
	128723,
	128725,
	128726,
	128736,
	128742,
	128745,
	128746,
	128747,
	128749,
	128752,
	128753,
	128755,
	128763,
	128992,
	129004,
	129293,
	129339,
	129340,
	129350,
	129351,
	129394,
	129395,
	129399,
	129402,
	129443,
	129445,
	129451,
	129454,
	129483,
	129485,
	129536,
	129648,
	129652,
	129656,
	129659,
	129664,
	129667,
	129680,
	129686
]);
property.set("Emoji_Component", [35, 36, 42, 43, 48, 58, 8205, 8206, 8419, 8420, 65039, 65040, 127462, 127488, 127995, 128000, 129456, 129460, 917536, 917632]);
property.set("Emoji_Modifier", [127995, 128000]);
property.set("Emoji_Modifier_Base", [
	9757,
	9758,
	9977,
	9978,
	9994,
	9998,
	127877,
	127878,
	127938,
	127941,
	127943,
	127944,
	127946,
	127949,
	128066,
	128068,
	128070,
	128081,
	128102,
	128121,
	128124,
	128125,
	128129,
	128132,
	128133,
	128136,
	128143,
	128144,
	128145,
	128146,
	128170,
	128171,
	128372,
	128374,
	128378,
	128379,
	128400,
	128401,
	128405,
	128407,
	128581,
	128584,
	128587,
	128592,
	128675,
	128676,
	128692,
	128695,
	128704,
	128705,
	128716,
	128717,
	129295,
	129296,
	129304,
	129312,
	129318,
	129319,
	129328,
	129338,
	129340,
	129343,
	129461,
	129463,
	129464,
	129466,
	129467,
	129468,
	129485,
	129488,
	129489,
	129502
]);
property.set("Emoji_Presentation", [
	8986,
	8988,
	9193,
	9197,
	9200,
	9201,
	9203,
	9204,
	9725,
	9727,
	9748,
	9750,
	9800,
	9812,
	9855,
	9856,
	9875,
	9876,
	9889,
	9890,
	9898,
	9900,
	9917,
	9919,
	9924,
	9926,
	9934,
	9935,
	9940,
	9941,
	9962,
	9963,
	9970,
	9972,
	9973,
	9974,
	9978,
	9979,
	9981,
	9982,
	9989,
	9990,
	9994,
	9996,
	10024,
	10025,
	10060,
	10061,
	10062,
	10063,
	10067,
	10070,
	10071,
	10072,
	10133,
	10136,
	10160,
	10161,
	10175,
	10176,
	11035,
	11037,
	11088,
	11089,
	11093,
	11094,
	126980,
	126981,
	127183,
	127184,
	127374,
	127375,
	127377,
	127387,
	127462,
	127488,
	127489,
	127490,
	127514,
	127515,
	127535,
	127536,
	127538,
	127543,
	127544,
	127547,
	127568,
	127570,
	127744,
	127777,
	127789,
	127798,
	127799,
	127869,
	127870,
	127892,
	127904,
	127947,
	127951,
	127956,
	127968,
	127985,
	127988,
	127989,
	127992,
	128063,
	128064,
	128065,
	128066,
	128253,
	128255,
	128318,
	128331,
	128335,
	128336,
	128360,
	128378,
	128379,
	128405,
	128407,
	128420,
	128421,
	128507,
	128592,
	128640,
	128710,
	128716,
	128717,
	128720,
	128723,
	128725,
	128726,
	128747,
	128749,
	128756,
	128763,
	128992,
	129004,
	129293,
	129339,
	129340,
	129350,
	129351,
	129394,
	129395,
	129399,
	129402,
	129443,
	129445,
	129451,
	129454,
	129483,
	129485,
	129536,
	129648,
	129652,
	129656,
	129659,
	129664,
	129667,
	129680,
	129686
]);
property.set("Extended_Pictographic", [
	169,
	170,
	174,
	175,
	8252,
	8253,
	8265,
	8266,
	8482,
	8483,
	8505,
	8506,
	8596,
	8602,
	8617,
	8619,
	8986,
	8988,
	9000,
	9001,
	9096,
	9097,
	9167,
	9168,
	9193,
	9204,
	9208,
	9211,
	9410,
	9411,
	9642,
	9644,
	9654,
	9655,
	9664,
	9665,
	9723,
	9727,
	9728,
	9734,
	9735,
	9747,
	9748,
	9862,
	9872,
	9990,
	9992,
	10003,
	10004,
	10005,
	10006,
	10007,
	10013,
	10014,
	10017,
	10018,
	10024,
	10025,
	10035,
	10037,
	10052,
	10053,
	10055,
	10056,
	10060,
	10061,
	10062,
	10063,
	10067,
	10070,
	10071,
	10072,
	10083,
	10088,
	10133,
	10136,
	10145,
	10146,
	10160,
	10161,
	10175,
	10176,
	10548,
	10550,
	11013,
	11016,
	11035,
	11037,
	11088,
	11089,
	11093,
	11094,
	12336,
	12337,
	12349,
	12350,
	12951,
	12952,
	12953,
	12954,
	126976,
	127232,
	127245,
	127248,
	127279,
	127280,
	127340,
	127346,
	127358,
	127360,
	127374,
	127375,
	127377,
	127387,
	127405,
	127462,
	127489,
	127504,
	127514,
	127515,
	127535,
	127536,
	127538,
	127547,
	127548,
	127552,
	127561,
	127995,
	128000,
	128318,
	128326,
	128592,
	128640,
	128768,
	128884,
	128896,
	128981,
	129024,
	129036,
	129040,
	129096,
	129104,
	129114,
	129120,
	129160,
	129168,
	129198,
	129280,
	129292,
	129339,
	129340,
	129350,
	129351,
	131070
]);
property.set("Extender", [
	183,
	184,
	720,
	722,
	1600,
	1601,
	2042,
	2043,
	3654,
	3655,
	3782,
	3783,
	6154,
	6155,
	6211,
	6212,
	6823,
	6824,
	7222,
	7223,
	7291,
	7292,
	12293,
	12294,
	12337,
	12342,
	12445,
	12447,
	12540,
	12543,
	40981,
	40982,
	42508,
	42509,
	43471,
	43472,
	43494,
	43495,
	43632,
	43633,
	43741,
	43742,
	43763,
	43765,
	65392,
	65393,
	70493,
	70494,
	71110,
	71113,
	72344,
	72345,
	92994,
	92996,
	94176,
	94178,
	94179,
	94180,
	123196,
	123198,
	125252,
	125255
]);
property.set("Grapheme_Base", [
	32,
	127,
	160,
	173,
	174,
	768,
	880,
	888,
	890,
	896,
	900,
	907,
	908,
	909,
	910,
	930,
	931,
	1155,
	1162,
	1328,
	1329,
	1367,
	1369,
	1419,
	1421,
	1424,
	1470,
	1471,
	1472,
	1473,
	1475,
	1476,
	1478,
	1479,
	1488,
	1515,
	1519,
	1525,
	1542,
	1552,
	1563,
	1564,
	1566,
	1611,
	1632,
	1648,
	1649,
	1750,
	1758,
	1759,
	1765,
	1767,
	1769,
	1770,
	1774,
	1806,
	1808,
	1809,
	1810,
	1840,
	1869,
	1958,
	1969,
	1970,
	1984,
	2027,
	2036,
	2043,
	2046,
	2070,
	2074,
	2075,
	2084,
	2085,
	2088,
	2089,
	2096,
	2111,
	2112,
	2137,
	2142,
	2143,
	2144,
	2155,
	2208,
	2229,
	2230,
	2238,
	2307,
	2362,
	2363,
	2364,
	2365,
	2369,
	2377,
	2381,
	2382,
	2385,
	2392,
	2402,
	2404,
	2433,
	2434,
	2436,
	2437,
	2445,
	2447,
	2449,
	2451,
	2473,
	2474,
	2481,
	2482,
	2483,
	2486,
	2490,
	2493,
	2494,
	2495,
	2497,
	2503,
	2505,
	2507,
	2509,
	2510,
	2511,
	2524,
	2526,
	2527,
	2530,
	2534,
	2558,
	2563,
	2564,
	2565,
	2571,
	2575,
	2577,
	2579,
	2601,
	2602,
	2609,
	2610,
	2612,
	2613,
	2615,
	2616,
	2618,
	2622,
	2625,
	2649,
	2653,
	2654,
	2655,
	2662,
	2672,
	2674,
	2677,
	2678,
	2679,
	2691,
	2692,
	2693,
	2702,
	2703,
	2706,
	2707,
	2729,
	2730,
	2737,
	2738,
	2740,
	2741,
	2746,
	2749,
	2753,
	2761,
	2762,
	2763,
	2765,
	2768,
	2769,
	2784,
	2786,
	2790,
	2802,
	2809,
	2810,
	2818,
	2820,
	2821,
	2829,
	2831,
	2833,
	2835,
	2857,
	2858,
	2865,
	2866,
	2868,
	2869,
	2874,
	2877,
	2878,
	2880,
	2881,
	2887,
	2889,
	2891,
	2893,
	2908,
	2910,
	2911,
	2914,
	2918,
	2936,
	2947,
	2948,
	2949,
	2955,
	2958,
	2961,
	2962,
	2966,
	2969,
	2971,
	2972,
	2973,
	2974,
	2976,
	2979,
	2981,
	2984,
	2987,
	2990,
	3002,
	3007,
	3008,
	3009,
	3011,
	3014,
	3017,
	3018,
	3021,
	3024,
	3025,
	3046,
	3067,
	3073,
	3076,
	3077,
	3085,
	3086,
	3089,
	3090,
	3113,
	3114,
	3130,
	3133,
	3134,
	3137,
	3141,
	3160,
	3163,
	3168,
	3170,
	3174,
	3184,
	3191,
	3201,
	3202,
	3213,
	3214,
	3217,
	3218,
	3241,
	3242,
	3252,
	3253,
	3258,
	3261,
	3263,
	3264,
	3266,
	3267,
	3269,
	3271,
	3273,
	3274,
	3276,
	3294,
	3295,
	3296,
	3298,
	3302,
	3312,
	3313,
	3315,
	3330,
	3332,
	3333,
	3341,
	3342,
	3345,
	3346,
	3387,
	3389,
	3390,
	3391,
	3393,
	3398,
	3401,
	3402,
	3405,
	3406,
	3408,
	3412,
	3415,
	3416,
	3426,
	3430,
	3456,
	3458,
	3460,
	3461,
	3479,
	3482,
	3506,
	3507,
	3516,
	3517,
	3518,
	3520,
	3527,
	3536,
	3538,
	3544,
	3551,
	3558,
	3568,
	3570,
	3573,
	3585,
	3633,
	3634,
	3636,
	3647,
	3655,
	3663,
	3676,
	3713,
	3715,
	3716,
	3717,
	3718,
	3723,
	3724,
	3748,
	3749,
	3750,
	3751,
	3761,
	3762,
	3764,
	3773,
	3774,
	3776,
	3781,
	3782,
	3783,
	3792,
	3802,
	3804,
	3808,
	3840,
	3864,
	3866,
	3893,
	3894,
	3895,
	3896,
	3897,
	3898,
	3912,
	3913,
	3949,
	3967,
	3968,
	3973,
	3974,
	3976,
	3981,
	4030,
	4038,
	4039,
	4045,
	4046,
	4059,
	4096,
	4141,
	4145,
	4146,
	4152,
	4153,
	4155,
	4157,
	4159,
	4184,
	4186,
	4190,
	4193,
	4209,
	4213,
	4226,
	4227,
	4229,
	4231,
	4237,
	4238,
	4253,
	4254,
	4294,
	4295,
	4296,
	4301,
	4302,
	4304,
	4681,
	4682,
	4686,
	4688,
	4695,
	4696,
	4697,
	4698,
	4702,
	4704,
	4745,
	4746,
	4750,
	4752,
	4785,
	4786,
	4790,
	4792,
	4799,
	4800,
	4801,
	4802,
	4806,
	4808,
	4823,
	4824,
	4881,
	4882,
	4886,
	4888,
	4955,
	4960,
	4989,
	4992,
	5018,
	5024,
	5110,
	5112,
	5118,
	5120,
	5789,
	5792,
	5881,
	5888,
	5901,
	5902,
	5906,
	5920,
	5938,
	5941,
	5943,
	5952,
	5970,
	5984,
	5997,
	5998,
	6001,
	6016,
	6068,
	6070,
	6071,
	6078,
	6086,
	6087,
	6089,
	6100,
	6109,
	6112,
	6122,
	6128,
	6138,
	6144,
	6155,
	6160,
	6170,
	6176,
	6265,
	6272,
	6277,
	6279,
	6313,
	6314,
	6315,
	6320,
	6390,
	6400,
	6431,
	6435,
	6439,
	6441,
	6444,
	6448,
	6450,
	6451,
	6457,
	6464,
	6465,
	6468,
	6510,
	6512,
	6517,
	6528,
	6572,
	6576,
	6602,
	6608,
	6619,
	6622,
	6679,
	6681,
	6683,
	6686,
	6742,
	6743,
	6744,
	6753,
	6754,
	6755,
	6757,
	6765,
	6771,
	6784,
	6794,
	6800,
	6810,
	6816,
	6830,
	6916,
	6964,
	6971,
	6972,
	6973,
	6978,
	6979,
	6988,
	6992,
	7019,
	7028,
	7037,
	7042,
	7074,
	7078,
	7080,
	7082,
	7083,
	7086,
	7142,
	7143,
	7144,
	7146,
	7149,
	7150,
	7151,
	7154,
	7156,
	7164,
	7212,
	7220,
	7222,
	7227,
	7242,
	7245,
	7305,
	7312,
	7355,
	7357,
	7368,
	7379,
	7380,
	7393,
	7394,
	7401,
	7405,
	7406,
	7412,
	7413,
	7416,
	7418,
	7419,
	7424,
	7616,
	7680,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8133,
	8134,
	8148,
	8150,
	8156,
	8157,
	8176,
	8178,
	8181,
	8182,
	8191,
	8192,
	8203,
	8208,
	8232,
	8239,
	8288,
	8304,
	8306,
	8308,
	8335,
	8336,
	8349,
	8352,
	8384,
	8448,
	8588,
	8592,
	9255,
	9280,
	9291,
	9312,
	11124,
	11126,
	11158,
	11160,
	11311,
	11312,
	11359,
	11360,
	11503,
	11506,
	11508,
	11513,
	11558,
	11559,
	11560,
	11565,
	11566,
	11568,
	11624,
	11631,
	11633,
	11648,
	11671,
	11680,
	11687,
	11688,
	11695,
	11696,
	11703,
	11704,
	11711,
	11712,
	11719,
	11720,
	11727,
	11728,
	11735,
	11736,
	11743,
	11776,
	11856,
	11904,
	11930,
	11931,
	12020,
	12032,
	12246,
	12272,
	12284,
	12288,
	12330,
	12336,
	12352,
	12353,
	12439,
	12443,
	12544,
	12549,
	12592,
	12593,
	12687,
	12688,
	12731,
	12736,
	12772,
	12784,
	12831,
	12832,
	13055,
	13056,
	19894,
	19904,
	40944,
	40960,
	42125,
	42128,
	42183,
	42192,
	42540,
	42560,
	42607,
	42611,
	42612,
	42622,
	42654,
	42656,
	42736,
	42738,
	42744,
	42752,
	42944,
	42946,
	42951,
	42999,
	43010,
	43011,
	43014,
	43015,
	43019,
	43020,
	43045,
	43047,
	43052,
	43056,
	43066,
	43072,
	43128,
	43136,
	43204,
	43214,
	43226,
	43250,
	43263,
	43264,
	43302,
	43310,
	43335,
	43346,
	43348,
	43359,
	43389,
	43395,
	43443,
	43444,
	43446,
	43450,
	43452,
	43454,
	43470,
	43471,
	43482,
	43486,
	43493,
	43494,
	43519,
	43520,
	43561,
	43567,
	43569,
	43571,
	43573,
	43584,
	43587,
	43588,
	43596,
	43597,
	43598,
	43600,
	43610,
	43612,
	43644,
	43645,
	43696,
	43697,
	43698,
	43701,
	43703,
	43705,
	43710,
	43712,
	43713,
	43714,
	43715,
	43739,
	43756,
	43758,
	43766,
	43777,
	43783,
	43785,
	43791,
	43793,
	43799,
	43808,
	43815,
	43816,
	43823,
	43824,
	43880,
	43888,
	44005,
	44006,
	44008,
	44009,
	44013,
	44016,
	44026,
	44032,
	55204,
	55216,
	55239,
	55243,
	55292,
	63744,
	64110,
	64112,
	64218,
	64256,
	64263,
	64275,
	64280,
	64285,
	64286,
	64287,
	64311,
	64312,
	64317,
	64318,
	64319,
	64320,
	64322,
	64323,
	64325,
	64326,
	64450,
	64467,
	64832,
	64848,
	64912,
	64914,
	64968,
	65008,
	65022,
	65040,
	65050,
	65072,
	65107,
	65108,
	65127,
	65128,
	65132,
	65136,
	65141,
	65142,
	65277,
	65281,
	65438,
	65440,
	65471,
	65474,
	65480,
	65482,
	65488,
	65490,
	65496,
	65498,
	65501,
	65504,
	65511,
	65512,
	65519,
	65532,
	65534,
	65536,
	65548,
	65549,
	65575,
	65576,
	65595,
	65596,
	65598,
	65599,
	65614,
	65616,
	65630,
	65664,
	65787,
	65792,
	65795,
	65799,
	65844,
	65847,
	65935,
	65936,
	65948,
	65952,
	65953,
	66000,
	66045,
	66176,
	66205,
	66208,
	66257,
	66273,
	66300,
	66304,
	66340,
	66349,
	66379,
	66384,
	66422,
	66432,
	66462,
	66463,
	66500,
	66504,
	66518,
	66560,
	66718,
	66720,
	66730,
	66736,
	66772,
	66776,
	66812,
	66816,
	66856,
	66864,
	66916,
	66927,
	66928,
	67072,
	67383,
	67392,
	67414,
	67424,
	67432,
	67584,
	67590,
	67592,
	67593,
	67594,
	67638,
	67639,
	67641,
	67644,
	67645,
	67647,
	67670,
	67671,
	67743,
	67751,
	67760,
	67808,
	67827,
	67828,
	67830,
	67835,
	67868,
	67871,
	67898,
	67903,
	67904,
	67968,
	68024,
	68028,
	68048,
	68050,
	68097,
	68112,
	68116,
	68117,
	68120,
	68121,
	68150,
	68160,
	68169,
	68176,
	68185,
	68192,
	68256,
	68288,
	68325,
	68331,
	68343,
	68352,
	68406,
	68409,
	68438,
	68440,
	68467,
	68472,
	68498,
	68505,
	68509,
	68521,
	68528,
	68608,
	68681,
	68736,
	68787,
	68800,
	68851,
	68858,
	68900,
	68912,
	68922,
	69216,
	69247,
	69376,
	69416,
	69424,
	69446,
	69457,
	69466,
	69600,
	69623,
	69632,
	69633,
	69634,
	69688,
	69703,
	69710,
	69714,
	69744,
	69762,
	69811,
	69815,
	69817,
	69819,
	69821,
	69822,
	69826,
	69840,
	69865,
	69872,
	69882,
	69891,
	69927,
	69932,
	69933,
	69942,
	69959,
	69968,
	70003,
	70004,
	70007,
	70018,
	70070,
	70079,
	70089,
	70093,
	70094,
	70096,
	70112,
	70113,
	70133,
	70144,
	70162,
	70163,
	70191,
	70194,
	70196,
	70197,
	70198,
	70200,
	70206,
	70272,
	70279,
	70280,
	70281,
	70282,
	70286,
	70287,
	70302,
	70303,
	70314,
	70320,
	70367,
	70368,
	70371,
	70384,
	70394,
	70402,
	70404,
	70405,
	70413,
	70415,
	70417,
	70419,
	70441,
	70442,
	70449,
	70450,
	70452,
	70453,
	70458,
	70461,
	70462,
	70463,
	70464,
	70465,
	70469,
	70471,
	70473,
	70475,
	70478,
	70480,
	70481,
	70493,
	70500,
	70656,
	70712,
	70720,
	70722,
	70725,
	70726,
	70727,
	70746,
	70747,
	70748,
	70749,
	70750,
	70751,
	70752,
	70784,
	70832,
	70833,
	70835,
	70841,
	70842,
	70843,
	70845,
	70846,
	70847,
	70849,
	70850,
	70852,
	70856,
	70864,
	70874,
	71040,
	71087,
	71088,
	71090,
	71096,
	71100,
	71102,
	71103,
	71105,
	71132,
	71168,
	71219,
	71227,
	71229,
	71230,
	71231,
	71233,
	71237,
	71248,
	71258,
	71264,
	71277,
	71296,
	71339,
	71340,
	71341,
	71342,
	71344,
	71350,
	71351,
	71352,
	71353,
	71360,
	71370,
	71424,
	71451,
	71456,
	71458,
	71462,
	71463,
	71472,
	71488,
	71680,
	71727,
	71736,
	71737,
	71739,
	71740,
	71840,
	71923,
	71935,
	71936,
	72096,
	72104,
	72106,
	72148,
	72156,
	72160,
	72161,
	72165,
	72192,
	72193,
	72203,
	72243,
	72249,
	72251,
	72255,
	72263,
	72272,
	72273,
	72279,
	72281,
	72284,
	72330,
	72343,
	72344,
	72346,
	72355,
	72384,
	72441,
	72704,
	72713,
	72714,
	72752,
	72766,
	72767,
	72768,
	72774,
	72784,
	72813,
	72816,
	72848,
	72873,
	72874,
	72881,
	72882,
	72884,
	72885,
	72960,
	72967,
	72968,
	72970,
	72971,
	73009,
	73030,
	73031,
	73040,
	73050,
	73056,
	73062,
	73063,
	73065,
	73066,
	73103,
	73107,
	73109,
	73110,
	73111,
	73112,
	73113,
	73120,
	73130,
	73440,
	73459,
	73461,
	73465,
	73664,
	73714,
	73727,
	74650,
	74752,
	74863,
	74864,
	74869,
	74880,
	75076,
	77824,
	78895,
	82944,
	83527,
	92160,
	92729,
	92736,
	92767,
	92768,
	92778,
	92782,
	92784,
	92880,
	92910,
	92917,
	92918,
	92928,
	92976,
	92983,
	92998,
	93008,
	93018,
	93019,
	93026,
	93027,
	93048,
	93053,
	93072,
	93760,
	93851,
	93952,
	94027,
	94032,
	94088,
	94099,
	94112,
	94176,
	94180,
	94208,
	100344,
	100352,
	101107,
	110592,
	110879,
	110928,
	110931,
	110948,
	110952,
	110960,
	111356,
	113664,
	113771,
	113776,
	113789,
	113792,
	113801,
	113808,
	113818,
	113820,
	113821,
	113823,
	113824,
	118784,
	119030,
	119040,
	119079,
	119081,
	119141,
	119142,
	119143,
	119146,
	119150,
	119171,
	119173,
	119180,
	119210,
	119214,
	119273,
	119296,
	119362,
	119365,
	119366,
	119520,
	119540,
	119552,
	119639,
	119648,
	119673,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120780,
	120782,
	121344,
	121399,
	121403,
	121453,
	121461,
	121462,
	121476,
	121477,
	121484,
	123136,
	123181,
	123191,
	123198,
	123200,
	123210,
	123214,
	123216,
	123584,
	123628,
	123632,
	123642,
	123647,
	123648,
	124928,
	125125,
	125127,
	125136,
	125184,
	125252,
	125259,
	125260,
	125264,
	125274,
	125278,
	125280,
	126065,
	126133,
	126209,
	126270,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	126704,
	126706,
	126976,
	127020,
	127024,
	127124,
	127136,
	127151,
	127153,
	127168,
	127169,
	127184,
	127185,
	127222,
	127232,
	127245,
	127248,
	127341,
	127344,
	127405,
	127462,
	127491,
	127504,
	127548,
	127552,
	127561,
	127568,
	127570,
	127584,
	127590,
	127744,
	128726,
	128736,
	128749,
	128752,
	128763,
	128768,
	128884,
	128896,
	128985,
	128992,
	129004,
	129024,
	129036,
	129040,
	129096,
	129104,
	129114,
	129120,
	129160,
	129168,
	129198,
	129280,
	129292,
	129293,
	129394,
	129395,
	129399,
	129402,
	129443,
	129445,
	129451,
	129454,
	129483,
	129485,
	129620,
	129632,
	129646,
	129648,
	129652,
	129656,
	129659,
	129664,
	129667,
	129680,
	129686,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457,
	194560,
	195102
]);
property.set("Grapheme_Extend", [
	768,
	880,
	1155,
	1162,
	1425,
	1470,
	1471,
	1472,
	1473,
	1475,
	1476,
	1478,
	1479,
	1480,
	1552,
	1563,
	1611,
	1632,
	1648,
	1649,
	1750,
	1757,
	1759,
	1765,
	1767,
	1769,
	1770,
	1774,
	1809,
	1810,
	1840,
	1867,
	1958,
	1969,
	2027,
	2036,
	2045,
	2046,
	2070,
	2074,
	2075,
	2084,
	2085,
	2088,
	2089,
	2094,
	2137,
	2140,
	2259,
	2274,
	2275,
	2307,
	2362,
	2363,
	2364,
	2365,
	2369,
	2377,
	2381,
	2382,
	2385,
	2392,
	2402,
	2404,
	2433,
	2434,
	2492,
	2493,
	2494,
	2495,
	2497,
	2501,
	2509,
	2510,
	2519,
	2520,
	2530,
	2532,
	2558,
	2559,
	2561,
	2563,
	2620,
	2621,
	2625,
	2627,
	2631,
	2633,
	2635,
	2638,
	2641,
	2642,
	2672,
	2674,
	2677,
	2678,
	2689,
	2691,
	2748,
	2749,
	2753,
	2758,
	2759,
	2761,
	2765,
	2766,
	2786,
	2788,
	2810,
	2816,
	2817,
	2818,
	2876,
	2877,
	2878,
	2880,
	2881,
	2885,
	2893,
	2894,
	2902,
	2904,
	2914,
	2916,
	2946,
	2947,
	3006,
	3007,
	3008,
	3009,
	3021,
	3022,
	3031,
	3032,
	3072,
	3073,
	3076,
	3077,
	3134,
	3137,
	3142,
	3145,
	3146,
	3150,
	3157,
	3159,
	3170,
	3172,
	3201,
	3202,
	3260,
	3261,
	3263,
	3264,
	3266,
	3267,
	3270,
	3271,
	3276,
	3278,
	3285,
	3287,
	3298,
	3300,
	3328,
	3330,
	3387,
	3389,
	3390,
	3391,
	3393,
	3397,
	3405,
	3406,
	3415,
	3416,
	3426,
	3428,
	3530,
	3531,
	3535,
	3536,
	3538,
	3541,
	3542,
	3543,
	3551,
	3552,
	3633,
	3634,
	3636,
	3643,
	3655,
	3663,
	3761,
	3762,
	3764,
	3773,
	3784,
	3790,
	3864,
	3866,
	3893,
	3894,
	3895,
	3896,
	3897,
	3898,
	3953,
	3967,
	3968,
	3973,
	3974,
	3976,
	3981,
	3992,
	3993,
	4029,
	4038,
	4039,
	4141,
	4145,
	4146,
	4152,
	4153,
	4155,
	4157,
	4159,
	4184,
	4186,
	4190,
	4193,
	4209,
	4213,
	4226,
	4227,
	4229,
	4231,
	4237,
	4238,
	4253,
	4254,
	4957,
	4960,
	5906,
	5909,
	5938,
	5941,
	5970,
	5972,
	6002,
	6004,
	6068,
	6070,
	6071,
	6078,
	6086,
	6087,
	6089,
	6100,
	6109,
	6110,
	6155,
	6158,
	6277,
	6279,
	6313,
	6314,
	6432,
	6435,
	6439,
	6441,
	6450,
	6451,
	6457,
	6460,
	6679,
	6681,
	6683,
	6684,
	6742,
	6743,
	6744,
	6751,
	6752,
	6753,
	6754,
	6755,
	6757,
	6765,
	6771,
	6781,
	6783,
	6784,
	6832,
	6847,
	6912,
	6916,
	6964,
	6971,
	6972,
	6973,
	6978,
	6979,
	7019,
	7028,
	7040,
	7042,
	7074,
	7078,
	7080,
	7082,
	7083,
	7086,
	7142,
	7143,
	7144,
	7146,
	7149,
	7150,
	7151,
	7154,
	7212,
	7220,
	7222,
	7224,
	7376,
	7379,
	7380,
	7393,
	7394,
	7401,
	7405,
	7406,
	7412,
	7413,
	7416,
	7418,
	7616,
	7674,
	7675,
	7680,
	8204,
	8205,
	8400,
	8433,
	11503,
	11506,
	11647,
	11648,
	11744,
	11776,
	12330,
	12336,
	12441,
	12443,
	42607,
	42611,
	42612,
	42622,
	42654,
	42656,
	42736,
	42738,
	43010,
	43011,
	43014,
	43015,
	43019,
	43020,
	43045,
	43047,
	43204,
	43206,
	43232,
	43250,
	43263,
	43264,
	43302,
	43310,
	43335,
	43346,
	43392,
	43395,
	43443,
	43444,
	43446,
	43450,
	43452,
	43454,
	43493,
	43494,
	43561,
	43567,
	43569,
	43571,
	43573,
	43575,
	43587,
	43588,
	43596,
	43597,
	43644,
	43645,
	43696,
	43697,
	43698,
	43701,
	43703,
	43705,
	43710,
	43712,
	43713,
	43714,
	43756,
	43758,
	43766,
	43767,
	44005,
	44006,
	44008,
	44009,
	44013,
	44014,
	64286,
	64287,
	65024,
	65040,
	65056,
	65072,
	65438,
	65440,
	66045,
	66046,
	66272,
	66273,
	66422,
	66427,
	68097,
	68100,
	68101,
	68103,
	68108,
	68112,
	68152,
	68155,
	68159,
	68160,
	68325,
	68327,
	68900,
	68904,
	69446,
	69457,
	69633,
	69634,
	69688,
	69703,
	69759,
	69762,
	69811,
	69815,
	69817,
	69819,
	69888,
	69891,
	69927,
	69932,
	69933,
	69941,
	70003,
	70004,
	70016,
	70018,
	70070,
	70079,
	70089,
	70093,
	70191,
	70194,
	70196,
	70197,
	70198,
	70200,
	70206,
	70207,
	70367,
	70368,
	70371,
	70379,
	70400,
	70402,
	70459,
	70461,
	70462,
	70463,
	70464,
	70465,
	70487,
	70488,
	70502,
	70509,
	70512,
	70517,
	70712,
	70720,
	70722,
	70725,
	70726,
	70727,
	70750,
	70751,
	70832,
	70833,
	70835,
	70841,
	70842,
	70843,
	70845,
	70846,
	70847,
	70849,
	70850,
	70852,
	71087,
	71088,
	71090,
	71094,
	71100,
	71102,
	71103,
	71105,
	71132,
	71134,
	71219,
	71227,
	71229,
	71230,
	71231,
	71233,
	71339,
	71340,
	71341,
	71342,
	71344,
	71350,
	71351,
	71352,
	71453,
	71456,
	71458,
	71462,
	71463,
	71468,
	71727,
	71736,
	71737,
	71739,
	72148,
	72152,
	72154,
	72156,
	72160,
	72161,
	72193,
	72203,
	72243,
	72249,
	72251,
	72255,
	72263,
	72264,
	72273,
	72279,
	72281,
	72284,
	72330,
	72343,
	72344,
	72346,
	72752,
	72759,
	72760,
	72766,
	72767,
	72768,
	72850,
	72872,
	72874,
	72881,
	72882,
	72884,
	72885,
	72887,
	73009,
	73015,
	73018,
	73019,
	73020,
	73022,
	73023,
	73030,
	73031,
	73032,
	73104,
	73106,
	73109,
	73110,
	73111,
	73112,
	73459,
	73461,
	92912,
	92917,
	92976,
	92983,
	94031,
	94032,
	94095,
	94099,
	113821,
	113823,
	119141,
	119142,
	119143,
	119146,
	119150,
	119155,
	119163,
	119171,
	119173,
	119180,
	119210,
	119214,
	119362,
	119365,
	121344,
	121399,
	121403,
	121453,
	121461,
	121462,
	121476,
	121477,
	121499,
	121504,
	121505,
	121520,
	122880,
	122887,
	122888,
	122905,
	122907,
	122914,
	122915,
	122917,
	122918,
	122923,
	123184,
	123191,
	123628,
	123632,
	125136,
	125143,
	125252,
	125259,
	917536,
	917632,
	917760,
	918000
]);
property.set("Hex_Digit", [48, 58, 65, 71, 97, 103, 65296, 65306, 65313, 65319, 65345, 65351]);
property.set("IDS_Binary_Operator", [12272, 12274, 12276, 12284]);
property.set("IDS_Trinary_Operator", [12274, 12276]);
property.set("ID_Continue", [
	48,
	58,
	65,
	91,
	95,
	96,
	97,
	123,
	170,
	171,
	181,
	182,
	183,
	184,
	186,
	187,
	192,
	215,
	216,
	247,
	248,
	706,
	710,
	722,
	736,
	741,
	748,
	749,
	750,
	751,
	768,
	885,
	886,
	888,
	890,
	894,
	895,
	896,
	902,
	907,
	908,
	909,
	910,
	930,
	931,
	1014,
	1015,
	1154,
	1155,
	1160,
	1162,
	1328,
	1329,
	1367,
	1369,
	1370,
	1376,
	1417,
	1425,
	1470,
	1471,
	1472,
	1473,
	1475,
	1476,
	1478,
	1479,
	1480,
	1488,
	1515,
	1519,
	1523,
	1552,
	1563,
	1568,
	1642,
	1646,
	1748,
	1749,
	1757,
	1759,
	1769,
	1770,
	1789,
	1791,
	1792,
	1808,
	1867,
	1869,
	1970,
	1984,
	2038,
	2042,
	2043,
	2045,
	2046,
	2048,
	2094,
	2112,
	2140,
	2144,
	2155,
	2208,
	2229,
	2230,
	2238,
	2259,
	2274,
	2275,
	2404,
	2406,
	2416,
	2417,
	2436,
	2437,
	2445,
	2447,
	2449,
	2451,
	2473,
	2474,
	2481,
	2482,
	2483,
	2486,
	2490,
	2492,
	2501,
	2503,
	2505,
	2507,
	2511,
	2519,
	2520,
	2524,
	2526,
	2527,
	2532,
	2534,
	2546,
	2556,
	2557,
	2558,
	2559,
	2561,
	2564,
	2565,
	2571,
	2575,
	2577,
	2579,
	2601,
	2602,
	2609,
	2610,
	2612,
	2613,
	2615,
	2616,
	2618,
	2620,
	2621,
	2622,
	2627,
	2631,
	2633,
	2635,
	2638,
	2641,
	2642,
	2649,
	2653,
	2654,
	2655,
	2662,
	2678,
	2689,
	2692,
	2693,
	2702,
	2703,
	2706,
	2707,
	2729,
	2730,
	2737,
	2738,
	2740,
	2741,
	2746,
	2748,
	2758,
	2759,
	2762,
	2763,
	2766,
	2768,
	2769,
	2784,
	2788,
	2790,
	2800,
	2809,
	2816,
	2817,
	2820,
	2821,
	2829,
	2831,
	2833,
	2835,
	2857,
	2858,
	2865,
	2866,
	2868,
	2869,
	2874,
	2876,
	2885,
	2887,
	2889,
	2891,
	2894,
	2902,
	2904,
	2908,
	2910,
	2911,
	2916,
	2918,
	2928,
	2929,
	2930,
	2946,
	2948,
	2949,
	2955,
	2958,
	2961,
	2962,
	2966,
	2969,
	2971,
	2972,
	2973,
	2974,
	2976,
	2979,
	2981,
	2984,
	2987,
	2990,
	3002,
	3006,
	3011,
	3014,
	3017,
	3018,
	3022,
	3024,
	3025,
	3031,
	3032,
	3046,
	3056,
	3072,
	3085,
	3086,
	3089,
	3090,
	3113,
	3114,
	3130,
	3133,
	3141,
	3142,
	3145,
	3146,
	3150,
	3157,
	3159,
	3160,
	3163,
	3168,
	3172,
	3174,
	3184,
	3200,
	3204,
	3205,
	3213,
	3214,
	3217,
	3218,
	3241,
	3242,
	3252,
	3253,
	3258,
	3260,
	3269,
	3270,
	3273,
	3274,
	3278,
	3285,
	3287,
	3294,
	3295,
	3296,
	3300,
	3302,
	3312,
	3313,
	3315,
	3328,
	3332,
	3333,
	3341,
	3342,
	3345,
	3346,
	3397,
	3398,
	3401,
	3402,
	3407,
	3412,
	3416,
	3423,
	3428,
	3430,
	3440,
	3450,
	3456,
	3458,
	3460,
	3461,
	3479,
	3482,
	3506,
	3507,
	3516,
	3517,
	3518,
	3520,
	3527,
	3530,
	3531,
	3535,
	3541,
	3542,
	3543,
	3544,
	3552,
	3558,
	3568,
	3570,
	3572,
	3585,
	3643,
	3648,
	3663,
	3664,
	3674,
	3713,
	3715,
	3716,
	3717,
	3718,
	3723,
	3724,
	3748,
	3749,
	3750,
	3751,
	3774,
	3776,
	3781,
	3782,
	3783,
	3784,
	3790,
	3792,
	3802,
	3804,
	3808,
	3840,
	3841,
	3864,
	3866,
	3872,
	3882,
	3893,
	3894,
	3895,
	3896,
	3897,
	3898,
	3902,
	3912,
	3913,
	3949,
	3953,
	3973,
	3974,
	3992,
	3993,
	4029,
	4038,
	4039,
	4096,
	4170,
	4176,
	4254,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	4304,
	4347,
	4348,
	4681,
	4682,
	4686,
	4688,
	4695,
	4696,
	4697,
	4698,
	4702,
	4704,
	4745,
	4746,
	4750,
	4752,
	4785,
	4786,
	4790,
	4792,
	4799,
	4800,
	4801,
	4802,
	4806,
	4808,
	4823,
	4824,
	4881,
	4882,
	4886,
	4888,
	4955,
	4957,
	4960,
	4969,
	4978,
	4992,
	5008,
	5024,
	5110,
	5112,
	5118,
	5121,
	5741,
	5743,
	5760,
	5761,
	5787,
	5792,
	5867,
	5870,
	5881,
	5888,
	5901,
	5902,
	5909,
	5920,
	5941,
	5952,
	5972,
	5984,
	5997,
	5998,
	6001,
	6002,
	6004,
	6016,
	6100,
	6103,
	6104,
	6108,
	6110,
	6112,
	6122,
	6155,
	6158,
	6160,
	6170,
	6176,
	6265,
	6272,
	6315,
	6320,
	6390,
	6400,
	6431,
	6432,
	6444,
	6448,
	6460,
	6470,
	6510,
	6512,
	6517,
	6528,
	6572,
	6576,
	6602,
	6608,
	6619,
	6656,
	6684,
	6688,
	6751,
	6752,
	6781,
	6783,
	6794,
	6800,
	6810,
	6823,
	6824,
	6832,
	6846,
	6912,
	6988,
	6992,
	7002,
	7019,
	7028,
	7040,
	7156,
	7168,
	7224,
	7232,
	7242,
	7245,
	7294,
	7296,
	7305,
	7312,
	7355,
	7357,
	7360,
	7376,
	7379,
	7380,
	7419,
	7424,
	7674,
	7675,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8125,
	8126,
	8127,
	8130,
	8133,
	8134,
	8141,
	8144,
	8148,
	8150,
	8156,
	8160,
	8173,
	8178,
	8181,
	8182,
	8189,
	8255,
	8257,
	8276,
	8277,
	8305,
	8306,
	8319,
	8320,
	8336,
	8349,
	8400,
	8413,
	8417,
	8418,
	8421,
	8433,
	8450,
	8451,
	8455,
	8456,
	8458,
	8468,
	8469,
	8470,
	8472,
	8478,
	8484,
	8485,
	8486,
	8487,
	8488,
	8489,
	8490,
	8506,
	8508,
	8512,
	8517,
	8522,
	8526,
	8527,
	8544,
	8585,
	11264,
	11311,
	11312,
	11359,
	11360,
	11493,
	11499,
	11508,
	11520,
	11558,
	11559,
	11560,
	11565,
	11566,
	11568,
	11624,
	11631,
	11632,
	11647,
	11671,
	11680,
	11687,
	11688,
	11695,
	11696,
	11703,
	11704,
	11711,
	11712,
	11719,
	11720,
	11727,
	11728,
	11735,
	11736,
	11743,
	11744,
	11776,
	12293,
	12296,
	12321,
	12336,
	12337,
	12342,
	12344,
	12349,
	12353,
	12439,
	12441,
	12448,
	12449,
	12539,
	12540,
	12544,
	12549,
	12592,
	12593,
	12687,
	12704,
	12731,
	12784,
	12800,
	13312,
	19894,
	19968,
	40944,
	40960,
	42125,
	42192,
	42238,
	42240,
	42509,
	42512,
	42540,
	42560,
	42608,
	42612,
	42622,
	42623,
	42738,
	42775,
	42784,
	42786,
	42889,
	42891,
	42944,
	42946,
	42951,
	42999,
	43048,
	43072,
	43124,
	43136,
	43206,
	43216,
	43226,
	43232,
	43256,
	43259,
	43260,
	43261,
	43310,
	43312,
	43348,
	43360,
	43389,
	43392,
	43457,
	43471,
	43482,
	43488,
	43519,
	43520,
	43575,
	43584,
	43598,
	43600,
	43610,
	43616,
	43639,
	43642,
	43715,
	43739,
	43742,
	43744,
	43760,
	43762,
	43767,
	43777,
	43783,
	43785,
	43791,
	43793,
	43799,
	43808,
	43815,
	43816,
	43823,
	43824,
	43867,
	43868,
	43880,
	43888,
	44011,
	44012,
	44014,
	44016,
	44026,
	44032,
	55204,
	55216,
	55239,
	55243,
	55292,
	63744,
	64110,
	64112,
	64218,
	64256,
	64263,
	64275,
	64280,
	64285,
	64297,
	64298,
	64311,
	64312,
	64317,
	64318,
	64319,
	64320,
	64322,
	64323,
	64325,
	64326,
	64434,
	64467,
	64830,
	64848,
	64912,
	64914,
	64968,
	65008,
	65020,
	65024,
	65040,
	65056,
	65072,
	65075,
	65077,
	65101,
	65104,
	65136,
	65141,
	65142,
	65277,
	65296,
	65306,
	65313,
	65339,
	65343,
	65344,
	65345,
	65371,
	65382,
	65471,
	65474,
	65480,
	65482,
	65488,
	65490,
	65496,
	65498,
	65501,
	65536,
	65548,
	65549,
	65575,
	65576,
	65595,
	65596,
	65598,
	65599,
	65614,
	65616,
	65630,
	65664,
	65787,
	65856,
	65909,
	66045,
	66046,
	66176,
	66205,
	66208,
	66257,
	66272,
	66273,
	66304,
	66336,
	66349,
	66379,
	66384,
	66427,
	66432,
	66462,
	66464,
	66500,
	66504,
	66512,
	66513,
	66518,
	66560,
	66718,
	66720,
	66730,
	66736,
	66772,
	66776,
	66812,
	66816,
	66856,
	66864,
	66916,
	67072,
	67383,
	67392,
	67414,
	67424,
	67432,
	67584,
	67590,
	67592,
	67593,
	67594,
	67638,
	67639,
	67641,
	67644,
	67645,
	67647,
	67670,
	67680,
	67703,
	67712,
	67743,
	67808,
	67827,
	67828,
	67830,
	67840,
	67862,
	67872,
	67898,
	67968,
	68024,
	68030,
	68032,
	68096,
	68100,
	68101,
	68103,
	68108,
	68116,
	68117,
	68120,
	68121,
	68150,
	68152,
	68155,
	68159,
	68160,
	68192,
	68221,
	68224,
	68253,
	68288,
	68296,
	68297,
	68327,
	68352,
	68406,
	68416,
	68438,
	68448,
	68467,
	68480,
	68498,
	68608,
	68681,
	68736,
	68787,
	68800,
	68851,
	68864,
	68904,
	68912,
	68922,
	69376,
	69405,
	69415,
	69416,
	69424,
	69457,
	69600,
	69623,
	69632,
	69703,
	69734,
	69744,
	69759,
	69819,
	69840,
	69865,
	69872,
	69882,
	69888,
	69941,
	69942,
	69952,
	69956,
	69959,
	69968,
	70004,
	70006,
	70007,
	70016,
	70085,
	70089,
	70093,
	70096,
	70107,
	70108,
	70109,
	70144,
	70162,
	70163,
	70200,
	70206,
	70207,
	70272,
	70279,
	70280,
	70281,
	70282,
	70286,
	70287,
	70302,
	70303,
	70313,
	70320,
	70379,
	70384,
	70394,
	70400,
	70404,
	70405,
	70413,
	70415,
	70417,
	70419,
	70441,
	70442,
	70449,
	70450,
	70452,
	70453,
	70458,
	70459,
	70469,
	70471,
	70473,
	70475,
	70478,
	70480,
	70481,
	70487,
	70488,
	70493,
	70500,
	70502,
	70509,
	70512,
	70517,
	70656,
	70731,
	70736,
	70746,
	70750,
	70752,
	70784,
	70854,
	70855,
	70856,
	70864,
	70874,
	71040,
	71094,
	71096,
	71105,
	71128,
	71134,
	71168,
	71233,
	71236,
	71237,
	71248,
	71258,
	71296,
	71353,
	71360,
	71370,
	71424,
	71451,
	71453,
	71468,
	71472,
	71482,
	71680,
	71739,
	71840,
	71914,
	71935,
	71936,
	72096,
	72104,
	72106,
	72152,
	72154,
	72162,
	72163,
	72165,
	72192,
	72255,
	72263,
	72264,
	72272,
	72346,
	72349,
	72350,
	72384,
	72441,
	72704,
	72713,
	72714,
	72759,
	72760,
	72769,
	72784,
	72794,
	72818,
	72848,
	72850,
	72872,
	72873,
	72887,
	72960,
	72967,
	72968,
	72970,
	72971,
	73015,
	73018,
	73019,
	73020,
	73022,
	73023,
	73032,
	73040,
	73050,
	73056,
	73062,
	73063,
	73065,
	73066,
	73103,
	73104,
	73106,
	73107,
	73113,
	73120,
	73130,
	73440,
	73463,
	73728,
	74650,
	74752,
	74863,
	74880,
	75076,
	77824,
	78895,
	82944,
	83527,
	92160,
	92729,
	92736,
	92767,
	92768,
	92778,
	92880,
	92910,
	92912,
	92917,
	92928,
	92983,
	92992,
	92996,
	93008,
	93018,
	93027,
	93048,
	93053,
	93072,
	93760,
	93824,
	93952,
	94027,
	94031,
	94088,
	94095,
	94112,
	94176,
	94178,
	94179,
	94180,
	94208,
	100344,
	100352,
	101107,
	110592,
	110879,
	110928,
	110931,
	110948,
	110952,
	110960,
	111356,
	113664,
	113771,
	113776,
	113789,
	113792,
	113801,
	113808,
	113818,
	113821,
	113823,
	119141,
	119146,
	119149,
	119155,
	119163,
	119171,
	119173,
	119180,
	119210,
	119214,
	119362,
	119365,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120513,
	120514,
	120539,
	120540,
	120571,
	120572,
	120597,
	120598,
	120629,
	120630,
	120655,
	120656,
	120687,
	120688,
	120713,
	120714,
	120745,
	120746,
	120771,
	120772,
	120780,
	120782,
	120832,
	121344,
	121399,
	121403,
	121453,
	121461,
	121462,
	121476,
	121477,
	121499,
	121504,
	121505,
	121520,
	122880,
	122887,
	122888,
	122905,
	122907,
	122914,
	122915,
	122917,
	122918,
	122923,
	123136,
	123181,
	123184,
	123198,
	123200,
	123210,
	123214,
	123215,
	123584,
	123642,
	124928,
	125125,
	125136,
	125143,
	125184,
	125260,
	125264,
	125274,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457,
	194560,
	195102,
	917760,
	918000
]);
property.set("ID_Start", [
	65,
	91,
	97,
	123,
	170,
	171,
	181,
	182,
	186,
	187,
	192,
	215,
	216,
	247,
	248,
	706,
	710,
	722,
	736,
	741,
	748,
	749,
	750,
	751,
	880,
	885,
	886,
	888,
	890,
	894,
	895,
	896,
	902,
	903,
	904,
	907,
	908,
	909,
	910,
	930,
	931,
	1014,
	1015,
	1154,
	1162,
	1328,
	1329,
	1367,
	1369,
	1370,
	1376,
	1417,
	1488,
	1515,
	1519,
	1523,
	1568,
	1611,
	1646,
	1648,
	1649,
	1748,
	1749,
	1750,
	1765,
	1767,
	1774,
	1776,
	1786,
	1789,
	1791,
	1792,
	1808,
	1809,
	1810,
	1840,
	1869,
	1958,
	1969,
	1970,
	1994,
	2027,
	2036,
	2038,
	2042,
	2043,
	2048,
	2070,
	2074,
	2075,
	2084,
	2085,
	2088,
	2089,
	2112,
	2137,
	2144,
	2155,
	2208,
	2229,
	2230,
	2238,
	2308,
	2362,
	2365,
	2366,
	2384,
	2385,
	2392,
	2402,
	2417,
	2433,
	2437,
	2445,
	2447,
	2449,
	2451,
	2473,
	2474,
	2481,
	2482,
	2483,
	2486,
	2490,
	2493,
	2494,
	2510,
	2511,
	2524,
	2526,
	2527,
	2530,
	2544,
	2546,
	2556,
	2557,
	2565,
	2571,
	2575,
	2577,
	2579,
	2601,
	2602,
	2609,
	2610,
	2612,
	2613,
	2615,
	2616,
	2618,
	2649,
	2653,
	2654,
	2655,
	2674,
	2677,
	2693,
	2702,
	2703,
	2706,
	2707,
	2729,
	2730,
	2737,
	2738,
	2740,
	2741,
	2746,
	2749,
	2750,
	2768,
	2769,
	2784,
	2786,
	2809,
	2810,
	2821,
	2829,
	2831,
	2833,
	2835,
	2857,
	2858,
	2865,
	2866,
	2868,
	2869,
	2874,
	2877,
	2878,
	2908,
	2910,
	2911,
	2914,
	2929,
	2930,
	2947,
	2948,
	2949,
	2955,
	2958,
	2961,
	2962,
	2966,
	2969,
	2971,
	2972,
	2973,
	2974,
	2976,
	2979,
	2981,
	2984,
	2987,
	2990,
	3002,
	3024,
	3025,
	3077,
	3085,
	3086,
	3089,
	3090,
	3113,
	3114,
	3130,
	3133,
	3134,
	3160,
	3163,
	3168,
	3170,
	3200,
	3201,
	3205,
	3213,
	3214,
	3217,
	3218,
	3241,
	3242,
	3252,
	3253,
	3258,
	3261,
	3262,
	3294,
	3295,
	3296,
	3298,
	3313,
	3315,
	3333,
	3341,
	3342,
	3345,
	3346,
	3387,
	3389,
	3390,
	3406,
	3407,
	3412,
	3415,
	3423,
	3426,
	3450,
	3456,
	3461,
	3479,
	3482,
	3506,
	3507,
	3516,
	3517,
	3518,
	3520,
	3527,
	3585,
	3633,
	3634,
	3636,
	3648,
	3655,
	3713,
	3715,
	3716,
	3717,
	3718,
	3723,
	3724,
	3748,
	3749,
	3750,
	3751,
	3761,
	3762,
	3764,
	3773,
	3774,
	3776,
	3781,
	3782,
	3783,
	3804,
	3808,
	3840,
	3841,
	3904,
	3912,
	3913,
	3949,
	3976,
	3981,
	4096,
	4139,
	4159,
	4160,
	4176,
	4182,
	4186,
	4190,
	4193,
	4194,
	4197,
	4199,
	4206,
	4209,
	4213,
	4226,
	4238,
	4239,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	4304,
	4347,
	4348,
	4681,
	4682,
	4686,
	4688,
	4695,
	4696,
	4697,
	4698,
	4702,
	4704,
	4745,
	4746,
	4750,
	4752,
	4785,
	4786,
	4790,
	4792,
	4799,
	4800,
	4801,
	4802,
	4806,
	4808,
	4823,
	4824,
	4881,
	4882,
	4886,
	4888,
	4955,
	4992,
	5008,
	5024,
	5110,
	5112,
	5118,
	5121,
	5741,
	5743,
	5760,
	5761,
	5787,
	5792,
	5867,
	5870,
	5881,
	5888,
	5901,
	5902,
	5906,
	5920,
	5938,
	5952,
	5970,
	5984,
	5997,
	5998,
	6001,
	6016,
	6068,
	6103,
	6104,
	6108,
	6109,
	6176,
	6265,
	6272,
	6313,
	6314,
	6315,
	6320,
	6390,
	6400,
	6431,
	6480,
	6510,
	6512,
	6517,
	6528,
	6572,
	6576,
	6602,
	6656,
	6679,
	6688,
	6741,
	6823,
	6824,
	6917,
	6964,
	6981,
	6988,
	7043,
	7073,
	7086,
	7088,
	7098,
	7142,
	7168,
	7204,
	7245,
	7248,
	7258,
	7294,
	7296,
	7305,
	7312,
	7355,
	7357,
	7360,
	7401,
	7405,
	7406,
	7412,
	7413,
	7415,
	7418,
	7419,
	7424,
	7616,
	7680,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8125,
	8126,
	8127,
	8130,
	8133,
	8134,
	8141,
	8144,
	8148,
	8150,
	8156,
	8160,
	8173,
	8178,
	8181,
	8182,
	8189,
	8305,
	8306,
	8319,
	8320,
	8336,
	8349,
	8450,
	8451,
	8455,
	8456,
	8458,
	8468,
	8469,
	8470,
	8472,
	8478,
	8484,
	8485,
	8486,
	8487,
	8488,
	8489,
	8490,
	8506,
	8508,
	8512,
	8517,
	8522,
	8526,
	8527,
	8544,
	8585,
	11264,
	11311,
	11312,
	11359,
	11360,
	11493,
	11499,
	11503,
	11506,
	11508,
	11520,
	11558,
	11559,
	11560,
	11565,
	11566,
	11568,
	11624,
	11631,
	11632,
	11648,
	11671,
	11680,
	11687,
	11688,
	11695,
	11696,
	11703,
	11704,
	11711,
	11712,
	11719,
	11720,
	11727,
	11728,
	11735,
	11736,
	11743,
	12293,
	12296,
	12321,
	12330,
	12337,
	12342,
	12344,
	12349,
	12353,
	12439,
	12443,
	12448,
	12449,
	12539,
	12540,
	12544,
	12549,
	12592,
	12593,
	12687,
	12704,
	12731,
	12784,
	12800,
	13312,
	19894,
	19968,
	40944,
	40960,
	42125,
	42192,
	42238,
	42240,
	42509,
	42512,
	42528,
	42538,
	42540,
	42560,
	42607,
	42623,
	42654,
	42656,
	42736,
	42775,
	42784,
	42786,
	42889,
	42891,
	42944,
	42946,
	42951,
	42999,
	43010,
	43011,
	43014,
	43015,
	43019,
	43020,
	43043,
	43072,
	43124,
	43138,
	43188,
	43250,
	43256,
	43259,
	43260,
	43261,
	43263,
	43274,
	43302,
	43312,
	43335,
	43360,
	43389,
	43396,
	43443,
	43471,
	43472,
	43488,
	43493,
	43494,
	43504,
	43514,
	43519,
	43520,
	43561,
	43584,
	43587,
	43588,
	43596,
	43616,
	43639,
	43642,
	43643,
	43646,
	43696,
	43697,
	43698,
	43701,
	43703,
	43705,
	43710,
	43712,
	43713,
	43714,
	43715,
	43739,
	43742,
	43744,
	43755,
	43762,
	43765,
	43777,
	43783,
	43785,
	43791,
	43793,
	43799,
	43808,
	43815,
	43816,
	43823,
	43824,
	43867,
	43868,
	43880,
	43888,
	44003,
	44032,
	55204,
	55216,
	55239,
	55243,
	55292,
	63744,
	64110,
	64112,
	64218,
	64256,
	64263,
	64275,
	64280,
	64285,
	64286,
	64287,
	64297,
	64298,
	64311,
	64312,
	64317,
	64318,
	64319,
	64320,
	64322,
	64323,
	64325,
	64326,
	64434,
	64467,
	64830,
	64848,
	64912,
	64914,
	64968,
	65008,
	65020,
	65136,
	65141,
	65142,
	65277,
	65313,
	65339,
	65345,
	65371,
	65382,
	65471,
	65474,
	65480,
	65482,
	65488,
	65490,
	65496,
	65498,
	65501,
	65536,
	65548,
	65549,
	65575,
	65576,
	65595,
	65596,
	65598,
	65599,
	65614,
	65616,
	65630,
	65664,
	65787,
	65856,
	65909,
	66176,
	66205,
	66208,
	66257,
	66304,
	66336,
	66349,
	66379,
	66384,
	66422,
	66432,
	66462,
	66464,
	66500,
	66504,
	66512,
	66513,
	66518,
	66560,
	66718,
	66736,
	66772,
	66776,
	66812,
	66816,
	66856,
	66864,
	66916,
	67072,
	67383,
	67392,
	67414,
	67424,
	67432,
	67584,
	67590,
	67592,
	67593,
	67594,
	67638,
	67639,
	67641,
	67644,
	67645,
	67647,
	67670,
	67680,
	67703,
	67712,
	67743,
	67808,
	67827,
	67828,
	67830,
	67840,
	67862,
	67872,
	67898,
	67968,
	68024,
	68030,
	68032,
	68096,
	68097,
	68112,
	68116,
	68117,
	68120,
	68121,
	68150,
	68192,
	68221,
	68224,
	68253,
	68288,
	68296,
	68297,
	68325,
	68352,
	68406,
	68416,
	68438,
	68448,
	68467,
	68480,
	68498,
	68608,
	68681,
	68736,
	68787,
	68800,
	68851,
	68864,
	68900,
	69376,
	69405,
	69415,
	69416,
	69424,
	69446,
	69600,
	69623,
	69635,
	69688,
	69763,
	69808,
	69840,
	69865,
	69891,
	69927,
	69956,
	69957,
	69968,
	70003,
	70006,
	70007,
	70019,
	70067,
	70081,
	70085,
	70106,
	70107,
	70108,
	70109,
	70144,
	70162,
	70163,
	70188,
	70272,
	70279,
	70280,
	70281,
	70282,
	70286,
	70287,
	70302,
	70303,
	70313,
	70320,
	70367,
	70405,
	70413,
	70415,
	70417,
	70419,
	70441,
	70442,
	70449,
	70450,
	70452,
	70453,
	70458,
	70461,
	70462,
	70480,
	70481,
	70493,
	70498,
	70656,
	70709,
	70727,
	70731,
	70751,
	70752,
	70784,
	70832,
	70852,
	70854,
	70855,
	70856,
	71040,
	71087,
	71128,
	71132,
	71168,
	71216,
	71236,
	71237,
	71296,
	71339,
	71352,
	71353,
	71424,
	71451,
	71680,
	71724,
	71840,
	71904,
	71935,
	71936,
	72096,
	72104,
	72106,
	72145,
	72161,
	72162,
	72163,
	72164,
	72192,
	72193,
	72203,
	72243,
	72250,
	72251,
	72272,
	72273,
	72284,
	72330,
	72349,
	72350,
	72384,
	72441,
	72704,
	72713,
	72714,
	72751,
	72768,
	72769,
	72818,
	72848,
	72960,
	72967,
	72968,
	72970,
	72971,
	73009,
	73030,
	73031,
	73056,
	73062,
	73063,
	73065,
	73066,
	73098,
	73112,
	73113,
	73440,
	73459,
	73728,
	74650,
	74752,
	74863,
	74880,
	75076,
	77824,
	78895,
	82944,
	83527,
	92160,
	92729,
	92736,
	92767,
	92880,
	92910,
	92928,
	92976,
	92992,
	92996,
	93027,
	93048,
	93053,
	93072,
	93760,
	93824,
	93952,
	94027,
	94032,
	94033,
	94099,
	94112,
	94176,
	94178,
	94179,
	94180,
	94208,
	100344,
	100352,
	101107,
	110592,
	110879,
	110928,
	110931,
	110948,
	110952,
	110960,
	111356,
	113664,
	113771,
	113776,
	113789,
	113792,
	113801,
	113808,
	113818,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120513,
	120514,
	120539,
	120540,
	120571,
	120572,
	120597,
	120598,
	120629,
	120630,
	120655,
	120656,
	120687,
	120688,
	120713,
	120714,
	120745,
	120746,
	120771,
	120772,
	120780,
	123136,
	123181,
	123191,
	123198,
	123214,
	123215,
	123584,
	123628,
	124928,
	125125,
	125184,
	125252,
	125259,
	125260,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457,
	194560,
	195102
]);
property.set("Ideographic", [
	12294,
	12296,
	12321,
	12330,
	12344,
	12347,
	13312,
	19894,
	19968,
	40944,
	63744,
	64110,
	64112,
	64218,
	94208,
	100344,
	100352,
	101107,
	110960,
	111356,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457,
	194560,
	195102
]);
property.set("Join_Control", [8204, 8206]);
property.set("Logical_Order_Exception", [3648, 3653, 3776, 3781, 6581, 6584, 6586, 6587, 43701, 43703, 43705, 43706, 43707, 43709]);
property.set("Lowercase", [
	97,
	123,
	170,
	171,
	181,
	182,
	186,
	187,
	223,
	247,
	248,
	256,
	257,
	258,
	259,
	260,
	261,
	262,
	263,
	264,
	265,
	266,
	267,
	268,
	269,
	270,
	271,
	272,
	273,
	274,
	275,
	276,
	277,
	278,
	279,
	280,
	281,
	282,
	283,
	284,
	285,
	286,
	287,
	288,
	289,
	290,
	291,
	292,
	293,
	294,
	295,
	296,
	297,
	298,
	299,
	300,
	301,
	302,
	303,
	304,
	305,
	306,
	307,
	308,
	309,
	310,
	311,
	313,
	314,
	315,
	316,
	317,
	318,
	319,
	320,
	321,
	322,
	323,
	324,
	325,
	326,
	327,
	328,
	330,
	331,
	332,
	333,
	334,
	335,
	336,
	337,
	338,
	339,
	340,
	341,
	342,
	343,
	344,
	345,
	346,
	347,
	348,
	349,
	350,
	351,
	352,
	353,
	354,
	355,
	356,
	357,
	358,
	359,
	360,
	361,
	362,
	363,
	364,
	365,
	366,
	367,
	368,
	369,
	370,
	371,
	372,
	373,
	374,
	375,
	376,
	378,
	379,
	380,
	381,
	382,
	385,
	387,
	388,
	389,
	390,
	392,
	393,
	396,
	398,
	402,
	403,
	405,
	406,
	409,
	412,
	414,
	415,
	417,
	418,
	419,
	420,
	421,
	422,
	424,
	425,
	426,
	428,
	429,
	430,
	432,
	433,
	436,
	437,
	438,
	439,
	441,
	443,
	445,
	448,
	454,
	455,
	457,
	458,
	460,
	461,
	462,
	463,
	464,
	465,
	466,
	467,
	468,
	469,
	470,
	471,
	472,
	473,
	474,
	475,
	476,
	478,
	479,
	480,
	481,
	482,
	483,
	484,
	485,
	486,
	487,
	488,
	489,
	490,
	491,
	492,
	493,
	494,
	495,
	497,
	499,
	500,
	501,
	502,
	505,
	506,
	507,
	508,
	509,
	510,
	511,
	512,
	513,
	514,
	515,
	516,
	517,
	518,
	519,
	520,
	521,
	522,
	523,
	524,
	525,
	526,
	527,
	528,
	529,
	530,
	531,
	532,
	533,
	534,
	535,
	536,
	537,
	538,
	539,
	540,
	541,
	542,
	543,
	544,
	545,
	546,
	547,
	548,
	549,
	550,
	551,
	552,
	553,
	554,
	555,
	556,
	557,
	558,
	559,
	560,
	561,
	562,
	563,
	570,
	572,
	573,
	575,
	577,
	578,
	579,
	583,
	584,
	585,
	586,
	587,
	588,
	589,
	590,
	591,
	660,
	661,
	697,
	704,
	706,
	736,
	741,
	837,
	838,
	881,
	882,
	883,
	884,
	887,
	888,
	890,
	894,
	912,
	913,
	940,
	975,
	976,
	978,
	981,
	984,
	985,
	986,
	987,
	988,
	989,
	990,
	991,
	992,
	993,
	994,
	995,
	996,
	997,
	998,
	999,
	1000,
	1001,
	1002,
	1003,
	1004,
	1005,
	1006,
	1007,
	1012,
	1013,
	1014,
	1016,
	1017,
	1019,
	1021,
	1072,
	1120,
	1121,
	1122,
	1123,
	1124,
	1125,
	1126,
	1127,
	1128,
	1129,
	1130,
	1131,
	1132,
	1133,
	1134,
	1135,
	1136,
	1137,
	1138,
	1139,
	1140,
	1141,
	1142,
	1143,
	1144,
	1145,
	1146,
	1147,
	1148,
	1149,
	1150,
	1151,
	1152,
	1153,
	1154,
	1163,
	1164,
	1165,
	1166,
	1167,
	1168,
	1169,
	1170,
	1171,
	1172,
	1173,
	1174,
	1175,
	1176,
	1177,
	1178,
	1179,
	1180,
	1181,
	1182,
	1183,
	1184,
	1185,
	1186,
	1187,
	1188,
	1189,
	1190,
	1191,
	1192,
	1193,
	1194,
	1195,
	1196,
	1197,
	1198,
	1199,
	1200,
	1201,
	1202,
	1203,
	1204,
	1205,
	1206,
	1207,
	1208,
	1209,
	1210,
	1211,
	1212,
	1213,
	1214,
	1215,
	1216,
	1218,
	1219,
	1220,
	1221,
	1222,
	1223,
	1224,
	1225,
	1226,
	1227,
	1228,
	1229,
	1230,
	1232,
	1233,
	1234,
	1235,
	1236,
	1237,
	1238,
	1239,
	1240,
	1241,
	1242,
	1243,
	1244,
	1245,
	1246,
	1247,
	1248,
	1249,
	1250,
	1251,
	1252,
	1253,
	1254,
	1255,
	1256,
	1257,
	1258,
	1259,
	1260,
	1261,
	1262,
	1263,
	1264,
	1265,
	1266,
	1267,
	1268,
	1269,
	1270,
	1271,
	1272,
	1273,
	1274,
	1275,
	1276,
	1277,
	1278,
	1279,
	1280,
	1281,
	1282,
	1283,
	1284,
	1285,
	1286,
	1287,
	1288,
	1289,
	1290,
	1291,
	1292,
	1293,
	1294,
	1295,
	1296,
	1297,
	1298,
	1299,
	1300,
	1301,
	1302,
	1303,
	1304,
	1305,
	1306,
	1307,
	1308,
	1309,
	1310,
	1311,
	1312,
	1313,
	1314,
	1315,
	1316,
	1317,
	1318,
	1319,
	1320,
	1321,
	1322,
	1323,
	1324,
	1325,
	1326,
	1327,
	1328,
	1376,
	1417,
	4304,
	4347,
	4349,
	4352,
	5112,
	5118,
	7296,
	7305,
	7424,
	7616,
	7681,
	7682,
	7683,
	7684,
	7685,
	7686,
	7687,
	7688,
	7689,
	7690,
	7691,
	7692,
	7693,
	7694,
	7695,
	7696,
	7697,
	7698,
	7699,
	7700,
	7701,
	7702,
	7703,
	7704,
	7705,
	7706,
	7707,
	7708,
	7709,
	7710,
	7711,
	7712,
	7713,
	7714,
	7715,
	7716,
	7717,
	7718,
	7719,
	7720,
	7721,
	7722,
	7723,
	7724,
	7725,
	7726,
	7727,
	7728,
	7729,
	7730,
	7731,
	7732,
	7733,
	7734,
	7735,
	7736,
	7737,
	7738,
	7739,
	7740,
	7741,
	7742,
	7743,
	7744,
	7745,
	7746,
	7747,
	7748,
	7749,
	7750,
	7751,
	7752,
	7753,
	7754,
	7755,
	7756,
	7757,
	7758,
	7759,
	7760,
	7761,
	7762,
	7763,
	7764,
	7765,
	7766,
	7767,
	7768,
	7769,
	7770,
	7771,
	7772,
	7773,
	7774,
	7775,
	7776,
	7777,
	7778,
	7779,
	7780,
	7781,
	7782,
	7783,
	7784,
	7785,
	7786,
	7787,
	7788,
	7789,
	7790,
	7791,
	7792,
	7793,
	7794,
	7795,
	7796,
	7797,
	7798,
	7799,
	7800,
	7801,
	7802,
	7803,
	7804,
	7805,
	7806,
	7807,
	7808,
	7809,
	7810,
	7811,
	7812,
	7813,
	7814,
	7815,
	7816,
	7817,
	7818,
	7819,
	7820,
	7821,
	7822,
	7823,
	7824,
	7825,
	7826,
	7827,
	7828,
	7829,
	7838,
	7839,
	7840,
	7841,
	7842,
	7843,
	7844,
	7845,
	7846,
	7847,
	7848,
	7849,
	7850,
	7851,
	7852,
	7853,
	7854,
	7855,
	7856,
	7857,
	7858,
	7859,
	7860,
	7861,
	7862,
	7863,
	7864,
	7865,
	7866,
	7867,
	7868,
	7869,
	7870,
	7871,
	7872,
	7873,
	7874,
	7875,
	7876,
	7877,
	7878,
	7879,
	7880,
	7881,
	7882,
	7883,
	7884,
	7885,
	7886,
	7887,
	7888,
	7889,
	7890,
	7891,
	7892,
	7893,
	7894,
	7895,
	7896,
	7897,
	7898,
	7899,
	7900,
	7901,
	7902,
	7903,
	7904,
	7905,
	7906,
	7907,
	7908,
	7909,
	7910,
	7911,
	7912,
	7913,
	7914,
	7915,
	7916,
	7917,
	7918,
	7919,
	7920,
	7921,
	7922,
	7923,
	7924,
	7925,
	7926,
	7927,
	7928,
	7929,
	7930,
	7931,
	7932,
	7933,
	7934,
	7935,
	7944,
	7952,
	7958,
	7968,
	7976,
	7984,
	7992,
	8000,
	8006,
	8016,
	8024,
	8032,
	8040,
	8048,
	8062,
	8064,
	8072,
	8080,
	8088,
	8096,
	8104,
	8112,
	8117,
	8118,
	8120,
	8126,
	8127,
	8130,
	8133,
	8134,
	8136,
	8144,
	8148,
	8150,
	8152,
	8160,
	8168,
	8178,
	8181,
	8182,
	8184,
	8305,
	8306,
	8319,
	8320,
	8336,
	8349,
	8458,
	8459,
	8462,
	8464,
	8467,
	8468,
	8495,
	8496,
	8500,
	8501,
	8505,
	8506,
	8508,
	8510,
	8518,
	8522,
	8526,
	8527,
	8560,
	8576,
	8580,
	8581,
	9424,
	9450,
	11312,
	11359,
	11361,
	11362,
	11365,
	11367,
	11368,
	11369,
	11370,
	11371,
	11372,
	11373,
	11377,
	11378,
	11379,
	11381,
	11382,
	11390,
	11393,
	11394,
	11395,
	11396,
	11397,
	11398,
	11399,
	11400,
	11401,
	11402,
	11403,
	11404,
	11405,
	11406,
	11407,
	11408,
	11409,
	11410,
	11411,
	11412,
	11413,
	11414,
	11415,
	11416,
	11417,
	11418,
	11419,
	11420,
	11421,
	11422,
	11423,
	11424,
	11425,
	11426,
	11427,
	11428,
	11429,
	11430,
	11431,
	11432,
	11433,
	11434,
	11435,
	11436,
	11437,
	11438,
	11439,
	11440,
	11441,
	11442,
	11443,
	11444,
	11445,
	11446,
	11447,
	11448,
	11449,
	11450,
	11451,
	11452,
	11453,
	11454,
	11455,
	11456,
	11457,
	11458,
	11459,
	11460,
	11461,
	11462,
	11463,
	11464,
	11465,
	11466,
	11467,
	11468,
	11469,
	11470,
	11471,
	11472,
	11473,
	11474,
	11475,
	11476,
	11477,
	11478,
	11479,
	11480,
	11481,
	11482,
	11483,
	11484,
	11485,
	11486,
	11487,
	11488,
	11489,
	11490,
	11491,
	11493,
	11500,
	11501,
	11502,
	11503,
	11507,
	11508,
	11520,
	11558,
	11559,
	11560,
	11565,
	11566,
	42561,
	42562,
	42563,
	42564,
	42565,
	42566,
	42567,
	42568,
	42569,
	42570,
	42571,
	42572,
	42573,
	42574,
	42575,
	42576,
	42577,
	42578,
	42579,
	42580,
	42581,
	42582,
	42583,
	42584,
	42585,
	42586,
	42587,
	42588,
	42589,
	42590,
	42591,
	42592,
	42593,
	42594,
	42595,
	42596,
	42597,
	42598,
	42599,
	42600,
	42601,
	42602,
	42603,
	42604,
	42605,
	42606,
	42625,
	42626,
	42627,
	42628,
	42629,
	42630,
	42631,
	42632,
	42633,
	42634,
	42635,
	42636,
	42637,
	42638,
	42639,
	42640,
	42641,
	42642,
	42643,
	42644,
	42645,
	42646,
	42647,
	42648,
	42649,
	42650,
	42651,
	42654,
	42787,
	42788,
	42789,
	42790,
	42791,
	42792,
	42793,
	42794,
	42795,
	42796,
	42797,
	42798,
	42799,
	42802,
	42803,
	42804,
	42805,
	42806,
	42807,
	42808,
	42809,
	42810,
	42811,
	42812,
	42813,
	42814,
	42815,
	42816,
	42817,
	42818,
	42819,
	42820,
	42821,
	42822,
	42823,
	42824,
	42825,
	42826,
	42827,
	42828,
	42829,
	42830,
	42831,
	42832,
	42833,
	42834,
	42835,
	42836,
	42837,
	42838,
	42839,
	42840,
	42841,
	42842,
	42843,
	42844,
	42845,
	42846,
	42847,
	42848,
	42849,
	42850,
	42851,
	42852,
	42853,
	42854,
	42855,
	42856,
	42857,
	42858,
	42859,
	42860,
	42861,
	42862,
	42863,
	42873,
	42874,
	42875,
	42876,
	42877,
	42879,
	42880,
	42881,
	42882,
	42883,
	42884,
	42885,
	42886,
	42887,
	42888,
	42892,
	42893,
	42894,
	42895,
	42897,
	42898,
	42899,
	42902,
	42903,
	42904,
	42905,
	42906,
	42907,
	42908,
	42909,
	42910,
	42911,
	42912,
	42913,
	42914,
	42915,
	42916,
	42917,
	42918,
	42919,
	42920,
	42921,
	42922,
	42927,
	42928,
	42933,
	42934,
	42935,
	42936,
	42937,
	42938,
	42939,
	42940,
	42941,
	42942,
	42943,
	42944,
	42947,
	42948,
	43000,
	43003,
	43824,
	43867,
	43868,
	43880,
	43888,
	43968,
	64256,
	64263,
	64275,
	64280,
	65345,
	65371,
	66600,
	66640,
	66776,
	66812,
	68800,
	68851,
	71872,
	71904,
	93792,
	93824,
	119834,
	119860,
	119886,
	119893,
	119894,
	119912,
	119938,
	119964,
	119990,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120016,
	120042,
	120068,
	120094,
	120120,
	120146,
	120172,
	120198,
	120224,
	120250,
	120276,
	120302,
	120328,
	120354,
	120380,
	120406,
	120432,
	120458,
	120486,
	120514,
	120539,
	120540,
	120546,
	120572,
	120597,
	120598,
	120604,
	120630,
	120655,
	120656,
	120662,
	120688,
	120713,
	120714,
	120720,
	120746,
	120771,
	120772,
	120778,
	120779,
	120780,
	125218,
	125252
]);
property.set("Math", [
	43,
	44,
	60,
	63,
	94,
	95,
	124,
	125,
	126,
	127,
	172,
	173,
	177,
	178,
	215,
	216,
	247,
	248,
	976,
	979,
	981,
	982,
	1008,
	1010,
	1012,
	1015,
	1542,
	1545,
	8214,
	8215,
	8242,
	8245,
	8256,
	8257,
	8260,
	8261,
	8274,
	8275,
	8289,
	8293,
	8314,
	8319,
	8330,
	8335,
	8400,
	8413,
	8417,
	8418,
	8421,
	8423,
	8427,
	8432,
	8450,
	8451,
	8455,
	8456,
	8458,
	8468,
	8469,
	8470,
	8472,
	8478,
	8484,
	8485,
	8488,
	8490,
	8492,
	8494,
	8495,
	8498,
	8499,
	8505,
	8508,
	8522,
	8523,
	8524,
	8592,
	8616,
	8617,
	8623,
	8624,
	8626,
	8630,
	8632,
	8636,
	8668,
	8669,
	8670,
	8676,
	8678,
	8692,
	8960,
	8968,
	8972,
	8992,
	8994,
	9084,
	9085,
	9115,
	9142,
	9143,
	9144,
	9168,
	9169,
	9180,
	9187,
	9632,
	9634,
	9646,
	9656,
	9660,
	9666,
	9670,
	9672,
	9674,
	9676,
	9679,
	9684,
	9698,
	9699,
	9700,
	9701,
	9703,
	9709,
	9720,
	9728,
	9733,
	9735,
	9792,
	9793,
	9794,
	9795,
	9824,
	9828,
	9837,
	9840,
	10176,
	10240,
	10496,
	11008,
	11056,
	11077,
	11079,
	11085,
	64297,
	64298,
	65121,
	65127,
	65128,
	65129,
	65291,
	65292,
	65308,
	65311,
	65340,
	65341,
	65342,
	65343,
	65372,
	65373,
	65374,
	65375,
	65506,
	65507,
	65513,
	65517,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120780,
	120782,
	120832,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	126704,
	126706
]);
property.set("Noncharacter_Code_Point", [
	64976,
	65008,
	65534,
	65536,
	131070,
	131072,
	196606,
	196608,
	262142,
	262144,
	327678,
	327680,
	393214,
	393216,
	458750,
	458752,
	524286,
	524288,
	589822,
	589824,
	655358,
	655360,
	720894,
	720896,
	786430,
	786432,
	851966,
	851968,
	917502,
	917504,
	983038,
	983040,
	1048574,
	1048576,
	1114110,
	1114112
]);
property.set("Pattern_Syntax", [
	33,
	48,
	58,
	65,
	91,
	95,
	96,
	97,
	123,
	127,
	161,
	168,
	169,
	170,
	171,
	173,
	174,
	175,
	176,
	178,
	182,
	183,
	187,
	188,
	191,
	192,
	215,
	216,
	247,
	248,
	8208,
	8232,
	8240,
	8255,
	8257,
	8276,
	8277,
	8287,
	8592,
	9312,
	9472,
	10102,
	10132,
	11264,
	11776,
	11904,
	12289,
	12292,
	12296,
	12321,
	12336,
	12337,
	64830,
	64832,
	65093,
	65095
]);
property.set("Pattern_White_Space", [9, 14, 32, 33, 133, 134, 8206, 8208, 8232, 8234]);
property.set("Quotation_Mark", [
	34,
	35,
	39,
	40,
	171,
	172,
	187,
	188,
	8216,
	8224,
	8249,
	8251,
	11842,
	11843,
	12300,
	12304,
	12317,
	12320,
	65089,
	65093,
	65282,
	65283,
	65287,
	65288,
	65378,
	65380
]);
property.set("Radical", [11904, 11930, 11931, 12020, 12032, 12246]);
property.set("Regional_Indicator", [127462, 127488]);
property.set("Sentence_Terminal", [
	33,
	34,
	46,
	47,
	63,
	64,
	1417,
	1418,
	1566,
	1568,
	1748,
	1749,
	1792,
	1795,
	2041,
	2042,
	2103,
	2104,
	2105,
	2106,
	2109,
	2111,
	2404,
	2406,
	4170,
	4172,
	4962,
	4963,
	4967,
	4969,
	5742,
	5743,
	5941,
	5943,
	6147,
	6148,
	6153,
	6154,
	6468,
	6470,
	6824,
	6828,
	7002,
	7004,
	7006,
	7008,
	7227,
	7229,
	7294,
	7296,
	8252,
	8254,
	8263,
	8266,
	11822,
	11823,
	11836,
	11837,
	12290,
	12291,
	42239,
	42240,
	42510,
	42512,
	42739,
	42740,
	42743,
	42744,
	43126,
	43128,
	43214,
	43216,
	43311,
	43312,
	43464,
	43466,
	43613,
	43616,
	43760,
	43762,
	44011,
	44012,
	65106,
	65107,
	65110,
	65112,
	65281,
	65282,
	65294,
	65295,
	65311,
	65312,
	65377,
	65378,
	68182,
	68184,
	69461,
	69466,
	69703,
	69705,
	69822,
	69826,
	69953,
	69956,
	70085,
	70087,
	70093,
	70094,
	70110,
	70112,
	70200,
	70202,
	70203,
	70205,
	70313,
	70314,
	70731,
	70733,
	71106,
	71108,
	71113,
	71128,
	71233,
	71235,
	71484,
	71487,
	72258,
	72260,
	72347,
	72349,
	72769,
	72771,
	73463,
	73465,
	92782,
	92784,
	92917,
	92918,
	92983,
	92985,
	92996,
	92997,
	93848,
	93849,
	113823,
	113824,
	121480,
	121481
]);
property.set("Soft_Dotted", [
	105,
	107,
	303,
	304,
	585,
	586,
	616,
	617,
	669,
	670,
	690,
	691,
	1011,
	1012,
	1110,
	1111,
	1112,
	1113,
	7522,
	7523,
	7574,
	7575,
	7588,
	7589,
	7592,
	7593,
	7725,
	7726,
	7883,
	7884,
	8305,
	8306,
	8520,
	8522,
	11388,
	11389,
	119842,
	119844,
	119894,
	119896,
	119946,
	119948,
	119998,
	120000,
	120050,
	120052,
	120102,
	120104,
	120154,
	120156,
	120206,
	120208,
	120258,
	120260,
	120310,
	120312,
	120362,
	120364,
	120414,
	120416,
	120466,
	120468
]);
property.set("Terminal_Punctuation", [
	33,
	34,
	44,
	45,
	46,
	47,
	58,
	60,
	63,
	64,
	894,
	895,
	903,
	904,
	1417,
	1418,
	1475,
	1476,
	1548,
	1549,
	1563,
	1564,
	1566,
	1568,
	1748,
	1749,
	1792,
	1803,
	1804,
	1805,
	2040,
	2042,
	2096,
	2111,
	2142,
	2143,
	2404,
	2406,
	3674,
	3676,
	3848,
	3849,
	3853,
	3859,
	4170,
	4172,
	4961,
	4969,
	5742,
	5743,
	5867,
	5870,
	5941,
	5943,
	6100,
	6103,
	6106,
	6107,
	6146,
	6150,
	6152,
	6154,
	6468,
	6470,
	6824,
	6828,
	7002,
	7004,
	7005,
	7008,
	7227,
	7232,
	7294,
	7296,
	8252,
	8254,
	8263,
	8266,
	11822,
	11823,
	11836,
	11837,
	11841,
	11842,
	11852,
	11853,
	11854,
	11856,
	12289,
	12291,
	42238,
	42240,
	42509,
	42512,
	42739,
	42744,
	43126,
	43128,
	43214,
	43216,
	43311,
	43312,
	43463,
	43466,
	43613,
	43616,
	43743,
	43744,
	43760,
	43762,
	44011,
	44012,
	65104,
	65107,
	65108,
	65112,
	65281,
	65282,
	65292,
	65293,
	65294,
	65295,
	65306,
	65308,
	65311,
	65312,
	65377,
	65378,
	65380,
	65381,
	66463,
	66464,
	66512,
	66513,
	67671,
	67672,
	67871,
	67872,
	68182,
	68184,
	68336,
	68342,
	68410,
	68416,
	68505,
	68509,
	69461,
	69466,
	69703,
	69710,
	69822,
	69826,
	69953,
	69956,
	70085,
	70087,
	70093,
	70094,
	70110,
	70112,
	70200,
	70205,
	70313,
	70314,
	70731,
	70734,
	70747,
	70748,
	71106,
	71110,
	71113,
	71128,
	71233,
	71235,
	71484,
	71487,
	72258,
	72260,
	72347,
	72349,
	72353,
	72355,
	72769,
	72772,
	72817,
	72818,
	73463,
	73465,
	74864,
	74869,
	92782,
	92784,
	92917,
	92918,
	92983,
	92986,
	92996,
	92997,
	93847,
	93849,
	113823,
	113824,
	121479,
	121483
]);
property.set("Unified_Ideograph", [
	13312,
	19894,
	19968,
	40944,
	64014,
	64016,
	64017,
	64018,
	64019,
	64021,
	64031,
	64032,
	64033,
	64034,
	64035,
	64037,
	64039,
	64042,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457
]);
property.set("Uppercase", [
	65,
	91,
	192,
	215,
	216,
	223,
	256,
	257,
	258,
	259,
	260,
	261,
	262,
	263,
	264,
	265,
	266,
	267,
	268,
	269,
	270,
	271,
	272,
	273,
	274,
	275,
	276,
	277,
	278,
	279,
	280,
	281,
	282,
	283,
	284,
	285,
	286,
	287,
	288,
	289,
	290,
	291,
	292,
	293,
	294,
	295,
	296,
	297,
	298,
	299,
	300,
	301,
	302,
	303,
	304,
	305,
	306,
	307,
	308,
	309,
	310,
	311,
	313,
	314,
	315,
	316,
	317,
	318,
	319,
	320,
	321,
	322,
	323,
	324,
	325,
	326,
	327,
	328,
	330,
	331,
	332,
	333,
	334,
	335,
	336,
	337,
	338,
	339,
	340,
	341,
	342,
	343,
	344,
	345,
	346,
	347,
	348,
	349,
	350,
	351,
	352,
	353,
	354,
	355,
	356,
	357,
	358,
	359,
	360,
	361,
	362,
	363,
	364,
	365,
	366,
	367,
	368,
	369,
	370,
	371,
	372,
	373,
	374,
	375,
	376,
	378,
	379,
	380,
	381,
	382,
	385,
	387,
	388,
	389,
	390,
	392,
	393,
	396,
	398,
	402,
	403,
	405,
	406,
	409,
	412,
	414,
	415,
	417,
	418,
	419,
	420,
	421,
	422,
	424,
	425,
	426,
	428,
	429,
	430,
	432,
	433,
	436,
	437,
	438,
	439,
	441,
	444,
	445,
	452,
	453,
	455,
	456,
	458,
	459,
	461,
	462,
	463,
	464,
	465,
	466,
	467,
	468,
	469,
	470,
	471,
	472,
	473,
	474,
	475,
	476,
	478,
	479,
	480,
	481,
	482,
	483,
	484,
	485,
	486,
	487,
	488,
	489,
	490,
	491,
	492,
	493,
	494,
	495,
	497,
	498,
	500,
	501,
	502,
	505,
	506,
	507,
	508,
	509,
	510,
	511,
	512,
	513,
	514,
	515,
	516,
	517,
	518,
	519,
	520,
	521,
	522,
	523,
	524,
	525,
	526,
	527,
	528,
	529,
	530,
	531,
	532,
	533,
	534,
	535,
	536,
	537,
	538,
	539,
	540,
	541,
	542,
	543,
	544,
	545,
	546,
	547,
	548,
	549,
	550,
	551,
	552,
	553,
	554,
	555,
	556,
	557,
	558,
	559,
	560,
	561,
	562,
	563,
	570,
	572,
	573,
	575,
	577,
	578,
	579,
	583,
	584,
	585,
	586,
	587,
	588,
	589,
	590,
	591,
	880,
	881,
	882,
	883,
	886,
	887,
	895,
	896,
	902,
	903,
	904,
	907,
	908,
	909,
	910,
	912,
	913,
	930,
	931,
	940,
	975,
	976,
	978,
	981,
	984,
	985,
	986,
	987,
	988,
	989,
	990,
	991,
	992,
	993,
	994,
	995,
	996,
	997,
	998,
	999,
	1000,
	1001,
	1002,
	1003,
	1004,
	1005,
	1006,
	1007,
	1012,
	1013,
	1015,
	1016,
	1017,
	1019,
	1021,
	1072,
	1120,
	1121,
	1122,
	1123,
	1124,
	1125,
	1126,
	1127,
	1128,
	1129,
	1130,
	1131,
	1132,
	1133,
	1134,
	1135,
	1136,
	1137,
	1138,
	1139,
	1140,
	1141,
	1142,
	1143,
	1144,
	1145,
	1146,
	1147,
	1148,
	1149,
	1150,
	1151,
	1152,
	1153,
	1162,
	1163,
	1164,
	1165,
	1166,
	1167,
	1168,
	1169,
	1170,
	1171,
	1172,
	1173,
	1174,
	1175,
	1176,
	1177,
	1178,
	1179,
	1180,
	1181,
	1182,
	1183,
	1184,
	1185,
	1186,
	1187,
	1188,
	1189,
	1190,
	1191,
	1192,
	1193,
	1194,
	1195,
	1196,
	1197,
	1198,
	1199,
	1200,
	1201,
	1202,
	1203,
	1204,
	1205,
	1206,
	1207,
	1208,
	1209,
	1210,
	1211,
	1212,
	1213,
	1214,
	1215,
	1216,
	1218,
	1219,
	1220,
	1221,
	1222,
	1223,
	1224,
	1225,
	1226,
	1227,
	1228,
	1229,
	1230,
	1232,
	1233,
	1234,
	1235,
	1236,
	1237,
	1238,
	1239,
	1240,
	1241,
	1242,
	1243,
	1244,
	1245,
	1246,
	1247,
	1248,
	1249,
	1250,
	1251,
	1252,
	1253,
	1254,
	1255,
	1256,
	1257,
	1258,
	1259,
	1260,
	1261,
	1262,
	1263,
	1264,
	1265,
	1266,
	1267,
	1268,
	1269,
	1270,
	1271,
	1272,
	1273,
	1274,
	1275,
	1276,
	1277,
	1278,
	1279,
	1280,
	1281,
	1282,
	1283,
	1284,
	1285,
	1286,
	1287,
	1288,
	1289,
	1290,
	1291,
	1292,
	1293,
	1294,
	1295,
	1296,
	1297,
	1298,
	1299,
	1300,
	1301,
	1302,
	1303,
	1304,
	1305,
	1306,
	1307,
	1308,
	1309,
	1310,
	1311,
	1312,
	1313,
	1314,
	1315,
	1316,
	1317,
	1318,
	1319,
	1320,
	1321,
	1322,
	1323,
	1324,
	1325,
	1326,
	1327,
	1329,
	1367,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	5024,
	5110,
	7312,
	7355,
	7357,
	7360,
	7680,
	7681,
	7682,
	7683,
	7684,
	7685,
	7686,
	7687,
	7688,
	7689,
	7690,
	7691,
	7692,
	7693,
	7694,
	7695,
	7696,
	7697,
	7698,
	7699,
	7700,
	7701,
	7702,
	7703,
	7704,
	7705,
	7706,
	7707,
	7708,
	7709,
	7710,
	7711,
	7712,
	7713,
	7714,
	7715,
	7716,
	7717,
	7718,
	7719,
	7720,
	7721,
	7722,
	7723,
	7724,
	7725,
	7726,
	7727,
	7728,
	7729,
	7730,
	7731,
	7732,
	7733,
	7734,
	7735,
	7736,
	7737,
	7738,
	7739,
	7740,
	7741,
	7742,
	7743,
	7744,
	7745,
	7746,
	7747,
	7748,
	7749,
	7750,
	7751,
	7752,
	7753,
	7754,
	7755,
	7756,
	7757,
	7758,
	7759,
	7760,
	7761,
	7762,
	7763,
	7764,
	7765,
	7766,
	7767,
	7768,
	7769,
	7770,
	7771,
	7772,
	7773,
	7774,
	7775,
	7776,
	7777,
	7778,
	7779,
	7780,
	7781,
	7782,
	7783,
	7784,
	7785,
	7786,
	7787,
	7788,
	7789,
	7790,
	7791,
	7792,
	7793,
	7794,
	7795,
	7796,
	7797,
	7798,
	7799,
	7800,
	7801,
	7802,
	7803,
	7804,
	7805,
	7806,
	7807,
	7808,
	7809,
	7810,
	7811,
	7812,
	7813,
	7814,
	7815,
	7816,
	7817,
	7818,
	7819,
	7820,
	7821,
	7822,
	7823,
	7824,
	7825,
	7826,
	7827,
	7828,
	7829,
	7838,
	7839,
	7840,
	7841,
	7842,
	7843,
	7844,
	7845,
	7846,
	7847,
	7848,
	7849,
	7850,
	7851,
	7852,
	7853,
	7854,
	7855,
	7856,
	7857,
	7858,
	7859,
	7860,
	7861,
	7862,
	7863,
	7864,
	7865,
	7866,
	7867,
	7868,
	7869,
	7870,
	7871,
	7872,
	7873,
	7874,
	7875,
	7876,
	7877,
	7878,
	7879,
	7880,
	7881,
	7882,
	7883,
	7884,
	7885,
	7886,
	7887,
	7888,
	7889,
	7890,
	7891,
	7892,
	7893,
	7894,
	7895,
	7896,
	7897,
	7898,
	7899,
	7900,
	7901,
	7902,
	7903,
	7904,
	7905,
	7906,
	7907,
	7908,
	7909,
	7910,
	7911,
	7912,
	7913,
	7914,
	7915,
	7916,
	7917,
	7918,
	7919,
	7920,
	7921,
	7922,
	7923,
	7924,
	7925,
	7926,
	7927,
	7928,
	7929,
	7930,
	7931,
	7932,
	7933,
	7934,
	7935,
	7944,
	7952,
	7960,
	7966,
	7976,
	7984,
	7992,
	8000,
	8008,
	8014,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8032,
	8040,
	8048,
	8120,
	8124,
	8136,
	8140,
	8152,
	8156,
	8168,
	8173,
	8184,
	8188,
	8450,
	8451,
	8455,
	8456,
	8459,
	8462,
	8464,
	8467,
	8469,
	8470,
	8473,
	8478,
	8484,
	8485,
	8486,
	8487,
	8488,
	8489,
	8490,
	8494,
	8496,
	8500,
	8510,
	8512,
	8517,
	8518,
	8544,
	8560,
	8579,
	8580,
	9398,
	9424,
	11264,
	11311,
	11360,
	11361,
	11362,
	11365,
	11367,
	11368,
	11369,
	11370,
	11371,
	11372,
	11373,
	11377,
	11378,
	11379,
	11381,
	11382,
	11390,
	11393,
	11394,
	11395,
	11396,
	11397,
	11398,
	11399,
	11400,
	11401,
	11402,
	11403,
	11404,
	11405,
	11406,
	11407,
	11408,
	11409,
	11410,
	11411,
	11412,
	11413,
	11414,
	11415,
	11416,
	11417,
	11418,
	11419,
	11420,
	11421,
	11422,
	11423,
	11424,
	11425,
	11426,
	11427,
	11428,
	11429,
	11430,
	11431,
	11432,
	11433,
	11434,
	11435,
	11436,
	11437,
	11438,
	11439,
	11440,
	11441,
	11442,
	11443,
	11444,
	11445,
	11446,
	11447,
	11448,
	11449,
	11450,
	11451,
	11452,
	11453,
	11454,
	11455,
	11456,
	11457,
	11458,
	11459,
	11460,
	11461,
	11462,
	11463,
	11464,
	11465,
	11466,
	11467,
	11468,
	11469,
	11470,
	11471,
	11472,
	11473,
	11474,
	11475,
	11476,
	11477,
	11478,
	11479,
	11480,
	11481,
	11482,
	11483,
	11484,
	11485,
	11486,
	11487,
	11488,
	11489,
	11490,
	11491,
	11499,
	11500,
	11501,
	11502,
	11506,
	11507,
	42560,
	42561,
	42562,
	42563,
	42564,
	42565,
	42566,
	42567,
	42568,
	42569,
	42570,
	42571,
	42572,
	42573,
	42574,
	42575,
	42576,
	42577,
	42578,
	42579,
	42580,
	42581,
	42582,
	42583,
	42584,
	42585,
	42586,
	42587,
	42588,
	42589,
	42590,
	42591,
	42592,
	42593,
	42594,
	42595,
	42596,
	42597,
	42598,
	42599,
	42600,
	42601,
	42602,
	42603,
	42604,
	42605,
	42624,
	42625,
	42626,
	42627,
	42628,
	42629,
	42630,
	42631,
	42632,
	42633,
	42634,
	42635,
	42636,
	42637,
	42638,
	42639,
	42640,
	42641,
	42642,
	42643,
	42644,
	42645,
	42646,
	42647,
	42648,
	42649,
	42650,
	42651,
	42786,
	42787,
	42788,
	42789,
	42790,
	42791,
	42792,
	42793,
	42794,
	42795,
	42796,
	42797,
	42798,
	42799,
	42802,
	42803,
	42804,
	42805,
	42806,
	42807,
	42808,
	42809,
	42810,
	42811,
	42812,
	42813,
	42814,
	42815,
	42816,
	42817,
	42818,
	42819,
	42820,
	42821,
	42822,
	42823,
	42824,
	42825,
	42826,
	42827,
	42828,
	42829,
	42830,
	42831,
	42832,
	42833,
	42834,
	42835,
	42836,
	42837,
	42838,
	42839,
	42840,
	42841,
	42842,
	42843,
	42844,
	42845,
	42846,
	42847,
	42848,
	42849,
	42850,
	42851,
	42852,
	42853,
	42854,
	42855,
	42856,
	42857,
	42858,
	42859,
	42860,
	42861,
	42862,
	42863,
	42873,
	42874,
	42875,
	42876,
	42877,
	42879,
	42880,
	42881,
	42882,
	42883,
	42884,
	42885,
	42886,
	42887,
	42891,
	42892,
	42893,
	42894,
	42896,
	42897,
	42898,
	42899,
	42902,
	42903,
	42904,
	42905,
	42906,
	42907,
	42908,
	42909,
	42910,
	42911,
	42912,
	42913,
	42914,
	42915,
	42916,
	42917,
	42918,
	42919,
	42920,
	42921,
	42922,
	42927,
	42928,
	42933,
	42934,
	42935,
	42936,
	42937,
	42938,
	42939,
	42940,
	42941,
	42942,
	42943,
	42946,
	42947,
	42948,
	42951,
	65313,
	65339,
	66560,
	66600,
	66736,
	66772,
	68736,
	68787,
	71840,
	71872,
	93760,
	93792,
	119808,
	119834,
	119860,
	119886,
	119912,
	119938,
	119964,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119990,
	120016,
	120042,
	120068,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120120,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120172,
	120198,
	120224,
	120250,
	120276,
	120302,
	120328,
	120354,
	120380,
	120406,
	120432,
	120458,
	120488,
	120513,
	120546,
	120571,
	120604,
	120629,
	120662,
	120687,
	120720,
	120745,
	120778,
	120779,
	125184,
	125218,
	127280,
	127306,
	127312,
	127338,
	127344,
	127370
]);
property.set("Variation_Selector", [6155, 6158, 65024, 65040, 917760, 918000]);
property.set("White_Space", [9, 14, 32, 33, 133, 134, 160, 161, 5760, 5761, 8192, 8203, 8232, 8234, 8239, 8240, 8287, 8288, 12288, 12289]);
property.set("XID_Continue", [
	48,
	58,
	65,
	91,
	95,
	96,
	97,
	123,
	170,
	171,
	181,
	182,
	183,
	184,
	186,
	187,
	192,
	215,
	216,
	247,
	248,
	706,
	710,
	722,
	736,
	741,
	748,
	749,
	750,
	751,
	768,
	885,
	886,
	888,
	891,
	894,
	895,
	896,
	902,
	907,
	908,
	909,
	910,
	930,
	931,
	1014,
	1015,
	1154,
	1155,
	1160,
	1162,
	1328,
	1329,
	1367,
	1369,
	1370,
	1376,
	1417,
	1425,
	1470,
	1471,
	1472,
	1473,
	1475,
	1476,
	1478,
	1479,
	1480,
	1488,
	1515,
	1519,
	1523,
	1552,
	1563,
	1568,
	1642,
	1646,
	1748,
	1749,
	1757,
	1759,
	1769,
	1770,
	1789,
	1791,
	1792,
	1808,
	1867,
	1869,
	1970,
	1984,
	2038,
	2042,
	2043,
	2045,
	2046,
	2048,
	2094,
	2112,
	2140,
	2144,
	2155,
	2208,
	2229,
	2230,
	2238,
	2259,
	2274,
	2275,
	2404,
	2406,
	2416,
	2417,
	2436,
	2437,
	2445,
	2447,
	2449,
	2451,
	2473,
	2474,
	2481,
	2482,
	2483,
	2486,
	2490,
	2492,
	2501,
	2503,
	2505,
	2507,
	2511,
	2519,
	2520,
	2524,
	2526,
	2527,
	2532,
	2534,
	2546,
	2556,
	2557,
	2558,
	2559,
	2561,
	2564,
	2565,
	2571,
	2575,
	2577,
	2579,
	2601,
	2602,
	2609,
	2610,
	2612,
	2613,
	2615,
	2616,
	2618,
	2620,
	2621,
	2622,
	2627,
	2631,
	2633,
	2635,
	2638,
	2641,
	2642,
	2649,
	2653,
	2654,
	2655,
	2662,
	2678,
	2689,
	2692,
	2693,
	2702,
	2703,
	2706,
	2707,
	2729,
	2730,
	2737,
	2738,
	2740,
	2741,
	2746,
	2748,
	2758,
	2759,
	2762,
	2763,
	2766,
	2768,
	2769,
	2784,
	2788,
	2790,
	2800,
	2809,
	2816,
	2817,
	2820,
	2821,
	2829,
	2831,
	2833,
	2835,
	2857,
	2858,
	2865,
	2866,
	2868,
	2869,
	2874,
	2876,
	2885,
	2887,
	2889,
	2891,
	2894,
	2902,
	2904,
	2908,
	2910,
	2911,
	2916,
	2918,
	2928,
	2929,
	2930,
	2946,
	2948,
	2949,
	2955,
	2958,
	2961,
	2962,
	2966,
	2969,
	2971,
	2972,
	2973,
	2974,
	2976,
	2979,
	2981,
	2984,
	2987,
	2990,
	3002,
	3006,
	3011,
	3014,
	3017,
	3018,
	3022,
	3024,
	3025,
	3031,
	3032,
	3046,
	3056,
	3072,
	3085,
	3086,
	3089,
	3090,
	3113,
	3114,
	3130,
	3133,
	3141,
	3142,
	3145,
	3146,
	3150,
	3157,
	3159,
	3160,
	3163,
	3168,
	3172,
	3174,
	3184,
	3200,
	3204,
	3205,
	3213,
	3214,
	3217,
	3218,
	3241,
	3242,
	3252,
	3253,
	3258,
	3260,
	3269,
	3270,
	3273,
	3274,
	3278,
	3285,
	3287,
	3294,
	3295,
	3296,
	3300,
	3302,
	3312,
	3313,
	3315,
	3328,
	3332,
	3333,
	3341,
	3342,
	3345,
	3346,
	3397,
	3398,
	3401,
	3402,
	3407,
	3412,
	3416,
	3423,
	3428,
	3430,
	3440,
	3450,
	3456,
	3458,
	3460,
	3461,
	3479,
	3482,
	3506,
	3507,
	3516,
	3517,
	3518,
	3520,
	3527,
	3530,
	3531,
	3535,
	3541,
	3542,
	3543,
	3544,
	3552,
	3558,
	3568,
	3570,
	3572,
	3585,
	3643,
	3648,
	3663,
	3664,
	3674,
	3713,
	3715,
	3716,
	3717,
	3718,
	3723,
	3724,
	3748,
	3749,
	3750,
	3751,
	3774,
	3776,
	3781,
	3782,
	3783,
	3784,
	3790,
	3792,
	3802,
	3804,
	3808,
	3840,
	3841,
	3864,
	3866,
	3872,
	3882,
	3893,
	3894,
	3895,
	3896,
	3897,
	3898,
	3902,
	3912,
	3913,
	3949,
	3953,
	3973,
	3974,
	3992,
	3993,
	4029,
	4038,
	4039,
	4096,
	4170,
	4176,
	4254,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	4304,
	4347,
	4348,
	4681,
	4682,
	4686,
	4688,
	4695,
	4696,
	4697,
	4698,
	4702,
	4704,
	4745,
	4746,
	4750,
	4752,
	4785,
	4786,
	4790,
	4792,
	4799,
	4800,
	4801,
	4802,
	4806,
	4808,
	4823,
	4824,
	4881,
	4882,
	4886,
	4888,
	4955,
	4957,
	4960,
	4969,
	4978,
	4992,
	5008,
	5024,
	5110,
	5112,
	5118,
	5121,
	5741,
	5743,
	5760,
	5761,
	5787,
	5792,
	5867,
	5870,
	5881,
	5888,
	5901,
	5902,
	5909,
	5920,
	5941,
	5952,
	5972,
	5984,
	5997,
	5998,
	6001,
	6002,
	6004,
	6016,
	6100,
	6103,
	6104,
	6108,
	6110,
	6112,
	6122,
	6155,
	6158,
	6160,
	6170,
	6176,
	6265,
	6272,
	6315,
	6320,
	6390,
	6400,
	6431,
	6432,
	6444,
	6448,
	6460,
	6470,
	6510,
	6512,
	6517,
	6528,
	6572,
	6576,
	6602,
	6608,
	6619,
	6656,
	6684,
	6688,
	6751,
	6752,
	6781,
	6783,
	6794,
	6800,
	6810,
	6823,
	6824,
	6832,
	6846,
	6912,
	6988,
	6992,
	7002,
	7019,
	7028,
	7040,
	7156,
	7168,
	7224,
	7232,
	7242,
	7245,
	7294,
	7296,
	7305,
	7312,
	7355,
	7357,
	7360,
	7376,
	7379,
	7380,
	7419,
	7424,
	7674,
	7675,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8125,
	8126,
	8127,
	8130,
	8133,
	8134,
	8141,
	8144,
	8148,
	8150,
	8156,
	8160,
	8173,
	8178,
	8181,
	8182,
	8189,
	8255,
	8257,
	8276,
	8277,
	8305,
	8306,
	8319,
	8320,
	8336,
	8349,
	8400,
	8413,
	8417,
	8418,
	8421,
	8433,
	8450,
	8451,
	8455,
	8456,
	8458,
	8468,
	8469,
	8470,
	8472,
	8478,
	8484,
	8485,
	8486,
	8487,
	8488,
	8489,
	8490,
	8506,
	8508,
	8512,
	8517,
	8522,
	8526,
	8527,
	8544,
	8585,
	11264,
	11311,
	11312,
	11359,
	11360,
	11493,
	11499,
	11508,
	11520,
	11558,
	11559,
	11560,
	11565,
	11566,
	11568,
	11624,
	11631,
	11632,
	11647,
	11671,
	11680,
	11687,
	11688,
	11695,
	11696,
	11703,
	11704,
	11711,
	11712,
	11719,
	11720,
	11727,
	11728,
	11735,
	11736,
	11743,
	11744,
	11776,
	12293,
	12296,
	12321,
	12336,
	12337,
	12342,
	12344,
	12349,
	12353,
	12439,
	12441,
	12443,
	12445,
	12448,
	12449,
	12539,
	12540,
	12544,
	12549,
	12592,
	12593,
	12687,
	12704,
	12731,
	12784,
	12800,
	13312,
	19894,
	19968,
	40944,
	40960,
	42125,
	42192,
	42238,
	42240,
	42509,
	42512,
	42540,
	42560,
	42608,
	42612,
	42622,
	42623,
	42738,
	42775,
	42784,
	42786,
	42889,
	42891,
	42944,
	42946,
	42951,
	42999,
	43048,
	43072,
	43124,
	43136,
	43206,
	43216,
	43226,
	43232,
	43256,
	43259,
	43260,
	43261,
	43310,
	43312,
	43348,
	43360,
	43389,
	43392,
	43457,
	43471,
	43482,
	43488,
	43519,
	43520,
	43575,
	43584,
	43598,
	43600,
	43610,
	43616,
	43639,
	43642,
	43715,
	43739,
	43742,
	43744,
	43760,
	43762,
	43767,
	43777,
	43783,
	43785,
	43791,
	43793,
	43799,
	43808,
	43815,
	43816,
	43823,
	43824,
	43867,
	43868,
	43880,
	43888,
	44011,
	44012,
	44014,
	44016,
	44026,
	44032,
	55204,
	55216,
	55239,
	55243,
	55292,
	63744,
	64110,
	64112,
	64218,
	64256,
	64263,
	64275,
	64280,
	64285,
	64297,
	64298,
	64311,
	64312,
	64317,
	64318,
	64319,
	64320,
	64322,
	64323,
	64325,
	64326,
	64434,
	64467,
	64606,
	64612,
	64830,
	64848,
	64912,
	64914,
	64968,
	65008,
	65018,
	65024,
	65040,
	65056,
	65072,
	65075,
	65077,
	65101,
	65104,
	65137,
	65138,
	65139,
	65140,
	65143,
	65144,
	65145,
	65146,
	65147,
	65148,
	65149,
	65150,
	65151,
	65277,
	65296,
	65306,
	65313,
	65339,
	65343,
	65344,
	65345,
	65371,
	65382,
	65471,
	65474,
	65480,
	65482,
	65488,
	65490,
	65496,
	65498,
	65501,
	65536,
	65548,
	65549,
	65575,
	65576,
	65595,
	65596,
	65598,
	65599,
	65614,
	65616,
	65630,
	65664,
	65787,
	65856,
	65909,
	66045,
	66046,
	66176,
	66205,
	66208,
	66257,
	66272,
	66273,
	66304,
	66336,
	66349,
	66379,
	66384,
	66427,
	66432,
	66462,
	66464,
	66500,
	66504,
	66512,
	66513,
	66518,
	66560,
	66718,
	66720,
	66730,
	66736,
	66772,
	66776,
	66812,
	66816,
	66856,
	66864,
	66916,
	67072,
	67383,
	67392,
	67414,
	67424,
	67432,
	67584,
	67590,
	67592,
	67593,
	67594,
	67638,
	67639,
	67641,
	67644,
	67645,
	67647,
	67670,
	67680,
	67703,
	67712,
	67743,
	67808,
	67827,
	67828,
	67830,
	67840,
	67862,
	67872,
	67898,
	67968,
	68024,
	68030,
	68032,
	68096,
	68100,
	68101,
	68103,
	68108,
	68116,
	68117,
	68120,
	68121,
	68150,
	68152,
	68155,
	68159,
	68160,
	68192,
	68221,
	68224,
	68253,
	68288,
	68296,
	68297,
	68327,
	68352,
	68406,
	68416,
	68438,
	68448,
	68467,
	68480,
	68498,
	68608,
	68681,
	68736,
	68787,
	68800,
	68851,
	68864,
	68904,
	68912,
	68922,
	69376,
	69405,
	69415,
	69416,
	69424,
	69457,
	69600,
	69623,
	69632,
	69703,
	69734,
	69744,
	69759,
	69819,
	69840,
	69865,
	69872,
	69882,
	69888,
	69941,
	69942,
	69952,
	69956,
	69959,
	69968,
	70004,
	70006,
	70007,
	70016,
	70085,
	70089,
	70093,
	70096,
	70107,
	70108,
	70109,
	70144,
	70162,
	70163,
	70200,
	70206,
	70207,
	70272,
	70279,
	70280,
	70281,
	70282,
	70286,
	70287,
	70302,
	70303,
	70313,
	70320,
	70379,
	70384,
	70394,
	70400,
	70404,
	70405,
	70413,
	70415,
	70417,
	70419,
	70441,
	70442,
	70449,
	70450,
	70452,
	70453,
	70458,
	70459,
	70469,
	70471,
	70473,
	70475,
	70478,
	70480,
	70481,
	70487,
	70488,
	70493,
	70500,
	70502,
	70509,
	70512,
	70517,
	70656,
	70731,
	70736,
	70746,
	70750,
	70752,
	70784,
	70854,
	70855,
	70856,
	70864,
	70874,
	71040,
	71094,
	71096,
	71105,
	71128,
	71134,
	71168,
	71233,
	71236,
	71237,
	71248,
	71258,
	71296,
	71353,
	71360,
	71370,
	71424,
	71451,
	71453,
	71468,
	71472,
	71482,
	71680,
	71739,
	71840,
	71914,
	71935,
	71936,
	72096,
	72104,
	72106,
	72152,
	72154,
	72162,
	72163,
	72165,
	72192,
	72255,
	72263,
	72264,
	72272,
	72346,
	72349,
	72350,
	72384,
	72441,
	72704,
	72713,
	72714,
	72759,
	72760,
	72769,
	72784,
	72794,
	72818,
	72848,
	72850,
	72872,
	72873,
	72887,
	72960,
	72967,
	72968,
	72970,
	72971,
	73015,
	73018,
	73019,
	73020,
	73022,
	73023,
	73032,
	73040,
	73050,
	73056,
	73062,
	73063,
	73065,
	73066,
	73103,
	73104,
	73106,
	73107,
	73113,
	73120,
	73130,
	73440,
	73463,
	73728,
	74650,
	74752,
	74863,
	74880,
	75076,
	77824,
	78895,
	82944,
	83527,
	92160,
	92729,
	92736,
	92767,
	92768,
	92778,
	92880,
	92910,
	92912,
	92917,
	92928,
	92983,
	92992,
	92996,
	93008,
	93018,
	93027,
	93048,
	93053,
	93072,
	93760,
	93824,
	93952,
	94027,
	94031,
	94088,
	94095,
	94112,
	94176,
	94178,
	94179,
	94180,
	94208,
	100344,
	100352,
	101107,
	110592,
	110879,
	110928,
	110931,
	110948,
	110952,
	110960,
	111356,
	113664,
	113771,
	113776,
	113789,
	113792,
	113801,
	113808,
	113818,
	113821,
	113823,
	119141,
	119146,
	119149,
	119155,
	119163,
	119171,
	119173,
	119180,
	119210,
	119214,
	119362,
	119365,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120513,
	120514,
	120539,
	120540,
	120571,
	120572,
	120597,
	120598,
	120629,
	120630,
	120655,
	120656,
	120687,
	120688,
	120713,
	120714,
	120745,
	120746,
	120771,
	120772,
	120780,
	120782,
	120832,
	121344,
	121399,
	121403,
	121453,
	121461,
	121462,
	121476,
	121477,
	121499,
	121504,
	121505,
	121520,
	122880,
	122887,
	122888,
	122905,
	122907,
	122914,
	122915,
	122917,
	122918,
	122923,
	123136,
	123181,
	123184,
	123198,
	123200,
	123210,
	123214,
	123215,
	123584,
	123642,
	124928,
	125125,
	125136,
	125143,
	125184,
	125260,
	125264,
	125274,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457,
	194560,
	195102,
	917760,
	918000
]);
property.set("XID_Start", [
	65,
	91,
	97,
	123,
	170,
	171,
	181,
	182,
	186,
	187,
	192,
	215,
	216,
	247,
	248,
	706,
	710,
	722,
	736,
	741,
	748,
	749,
	750,
	751,
	880,
	885,
	886,
	888,
	891,
	894,
	895,
	896,
	902,
	903,
	904,
	907,
	908,
	909,
	910,
	930,
	931,
	1014,
	1015,
	1154,
	1162,
	1328,
	1329,
	1367,
	1369,
	1370,
	1376,
	1417,
	1488,
	1515,
	1519,
	1523,
	1568,
	1611,
	1646,
	1648,
	1649,
	1748,
	1749,
	1750,
	1765,
	1767,
	1774,
	1776,
	1786,
	1789,
	1791,
	1792,
	1808,
	1809,
	1810,
	1840,
	1869,
	1958,
	1969,
	1970,
	1994,
	2027,
	2036,
	2038,
	2042,
	2043,
	2048,
	2070,
	2074,
	2075,
	2084,
	2085,
	2088,
	2089,
	2112,
	2137,
	2144,
	2155,
	2208,
	2229,
	2230,
	2238,
	2308,
	2362,
	2365,
	2366,
	2384,
	2385,
	2392,
	2402,
	2417,
	2433,
	2437,
	2445,
	2447,
	2449,
	2451,
	2473,
	2474,
	2481,
	2482,
	2483,
	2486,
	2490,
	2493,
	2494,
	2510,
	2511,
	2524,
	2526,
	2527,
	2530,
	2544,
	2546,
	2556,
	2557,
	2565,
	2571,
	2575,
	2577,
	2579,
	2601,
	2602,
	2609,
	2610,
	2612,
	2613,
	2615,
	2616,
	2618,
	2649,
	2653,
	2654,
	2655,
	2674,
	2677,
	2693,
	2702,
	2703,
	2706,
	2707,
	2729,
	2730,
	2737,
	2738,
	2740,
	2741,
	2746,
	2749,
	2750,
	2768,
	2769,
	2784,
	2786,
	2809,
	2810,
	2821,
	2829,
	2831,
	2833,
	2835,
	2857,
	2858,
	2865,
	2866,
	2868,
	2869,
	2874,
	2877,
	2878,
	2908,
	2910,
	2911,
	2914,
	2929,
	2930,
	2947,
	2948,
	2949,
	2955,
	2958,
	2961,
	2962,
	2966,
	2969,
	2971,
	2972,
	2973,
	2974,
	2976,
	2979,
	2981,
	2984,
	2987,
	2990,
	3002,
	3024,
	3025,
	3077,
	3085,
	3086,
	3089,
	3090,
	3113,
	3114,
	3130,
	3133,
	3134,
	3160,
	3163,
	3168,
	3170,
	3200,
	3201,
	3205,
	3213,
	3214,
	3217,
	3218,
	3241,
	3242,
	3252,
	3253,
	3258,
	3261,
	3262,
	3294,
	3295,
	3296,
	3298,
	3313,
	3315,
	3333,
	3341,
	3342,
	3345,
	3346,
	3387,
	3389,
	3390,
	3406,
	3407,
	3412,
	3415,
	3423,
	3426,
	3450,
	3456,
	3461,
	3479,
	3482,
	3506,
	3507,
	3516,
	3517,
	3518,
	3520,
	3527,
	3585,
	3633,
	3634,
	3635,
	3648,
	3655,
	3713,
	3715,
	3716,
	3717,
	3718,
	3723,
	3724,
	3748,
	3749,
	3750,
	3751,
	3761,
	3762,
	3763,
	3773,
	3774,
	3776,
	3781,
	3782,
	3783,
	3804,
	3808,
	3840,
	3841,
	3904,
	3912,
	3913,
	3949,
	3976,
	3981,
	4096,
	4139,
	4159,
	4160,
	4176,
	4182,
	4186,
	4190,
	4193,
	4194,
	4197,
	4199,
	4206,
	4209,
	4213,
	4226,
	4238,
	4239,
	4256,
	4294,
	4295,
	4296,
	4301,
	4302,
	4304,
	4347,
	4348,
	4681,
	4682,
	4686,
	4688,
	4695,
	4696,
	4697,
	4698,
	4702,
	4704,
	4745,
	4746,
	4750,
	4752,
	4785,
	4786,
	4790,
	4792,
	4799,
	4800,
	4801,
	4802,
	4806,
	4808,
	4823,
	4824,
	4881,
	4882,
	4886,
	4888,
	4955,
	4992,
	5008,
	5024,
	5110,
	5112,
	5118,
	5121,
	5741,
	5743,
	5760,
	5761,
	5787,
	5792,
	5867,
	5870,
	5881,
	5888,
	5901,
	5902,
	5906,
	5920,
	5938,
	5952,
	5970,
	5984,
	5997,
	5998,
	6001,
	6016,
	6068,
	6103,
	6104,
	6108,
	6109,
	6176,
	6265,
	6272,
	6313,
	6314,
	6315,
	6320,
	6390,
	6400,
	6431,
	6480,
	6510,
	6512,
	6517,
	6528,
	6572,
	6576,
	6602,
	6656,
	6679,
	6688,
	6741,
	6823,
	6824,
	6917,
	6964,
	6981,
	6988,
	7043,
	7073,
	7086,
	7088,
	7098,
	7142,
	7168,
	7204,
	7245,
	7248,
	7258,
	7294,
	7296,
	7305,
	7312,
	7355,
	7357,
	7360,
	7401,
	7405,
	7406,
	7412,
	7413,
	7415,
	7418,
	7419,
	7424,
	7616,
	7680,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8125,
	8126,
	8127,
	8130,
	8133,
	8134,
	8141,
	8144,
	8148,
	8150,
	8156,
	8160,
	8173,
	8178,
	8181,
	8182,
	8189,
	8305,
	8306,
	8319,
	8320,
	8336,
	8349,
	8450,
	8451,
	8455,
	8456,
	8458,
	8468,
	8469,
	8470,
	8472,
	8478,
	8484,
	8485,
	8486,
	8487,
	8488,
	8489,
	8490,
	8506,
	8508,
	8512,
	8517,
	8522,
	8526,
	8527,
	8544,
	8585,
	11264,
	11311,
	11312,
	11359,
	11360,
	11493,
	11499,
	11503,
	11506,
	11508,
	11520,
	11558,
	11559,
	11560,
	11565,
	11566,
	11568,
	11624,
	11631,
	11632,
	11648,
	11671,
	11680,
	11687,
	11688,
	11695,
	11696,
	11703,
	11704,
	11711,
	11712,
	11719,
	11720,
	11727,
	11728,
	11735,
	11736,
	11743,
	12293,
	12296,
	12321,
	12330,
	12337,
	12342,
	12344,
	12349,
	12353,
	12439,
	12445,
	12448,
	12449,
	12539,
	12540,
	12544,
	12549,
	12592,
	12593,
	12687,
	12704,
	12731,
	12784,
	12800,
	13312,
	19894,
	19968,
	40944,
	40960,
	42125,
	42192,
	42238,
	42240,
	42509,
	42512,
	42528,
	42538,
	42540,
	42560,
	42607,
	42623,
	42654,
	42656,
	42736,
	42775,
	42784,
	42786,
	42889,
	42891,
	42944,
	42946,
	42951,
	42999,
	43010,
	43011,
	43014,
	43015,
	43019,
	43020,
	43043,
	43072,
	43124,
	43138,
	43188,
	43250,
	43256,
	43259,
	43260,
	43261,
	43263,
	43274,
	43302,
	43312,
	43335,
	43360,
	43389,
	43396,
	43443,
	43471,
	43472,
	43488,
	43493,
	43494,
	43504,
	43514,
	43519,
	43520,
	43561,
	43584,
	43587,
	43588,
	43596,
	43616,
	43639,
	43642,
	43643,
	43646,
	43696,
	43697,
	43698,
	43701,
	43703,
	43705,
	43710,
	43712,
	43713,
	43714,
	43715,
	43739,
	43742,
	43744,
	43755,
	43762,
	43765,
	43777,
	43783,
	43785,
	43791,
	43793,
	43799,
	43808,
	43815,
	43816,
	43823,
	43824,
	43867,
	43868,
	43880,
	43888,
	44003,
	44032,
	55204,
	55216,
	55239,
	55243,
	55292,
	63744,
	64110,
	64112,
	64218,
	64256,
	64263,
	64275,
	64280,
	64285,
	64286,
	64287,
	64297,
	64298,
	64311,
	64312,
	64317,
	64318,
	64319,
	64320,
	64322,
	64323,
	64325,
	64326,
	64434,
	64467,
	64606,
	64612,
	64830,
	64848,
	64912,
	64914,
	64968,
	65008,
	65018,
	65137,
	65138,
	65139,
	65140,
	65143,
	65144,
	65145,
	65146,
	65147,
	65148,
	65149,
	65150,
	65151,
	65277,
	65313,
	65339,
	65345,
	65371,
	65382,
	65438,
	65440,
	65471,
	65474,
	65480,
	65482,
	65488,
	65490,
	65496,
	65498,
	65501,
	65536,
	65548,
	65549,
	65575,
	65576,
	65595,
	65596,
	65598,
	65599,
	65614,
	65616,
	65630,
	65664,
	65787,
	65856,
	65909,
	66176,
	66205,
	66208,
	66257,
	66304,
	66336,
	66349,
	66379,
	66384,
	66422,
	66432,
	66462,
	66464,
	66500,
	66504,
	66512,
	66513,
	66518,
	66560,
	66718,
	66736,
	66772,
	66776,
	66812,
	66816,
	66856,
	66864,
	66916,
	67072,
	67383,
	67392,
	67414,
	67424,
	67432,
	67584,
	67590,
	67592,
	67593,
	67594,
	67638,
	67639,
	67641,
	67644,
	67645,
	67647,
	67670,
	67680,
	67703,
	67712,
	67743,
	67808,
	67827,
	67828,
	67830,
	67840,
	67862,
	67872,
	67898,
	67968,
	68024,
	68030,
	68032,
	68096,
	68097,
	68112,
	68116,
	68117,
	68120,
	68121,
	68150,
	68192,
	68221,
	68224,
	68253,
	68288,
	68296,
	68297,
	68325,
	68352,
	68406,
	68416,
	68438,
	68448,
	68467,
	68480,
	68498,
	68608,
	68681,
	68736,
	68787,
	68800,
	68851,
	68864,
	68900,
	69376,
	69405,
	69415,
	69416,
	69424,
	69446,
	69600,
	69623,
	69635,
	69688,
	69763,
	69808,
	69840,
	69865,
	69891,
	69927,
	69956,
	69957,
	69968,
	70003,
	70006,
	70007,
	70019,
	70067,
	70081,
	70085,
	70106,
	70107,
	70108,
	70109,
	70144,
	70162,
	70163,
	70188,
	70272,
	70279,
	70280,
	70281,
	70282,
	70286,
	70287,
	70302,
	70303,
	70313,
	70320,
	70367,
	70405,
	70413,
	70415,
	70417,
	70419,
	70441,
	70442,
	70449,
	70450,
	70452,
	70453,
	70458,
	70461,
	70462,
	70480,
	70481,
	70493,
	70498,
	70656,
	70709,
	70727,
	70731,
	70751,
	70752,
	70784,
	70832,
	70852,
	70854,
	70855,
	70856,
	71040,
	71087,
	71128,
	71132,
	71168,
	71216,
	71236,
	71237,
	71296,
	71339,
	71352,
	71353,
	71424,
	71451,
	71680,
	71724,
	71840,
	71904,
	71935,
	71936,
	72096,
	72104,
	72106,
	72145,
	72161,
	72162,
	72163,
	72164,
	72192,
	72193,
	72203,
	72243,
	72250,
	72251,
	72272,
	72273,
	72284,
	72330,
	72349,
	72350,
	72384,
	72441,
	72704,
	72713,
	72714,
	72751,
	72768,
	72769,
	72818,
	72848,
	72960,
	72967,
	72968,
	72970,
	72971,
	73009,
	73030,
	73031,
	73056,
	73062,
	73063,
	73065,
	73066,
	73098,
	73112,
	73113,
	73440,
	73459,
	73728,
	74650,
	74752,
	74863,
	74880,
	75076,
	77824,
	78895,
	82944,
	83527,
	92160,
	92729,
	92736,
	92767,
	92880,
	92910,
	92928,
	92976,
	92992,
	92996,
	93027,
	93048,
	93053,
	93072,
	93760,
	93824,
	93952,
	94027,
	94032,
	94033,
	94099,
	94112,
	94176,
	94178,
	94179,
	94180,
	94208,
	100344,
	100352,
	101107,
	110592,
	110879,
	110928,
	110931,
	110948,
	110952,
	110960,
	111356,
	113664,
	113771,
	113776,
	113789,
	113792,
	113801,
	113808,
	113818,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120513,
	120514,
	120539,
	120540,
	120571,
	120572,
	120597,
	120598,
	120629,
	120630,
	120655,
	120656,
	120687,
	120688,
	120713,
	120714,
	120745,
	120746,
	120771,
	120772,
	120780,
	123136,
	123181,
	123191,
	123198,
	123214,
	123215,
	123584,
	123628,
	124928,
	125125,
	125184,
	125252,
	125259,
	125260,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457,
	194560,
	195102
]);

export const script: Map<string, number[]> = new Map();
export const scriptExtensions: Map<string, number[]> = new Map();
script.set("Adlam", [125184, 125260, 125264, 125274, 125278, 125280]);
scriptExtensions.set("Adlam", [1600, 1601]);
script.set("Ahom", [71424, 71451, 71453, 71468, 71472, 71488]);
scriptExtensions.set("Ahom", []);
script.set("Anatolian_Hieroglyphs", [82944, 83527]);
scriptExtensions.set("Anatolian_Hieroglyphs", []);
script.set("Arabic", [
	1536,
	1541,
	1542,
	1548,
	1549,
	1563,
	1564,
	1565,
	1566,
	1567,
	1568,
	1600,
	1601,
	1611,
	1622,
	1648,
	1649,
	1757,
	1758,
	1792,
	1872,
	1920,
	2208,
	2229,
	2230,
	2238,
	2259,
	2274,
	2275,
	2304,
	64336,
	64450,
	64467,
	64830,
	64848,
	64912,
	64914,
	64968,
	65008,
	65022,
	65136,
	65141,
	65142,
	65277,
	69216,
	69247,
	126464,
	126468,
	126469,
	126496,
	126497,
	126499,
	126500,
	126501,
	126503,
	126504,
	126505,
	126515,
	126516,
	126520,
	126521,
	126522,
	126523,
	126524,
	126530,
	126531,
	126535,
	126536,
	126537,
	126538,
	126539,
	126540,
	126541,
	126544,
	126545,
	126547,
	126548,
	126549,
	126551,
	126552,
	126553,
	126554,
	126555,
	126556,
	126557,
	126558,
	126559,
	126560,
	126561,
	126563,
	126564,
	126565,
	126567,
	126571,
	126572,
	126579,
	126580,
	126584,
	126585,
	126589,
	126590,
	126591,
	126592,
	126602,
	126603,
	126620,
	126625,
	126628,
	126629,
	126634,
	126635,
	126652,
	126704,
	126706
]);
scriptExtensions.set("Arabic", [1548, 1549, 1563, 1564, 1567, 1568, 1600, 1601, 1611, 1622, 1648, 1649, 66272, 66300]);
script.set("Armenian", [1329, 1367, 1369, 1417, 1418, 1419, 1421, 1424, 64275, 64280]);
scriptExtensions.set("Armenian", [1417, 1418]);
script.set("Avestan", [68352, 68406, 68409, 68416]);
scriptExtensions.set("Avestan", []);
script.set("Balinese", [6912, 6988, 6992, 7037]);
scriptExtensions.set("Balinese", []);
script.set("Bamum", [42656, 42744, 92160, 92729]);
scriptExtensions.set("Bamum", []);
script.set("Bassa_Vah", [92880, 92910, 92912, 92918]);
scriptExtensions.set("Bassa_Vah", []);
script.set("Batak", [7104, 7156, 7164, 7168]);
scriptExtensions.set("Batak", []);
script.set("Bengali", [
	2432,
	2436,
	2437,
	2445,
	2447,
	2449,
	2451,
	2473,
	2474,
	2481,
	2482,
	2483,
	2486,
	2490,
	2492,
	2501,
	2503,
	2505,
	2507,
	2511,
	2519,
	2520,
	2524,
	2526,
	2527,
	2532,
	2534,
	2559
]);
scriptExtensions.set("Bengali", [2385, 2387, 2404, 2406, 7376, 7377, 7378, 7379, 7381, 7383, 7384, 7385, 7393, 7394, 7402, 7403, 7405, 7406, 7410, 7411, 7413, 7416, 43249, 43250]);
script.set("Bhaiksuki", [72704, 72713, 72714, 72759, 72760, 72774, 72784, 72813]);
scriptExtensions.set("Bhaiksuki", []);
script.set("Bopomofo", [746, 748, 12549, 12592, 12704, 12731]);
scriptExtensions.set("Bopomofo", [12289, 12292, 12296, 12306, 12307, 12320, 12330, 12334, 12336, 12337, 12343, 12344, 12539, 12540, 65093, 65095, 65377, 65382]);
script.set("Brahmi", [69632, 69710, 69714, 69744, 69759, 69760]);
scriptExtensions.set("Brahmi", []);
script.set("Braille", [10240, 10496]);
scriptExtensions.set("Braille", []);
script.set("Buginese", [6656, 6684, 6686, 6688]);
scriptExtensions.set("Buginese", [43471, 43472]);
script.set("Buhid", [5952, 5972]);
scriptExtensions.set("Buhid", [5941, 5943]);
script.set("Canadian_Aboriginal", [5120, 5760, 6320, 6390]);
scriptExtensions.set("Canadian_Aboriginal", []);
script.set("Carian", [66208, 66257]);
scriptExtensions.set("Carian", []);
script.set("Caucasian_Albanian", [66864, 66916, 66927, 66928]);
scriptExtensions.set("Caucasian_Albanian", []);
script.set("Chakma", [69888, 69941, 69942, 69959]);
scriptExtensions.set("Chakma", [2534, 2544, 4160, 4170]);
script.set("Cham", [43520, 43575, 43584, 43598, 43600, 43610, 43612, 43616]);
scriptExtensions.set("Cham", []);
script.set("Cherokee", [5024, 5110, 5112, 5118, 43888, 43968]);
scriptExtensions.set("Cherokee", []);
script.set("Common", [
	0,
	65,
	91,
	97,
	123,
	170,
	171,
	186,
	187,
	192,
	215,
	216,
	247,
	248,
	697,
	736,
	741,
	746,
	748,
	768,
	884,
	885,
	894,
	895,
	901,
	902,
	903,
	904,
	1417,
	1418,
	1541,
	1542,
	1548,
	1549,
	1563,
	1564,
	1567,
	1568,
	1600,
	1601,
	1757,
	1758,
	2274,
	2275,
	2404,
	2406,
	3647,
	3648,
	4053,
	4057,
	4347,
	4348,
	5867,
	5870,
	5941,
	5943,
	6146,
	6148,
	6149,
	6150,
	7379,
	7380,
	7393,
	7394,
	7401,
	7405,
	7406,
	7412,
	7413,
	7416,
	7418,
	7419,
	8192,
	8204,
	8206,
	8293,
	8294,
	8305,
	8308,
	8319,
	8320,
	8335,
	8352,
	8384,
	8448,
	8486,
	8487,
	8490,
	8492,
	8498,
	8499,
	8526,
	8527,
	8544,
	8585,
	8588,
	8592,
	9255,
	9280,
	9291,
	9312,
	10240,
	10496,
	11124,
	11126,
	11158,
	11160,
	11264,
	11776,
	11856,
	12272,
	12284,
	12288,
	12293,
	12294,
	12295,
	12296,
	12321,
	12336,
	12344,
	12348,
	12352,
	12443,
	12445,
	12448,
	12449,
	12539,
	12541,
	12688,
	12704,
	12736,
	12772,
	12832,
	12896,
	12927,
	13008,
	13144,
	13312,
	19904,
	19968,
	42752,
	42786,
	42888,
	42891,
	43056,
	43066,
	43310,
	43311,
	43471,
	43472,
	43867,
	43868,
	64830,
	64832,
	65040,
	65050,
	65072,
	65107,
	65108,
	65127,
	65128,
	65132,
	65279,
	65280,
	65281,
	65313,
	65339,
	65345,
	65371,
	65382,
	65392,
	65393,
	65438,
	65440,
	65504,
	65511,
	65512,
	65519,
	65529,
	65534,
	65792,
	65795,
	65799,
	65844,
	65847,
	65856,
	65936,
	65948,
	66000,
	66045,
	66273,
	66300,
	94178,
	94180,
	113824,
	113828,
	118784,
	119030,
	119040,
	119079,
	119081,
	119143,
	119146,
	119163,
	119171,
	119173,
	119180,
	119210,
	119214,
	119273,
	119520,
	119540,
	119552,
	119639,
	119648,
	119673,
	119808,
	119893,
	119894,
	119965,
	119966,
	119968,
	119970,
	119971,
	119973,
	119975,
	119977,
	119981,
	119982,
	119994,
	119995,
	119996,
	119997,
	120004,
	120005,
	120070,
	120071,
	120075,
	120077,
	120085,
	120086,
	120093,
	120094,
	120122,
	120123,
	120127,
	120128,
	120133,
	120134,
	120135,
	120138,
	120145,
	120146,
	120486,
	120488,
	120780,
	120782,
	120832,
	126065,
	126133,
	126209,
	126270,
	126976,
	127020,
	127024,
	127124,
	127136,
	127151,
	127153,
	127168,
	127169,
	127184,
	127185,
	127222,
	127232,
	127245,
	127248,
	127341,
	127344,
	127405,
	127462,
	127488,
	127489,
	127491,
	127504,
	127548,
	127552,
	127561,
	127568,
	127570,
	127584,
	127590,
	127744,
	128726,
	128736,
	128749,
	128752,
	128763,
	128768,
	128884,
	128896,
	128985,
	128992,
	129004,
	129024,
	129036,
	129040,
	129096,
	129104,
	129114,
	129120,
	129160,
	129168,
	129198,
	129280,
	129292,
	129293,
	129394,
	129395,
	129399,
	129402,
	129443,
	129445,
	129451,
	129454,
	129483,
	129485,
	129620,
	129632,
	129646,
	129648,
	129652,
	129656,
	129659,
	129664,
	129667,
	129680,
	129686,
	917505,
	917506,
	917536,
	917632
]);
scriptExtensions.set("Common", []);
script.set("Coptic", [994, 1008, 11392, 11508, 11513, 11520]);
scriptExtensions.set("Coptic", [66272, 66300]);
script.set("Cuneiform", [73728, 74650, 74752, 74863, 74864, 74869, 74880, 75076]);
scriptExtensions.set("Cuneiform", []);
script.set("Cypriot", [67584, 67590, 67592, 67593, 67594, 67638, 67639, 67641, 67644, 67645, 67647, 67648]);
scriptExtensions.set("Cypriot", [65792, 65795, 65799, 65844, 65847, 65856]);
script.set("Cyrillic", [1024, 1157, 1159, 1328, 7296, 7305, 7467, 7468, 7544, 7545, 11744, 11776, 42560, 42656, 65070, 65072]);
scriptExtensions.set("Cyrillic", [1157, 1159, 11843, 11844]);
script.set("Deseret", [66560, 66640]);
scriptExtensions.set("Deseret", []);
script.set("Devanagari", [2304, 2385, 2389, 2404, 2406, 2432, 43232, 43264]);
scriptExtensions.set("Devanagari", [2385, 2387, 2404, 2406, 7376, 7415, 7416, 7418, 8432, 8433, 43056, 43066]);
script.set("Dogra", [71680, 71740]);
scriptExtensions.set("Dogra", [2404, 2416, 43056, 43066]);
script.set("Duployan", [113664, 113771, 113776, 113789, 113792, 113801, 113808, 113818, 113820, 113824]);
scriptExtensions.set("Duployan", [113824, 113828]);
script.set("Egyptian_Hieroglyphs", [77824, 78895, 78896, 78905]);
scriptExtensions.set("Egyptian_Hieroglyphs", []);
script.set("Elbasan", [66816, 66856]);
scriptExtensions.set("Elbasan", []);
script.set("Ethiopic", [
	4608,
	4681,
	4682,
	4686,
	4688,
	4695,
	4696,
	4697,
	4698,
	4702,
	4704,
	4745,
	4746,
	4750,
	4752,
	4785,
	4786,
	4790,
	4792,
	4799,
	4800,
	4801,
	4802,
	4806,
	4808,
	4823,
	4824,
	4881,
	4882,
	4886,
	4888,
	4955,
	4957,
	4989,
	4992,
	5018,
	11648,
	11671,
	11680,
	11687,
	11688,
	11695,
	11696,
	11703,
	11704,
	11711,
	11712,
	11719,
	11720,
	11727,
	11728,
	11735,
	11736,
	11743,
	43777,
	43783,
	43785,
	43791,
	43793,
	43799,
	43808,
	43815,
	43816,
	43823
]);
scriptExtensions.set("Ethiopic", []);
script.set("Georgian", [4256, 4294, 4295, 4296, 4301, 4302, 4304, 4347, 4348, 4352, 7312, 7355, 7357, 7360, 11520, 11558, 11559, 11560, 11565, 11566]);
scriptExtensions.set("Georgian", [1417, 1418, 4347, 4348]);
script.set("Glagolitic", [11264, 11311, 11312, 11359, 122880, 122887, 122888, 122905, 122907, 122914, 122915, 122917, 122918, 122923]);
scriptExtensions.set("Glagolitic", [1156, 1157, 1159, 1160, 11843, 11844, 42607, 42608]);
script.set("Gothic", [66352, 66379]);
scriptExtensions.set("Gothic", []);
script.set("Grantha", [
	70400,
	70404,
	70405,
	70413,
	70415,
	70417,
	70419,
	70441,
	70442,
	70449,
	70450,
	70452,
	70453,
	70458,
	70460,
	70469,
	70471,
	70473,
	70475,
	70478,
	70480,
	70481,
	70487,
	70488,
	70493,
	70500,
	70502,
	70509,
	70512,
	70517
]);
scriptExtensions.set("Grantha", [2385, 2387, 2404, 2406, 3046, 3060, 7376, 7377, 7378, 7380, 7410, 7413, 7416, 7418, 8432, 8433, 70459, 70460, 73680, 73682, 73683, 73684]);
script.set("Greek", [
	880,
	884,
	885,
	888,
	890,
	894,
	895,
	896,
	900,
	901,
	902,
	903,
	904,
	907,
	908,
	909,
	910,
	930,
	931,
	994,
	1008,
	1024,
	7462,
	7467,
	7517,
	7522,
	7526,
	7531,
	7615,
	7616,
	7936,
	7958,
	7960,
	7966,
	7968,
	8006,
	8008,
	8014,
	8016,
	8024,
	8025,
	8026,
	8027,
	8028,
	8029,
	8030,
	8031,
	8062,
	8064,
	8117,
	8118,
	8133,
	8134,
	8148,
	8150,
	8156,
	8157,
	8176,
	8178,
	8181,
	8182,
	8191,
	8486,
	8487,
	43877,
	43878,
	65856,
	65935,
	65952,
	65953,
	119296,
	119366
]);
scriptExtensions.set("Greek", [834, 835, 837, 838, 7616, 7618]);
script.set("Gujarati", [
	2689,
	2692,
	2693,
	2702,
	2703,
	2706,
	2707,
	2729,
	2730,
	2737,
	2738,
	2740,
	2741,
	2746,
	2748,
	2758,
	2759,
	2762,
	2763,
	2766,
	2768,
	2769,
	2784,
	2788,
	2790,
	2802,
	2809,
	2816
]);
scriptExtensions.set("Gujarati", [2385, 2387, 2404, 2406, 43056, 43066]);
script.set("Gunjala_Gondi", [73056, 73062, 73063, 73065, 73066, 73103, 73104, 73106, 73107, 73113, 73120, 73130]);
scriptExtensions.set("Gunjala_Gondi", [2404, 2406]);
script.set("Gurmukhi", [
	2561,
	2564,
	2565,
	2571,
	2575,
	2577,
	2579,
	2601,
	2602,
	2609,
	2610,
	2612,
	2613,
	2615,
	2616,
	2618,
	2620,
	2621,
	2622,
	2627,
	2631,
	2633,
	2635,
	2638,
	2641,
	2642,
	2649,
	2653,
	2654,
	2655,
	2662,
	2679
]);
scriptExtensions.set("Gurmukhi", [2385, 2387, 2404, 2406, 43056, 43066]);
script.set("Han", [
	11904,
	11930,
	11931,
	12020,
	12032,
	12246,
	12293,
	12294,
	12295,
	12296,
	12321,
	12330,
	12344,
	12348,
	13312,
	19894,
	19968,
	40944,
	63744,
	64110,
	64112,
	64218,
	131072,
	173783,
	173824,
	177973,
	177984,
	178206,
	178208,
	183970,
	183984,
	191457,
	194560,
	195102
]);
scriptExtensions.set("Han", [
	12289,
	12292,
	12294,
	12295,
	12296,
	12306,
	12307,
	12320,
	12330,
	12334,
	12336,
	12337,
	12343,
	12344,
	12348,
	12352,
	12539,
	12540,
	12688,
	12704,
	12736,
	12772,
	12832,
	12872,
	12928,
	12977,
	12992,
	13004,
	13144,
	13169,
	13179,
	13184,
	13280,
	13311,
	65093,
	65095,
	65377,
	65382,
	119648,
	119666,
	127568,
	127570
]);
script.set("Hangul", [
	4352,
	4608,
	12334,
	12336,
	12593,
	12687,
	12800,
	12831,
	12896,
	12927,
	43360,
	43389,
	44032,
	55204,
	55216,
	55239,
	55243,
	55292,
	65440,
	65471,
	65474,
	65480,
	65482,
	65488,
	65490,
	65496,
	65498,
	65501
]);
scriptExtensions.set("Hangul", [12289, 12292, 12296, 12306, 12307, 12320, 12336, 12337, 12343, 12344, 12539, 12540, 65093, 65095, 65377, 65382]);
script.set("Hanifi_Rohingya", [68864, 68904, 68912, 68922]);
scriptExtensions.set("Hanifi_Rohingya", [1548, 1549, 1563, 1564, 1567, 1568, 1600, 1601, 1748, 1749]);
script.set("Hanunoo", [5920, 5941]);
scriptExtensions.set("Hanunoo", [5941, 5943]);
script.set("Hatran", [67808, 67827, 67828, 67830, 67835, 67840]);
scriptExtensions.set("Hatran", []);
script.set("Hebrew", [1425, 1480, 1488, 1515, 1519, 1525, 64285, 64311, 64312, 64317, 64318, 64319, 64320, 64322, 64323, 64325, 64326, 64336]);
scriptExtensions.set("Hebrew", []);
script.set("Hiragana", [12353, 12439, 12445, 12448, 110593, 110879, 110928, 110931, 127488, 127489]);
scriptExtensions.set("Hiragana", [
	12289,
	12292,
	12296,
	12306,
	12307,
	12320,
	12336,
	12342,
	12343,
	12344,
	12348,
	12350,
	12441,
	12445,
	12448,
	12449,
	12539,
	12541,
	65093,
	65095,
	65377,
	65382,
	65392,
	65393,
	65438,
	65440
]);
script.set("Imperial_Aramaic", [67648, 67670, 67671, 67680]);
scriptExtensions.set("Imperial_Aramaic", []);
script.set("Inherited", [
	768,
	880,
	1157,
	1159,
	1611,
	1622,
	1648,
	1649,
	2385,
	2389,
	6832,
	6847,
	7376,
	7379,
	7380,
	7393,
	7394,
	7401,
	7405,
	7406,
	7412,
	7413,
	7416,
	7418,
	7616,
	7674,
	7675,
	7680,
	8204,
	8206,
	8400,
	8433,
	12330,
	12334,
	12441,
	12443,
	65024,
	65040,
	65056,
	65070,
	66045,
	66046,
	66272,
	66273,
	70459,
	70460,
	119143,
	119146,
	119163,
	119171,
	119173,
	119180,
	119210,
	119214,
	917760,
	918000
]);
scriptExtensions.set("Inherited", []);
script.set("Inscriptional_Pahlavi", [68448, 68467, 68472, 68480]);
scriptExtensions.set("Inscriptional_Pahlavi", []);
script.set("Inscriptional_Parthian", [68416, 68438, 68440, 68448]);
scriptExtensions.set("Inscriptional_Parthian", []);
script.set("Javanese", [43392, 43470, 43472, 43482, 43486, 43488]);
scriptExtensions.set("Javanese", [43471, 43472]);
script.set("Kaithi", [69760, 69826, 69837, 69838]);
scriptExtensions.set("Kaithi", [2406, 2416, 43056, 43066]);
script.set("Kannada", [3200, 3213, 3214, 3217, 3218, 3241, 3242, 3252, 3253, 3258, 3260, 3269, 3270, 3273, 3274, 3278, 3285, 3287, 3294, 3295, 3296, 3300, 3302, 3312, 3313, 3315]);
scriptExtensions.set("Kannada", [2385, 2387, 2404, 2406, 7376, 7377, 7378, 7379, 7386, 7387, 7410, 7411, 7412, 7413, 43056, 43062]);
script.set("Katakana", [12449, 12539, 12541, 12544, 12784, 12800, 13008, 13055, 13056, 13144, 65382, 65392, 65393, 65438, 110592, 110593, 110948, 110952]);
scriptExtensions.set("Katakana", [
	12289,
	12292,
	12296,
	12306,
	12307,
	12320,
	12336,
	12342,
	12343,
	12344,
	12348,
	12350,
	12441,
	12445,
	12448,
	12449,
	12539,
	12541,
	65093,
	65095,
	65377,
	65382,
	65392,
	65393,
	65438,
	65440
]);
script.set("Kayah_Li", [43264, 43310, 43311, 43312]);
scriptExtensions.set("Kayah_Li", [43310, 43311]);
script.set("Kharoshthi", [68096, 68100, 68101, 68103, 68108, 68116, 68117, 68120, 68121, 68150, 68152, 68155, 68159, 68169, 68176, 68185]);
scriptExtensions.set("Kharoshthi", []);
script.set("Khmer", [6016, 6110, 6112, 6122, 6128, 6138, 6624, 6656]);
scriptExtensions.set("Khmer", []);
script.set("Khojki", [70144, 70162, 70163, 70207]);
scriptExtensions.set("Khojki", [2790, 2800, 43056, 43066]);
script.set("Khudawadi", [70320, 70379, 70384, 70394]);
scriptExtensions.set("Khudawadi", [2404, 2406, 43056, 43066]);
script.set("Lao", [3713, 3715, 3716, 3717, 3718, 3723, 3724, 3748, 3749, 3750, 3751, 3774, 3776, 3781, 3782, 3783, 3784, 3790, 3792, 3802, 3804, 3808]);
scriptExtensions.set("Lao", []);
script.set("Latin", [
	65,
	91,
	97,
	123,
	170,
	171,
	186,
	187,
	192,
	215,
	216,
	247,
	248,
	697,
	736,
	741,
	7424,
	7462,
	7468,
	7517,
	7522,
	7526,
	7531,
	7544,
	7545,
	7615,
	7680,
	7936,
	8305,
	8306,
	8319,
	8320,
	8336,
	8349,
	8490,
	8492,
	8498,
	8499,
	8526,
	8527,
	8544,
	8585,
	11360,
	11392,
	42786,
	42888,
	42891,
	42944,
	42946,
	42951,
	42999,
	43008,
	43824,
	43867,
	43868,
	43877,
	43878,
	43880,
	64256,
	64263,
	65313,
	65339,
	65345,
	65371
]);
scriptExtensions.set("Latin", [867, 880, 1157, 1159, 2385, 2387, 4347, 4348, 8239, 8240, 8432, 8433, 43310, 43311]);
script.set("Lepcha", [7168, 7224, 7227, 7242, 7245, 7248]);
scriptExtensions.set("Lepcha", []);
script.set("Limbu", [6400, 6431, 6432, 6444, 6448, 6460, 6464, 6465, 6468, 6480]);
scriptExtensions.set("Limbu", [2405, 2406]);
script.set("Linear_A", [67072, 67383, 67392, 67414, 67424, 67432]);
scriptExtensions.set("Linear_A", [65799, 65844]);
script.set("Linear_B", [65536, 65548, 65549, 65575, 65576, 65595, 65596, 65598, 65599, 65614, 65616, 65630, 65664, 65787]);
scriptExtensions.set("Linear_B", [65792, 65795, 65799, 65844, 65847, 65856]);
script.set("Lisu", [42192, 42240]);
scriptExtensions.set("Lisu", []);
script.set("Lycian", [66176, 66205]);
scriptExtensions.set("Lycian", []);
script.set("Lydian", [67872, 67898, 67903, 67904]);
scriptExtensions.set("Lydian", []);
script.set("Mahajani", [69968, 70007]);
scriptExtensions.set("Mahajani", [2404, 2416, 43056, 43066]);
script.set("Makasar", [73440, 73465]);
scriptExtensions.set("Makasar", []);
script.set("Malayalam", [3328, 3332, 3333, 3341, 3342, 3345, 3346, 3397, 3398, 3401, 3402, 3408, 3412, 3428, 3430, 3456]);
scriptExtensions.set("Malayalam", [2385, 2387, 2404, 2406, 7386, 7387, 43056, 43059]);
script.set("Mandaic", [2112, 2140, 2142, 2143]);
scriptExtensions.set("Mandaic", [1600, 1601]);
script.set("Manichaean", [68288, 68327, 68331, 68343]);
scriptExtensions.set("Manichaean", [1600, 1601]);
script.set("Marchen", [72816, 72848, 72850, 72872, 72873, 72887]);
scriptExtensions.set("Marchen", []);
script.set("Medefaidrin", [93760, 93851]);
scriptExtensions.set("Medefaidrin", []);
script.set("Masaram_Gondi", [72960, 72967, 72968, 72970, 72971, 73015, 73018, 73019, 73020, 73022, 73023, 73032, 73040, 73050]);
scriptExtensions.set("Masaram_Gondi", [2404, 2406]);
script.set("Meetei_Mayek", [43744, 43767, 43968, 44014, 44016, 44026]);
scriptExtensions.set("Meetei_Mayek", []);
script.set("Mende_Kikakui", [124928, 125125, 125127, 125143]);
scriptExtensions.set("Mende_Kikakui", []);
script.set("Meroitic_Cursive", [68000, 68024, 68028, 68048, 68050, 68096]);
scriptExtensions.set("Meroitic_Cursive", []);
script.set("Meroitic_Hieroglyphs", [67968, 68000]);
scriptExtensions.set("Meroitic_Hieroglyphs", []);
script.set("Miao", [93952, 94027, 94031, 94088, 94095, 94112]);
scriptExtensions.set("Miao", []);
script.set("Modi", [71168, 71237, 71248, 71258]);
scriptExtensions.set("Modi", [43056, 43066]);
script.set("Mongolian", [6144, 6146, 6148, 6149, 6150, 6159, 6160, 6170, 6176, 6265, 6272, 6315, 71264, 71277]);
scriptExtensions.set("Mongolian", [6146, 6148, 6149, 6150, 8239, 8240]);
script.set("Mro", [92736, 92767, 92768, 92778, 92782, 92784]);
scriptExtensions.set("Mro", []);
script.set("Multani", [70272, 70279, 70280, 70281, 70282, 70286, 70287, 70302, 70303, 70314]);
scriptExtensions.set("Multani", [2662, 2672]);
script.set("Myanmar", [4096, 4256, 43488, 43519, 43616, 43648]);
scriptExtensions.set("Myanmar", [43310, 43311]);
script.set("Nabataean", [67712, 67743, 67751, 67760]);
scriptExtensions.set("Nabataean", []);
script.set("New_Tai_Lue", [6528, 6572, 6576, 6602, 6608, 6619, 6622, 6624]);
scriptExtensions.set("New_Tai_Lue", []);
script.set("Newa", [70656, 70746, 70747, 70748, 70749, 70752]);
scriptExtensions.set("Newa", []);
script.set("Nko", [1984, 2043, 2045, 2048]);
scriptExtensions.set("Nko", []);
script.set("Nushu", [94177, 94178, 110960, 111356]);
scriptExtensions.set("Nushu", []);
script.set("Ogham", [5760, 5789]);
scriptExtensions.set("Ogham", []);
script.set("Ol_Chiki", [7248, 7296]);
scriptExtensions.set("Ol_Chiki", []);
script.set("Old_Hungarian", [68736, 68787, 68800, 68851, 68858, 68864]);
scriptExtensions.set("Old_Hungarian", []);
script.set("Old_Italic", [66304, 66340, 66349, 66352]);
scriptExtensions.set("Old_Italic", []);
script.set("Old_North_Arabian", [68224, 68256]);
scriptExtensions.set("Old_North_Arabian", []);
script.set("Old_Permic", [66384, 66427]);
scriptExtensions.set("Old_Permic", [1155, 1156]);
script.set("Old_Persian", [66464, 66500, 66504, 66518]);
scriptExtensions.set("Old_Persian", []);
script.set("Old_Sogdian", [69376, 69416]);
scriptExtensions.set("Old_Sogdian", []);
script.set("Old_South_Arabian", [68192, 68224]);
scriptExtensions.set("Old_South_Arabian", []);
script.set("Old_Turkic", [68608, 68681]);
scriptExtensions.set("Old_Turkic", []);
script.set("Oriya", [
	2817,
	2820,
	2821,
	2829,
	2831,
	2833,
	2835,
	2857,
	2858,
	2865,
	2866,
	2868,
	2869,
	2874,
	2876,
	2885,
	2887,
	2889,
	2891,
	2894,
	2902,
	2904,
	2908,
	2910,
	2911,
	2916,
	2918,
	2936
]);
scriptExtensions.set("Oriya", [2385, 2387, 2404, 2406, 7386, 7387, 7410, 7411]);
script.set("Osage", [66736, 66772, 66776, 66812]);
scriptExtensions.set("Osage", []);
script.set("Osmanya", [66688, 66718, 66720, 66730]);
scriptExtensions.set("Osmanya", []);
script.set("Pahawh_Hmong", [92928, 92998, 93008, 93018, 93019, 93026, 93027, 93048, 93053, 93072]);
scriptExtensions.set("Pahawh_Hmong", []);
script.set("Palmyrene", [67680, 67712]);
scriptExtensions.set("Palmyrene", []);
script.set("Pau_Cin_Hau", [72384, 72441]);
scriptExtensions.set("Pau_Cin_Hau", []);
script.set("Phags_Pa", [43072, 43128]);
scriptExtensions.set("Phags_Pa", [6146, 6148, 6149, 6150]);
script.set("Phoenician", [67840, 67868, 67871, 67872]);
scriptExtensions.set("Phoenician", []);
script.set("Psalter_Pahlavi", [68480, 68498, 68505, 68509, 68521, 68528]);
scriptExtensions.set("Psalter_Pahlavi", [1600, 1601]);
script.set("Rejang", [43312, 43348, 43359, 43360]);
scriptExtensions.set("Rejang", []);
script.set("Runic", [5792, 5867, 5870, 5881]);
scriptExtensions.set("Runic", []);
script.set("Samaritan", [2048, 2094, 2096, 2111]);
scriptExtensions.set("Samaritan", []);
script.set("Saurashtra", [43136, 43206, 43214, 43226]);
scriptExtensions.set("Saurashtra", []);
script.set("Sharada", [70016, 70094, 70096, 70112]);
scriptExtensions.set("Sharada", [2385, 2386, 7383, 7384, 7385, 7386, 7388, 7390, 7392, 7393]);
script.set("Shavian", [66640, 66688]);
scriptExtensions.set("Shavian", []);
script.set("Siddham", [71040, 71094, 71096, 71134]);
scriptExtensions.set("Siddham", []);
script.set("SignWriting", [120832, 121484, 121499, 121504, 121505, 121520]);
scriptExtensions.set("SignWriting", []);
script.set("Sinhala", [
	3458,
	3460,
	3461,
	3479,
	3482,
	3506,
	3507,
	3516,
	3517,
	3518,
	3520,
	3527,
	3530,
	3531,
	3535,
	3541,
	3542,
	3543,
	3544,
	3552,
	3558,
	3568,
	3570,
	3573,
	70113,
	70133
]);
scriptExtensions.set("Sinhala", [2404, 2406]);
script.set("Sogdian", [69424, 69466]);
scriptExtensions.set("Sogdian", [1600, 1601]);
script.set("Sora_Sompeng", [69840, 69865, 69872, 69882]);
scriptExtensions.set("Sora_Sompeng", []);
script.set("Soyombo", [72272, 72355]);
scriptExtensions.set("Soyombo", []);
script.set("Sundanese", [7040, 7104, 7360, 7368]);
scriptExtensions.set("Sundanese", []);
script.set("Syloti_Nagri", [43008, 43052]);
scriptExtensions.set("Syloti_Nagri", [2404, 2406, 2534, 2544]);
script.set("Syriac", [1792, 1806, 1807, 1867, 1869, 1872, 2144, 2155]);
scriptExtensions.set("Syriac", [1548, 1549, 1563, 1565, 1567, 1568, 1600, 1601, 1611, 1622, 1648, 1649]);
script.set("Tagalog", [5888, 5901, 5902, 5909]);
scriptExtensions.set("Tagalog", [5941, 5943]);
script.set("Tagbanwa", [5984, 5997, 5998, 6001, 6002, 6004]);
scriptExtensions.set("Tagbanwa", [5941, 5943]);
script.set("Tai_Le", [6480, 6510, 6512, 6517]);
scriptExtensions.set("Tai_Le", [4160, 4170]);
script.set("Tai_Tham", [6688, 6751, 6752, 6781, 6783, 6794, 6800, 6810, 6816, 6830]);
scriptExtensions.set("Tai_Tham", []);
script.set("Tai_Viet", [43648, 43715, 43739, 43744]);
scriptExtensions.set("Tai_Viet", []);
script.set("Takri", [71296, 71353, 71360, 71370]);
scriptExtensions.set("Takri", [2404, 2406, 43056, 43066]);
script.set("Tamil", [
	2946,
	2948,
	2949,
	2955,
	2958,
	2961,
	2962,
	2966,
	2969,
	2971,
	2972,
	2973,
	2974,
	2976,
	2979,
	2981,
	2984,
	2987,
	2990,
	3002,
	3006,
	3011,
	3014,
	3017,
	3018,
	3022,
	3024,
	3025,
	3031,
	3032,
	3046,
	3067,
	73664,
	73714,
	73727,
	73728
]);
scriptExtensions.set("Tamil", [2385, 2387, 2404, 2406, 7386, 7387, 43251, 43252, 70401, 70402, 70403, 70404, 70459, 70461]);
script.set("Tangut", [94176, 94177, 94208, 100344, 100352, 101107]);
scriptExtensions.set("Tangut", []);
script.set("Telugu", [3072, 3085, 3086, 3089, 3090, 3113, 3114, 3130, 3133, 3141, 3142, 3145, 3146, 3150, 3157, 3159, 3160, 3163, 3168, 3172, 3174, 3184, 3191, 3200]);
scriptExtensions.set("Telugu", [2385, 2387, 2404, 2406, 7386, 7387, 7410, 7411]);
script.set("Thaana", [1920, 1970]);
scriptExtensions.set("Thaana", [1548, 1549, 1563, 1565, 1567, 1568, 1632, 1642, 65010, 65011, 65021, 65022]);
script.set("Thai", [3585, 3643, 3648, 3676]);
scriptExtensions.set("Thai", []);
script.set("Tibetan", [3840, 3912, 3913, 3949, 3953, 3992, 3993, 4029, 4030, 4045, 4046, 4053, 4057, 4059]);
scriptExtensions.set("Tibetan", []);
script.set("Tifinagh", [11568, 11624, 11631, 11633, 11647, 11648]);
scriptExtensions.set("Tifinagh", []);
script.set("Tirhuta", [70784, 70856, 70864, 70874]);
scriptExtensions.set("Tirhuta", [2385, 2387, 2404, 2406, 7410, 7411, 43056, 43066]);
script.set("Ugaritic", [66432, 66462, 66463, 66464]);
scriptExtensions.set("Ugaritic", []);
script.set("Vai", [42240, 42540]);
scriptExtensions.set("Vai", []);
script.set("Warang_Citi", [71840, 71923, 71935, 71936]);
scriptExtensions.set("Warang_Citi", []);
script.set("Yi", [40960, 42125, 42128, 42183]);
scriptExtensions.set("Yi", [12289, 12291, 12296, 12306, 12308, 12316, 12539, 12540, 65377, 65382]);
script.set("Zanabazar_Square", [72192, 72264]);
scriptExtensions.set("Zanabazar_Square", []);
